import { api } from "./api";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiSettings: build.query<
      GetApiSettingsApiResponse,
      GetApiSettingsApiArg
    >({
      query: () => ({ url: `/api/settings` }),
    }),
    putApiSettingsByCodeAndValue: build.mutation<
      PutApiSettingsByCodeAndValueApiResponse,
      PutApiSettingsByCodeAndValueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/settings/${queryArg.code}/${queryArg.value}`,
        method: "PUT",
      }),
    }),
    getApiAlertsThermostats: build.query<
      GetApiAlertsThermostatsApiResponse,
      GetApiAlertsThermostatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/alerts/thermostats`,
        params: {
          From: queryArg["from"],
          To: queryArg.to,
          AlertTypes: queryArg.alertTypes,
          ThermostatIds: queryArg.thermostatIds,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdAlertsThermostats: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdAlertsThermostatsApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdAlertsThermostatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/alerts/thermostats`,
        params: {
          From: queryArg["from"],
          To: queryArg.to,
          AlertTypes: queryArg.alertTypes,
          ThermostatIds: queryArg.thermostatIds,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiAlertsStatistic: build.query<
      GetApiAlertsStatisticApiResponse,
      GetApiAlertsStatisticApiArg
    >({
      query: (queryArg) => ({
        url: `/api/alerts/statistic`,
        params: {
          From: queryArg["from"],
          To: queryArg.to,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
        },
      }),
    }),
    getApiAlertsEuiAutocomplete: build.query<
      GetApiAlertsEuiAutocompleteApiResponse,
      GetApiAlertsEuiAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/alerts/eui-autocomplete`,
        params: {
          From: queryArg["from"],
          To: queryArg.to,
          Eui: queryArg.eui,
          Take: queryArg.take,
          CrossTenant: queryArg.crossTenant,
        },
      }),
    }),
    postApiAppointments: build.mutation<
      PostApiAppointmentsApiResponse,
      PostApiAppointmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiAppointmentsByAppointmentId: build.mutation<
      DeleteApiAppointmentsByAppointmentIdApiResponse,
      DeleteApiAppointmentsByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/${queryArg.appointmentId}`,
        method: "DELETE",
      }),
    }),
    getApiAppointmentsByAppointmentId: build.query<
      GetApiAppointmentsByAppointmentIdApiResponse,
      GetApiAppointmentsByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/${queryArg.appointmentId}`,
      }),
    }),
    patchApiAppointmentsByAppointmentId: build.mutation<
      PatchApiAppointmentsByAppointmentIdApiResponse,
      PatchApiAppointmentsByAppointmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/${queryArg.appointmentId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiAppointmentsBuildingUnitByBuildingUnitId: build.query<
      GetApiAppointmentsBuildingUnitByBuildingUnitIdApiResponse,
      GetApiAppointmentsBuildingUnitByBuildingUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/appointments/building-unit/${queryArg.buildingUnitId}`,
      }),
    }),
    postApiTaxonomyBuildingComplexes: build.mutation<
      PostApiTaxonomyBuildingComplexesApiResponse,
      PostApiTaxonomyBuildingComplexesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-complexes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexes:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-complexes`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    getApiTaxonomyBuildingComplexesByBuildingComplexId: build.query<
      GetApiTaxonomyBuildingComplexesByBuildingComplexIdApiResponse,
      GetApiTaxonomyBuildingComplexesByBuildingComplexIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-complexes/${queryArg.buildingComplexId}`,
      }),
    }),
    deleteApiTaxonomyBuildingComplexesByBuildingComplexId: build.mutation<
      DeleteApiTaxonomyBuildingComplexesByBuildingComplexIdApiResponse,
      DeleteApiTaxonomyBuildingComplexesByBuildingComplexIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-complexes/${queryArg.buildingComplexId}`,
        method: "DELETE",
      }),
    }),
    patchApiTaxonomyBuildingComplexesByBuildingComplexId: build.mutation<
      PatchApiTaxonomyBuildingComplexesByBuildingComplexIdApiResponse,
      PatchApiTaxonomyBuildingComplexesByBuildingComplexIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-complexes/${queryArg.buildingComplexId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-complexes/${queryArg.buildingComplexId}`,
        }),
      }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexId:
      build.mutation<
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiResponse,
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-complexes/${queryArg.buildingComplexId}`,
          method: "DELETE",
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-complexes/${queryArg.buildingComplexId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdTree:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdTreeApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdTreeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-complexes/${queryArg.buildingComplexId}/tree`,
        }),
      }),
    postApiTaxonomyBuildingComplexesMoveToLocation: build.mutation<
      PostApiTaxonomyBuildingComplexesMoveToLocationApiResponse,
      PostApiTaxonomyBuildingComplexesMoveToLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-complexes/move-to-location`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiTaxonomyBuildingComplexesByBuildingComplexIdFloors: build.mutation<
      PostApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsApiResponse,
      PostApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-complexes/${queryArg.buildingComplexId}/floors`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyBuildingComplexesByBuildingComplexIdFloors: build.query<
      GetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsApiResponse,
      GetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-complexes/${queryArg.buildingComplexId}/floors`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorId:
      build.query<
        GetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdApiResponse,
        GetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/taxonomy/building-complexes/${queryArg.buildingComplexId}/floors/${queryArg.floorId}`,
        }),
      }),
    patchApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorId:
      build.mutation<
        PatchApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdApiResponse,
        PatchApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/taxonomy/building-complexes/${queryArg.buildingComplexId}/floors/${queryArg.floorId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiTaxonomyBuildingsByBuildingIdFloors: build.query<
      GetApiTaxonomyBuildingsByBuildingIdFloorsApiResponse,
      GetApiTaxonomyBuildingsByBuildingIdFloorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}/floors`,
      }),
    }),
    postApiTaxonomyBuildingUnits: build.mutation<
      PostApiTaxonomyBuildingUnitsApiResponse,
      PostApiTaxonomyBuildingUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-units`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnits: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-units`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyBuildingUnitsByBuildingUnitId: build.query<
      GetApiTaxonomyBuildingUnitsByBuildingUnitIdApiResponse,
      GetApiTaxonomyBuildingUnitsByBuildingUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-units/${queryArg.buildingUnitId}`,
      }),
    }),
    deleteApiTaxonomyBuildingUnitsByBuildingUnitId: build.mutation<
      DeleteApiTaxonomyBuildingUnitsByBuildingUnitIdApiResponse,
      DeleteApiTaxonomyBuildingUnitsByBuildingUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-units/${queryArg.buildingUnitId}`,
        method: "DELETE",
      }),
    }),
    patchApiTaxonomyBuildingUnitsByBuildingUnitId: build.mutation<
      PatchApiTaxonomyBuildingUnitsByBuildingUnitIdApiResponse,
      PatchApiTaxonomyBuildingUnitsByBuildingUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-units/${queryArg.buildingUnitId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-units/${queryArg.buildingUnitId}`,
        }),
      }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitId:
      build.mutation<
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiResponse,
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-units/${queryArg.buildingUnitId}`,
          method: "DELETE",
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-units/${queryArg.buildingUnitId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdTree:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdTreeApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdTreeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-units/${queryArg.buildingUnitId}/tree`,
        }),
      }),
    patchApiTaxonomyBuildingUnitsByBuildingUnitIdStatus: build.mutation<
      PatchApiTaxonomyBuildingUnitsByBuildingUnitIdStatusApiResponse,
      PatchApiTaxonomyBuildingUnitsByBuildingUnitIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/building-units/${queryArg.buildingUnitId}/status`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdStatus:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdStatusApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/building-units/${queryArg.buildingUnitId}/status`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    postApiTaxonomyBuildings: build.mutation<
      PostApiTaxonomyBuildingsApiResponse,
      PostApiTaxonomyBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildings: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyBuildingsByBuildingId: build.query<
      GetApiTaxonomyBuildingsByBuildingIdApiResponse,
      GetApiTaxonomyBuildingsByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}`,
      }),
    }),
    deleteApiTaxonomyBuildingsByBuildingId: build.mutation<
      DeleteApiTaxonomyBuildingsByBuildingIdApiResponse,
      DeleteApiTaxonomyBuildingsByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}`,
        method: "DELETE",
      }),
    }),
    patchApiTaxonomyBuildingsByBuildingId: build.mutation<
      PatchApiTaxonomyBuildingsByBuildingIdApiResponse,
      PatchApiTaxonomyBuildingsByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}`,
      }),
    }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingId:
      build.mutation<
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiResponse,
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}`,
          method: "DELETE",
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdTree:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdTreeApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdTreeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/tree`,
        }),
      }),
    postApiTaxonomyBuildingsByBuildingIdGatewaySignalTest: build.mutation<
      PostApiTaxonomyBuildingsByBuildingIdGatewaySignalTestApiResponse,
      PostApiTaxonomyBuildingsByBuildingIdGatewaySignalTestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}/gateway-signal-test`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyBuildingsByBuildingIdGatewaySignalTest: build.query<
      GetApiTaxonomyBuildingsByBuildingIdGatewaySignalTestApiResponse,
      GetApiTaxonomyBuildingsByBuildingIdGatewaySignalTestApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}/gateway-signal-test`,
      }),
    }),
    getApiTaxonomyBuildingsByBuildingIdGatewayIssues: build.query<
      GetApiTaxonomyBuildingsByBuildingIdGatewayIssuesApiResponse,
      GetApiTaxonomyBuildingsByBuildingIdGatewayIssuesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}/gateway-issues`,
      }),
    }),
    patchApiTaxonomyBuildingsByBuildingIdGatewayIssues: build.mutation<
      PatchApiTaxonomyBuildingsByBuildingIdGatewayIssuesApiResponse,
      PatchApiTaxonomyBuildingsByBuildingIdGatewayIssuesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}/gateway-issues`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchApiTaxonomyBuildingsByBuildingIdGatewaySignalTestFloor: build.mutation<
      PatchApiTaxonomyBuildingsByBuildingIdGatewaySignalTestFloorApiResponse,
      PatchApiTaxonomyBuildingsByBuildingIdGatewaySignalTestFloorApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/buildings/${queryArg.buildingId}/gateway-signal-test-floor`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postApiDataPrivacy: build.mutation<
      PostApiDataPrivacyApiResponse,
      PostApiDataPrivacyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/data-privacy`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiDataPrivacy: build.query<
      GetApiDataPrivacyApiResponse,
      GetApiDataPrivacyApiArg
    >({
      query: () => ({ url: `/api/data-privacy` }),
    }),
    getApiDataPrivacyById: build.query<
      GetApiDataPrivacyByIdApiResponse,
      GetApiDataPrivacyByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/data-privacy/${queryArg.id}` }),
    }),
    getApiDataPrivacyLatest: build.query<
      GetApiDataPrivacyLatestApiResponse,
      GetApiDataPrivacyLatestApiArg
    >({
      query: () => ({ url: `/api/data-privacy/latest` }),
    }),
    postApiDataPrivacySiteSignup: build.mutation<
      PostApiDataPrivacySiteSignupApiResponse,
      PostApiDataPrivacySiteSignupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/data-privacy-site/signup`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiDataPrivacySiteRevokeByToken: build.mutation<
      PostApiDataPrivacySiteRevokeByTokenApiResponse,
      PostApiDataPrivacySiteRevokeByTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/data-privacy-site/revoke/${queryArg.token}`,
        method: "POST",
      }),
    }),
    getApiDataPrivacySiteFilter: build.query<
      GetApiDataPrivacySiteFilterApiResponse,
      GetApiDataPrivacySiteFilterApiArg
    >({
      query: (queryArg) => ({
        url: `/api/data-privacy-site/filter`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          PersonName: queryArg.personName,
          City: queryArg.city,
          Street: queryArg.street,
          HouseNumber: queryArg.houseNumber,
          Processed: queryArg.processed,
        },
      }),
    }),
    patchApiDataPrivacySiteByDataPrivacyAgreementId: build.mutation<
      PatchApiDataPrivacySiteByDataPrivacyAgreementIdApiResponse,
      PatchApiDataPrivacySiteByDataPrivacyAgreementIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/data-privacy-site/${queryArg.dataPrivacyAgreementId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteApiDevelopmentAutoFuotaByAutoFuotaId: build.mutation<
      DeleteApiDevelopmentAutoFuotaByAutoFuotaIdApiResponse,
      DeleteApiDevelopmentAutoFuotaByAutoFuotaIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/auto-fuota/${queryArg.autoFuotaId}`,
        method: "DELETE",
      }),
    }),
    putApiDevelopmentAutoFuotaByAutoFuotaIdForce: build.mutation<
      PutApiDevelopmentAutoFuotaByAutoFuotaIdForceApiResponse,
      PutApiDevelopmentAutoFuotaByAutoFuotaIdForceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/auto-fuota/${queryArg.autoFuotaId}/force`,
        method: "PUT",
      }),
    }),
    getApiDevelopmentAutoFuota: build.query<
      GetApiDevelopmentAutoFuotaApiResponse,
      GetApiDevelopmentAutoFuotaApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/auto-fuota`,
        params: {
          TenantId: queryArg.tenantId,
          Eui: queryArg.eui,
          BuildingIds: queryArg.buildingIds,
          "ScheduledAt.From": queryArg["ScheduledAt.From"],
          "ScheduledAt.To": queryArg["ScheduledAt.To"],
          "StartedAt.From": queryArg["StartedAt.From"],
          "StartedAt.To": queryArg["StartedAt.To"],
          "FinishedAt.From": queryArg["FinishedAt.From"],
          "FinishedAt.To": queryArg["FinishedAt.To"],
          Type: queryArg["type"],
          Name: queryArg.name,
          IsForced: queryArg.isForced,
          "FingerprintHash.Value": queryArg["FingerprintHash.Value"],
          "FingerprintHash.Type": queryArg["FingerprintHash.Type"],
          UserIds: queryArg.userIds,
          Status: queryArg.status,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiDevelopmentGateways: build.query<
      GetApiDevelopmentGatewaysApiResponse,
      GetApiDevelopmentGatewaysApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/gateways`,
        params: {
          TenantId: queryArg.tenantId,
          Eui: queryArg.eui,
          InstallationDone: queryArg.installationDone,
          BuildingIds: queryArg.buildingIds,
          "LastSeen.From": queryArg["LastSeen.From"],
          "LastSeen.To": queryArg["LastSeen.To"],
          "LastThermostatUplinkAt.From":
            queryArg["LastThermostatUplinkAt.From"],
          "LastThermostatUplinkAt.To": queryArg["LastThermostatUplinkAt.To"],
          Status: queryArg.status,
          "WanesyLastSeen.From": queryArg["WanesyLastSeen.From"],
          "WanesyLastSeen.To": queryArg["WanesyLastSeen.To"],
          WanesyStatus: queryArg.wanesyStatus,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdDevelopmentGateways: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdDevelopmentGatewaysApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdDevelopmentGatewaysApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/development/gateways`,
        params: {
          TenantId: queryArg.TenantId,
          Eui: queryArg.eui,
          InstallationDone: queryArg.installationDone,
          BuildingIds: queryArg.buildingIds,
          "LastSeen.From": queryArg["LastSeen.From"],
          "LastSeen.To": queryArg["LastSeen.To"],
          "LastThermostatUplinkAt.From":
            queryArg["LastThermostatUplinkAt.From"],
          "LastThermostatUplinkAt.To": queryArg["LastThermostatUplinkAt.To"],
          Status: queryArg.status,
          "WanesyLastSeen.From": queryArg["WanesyLastSeen.From"],
          "WanesyLastSeen.To": queryArg["WanesyLastSeen.To"],
          WanesyStatus: queryArg.wanesyStatus,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiDevelopmentGatewaysByGatewayIdThermostats: build.query<
      GetApiDevelopmentGatewaysByGatewayIdThermostatsApiResponse,
      GetApiDevelopmentGatewaysByGatewayIdThermostatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/gateways/${queryArg.gatewayId}/thermostats`,
        params: {
          TenantId: queryArg.tenantId,
          Eui: queryArg.eui,
          "Hash.Value": queryArg["Hash.Value"],
          "Hash.Type": queryArg["Hash.Type"],
          Mode: queryArg.mode,
          "Snr.From": queryArg["Snr.From"],
          "Snr.To": queryArg["Snr.To"],
          "SpreadingFactor.From": queryArg["SpreadingFactor.From"],
          "SpreadingFactor.To": queryArg["SpreadingFactor.To"],
          BuildingIds: queryArg.buildingIds,
          DataTransferToDeviceOngoing: queryArg.dataTransferToDeviceOngoing,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiDevelopmentDataTransferFromDeviceByThermostatIdAbort: build.mutation<
      PostApiDevelopmentDataTransferFromDeviceByThermostatIdAbortApiResponse,
      PostApiDevelopmentDataTransferFromDeviceByThermostatIdAbortApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-from-device/${queryArg.thermostatId}/abort`,
        method: "POST",
        params: {
          notifyDevice: queryArg.notifyDevice,
          forced: queryArg.forced,
        },
      }),
    }),
    getApiDevelopmentDataTransferFromDeviceByTransferIdDownload: build.query<
      GetApiDevelopmentDataTransferFromDeviceByTransferIdDownloadApiResponse,
      GetApiDevelopmentDataTransferFromDeviceByTransferIdDownloadApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-from-device/${queryArg.transferId}/download`,
      }),
    }),
    postApiDevelopmentDataTransferFromDeviceByThermostatIdFlash: build.mutation<
      PostApiDevelopmentDataTransferFromDeviceByThermostatIdFlashApiResponse,
      PostApiDevelopmentDataTransferFromDeviceByThermostatIdFlashApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-from-device/${queryArg.thermostatId}/flash`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiDevelopmentDataTransferFromDeviceByThermostatIdLogs: build.mutation<
      PostApiDevelopmentDataTransferFromDeviceByThermostatIdLogsApiResponse,
      PostApiDevelopmentDataTransferFromDeviceByThermostatIdLogsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-from-device/${queryArg.thermostatId}/logs`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiDevelopmentDataTransferFromDeviceByThermostatIdRam: build.mutation<
      PostApiDevelopmentDataTransferFromDeviceByThermostatIdRamApiResponse,
      PostApiDevelopmentDataTransferFromDeviceByThermostatIdRamApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-from-device/${queryArg.thermostatId}/ram`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiDevelopmentDataTransferFromDeviceTransfers: build.query<
      GetApiDevelopmentDataTransferFromDeviceTransfersApiResponse,
      GetApiDevelopmentDataTransferFromDeviceTransfersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-from-device/transfers`,
        params: {
          Eui: queryArg.eui,
          BuildingIds: queryArg.buildingIds,
          "StartedAt.From": queryArg["StartedAt.From"],
          "StartedAt.To": queryArg["StartedAt.To"],
          BankId: queryArg.bankId,
          Name: queryArg.name,
          "FingerprintHash.Value": queryArg["FingerprintHash.Value"],
          "FingerprintHash.Type": queryArg["FingerprintHash.Type"],
          UserIds: queryArg.userIds,
          Status: queryArg.status,
          "LastReceivedAt.From": queryArg["LastReceivedAt.From"],
          "LastReceivedAt.To": queryArg["LastReceivedAt.To"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdAbort: build.mutation<
      PostApiDevelopmentDownlinkDataTransferByThermostatIdAbortApiResponse,
      PostApiDevelopmentDownlinkDataTransferByThermostatIdAbortApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/abort`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdGetAppsInfo:
      build.mutation<
        PostApiDevelopmentDownlinkDataTransferByThermostatIdGetAppsInfoApiResponse,
        PostApiDevelopmentDownlinkDataTransferByThermostatIdGetAppsInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/get-apps-info`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdInstallCore:
      build.mutation<
        PostApiDevelopmentDownlinkDataTransferByThermostatIdInstallCoreApiResponse,
        PostApiDevelopmentDownlinkDataTransferByThermostatIdInstallCoreApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/install-core`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdPause: build.mutation<
      PostApiDevelopmentDownlinkDataTransferByThermostatIdPauseApiResponse,
      PostApiDevelopmentDownlinkDataTransferByThermostatIdPauseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/pause`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdResume: build.mutation<
      PostApiDevelopmentDownlinkDataTransferByThermostatIdResumeApiResponse,
      PostApiDevelopmentDownlinkDataTransferByThermostatIdResumeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/resume`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdSendApp: build.mutation<
      PostApiDevelopmentDownlinkDataTransferByThermostatIdSendAppApiResponse,
      PostApiDevelopmentDownlinkDataTransferByThermostatIdSendAppApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/send-app`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdSendCore:
      build.mutation<
        PostApiDevelopmentDownlinkDataTransferByThermostatIdSendCoreApiResponse,
        PostApiDevelopmentDownlinkDataTransferByThermostatIdSendCoreApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/send-core`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdSendStaticData:
      build.mutation<
        PostApiDevelopmentDownlinkDataTransferByThermostatIdSendStaticDataApiResponse,
        PostApiDevelopmentDownlinkDataTransferByThermostatIdSendStaticDataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/send-static-data`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkDataTransferByThermostatIdSpeedUp: build.mutation<
      PostApiDevelopmentDownlinkDataTransferByThermostatIdSpeedUpApiResponse,
      PostApiDevelopmentDownlinkDataTransferByThermostatIdSpeedUpApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/data-transfer/${queryArg.thermostatId}/speed-up`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDataTransferToDeviceAbortByThermostatId: build.mutation<
      PostApiDevelopmentDataTransferToDeviceAbortByThermostatIdApiResponse,
      PostApiDevelopmentDataTransferToDeviceAbortByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device/abort/${queryArg.thermostatId}`,
        method: "POST",
        params: {
          notifyDevice: queryArg.notifyDevice,
          forced: queryArg.forced,
        },
      }),
    }),
    postApiDevelopmentDataTransferToDeviceBulkUploadAppByBuildingIdAndAppIdVersionKey:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceBulkUploadAppByBuildingIdAndAppIdVersionKeyApiResponse,
        PostApiDevelopmentDataTransferToDeviceBulkUploadAppByBuildingIdAndAppIdVersionKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/bulk-upload-app/${queryArg.buildingId}/${queryArg.appId}/${queryArg.versionKey}`,
          method: "POST",
          params: {
            FirmwareVersions: queryArg.firmwareVersions,
            "FingerprintHash.Value": queryArg["FingerprintHash.Value"],
            "FingerprintHash.Type": queryArg["FingerprintHash.Type"],
            BatteryLevelThreshold: queryArg.batteryLevelThreshold,
            BatteryVoltageThreshold: queryArg.batteryVoltageThreshold,
            autoFuota: queryArg.autoFuota,
            forced: queryArg.forced,
          },
        }),
      }),
    postApiDevelopmentDataTransferToDeviceBulkUploadBinaryByBuildingId:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceBulkUploadBinaryByBuildingIdApiResponse,
        PostApiDevelopmentDataTransferToDeviceBulkUploadBinaryByBuildingIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/bulk-upload-binary/${queryArg.buildingId}`,
          method: "POST",
          body: queryArg.body,
          params: {
            FirmwareVersions: queryArg.firmwareVersions,
            "FingerprintHash.Value": queryArg["FingerprintHash.Value"],
            "FingerprintHash.Type": queryArg["FingerprintHash.Type"],
            BatteryLevelThreshold: queryArg.batteryLevelThreshold,
            BatteryVoltageThreshold: queryArg.batteryVoltageThreshold,
            autoFuota: queryArg.autoFuota,
            forced: queryArg.forced,
          },
        }),
      }),
    postApiDevelopmentDataTransferToDeviceBulkUploadCoreByBuildingIdAndVersionKey:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceBulkUploadCoreByBuildingIdAndVersionKeyApiResponse,
        PostApiDevelopmentDataTransferToDeviceBulkUploadCoreByBuildingIdAndVersionKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/bulk-upload-core/${queryArg.buildingId}/${queryArg.versionKey}`,
          method: "POST",
          params: {
            FirmwareVersions: queryArg.firmwareVersions,
            "FingerprintHash.Value": queryArg["FingerprintHash.Value"],
            "FingerprintHash.Type": queryArg["FingerprintHash.Type"],
            BatteryLevelThreshold: queryArg.batteryLevelThreshold,
            BatteryVoltageThreshold: queryArg.batteryVoltageThreshold,
            autoFuota: queryArg.autoFuota,
            forced: queryArg.forced,
          },
        }),
      }),
    getApiDevelopmentFirmwareUpdateDashboard: build.query<
      GetApiDevelopmentFirmwareUpdateDashboardApiResponse,
      GetApiDevelopmentFirmwareUpdateDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/firmware-update/dashboard`,
        params: {
          hardware: queryArg.hardware,
          firmware: queryArg.firmware,
          euiPrefix: queryArg.euiPrefix,
          status: queryArg.status,
          updating: queryArg.updating,
          deviceInProgress: queryArg.deviceInProgress,
        },
      }),
    }),
    postApiDevelopmentFirmwareUpdateDashboard: build.mutation<
      PostApiDevelopmentFirmwareUpdateDashboardApiResponse,
      PostApiDevelopmentFirmwareUpdateDashboardApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/firmware-update/dashboard`,
        method: "POST",
        params: {
          hardware: queryArg.hardware,
          firmware: queryArg.firmware,
          euiPrefix: queryArg.euiPrefix,
          status: queryArg.status,
        },
      }),
    }),
    putApiDevelopmentDataTransferToDeviceForceByThermostatId: build.mutation<
      PutApiDevelopmentDataTransferToDeviceForceByThermostatIdApiResponse,
      PutApiDevelopmentDataTransferToDeviceForceByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device/force/${queryArg.thermostatId}`,
        method: "PUT",
      }),
    }),
    getApiDevelopmentDataTransferToDevice: build.query<
      GetApiDevelopmentDataTransferToDeviceApiResponse,
      GetApiDevelopmentDataTransferToDeviceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device`,
        params: {
          eui: queryArg.eui,
          type: queryArg["type"],
          name: queryArg.name,
          startedFrom: queryArg.startedFrom,
          startedTo: queryArg.startedTo,
          hash: queryArg.hash,
        },
      }),
    }),
    getApiDevelopmentFirmwareInfoByThermostatId: build.query<
      GetApiDevelopmentFirmwareInfoByThermostatIdApiResponse,
      GetApiDevelopmentFirmwareInfoByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/firmware-info/${queryArg.thermostatId}`,
      }),
    }),
    postApiDevelopmentDataTransferToDeviceByThermostatIdUploadAppAndAppIdMajorMinorPatch:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadAppAndAppIdMajorMinorPatchApiResponse,
        PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadAppAndAppIdMajorMinorPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/${queryArg.thermostatId}/upload-app/${queryArg.appId}/${queryArg.major}/${queryArg.minor}/${queryArg.patch}`,
          method: "POST",
          params: {
            autoFuota: queryArg.autoFuota,
            forced: queryArg.forced,
          },
        }),
      }),
    postApiDevelopmentDataTransferToDeviceByThermostatIdUploadBinary:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadBinaryApiResponse,
        PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadBinaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/${queryArg.thermostatId}/upload-binary`,
          method: "POST",
          body: queryArg.body,
          params: {
            autoFuota: queryArg.autoFuota,
            forced: queryArg.forced,
          },
        }),
      }),
    postApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreAndMajorMinorPatch:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreAndMajorMinorPatchApiResponse,
        PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreAndMajorMinorPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/${queryArg.thermostatId}/upload-core/${queryArg.major}/${queryArg.minor}/${queryArg.patch}`,
          method: "POST",
          params: {
            autoFuota: queryArg.autoFuota,
            forced: queryArg.forced,
          },
        }),
      }),
    postApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreByKeyAndKey:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreByKeyAndKeyApiResponse,
        PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreByKeyAndKeyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/${queryArg.thermostatId}/upload-core-by-key/${queryArg.key}`,
          method: "POST",
          params: {
            autoFuota: queryArg.autoFuota,
            forced: queryArg.forced,
          },
        }),
      }),
    postApiDevelopmentDataTransferToDeviceBatchesAbortByBatchId: build.mutation<
      PostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdApiResponse,
      PostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device/batches/abort/${queryArg.batchId}`,
        method: "POST",
      }),
    }),
    postApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdPhaseAndPhaseId:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdPhaseAndPhaseIdApiResponse,
        PostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdPhaseAndPhaseIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/batches/abort/${queryArg.batchId}/phase/${queryArg.phaseId}`,
          method: "POST",
        }),
      }),
    postApiDevelopmentDataTransferToDeviceBatchesCreateCoreBatchByMajorAndMinorPatch:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceBatchesCreateCoreBatchByMajorAndMinorPatchApiResponse,
        PostApiDevelopmentDataTransferToDeviceBatchesCreateCoreBatchByMajorAndMinorPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/batches/create-core-batch/${queryArg.major}/${queryArg.minor}/${queryArg.patch}`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiDevelopmentDataTransferToDeviceBatchesCreateAppBatchByAppIdAndMajorMinorPatch:
      build.mutation<
        PostApiDevelopmentDataTransferToDeviceBatchesCreateAppBatchByAppIdAndMajorMinorPatchApiResponse,
        PostApiDevelopmentDataTransferToDeviceBatchesCreateAppBatchByAppIdAndMajorMinorPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/data-transfer-to-device/batches/create-app-batch/${queryArg.appId}/${queryArg.major}/${queryArg.minor}/${queryArg.patch}`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiDevelopmentDataTransferToDeviceBatchesPhase: build.mutation<
      PostApiDevelopmentDataTransferToDeviceBatchesPhaseApiResponse,
      PostApiDevelopmentDataTransferToDeviceBatchesPhaseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device/batches/phase`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiDevelopmentDataTransferToDeviceBatchesExportByBatchId: build.query<
      GetApiDevelopmentDataTransferToDeviceBatchesExportByBatchIdApiResponse,
      GetApiDevelopmentDataTransferToDeviceBatchesExportByBatchIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device/batches/export/${queryArg.batchId}`,
      }),
    }),
    getApiDevelopmentDataTransferToDeviceBatches: build.query<
      GetApiDevelopmentDataTransferToDeviceBatchesApiResponse,
      GetApiDevelopmentDataTransferToDeviceBatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device/batches`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
          "Name.Value": queryArg["Name.Value"],
          "Name.Type": queryArg["Name.Type"],
          "Note.Value": queryArg["Note.Value"],
          "Note.Type": queryArg["Note.Type"],
          CreatedBy: queryArg.createdBy,
          "CreatedAt.From": queryArg["CreatedAt.From"],
          "CreatedAt.To": queryArg["CreatedAt.To"],
          Statuses: queryArg.statuses,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
        },
      }),
    }),
    getApiDevelopmentDataTransferToDeviceBatchesPhaseByBatchId: build.query<
      GetApiDevelopmentDataTransferToDeviceBatchesPhaseByBatchIdApiResponse,
      GetApiDevelopmentDataTransferToDeviceBatchesPhaseByBatchIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device/batches/phase/${queryArg.batchId}`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiDevelopmentDataTransferToDeviceBatchesPreview: build.mutation<
      PostApiDevelopmentDataTransferToDeviceBatchesPreviewApiResponse,
      PostApiDevelopmentDataTransferToDeviceBatchesPreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/data-transfer-to-device/batches/preview`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiDevelopmentThermostatOperations: build.query<
      GetApiDevelopmentThermostatOperationsApiResponse,
      GetApiDevelopmentThermostatOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/thermostat-operations`,
        params: {
          TenantId: queryArg.tenantId,
          Eui: queryArg.eui,
          BuildingIds: queryArg.buildingIds,
          Code: queryArg.code,
          "StartedAt.From": queryArg["StartedAt.From"],
          "StartedAt.To": queryArg["StartedAt.To"],
          "LastUpdatedAt.From": queryArg["LastUpdatedAt.From"],
          "LastUpdatedAt.To": queryArg["LastUpdatedAt.To"],
          Completed: queryArg.completed,
          Success: queryArg.success,
          UserIds: queryArg.userIds,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdGeneralGetInfo: build.mutation<
      PostApiDevelopmentDownlinkByThermostatIdGeneralGetInfoApiResponse,
      PostApiDevelopmentDownlinkByThermostatIdGeneralGetInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/general-get-info`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdMcuReset: build.mutation<
      PostApiDevelopmentDownlinkByThermostatIdMcuResetApiResponse,
      PostApiDevelopmentDownlinkByThermostatIdMcuResetApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/mcu-reset`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdSetDisplayRotation: build.mutation<
      PostApiDevelopmentDownlinkByThermostatIdSetDisplayRotationApiResponse,
      PostApiDevelopmentDownlinkByThermostatIdSetDisplayRotationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/set-display-rotation`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdSetMajorMode: build.mutation<
      PostApiDevelopmentDownlinkByThermostatIdSetMajorModeApiResponse,
      PostApiDevelopmentDownlinkByThermostatIdSetMajorModeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/set-major-mode`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdSetMotorPositionConstraint:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdSetMotorPositionConstraintApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdSetMotorPositionConstraintApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/set-motor-position-constraint`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdSetMotorPosition: build.mutation<
      PostApiDevelopmentDownlinkByThermostatIdSetMotorPositionApiResponse,
      PostApiDevelopmentDownlinkByThermostatIdSetMotorPositionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/set-motor-position`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureAndLevel:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureAndLevelApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureAndLevelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/set-target-temperature-and-level`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdSetTargetTemperature:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/set-target-temperature`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevel:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/set-target-temperature-level`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdToggleDirectMotorControl:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdToggleDirectMotorControlApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdToggleDirectMotorControlApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/toggle-direct-motor-control`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdMotorOutwardStallDetection:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdMotorOutwardStallDetectionApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdMotorOutwardStallDetectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/motor-outward-stall-detection`,
          method: "POST",
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdMotorInwardStallDetection:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdMotorInwardStallDetectionApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdMotorInwardStallDetectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/motor-inward-stall-detection`,
          method: "POST",
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelMapping:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelMappingApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelMappingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/set-target-temperature-level-mapping`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdConfigureMeasurements:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdConfigureMeasurementsApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdConfigureMeasurementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/configure-measurements`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
          },
        }),
      }),
    postApiDevelopmentDownlinkByThermostatIdSuperBlockGc: build.mutation<
      PostApiDevelopmentDownlinkByThermostatIdSuperBlockGcApiResponse,
      PostApiDevelopmentDownlinkByThermostatIdSuperBlockGcApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/super-block-gc`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdAutoCalibrationClosedValveThreshold:
      build.mutation<
        PostApiDevelopmentDownlinkByThermostatIdAutoCalibrationClosedValveThresholdApiResponse,
        PostApiDevelopmentDownlinkByThermostatIdAutoCalibrationClosedValveThresholdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/downlink/${queryArg.thermostatId}/auto-calibration/closed-valve-threshold`,
          method: "POST",
          body: queryArg.body,
          params: {
            IgnoreVersion: queryArg.ignoreVersion,
            ExpirationMinutes: queryArg.expirationMinutes,
            makeDefault: queryArg.makeDefault,
          },
        }),
      }),
    putApiDevelopmentDownlinkByThermostatIdAmbientTemperature: build.mutation<
      PutApiDevelopmentDownlinkByThermostatIdAmbientTemperatureApiResponse,
      PutApiDevelopmentDownlinkByThermostatIdAmbientTemperatureApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/ambient-temperature`,
        method: "PUT",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdAppData: build.mutation<
      PostApiDevelopmentDownlinkByThermostatIdAppDataApiResponse,
      PostApiDevelopmentDownlinkByThermostatIdAppDataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/app-data`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentDownlinkByThermostatIdHexCommand: build.mutation<
      PostApiDevelopmentDownlinkByThermostatIdHexCommandApiResponse,
      PostApiDevelopmentDownlinkByThermostatIdHexCommandApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/downlink/${queryArg.thermostatId}/hex-command`,
        method: "POST",
        body: queryArg.body,
        params: {
          IgnoreVersion: queryArg.ignoreVersion,
          ExpirationMinutes: queryArg.expirationMinutes,
        },
      }),
    }),
    postApiDevelopmentInvokeError: build.mutation<
      PostApiDevelopmentInvokeErrorApiResponse,
      PostApiDevelopmentInvokeErrorApiArg
    >({
      query: () => ({ url: `/api/development/invoke-error`, method: "POST" }),
    }),
    getApiDevelopmentChirpstackDeviceConfigurationData: build.query<
      GetApiDevelopmentChirpstackDeviceConfigurationDataApiResponse,
      GetApiDevelopmentChirpstackDeviceConfigurationDataApiArg
    >({
      query: () => ({
        url: `/api/development/chirpstack/device-configuration-data`,
      }),
    }),
    postApiDevelopmentOnboardingThermostats: build.mutation<
      PostApiDevelopmentOnboardingThermostatsApiResponse,
      PostApiDevelopmentOnboardingThermostatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/onboarding/thermostats`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiDevelopmentAssemblyLineDetail: build.mutation<
      PostApiDevelopmentAssemblyLineDetailApiResponse,
      PostApiDevelopmentAssemblyLineDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/assembly-line/detail`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiDevelopmentAssemblyLineSummary: build.mutation<
      PostApiDevelopmentAssemblyLineSummaryApiResponse,
      PostApiDevelopmentAssemblyLineSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/assembly-line/summary`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiDevelopmentArtifactsFirmwareCore: build.query<
      GetApiDevelopmentArtifactsFirmwareCoreApiResponse,
      GetApiDevelopmentArtifactsFirmwareCoreApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/artifacts/firmware-core`,
        params: {
          major: queryArg.major,
          minor: queryArg.minor,
          patch: queryArg.patch,
          hwrev: queryArg.hwrev,
        },
      }),
    }),
    postApiDevelopmentArtifactsFirmwareCore: build.mutation<
      PostApiDevelopmentArtifactsFirmwareCoreApiResponse,
      PostApiDevelopmentArtifactsFirmwareCoreApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/artifacts/firmware-core`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiDevelopmentArtifactsFirmwareCoreByMajorAndMinorPatch:
      build.mutation<
        DeleteApiDevelopmentArtifactsFirmwareCoreByMajorAndMinorPatchApiResponse,
        DeleteApiDevelopmentArtifactsFirmwareCoreByMajorAndMinorPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/artifacts/firmware-core/${queryArg.major}/${queryArg.minor}/${queryArg.patch}`,
          method: "DELETE",
        }),
      }),
    getApiDevelopmentArtifactsTermiosApp: build.query<
      GetApiDevelopmentArtifactsTermiosAppApiResponse,
      GetApiDevelopmentArtifactsTermiosAppApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/artifacts/termios-app`,
        params: {
          appId: queryArg.appId,
          major: queryArg.major,
          minor: queryArg.minor,
          patch: queryArg.patch,
          fw: queryArg.fw,
          fwmin: queryArg.fwmin,
        },
      }),
    }),
    postApiDevelopmentArtifactsTermiosApp: build.mutation<
      PostApiDevelopmentArtifactsTermiosAppApiResponse,
      PostApiDevelopmentArtifactsTermiosAppApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/artifacts/termios-app`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiDevelopmentArtifactsTermiosAppByAppIdAndMajorMinorPatch:
      build.mutation<
        DeleteApiDevelopmentArtifactsTermiosAppByAppIdAndMajorMinorPatchApiResponse,
        DeleteApiDevelopmentArtifactsTermiosAppByAppIdAndMajorMinorPatchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/development/artifacts/termios-app/${queryArg.appId}/${queryArg.major}/${queryArg.minor}/${queryArg.patch}`,
          method: "DELETE",
        }),
      }),
    getApiDevicesBuildingDeviceMetadataByBuildingId: build.query<
      GetApiDevicesBuildingDeviceMetadataByBuildingIdApiResponse,
      GetApiDevicesBuildingDeviceMetadataByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/devices/building-device-metadata/${queryArg.buildingId}`,
      }),
    }),
    getApiDevicesByDeviceTypeImageAndImageId: build.query<
      GetApiDevicesByDeviceTypeImageAndImageIdApiResponse,
      GetApiDevicesByDeviceTypeImageAndImageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/devices/${queryArg.deviceType}/image/${queryArg.imageId}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageImageId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageImageIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageImageIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/devices/${queryArg.deviceType}/image/${queryArg.imageId}`,
        }),
      }),
    postApiDevicesImagesByBuildingIdBulk: build.mutation<
      PostApiDevicesImagesByBuildingIdBulkApiResponse,
      PostApiDevicesImagesByBuildingIdBulkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/devices/images/${queryArg.buildingId}/bulk`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdDevicesImagesBuildingIdBulk:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdDevicesImagesBuildingIdBulkApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdDevicesImagesBuildingIdBulkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/devices/images/${queryArg.buildingId}/bulk`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    getApiDevicesByDeviceTypeImageMetadataAndDeviceId: build.query<
      GetApiDevicesByDeviceTypeImageMetadataAndDeviceIdApiResponse,
      GetApiDevicesByDeviceTypeImageMetadataAndDeviceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/devices/${queryArg.deviceType}/image-metadata/${queryArg.deviceId}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageMetadataDeviceId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageMetadataDeviceIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageMetadataDeviceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/devices/${queryArg.deviceType}/image-metadata/${queryArg.deviceId}`,
        }),
      }),
    getApiFilesFileTemplateByTemplate: build.query<
      GetApiFilesFileTemplateByTemplateApiResponse,
      GetApiFilesFileTemplateByTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/files/file-template/${queryArg.template}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdFilesFileTemplateTemplate: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdFilesFileTemplateTemplateApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdFilesFileTemplateTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/files/file-template/${queryArg.template}`,
      }),
    }),
    getApiGlobalDeviceListComplexes: build.query<
      GetApiGlobalDeviceListComplexesApiResponse,
      GetApiGlobalDeviceListComplexesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/complexes`,
        params: {
          ComplexName: queryArg.complexName,
          LocationIds: queryArg.locationIds,
          TenantIds: queryArg.tenantIds,
          Take: queryArg.take,
        },
      }),
    }),
    getApiGlobalDeviceListBuildingFloors: build.query<
      GetApiGlobalDeviceListBuildingFloorsApiResponse,
      GetApiGlobalDeviceListBuildingFloorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/building-floors`,
        params: {
          BuildingIds: queryArg.buildingIds,
        },
      }),
    }),
    getApiGlobalDeviceListBuildings: build.query<
      GetApiGlobalDeviceListBuildingsApiResponse,
      GetApiGlobalDeviceListBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/buildings`,
        params: {
          BuildingName: queryArg.buildingName,
          ComplexIds: queryArg.complexIds,
          LocationIds: queryArg.locationIds,
          TenantIds: queryArg.tenantIds,
          Take: queryArg.take,
        },
      }),
    }),
    getApiGlobalDeviceListBuildingUnits: build.query<
      GetApiGlobalDeviceListBuildingUnitsApiResponse,
      GetApiGlobalDeviceListBuildingUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/building-units`,
        params: {
          BuildingIds: queryArg.buildingIds,
        },
      }),
    }),
    getApiGlobalDeviceListFirmwareVersions: build.query<
      GetApiGlobalDeviceListFirmwareVersionsApiResponse,
      GetApiGlobalDeviceListFirmwareVersionsApiArg
    >({
      query: () => ({ url: `/api/global-device-list/firmware-versions` }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListSensors: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListSensorsApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListSensorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/global-device-list/sensors`,
        params: {
          Eui: queryArg.eui,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          LifecycleStatuses: queryArg.lifecycleStatuses,
          Placements: queryArg.placements,
          Types: queryArg.types,
          PairingStatuses: queryArg.pairingStatuses,
          NetworkStatuses: queryArg.networkStatuses,
          Assigned: queryArg.assigned,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiGlobalDeviceListHardwareVersions: build.query<
      GetApiGlobalDeviceListHardwareVersionsApiResponse,
      GetApiGlobalDeviceListHardwareVersionsApiArg
    >({
      query: () => ({ url: `/api/global-device-list/hardware-versions` }),
    }),
    getApiGlobalDeviceListLocations: build.query<
      GetApiGlobalDeviceListLocationsApiResponse,
      GetApiGlobalDeviceListLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/locations`,
        params: {
          LocationName: queryArg.locationName,
          TenantIds: queryArg.tenantIds,
          Take: queryArg.take,
        },
      }),
    }),
    getApiGlobalDeviceListSpaceCustomers: build.query<
      GetApiGlobalDeviceListSpaceCustomersApiResponse,
      GetApiGlobalDeviceListSpaceCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/space-customers`,
        params: {
          CustomerId: queryArg.customerId,
          TenantIds: queryArg.tenantIds,
          Take: queryArg.take,
        },
      }),
    }),
    postApiGlobalDeviceListThermostats: build.mutation<
      PostApiGlobalDeviceListThermostatsApiResponse,
      PostApiGlobalDeviceListThermostatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/thermostats`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiGateways: build.mutation<
      PostApiGatewaysApiResponse,
      PostApiGatewaysApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiGateways: build.query<
      GetApiGatewaysApiResponse,
      GetApiGatewaysApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
          OrganizationId: queryArg.organizationId,
          OnlyUnassigned: queryArg.onlyUnassigned,
        },
      }),
    }),
    postApiGatewaysAssignByGatewayId: build.mutation<
      PostApiGatewaysAssignByGatewayIdApiResponse,
      PostApiGatewaysAssignByGatewayIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/assign/${queryArg.gatewayId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiGatewaysByGatewayId: build.mutation<
      DeleteApiGatewaysByGatewayIdApiResponse,
      DeleteApiGatewaysByGatewayIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/${queryArg.gatewayId}`,
        method: "DELETE",
      }),
    }),
    getApiGatewaysByGatewayId: build.query<
      GetApiGatewaysByGatewayIdApiResponse,
      GetApiGatewaysByGatewayIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/gateways/${queryArg.gatewayId}` }),
    }),
    patchApiGatewaysByGatewayId: build.mutation<
      PatchApiGatewaysByGatewayIdApiResponse,
      PatchApiGatewaysByGatewayIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/${queryArg.gatewayId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/gateways/${queryArg.gatewayId}`,
      }),
    }),
    patchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayId: build.mutation<
      PatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdApiResponse,
      PatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/gateways/${queryArg.gatewayId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiGatewaysAutocomplete: build.query<
      GetApiGatewaysAutocompleteApiResponse,
      GetApiGatewaysAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/autocomplete`,
        params: {
          Eui: queryArg.eui,
          Assigned: queryArg.assigned,
          NetworkStatus: queryArg.networkStatus,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdGatewaysAutocomplete: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysAutocompleteApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/gateways/autocomplete`,
        params: {
          Eui: queryArg.eui,
          Assigned: queryArg.assigned,
          NetworkStatus: queryArg.networkStatus,
        },
      }),
    }),
    getApiGatewaysExport: build.query<
      GetApiGatewaysExportApiResponse,
      GetApiGatewaysExportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/export`,
        params: {
          Euis: queryArg.euis,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          LocationIds: queryArg.locationIds,
          BuildingComplexIds: queryArg.buildingComplexIds,
          BuildingIds: queryArg.buildingIds,
          Iccids: queryArg.iccids,
          KerosVersions: queryArg.kerosVersions,
          Placement: queryArg.placement,
          NetworkStatuses: queryArg.networkStatuses,
          SignalStrengths: queryArg.signalStrengths,
          WanesyConnectionStatuses: queryArg.wanesyConnectionStatuses,
          Assigned: queryArg.assigned,
          SortBy: queryArg.sortBy,
          SortDirection: queryArg.sortDirection,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiGatewaysList: build.query<
      GetApiGatewaysListApiResponse,
      GetApiGatewaysListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/list`,
        params: {
          Euis: queryArg.euis,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          LocationIds: queryArg.locationIds,
          BuildingComplexIds: queryArg.buildingComplexIds,
          BuildingIds: queryArg.buildingIds,
          Iccids: queryArg.iccids,
          KerosVersions: queryArg.kerosVersions,
          Placement: queryArg.placement,
          NetworkStatuses: queryArg.networkStatuses,
          SignalStrengths: queryArg.signalStrengths,
          WanesyConnectionStatuses: queryArg.wanesyConnectionStatuses,
          Assigned: queryArg.assigned,
          SortBy: queryArg.sortBy,
          SortDirection: queryArg.sortDirection,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdGatewaysList: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysListApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/gateways/list`,
        params: {
          Euis: queryArg.euis,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          LocationIds: queryArg.locationIds,
          BuildingComplexIds: queryArg.buildingComplexIds,
          BuildingIds: queryArg.buildingIds,
          Iccids: queryArg.iccids,
          KerosVersions: queryArg.kerosVersions,
          Placement: queryArg.placement,
          NetworkStatuses: queryArg.networkStatuses,
          SignalStrengths: queryArg.signalStrengths,
          WanesyConnectionStatuses: queryArg.wanesyConnectionStatuses,
          Assigned: queryArg.assigned,
          SortBy: queryArg.sortBy,
          SortDirection: queryArg.sortDirection,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiGatewaysSearch: build.query<
      GetApiGatewaysSearchApiResponse,
      GetApiGatewaysSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/search`,
        params: {
          Euis: queryArg.euis,
          TenantIds: queryArg.tenantIds,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiGatewaysImportTenantReassign: build.mutation<
      PostApiGatewaysImportTenantReassignApiResponse,
      PostApiGatewaysImportTenantReassignApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/import-tenant-reassign`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiGatewaysReassignTenantByGatewayEui: build.mutation<
      PostApiGatewaysReassignTenantByGatewayEuiApiResponse,
      PostApiGatewaysReassignTenantByGatewayEuiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/reassign-tenant/${queryArg.gatewayEui}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiGatewaysUnassignByGatewayId: build.mutation<
      PostApiGatewaysUnassignByGatewayIdApiResponse,
      PostApiGatewaysUnassignByGatewayIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/unassign/${queryArg.gatewayId}`,
        method: "POST",
      }),
    }),
    patchApiGatewaysByGatewayIdInstallationProcess: build.mutation<
      PatchApiGatewaysByGatewayIdInstallationProcessApiResponse,
      PatchApiGatewaysByGatewayIdInstallationProcessApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/${queryArg.gatewayId}/installation-process`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdInstallationProcess:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdInstallationProcessApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdInstallationProcessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/gateways/${queryArg.gatewayId}/installation-process`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    postApiGatewayOnboarderGateway: build.mutation<
      PostApiGatewayOnboarderGatewayApiResponse,
      PostApiGatewayOnboarderGatewayApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateway-onboarder/gateway`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiHeatingClampsByBuildingIdStatistics: build.query<
      GetApiHeatingClampsByBuildingIdStatisticsApiResponse,
      GetApiHeatingClampsByBuildingIdStatisticsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-clamps/${queryArg.buildingId}/statistics`,
      }),
    }),
    getApiHeatingClampsByBuildingIdThermostats: build.query<
      GetApiHeatingClampsByBuildingIdThermostatsApiResponse,
      GetApiHeatingClampsByBuildingIdThermostatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-clamps/${queryArg.buildingId}/thermostats`,
      }),
    }),
    putApiHeatingClampsDefault: build.mutation<
      PutApiHeatingClampsDefaultApiResponse,
      PutApiHeatingClampsDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-clamps/default`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putApiHeatingClamps: build.mutation<
      PutApiHeatingClampsApiResponse,
      PutApiHeatingClampsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-clamps`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getApiHeatingLoadByBuildingIdCompletionStatistic: build.query<
      GetApiHeatingLoadByBuildingIdCompletionStatisticApiResponse,
      GetApiHeatingLoadByBuildingIdCompletionStatisticApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-load/${queryArg.buildingId}/completion-statistic`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdCompletionStatistic:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdCompletionStatisticApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdCompletionStatisticApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-load/${queryArg.buildingId}/completion-statistic`,
        }),
      }),
    getApiHeatingLoadByBuildingIdNonResidentialUnits: build.query<
      GetApiHeatingLoadByBuildingIdNonResidentialUnitsApiResponse,
      GetApiHeatingLoadByBuildingIdNonResidentialUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-load/${queryArg.buildingId}/non-residential-units`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdNonResidentialUnits:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdNonResidentialUnitsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdNonResidentialUnitsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-load/${queryArg.buildingId}/non-residential-units`,
        }),
      }),
    getApiHeatingLoadByBuildingIdEmptyBuildingUnits: build.query<
      GetApiHeatingLoadByBuildingIdEmptyBuildingUnitsApiResponse,
      GetApiHeatingLoadByBuildingIdEmptyBuildingUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-load/${queryArg.buildingId}/empty-building-units`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdEmptyBuildingUnits:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdEmptyBuildingUnitsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdEmptyBuildingUnitsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-load/${queryArg.buildingId}/empty-building-units`,
          params: {
            "Sort.SortOption": queryArg["Sort.SortOption"],
            "Sort.Direction": queryArg["Sort.Direction"],
            Page: queryArg.page,
            PageSize: queryArg.pageSize,
          },
        }),
      }),
    getApiHeatingLoadByBuildingIdAttempts: build.query<
      GetApiHeatingLoadByBuildingIdAttemptsApiResponse,
      GetApiHeatingLoadByBuildingIdAttemptsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-load/${queryArg.buildingId}/attempts`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          StatusFilter: queryArg.statusFilter,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdAttempts:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdAttemptsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdAttemptsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-load/${queryArg.buildingId}/attempts`,
          params: {
            "Sort.SortOption": queryArg["Sort.SortOption"],
            "Sort.Direction": queryArg["Sort.Direction"],
            StatusFilter: queryArg.statusFilter,
            Page: queryArg.page,
            PageSize: queryArg.pageSize,
          },
        }),
      }),
    getApiHeatingLoadByAttemptIdExport: build.query<
      GetApiHeatingLoadByAttemptIdExportApiResponse,
      GetApiHeatingLoadByAttemptIdExportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-load/${queryArg.attemptId}/export`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadAttemptIdExport: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadAttemptIdExportApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadAttemptIdExportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-load/${queryArg.attemptId}/export`,
      }),
    }),
    getApiHeatingLoadByBuildingIdValidation: build.query<
      GetApiHeatingLoadByBuildingIdValidationApiResponse,
      GetApiHeatingLoadByBuildingIdValidationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-load/${queryArg.buildingId}/validation`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdValidation:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdValidationApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdValidationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-load/${queryArg.buildingId}/validation`,
        }),
      }),
    getApiHeatingLoadByBuildingIdInvalidRooms: build.query<
      GetApiHeatingLoadByBuildingIdInvalidRoomsApiResponse,
      GetApiHeatingLoadByBuildingIdInvalidRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-load/${queryArg.buildingId}/invalid-rooms`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdInvalidRooms:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdInvalidRoomsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdInvalidRoomsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-load/${queryArg.buildingId}/invalid-rooms`,
          params: {
            "Sort.SortOption": queryArg["Sort.SortOption"],
            "Sort.Direction": queryArg["Sort.Direction"],
            Page: queryArg.page,
            PageSize: queryArg.pageSize,
          },
        }),
      }),
    postApiHeatingLoadStartCalculationJob: build.mutation<
      PostApiHeatingLoadStartCalculationJobApiResponse,
      PostApiHeatingLoadStartCalculationJobApiArg
    >({
      query: (queryArg) => ({
        url: `/api/heating-load/start-calculation-job`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadStartCalculationJob:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadStartCalculationJobApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadStartCalculationJobApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-load/start-calculation-job`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiHydraulicBalancingManage: build.mutation<
      PostApiHydraulicBalancingManageApiResponse,
      PostApiHydraulicBalancingManageApiArg
    >({
      query: (queryArg) => ({
        url: `/api/hydraulic-balancing/manage`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    patchApiHydraulicBalancingAttemptsByAttemptIdSettings: build.mutation<
      PatchApiHydraulicBalancingAttemptsByAttemptIdSettingsApiResponse,
      PatchApiHydraulicBalancingAttemptsByAttemptIdSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/hydraulic-balancing/attempts/${queryArg.attemptId}/settings`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationInitialMotorPositionConstraintsFillMissing:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationInitialMotorPositionConstraintsFillMissingApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationInitialMotorPositionConstraintsFillMissingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/hydraulic-balancing/heating-circuits/${queryArg.heatingCircuitId}/vdz-calculation/initial-motor-position-constraints/fill-missing`,
          method: "POST",
        }),
      }),
    getApiHydraulicBalancingVdzCalculationAttemptsByAttemptIdExport:
      build.query<
        GetApiHydraulicBalancingVdzCalculationAttemptsByAttemptIdExportApiResponse,
        GetApiHydraulicBalancingVdzCalculationAttemptsByAttemptIdExportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/hydraulic-balancing/vdz-calculation/attempts/${queryArg.attemptId}/export`,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingVdzCalculationAttemptsAttemptIdExport:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingVdzCalculationAttemptsAttemptIdExportApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingVdzCalculationAttemptsAttemptIdExportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/hydraulic-balancing/vdz-calculation/attempts/${queryArg.attemptId}/export`,
        }),
      }),
    getApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationValidate:
      build.query<
        GetApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationValidateApiResponse,
        GetApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationValidateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/hydraulic-balancing/heating-circuits/${queryArg.heatingCircuitId}/vdz-calculation/validate`,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationValidate:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationValidateApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationValidateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/hydraulic-balancing/heating-circuits/${queryArg.heatingCircuitId}/vdz-calculation/validate`,
        }),
      }),
    postApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationRun:
      build.mutation<
        PostApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationRunApiResponse,
        PostApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationRunApiArg
      >({
        query: (queryArg) => ({
          url: `/api/hydraulic-balancing/heating-circuits/${queryArg.heatingCircuitId}/vdz-calculation/run`,
          method: "POST",
        }),
      }),
    postApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationRun:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationRunApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationRunApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/hydraulic-balancing/heating-circuits/${queryArg.heatingCircuitId}/vdz-calculation/run`,
          method: "POST",
        }),
      }),
    postApiHydraulicBalancingImportRadiatorPower: build.mutation<
      PostApiHydraulicBalancingImportRadiatorPowerApiResponse,
      PostApiHydraulicBalancingImportRadiatorPowerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/hydraulic-balancing/import/radiator-power`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPower:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/hydraulic-balancing/import/radiator-power`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiHydraulicBalancingImportRadiatorPowerValidate: build.mutation<
      PostApiHydraulicBalancingImportRadiatorPowerValidateApiResponse,
      PostApiHydraulicBalancingImportRadiatorPowerValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/hydraulic-balancing/import/radiator-power/validate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerValidate:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerValidateApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerValidateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/hydraulic-balancing/import/radiator-power/validate`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    getApiInstallToolProjectsByProjectId: build.query<
      GetApiInstallToolProjectsByProjectIdApiResponse,
      GetApiInstallToolProjectsByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/projects/${queryArg.projectId}`,
      }),
    }),
    getApiInstallToolProjects: build.query<
      GetApiInstallToolProjectsApiResponse,
      GetApiInstallToolProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/projects`,
        params: {
          Query: queryArg.query,
        },
      }),
    }),
    getApiInstallToolBuildingByFloorsByBuildingId: build.query<
      GetApiInstallToolBuildingByFloorsByBuildingIdApiResponse,
      GetApiInstallToolBuildingByFloorsByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/building-by-floors/${queryArg.buildingId}`,
      }),
    }),
    getApiInstallToolBuildings: build.query<
      GetApiInstallToolBuildingsApiResponse,
      GetApiInstallToolBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/buildings`,
        params: {
          ProjectId: queryArg.projectId,
          Query: queryArg.query,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiInstallToolBuildingUnitsByBuildingUnitId: build.query<
      GetApiInstallToolBuildingUnitsByBuildingUnitIdApiResponse,
      GetApiInstallToolBuildingUnitsByBuildingUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/building-units/${queryArg.buildingUnitId}`,
      }),
    }),
    getApiInstallToolGateways: build.query<
      GetApiInstallToolGatewaysApiResponse,
      GetApiInstallToolGatewaysApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/gateways`,
        params: {
          spaceId: queryArg.spaceId,
        },
      }),
    }),
    getApiInstallToolAppointmentsByProjectId: build.query<
      GetApiInstallToolAppointmentsByProjectIdApiResponse,
      GetApiInstallToolAppointmentsByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/appointments/${queryArg.projectId}`,
        params: {
          FromUtc: queryArg.fromUtc,
          ToUtc: queryArg.toUtc,
        },
      }),
    }),
    getApiInstallToolRadiatorsByRadiatorId: build.query<
      GetApiInstallToolRadiatorsByRadiatorIdApiResponse,
      GetApiInstallToolRadiatorsByRadiatorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/radiators/${queryArg.radiatorId}`,
      }),
    }),
    getApiInstallToolRoomsByRoomId: build.query<
      GetApiInstallToolRoomsByRoomIdApiResponse,
      GetApiInstallToolRoomsByRoomIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/rooms/${queryArg.roomId}`,
      }),
    }),
    getApiInstallToolRadiatorSpecificationCatalogue: build.query<
      GetApiInstallToolRadiatorSpecificationCatalogueApiResponse,
      GetApiInstallToolRadiatorSpecificationCatalogueApiArg
    >({
      query: () => ({
        url: `/api/install-tool/radiator-specification/catalogue`,
      }),
    }),
    patchApiInstallToolGatewaysBuildingsByBuildingId: build.mutation<
      PatchApiInstallToolGatewaysBuildingsByBuildingIdApiResponse,
      PatchApiInstallToolGatewaysBuildingsByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/gateways/buildings/${queryArg.buildingId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiInstallToolGatewaysBuildingsByBuildingId: build.query<
      GetApiInstallToolGatewaysBuildingsByBuildingIdApiResponse,
      GetApiInstallToolGatewaysBuildingsByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/gateways/buildings/${queryArg.buildingId}`,
      }),
    }),
    postApiThermostatsAssignWithChecksAndImageByThermostatId: build.mutation<
      PostApiThermostatsAssignWithChecksAndImageByThermostatIdApiResponse,
      PostApiThermostatsAssignWithChecksAndImageByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/assign-with-checks-and-image/${queryArg.thermostatId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiInstallToolGatewaysBuildings: build.query<
      GetApiInstallToolGatewaysBuildingsApiResponse,
      GetApiInstallToolGatewaysBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/gateways/buildings`,
        params: {
          ProjectId: queryArg.projectId,
          SearchBy: queryArg.searchBy,
          GatewayInstallationNeeded: queryArg.gatewayInstallationNeeded,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
        },
      }),
    }),
    postApiInstallToolByDeviceIdAndDeviceTypeImages: build.mutation<
      PostApiInstallToolByDeviceIdAndDeviceTypeImagesApiResponse,
      PostApiInstallToolByDeviceIdAndDeviceTypeImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/install-tool/${queryArg.deviceId}/${queryArg.deviceType}/images`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiKerlinkCheckByEui: build.query<
      GetApiKerlinkCheckByEuiApiResponse,
      GetApiKerlinkCheckByEuiApiArg
    >({
      query: (queryArg) => ({ url: `/api/kerlink/check/${queryArg.eui}` }),
    }),
    postApiKerlinkProvisionByEui: build.mutation<
      PostApiKerlinkProvisionByEuiApiResponse,
      PostApiKerlinkProvisionByEuiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/kerlink/provision/${queryArg.eui}`,
        method: "POST",
      }),
    }),
    postApiLeases: build.mutation<
      PostApiLeasesApiResponse,
      PostApiLeasesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/leases`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdLeases: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdLeasesApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdLeasesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/leases`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiLeasesByLeaseId: build.mutation<
      DeleteApiLeasesByLeaseIdApiResponse,
      DeleteApiLeasesByLeaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/leases/${queryArg.leaseId}`,
        method: "DELETE",
      }),
    }),
    getApiLeasesByLeaseId: build.query<
      GetApiLeasesByLeaseIdApiResponse,
      GetApiLeasesByLeaseIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/leases/${queryArg.leaseId}` }),
    }),
    patchApiLeasesByLeaseId: build.mutation<
      PatchApiLeasesByLeaseIdApiResponse,
      PatchApiLeasesByLeaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/leases/${queryArg.leaseId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseId: build.mutation<
      DeleteApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiResponse,
      DeleteApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/leases/${queryArg.leaseId}`,
        method: "DELETE",
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/leases/${queryArg.leaseId}`,
      }),
    }),
    patchApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseId: build.mutation<
      PatchApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiResponse,
      PatchApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/leases/${queryArg.leaseId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiLeasesBuildingUnitByBuildingUnitIdActive: build.query<
      GetApiLeasesBuildingUnitByBuildingUnitIdActiveApiResponse,
      GetApiLeasesBuildingUnitByBuildingUnitIdActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/leases/building-unit/${queryArg.buildingUnitId}/active`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdActive:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdActiveApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdActiveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/leases/building-unit/${queryArg.buildingUnitId}/active`,
        }),
      }),
    getApiLeasesBuildingUnitByBuildingUnitId: build.query<
      GetApiLeasesBuildingUnitByBuildingUnitIdApiResponse,
      GetApiLeasesBuildingUnitByBuildingUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/leases/building-unit/${queryArg.buildingUnitId}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/leases/building-unit/${queryArg.buildingUnitId}`,
        }),
      }),
    postApiLegalNote: build.mutation<
      PostApiLegalNoteApiResponse,
      PostApiLegalNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/legal-note`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiLegalNote: build.query<
      GetApiLegalNoteApiResponse,
      GetApiLegalNoteApiArg
    >({
      query: () => ({ url: `/api/legal-note` }),
    }),
    getApiLegalNoteLatest: build.query<
      GetApiLegalNoteLatestApiResponse,
      GetApiLegalNoteLatestApiArg
    >({
      query: () => ({ url: `/api/legal-note/latest` }),
    }),
    getApiLegalNoteById: build.query<
      GetApiLegalNoteByIdApiResponse,
      GetApiLegalNoteByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/legal-note/${queryArg.id}` }),
    }),
    getApiLocationAutocompleteLocations: build.query<
      GetApiLocationAutocompleteLocationsApiResponse,
      GetApiLocationAutocompleteLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/location/autocomplete/locations`,
        params: {
          SearchBy: queryArg.searchBy,
          Limit: queryArg.limit,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdLocationAutocompleteLocations:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdLocationAutocompleteLocationsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdLocationAutocompleteLocationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/location/autocomplete/locations`,
          params: {
            SearchBy: queryArg.searchBy,
            Limit: queryArg.limit,
          },
        }),
      }),
    postApiTaxonomyLocations: build.mutation<
      PostApiTaxonomyLocationsApiResponse,
      PostApiTaxonomyLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/locations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyLocations: build.query<
      GetApiTaxonomyLocationsApiResponse,
      GetApiTaxonomyLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/locations`,
        params: {
          LocationSearch: queryArg.locationSearch,
          RenterSearch: queryArg.renterSearch,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocations: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/locations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyLocationsByLocationId: build.query<
      GetApiTaxonomyLocationsByLocationIdApiResponse,
      GetApiTaxonomyLocationsByLocationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/locations/${queryArg.locationId}`,
      }),
    }),
    deleteApiTaxonomyLocationsByLocationId: build.mutation<
      DeleteApiTaxonomyLocationsByLocationIdApiResponse,
      DeleteApiTaxonomyLocationsByLocationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/locations/${queryArg.locationId}`,
        method: "DELETE",
      }),
    }),
    patchApiTaxonomyLocationsByLocationId: build.mutation<
      PatchApiTaxonomyLocationsByLocationIdApiResponse,
      PatchApiTaxonomyLocationsByLocationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/locations/${queryArg.locationId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/locations/${queryArg.locationId}`,
      }),
    }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationId:
      build.mutation<
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiResponse,
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/locations/${queryArg.locationId}`,
          method: "DELETE",
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/locations/${queryArg.locationId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdTree:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdTreeApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdTreeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/locations/${queryArg.locationId}/tree`,
        }),
      }),
    postApiTaxonomyLocationsByLocationIdResync: build.mutation<
      PostApiTaxonomyLocationsByLocationIdResyncApiResponse,
      PostApiTaxonomyLocationsByLocationIdResyncApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/locations/${queryArg.locationId}/resync`,
        method: "POST",
      }),
    }),
    postApiTaxonomyLocationsByLocationIdHeatingCircuits: build.mutation<
      PostApiTaxonomyLocationsByLocationIdHeatingCircuitsApiResponse,
      PostApiTaxonomyLocationsByLocationIdHeatingCircuitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/locations/${queryArg.locationId}/heating-circuits`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyLocationsByLocationIdHeatingCircuits: build.query<
      GetApiTaxonomyLocationsByLocationIdHeatingCircuitsApiResponse,
      GetApiTaxonomyLocationsByLocationIdHeatingCircuitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/locations/${queryArg.locationId}/heating-circuits`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdChain:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdChainApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdChainApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/heating-circuits/${queryArg.heatingCircuitId}/chain`,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/heating-circuits/${queryArg.heatingCircuitId}`,
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/heating-circuits/${queryArg.heatingCircuitId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitId:
      build.query<
        GetApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiResponse,
        GetApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/taxonomy/locations/${queryArg.locationId}/heating-circuits/${queryArg.heatingCircuitId}`,
        }),
      }),
    deleteApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitId:
      build.mutation<
        DeleteApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiResponse,
        DeleteApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/taxonomy/locations/${queryArg.locationId}/heating-circuits/${queryArg.heatingCircuitId}`,
          method: "DELETE",
        }),
      }),
    patchApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitId:
      build.mutation<
        PatchApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiResponse,
        PatchApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/taxonomy/locations/${queryArg.locationId}/heating-circuits/${queryArg.heatingCircuitId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdHeatingCircuits:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdHeatingCircuitsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdHeatingCircuitsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/locations/${queryArg.locationId}/heating-circuits`,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsSpaceTypeSpaceId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsSpaceTypeSpaceIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsSpaceTypeSpaceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/heating-circuits/${queryArg.spaceType}/${queryArg.spaceId}`,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdThermostats:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdThermostatsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdThermostatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/heating-circuits/${queryArg.heatingCircuitId}/thermostats`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdActivities: build.query<
      GetApiNonResidentialOrgByOrgIdTenantAndTenantIdActivitiesApiResponse,
      GetApiNonResidentialOrgByOrgIdTenantAndTenantIdActivitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/activities`,
        params: {
          From: queryArg["from"],
          To: queryArg.to,
          Types: queryArg.types,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingModesTemperatures:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingModesTemperaturesApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingModesTemperaturesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-modes/temperatures`,
        }),
      }),
    postApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignments:
      build.mutation<
        PostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsApiResponse,
        PostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/floors/${queryArg.floorId}/heating-plan-assignments`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignments:
      build.mutation<
        PostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsApiResponse,
        PostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/nodes/${queryArg.nodeType}/${queryArg.nodeId}/heating-plan-assignments`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    deleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsAssignmentId:
      build.mutation<
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsAssignmentIdApiResponse,
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsAssignmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/floors/${queryArg.floorId}/heating-plan-assignments/${queryArg.assignmentId}`,
          method: "DELETE",
        }),
      }),
    deleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsAssignmentId:
      build.mutation<
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsAssignmentIdApiResponse,
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsAssignmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/nodes/${queryArg.nodeType}/${queryArg.nodeId}/heating-plan-assignments/${queryArg.assignmentId}`,
          method: "DELETE",
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlan:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/floors/${queryArg.floorId}/heating-plan`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlan:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/nodes/${queryArg.nodeType}/${queryArg.nodeId}/heating-plan`,
        }),
      }),
    putApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsOrder:
      build.mutation<
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsOrderApiResponse,
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/floors/${queryArg.floorId}/heating-plan-assignments/order`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    putApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsOrder:
      build.mutation<
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsOrderApiResponse,
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsOrderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/nodes/${queryArg.nodeType}/${queryArg.nodeId}/heating-plan-assignments/order`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    postApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlans:
      build.mutation<
        PostApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansApiResponse,
        PostApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-plans`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlans: build.query<
      GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansApiResponse,
      GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansApiArg
    >({
      query: (queryArg) => ({
        url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-plans`,
        params: {
          search: queryArg.search,
        },
      }),
    }),
    deleteApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanId:
      build.mutation<
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiResponse,
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-plans/${queryArg.planId}`,
          method: "DELETE",
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanId:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-plans/${queryArg.planId}`,
        }),
      }),
    putApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanId:
      build.mutation<
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiResponse,
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-plans/${queryArg.planId}`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBase:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-plans/base`,
        }),
      }),
    putApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBase:
      build.mutation<
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseApiResponse,
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-plans/base`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    putApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdStatus:
      build.mutation<
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdStatusApiResponse,
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/heating-plans/${queryArg.planId}/status`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    deleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperatures:
      build.mutation<
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiResponse,
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/floors/${queryArg.floorId}/heating-temperatures`,
          method: "DELETE",
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperatures:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/floors/${queryArg.floorId}/heating-temperatures`,
        }),
      }),
    putApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperatures:
      build.mutation<
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiResponse,
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/floors/${queryArg.floorId}/heating-temperatures`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    deleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperatures:
      build.mutation<
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiResponse,
        DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/nodes/${queryArg.nodeType}/${queryArg.nodeId}/heating-temperatures`,
          method: "DELETE",
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperatures:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/nodes/${queryArg.nodeType}/${queryArg.nodeId}/heating-temperatures`,
        }),
      }),
    putApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperatures:
      build.mutation<
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiResponse,
        PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/nodes/${queryArg.nodeType}/${queryArg.nodeId}/heating-temperatures`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdSubtree:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdSubtreeApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdSubtreeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/navigation/buildings/${queryArg.buildingId}/subtree`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdFloorsFloorId:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdFloorsFloorIdApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdFloorsFloorIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/navigation/buildings/${queryArg.buildingId}/floors/${queryArg.floorId}`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationLocationsLocationIdSubtree:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationLocationsLocationIdSubtreeApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationLocationsLocationIdSubtreeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/navigation/locations/${queryArg.locationId}/subtree`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationNodesNodeTypeNodeId:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationNodesNodeTypeNodeIdApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationNodesNodeTypeNodeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/navigation/nodes/${queryArg.nodeType}/${queryArg.nodeId}`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationRoots: build.query<
      GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationRootsApiResponse,
      GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationRootsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/navigation/roots`,
      }),
    }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdHeatingState:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdHeatingStateApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdHeatingStateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms/${queryArg.roomId}/heating-state`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdThermostats:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdThermostatsApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdThermostatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/buildings/${queryArg.buildingId}/thermostats`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdSummary:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdSummaryApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/locations/${queryArg.locationId}/summary`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdThermostats:
      build.query<
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdThermostatsApiResponse,
        GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdThermostatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms/${queryArg.roomId}/thermostats`,
        }),
      }),
    getApiNonResidentialOrgByOrgIdTenantAndTenantIdThermostatsEui: build.query<
      GetApiNonResidentialOrgByOrgIdTenantAndTenantIdThermostatsEuiApiResponse,
      GetApiNonResidentialOrgByOrgIdTenantAndTenantIdThermostatsEuiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/non-residential/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/${queryArg.eui}`,
      }),
    }),
    postApiNotificationsTestSendByUserId: build.mutation<
      PostApiNotificationsTestSendByUserIdApiResponse,
      PostApiNotificationsTestSendByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/notifications/test-send/${queryArg.userId}`,
        method: "POST",
        params: {
          title: queryArg.title,
          body: queryArg.body,
        },
      }),
    }),
    postApiOptIn: build.mutation<PostApiOptInApiResponse, PostApiOptInApiArg>({
      query: (queryArg) => ({
        url: `/api/opt-in`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiOptIn: build.mutation<
      DeleteApiOptInApiResponse,
      DeleteApiOptInApiArg
    >({
      query: (queryArg) => ({
        url: `/api/opt-in`,
        method: "DELETE",
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getApiOptIn: build.query<GetApiOptInApiResponse, GetApiOptInApiArg>({
      query: () => ({ url: `/api/opt-in` }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdOptIn: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdOptInApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdOptInApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/opt-in`,
      }),
    }),
    getApiOptInLatest: build.query<
      GetApiOptInLatestApiResponse,
      GetApiOptInLatestApiArg
    >({
      query: () => ({ url: `/api/opt-in/latest` }),
    }),
    getApiOptInById: build.query<
      GetApiOptInByIdApiResponse,
      GetApiOptInByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/opt-in/${queryArg.id}` }),
    }),
    postApiOrganizations: build.mutation<
      PostApiOrganizationsApiResponse,
      PostApiOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/organizations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiOrganizations: build.query<
      GetApiOrganizationsApiResponse,
      GetApiOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/organizations`,
        params: {
          SearchTerm: queryArg.searchTerm,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    putApiOrganizationsByOrganizationId: build.mutation<
      PutApiOrganizationsByOrganizationIdApiResponse,
      PutApiOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/organizations/${queryArg.organizationId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdPortfolioAutocomplete: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioAutocompleteApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/portfolio/autocomplete`,
        params: {
          Client: queryArg.client,
          Address: queryArg.address,
          Tenant: queryArg.tenant,
          Eui: queryArg.eui,
          HeatingCircuit: queryArg.heatingCircuit,
          ClientIds: queryArg.clientIds,
          Take: queryArg.take,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdPortfolioCounts: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioCountsApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/portfolio/counts`,
        params: {
          ClientIds: queryArg.clientIds,
          BuildingIds: queryArg.buildingIds,
          TenantIds: queryArg.tenantIds,
          Euis: queryArg.euis,
          HeatingCircuitIds: queryArg.heatingCircuitIds,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdPortfolio: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/portfolio`,
        params: {
          Tab: queryArg.tab,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          ClientIds: queryArg.clientIds,
          BuildingIds: queryArg.buildingIds,
          TenantIds: queryArg.tenantIds,
          Euis: queryArg.euis,
          HeatingCircuitIds: queryArg.heatingCircuitIds,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiProjectsSyncByProjectIdRenowate: build.query<
      GetApiProjectsSyncByProjectIdRenowateApiResponse,
      GetApiProjectsSyncByProjectIdRenowateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/sync/${queryArg.projectId}/renowate`,
      }),
    }),
    postApiProjectsSyncByProjectIdRenowate: build.mutation<
      PostApiProjectsSyncByProjectIdRenowateApiResponse,
      PostApiProjectsSyncByProjectIdRenowateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/sync/${queryArg.projectId}/renowate`,
        method: "POST",
      }),
    }),
    getApiProjectsSyncRenowateFailureItems: build.query<
      GetApiProjectsSyncRenowateFailureItemsApiResponse,
      GetApiProjectsSyncRenowateFailureItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/sync/renowate/failure-items`,
        params: {
          RenowateSyncId: queryArg.renowateSyncId,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiProjectsByProjectIdExport: build.query<
      GetApiProjectsByProjectIdExportApiResponse,
      GetApiProjectsByProjectIdExportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/${queryArg.projectId}/export`,
      }),
    }),
    getApiProjects: build.query<
      GetApiProjectsApiResponse,
      GetApiProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects`,
        params: {
          Query: queryArg.query,
          Status: queryArg.status,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdProjects: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdProjectsApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects`,
        params: {
          Query: queryArg.query,
          Statuses: queryArg.statuses,
          OwnerIds: queryArg.ownerIds,
          TenantIds: queryArg.tenantIds,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersons:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/contact-persons`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiProjectsManagement: build.mutation<
      PostApiProjectsManagementApiResponse,
      PostApiProjectsManagementApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiProjectsManagementByProjectIdAssignBuildings: build.mutation<
      PostApiProjectsManagementByProjectIdAssignBuildingsApiResponse,
      PostApiProjectsManagementByProjectIdAssignBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}/assign-buildings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignBuildings:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignBuildingsApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignBuildingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/assign-buildings`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiProjectsManagementByProjectIdAssignUsers: build.mutation<
      PostApiProjectsManagementByProjectIdAssignUsersApiResponse,
      PostApiProjectsManagementByProjectIdAssignUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}/assign-users`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignUsers:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignUsersApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/assign-users`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonId:
      build.mutation<
        DeleteApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdApiResponse,
        DeleteApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/contact-persons/${queryArg.contactPersonId}`,
          method: "DELETE",
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/contact-persons/${queryArg.contactPersonId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    deleteApiProjectsManagementByProjectId: build.mutation<
      DeleteApiProjectsManagementByProjectIdApiResponse,
      DeleteApiProjectsManagementByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}`,
        method: "DELETE",
      }),
    }),
    getApiProjectsManagementByProjectId: build.query<
      GetApiProjectsManagementByProjectIdApiResponse,
      GetApiProjectsManagementByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}`,
      }),
    }),
    patchApiProjectsManagementByProjectId: build.mutation<
      PatchApiProjectsManagementByProjectIdApiResponse,
      PatchApiProjectsManagementByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiProjectsManagementByProjectIdFilterBuildingComplexes: build.query<
      GetApiProjectsManagementByProjectIdFilterBuildingComplexesApiResponse,
      GetApiProjectsManagementByProjectIdFilterBuildingComplexesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}/filter-building-complexes`,
        params: {
          ComplexName: queryArg.complexName,
          LocationIds: queryArg.locationIds,
          Take: queryArg.take,
        },
      }),
    }),
    getApiProjectsManagementByProjectIdFilterLocations: build.query<
      GetApiProjectsManagementByProjectIdFilterLocationsApiResponse,
      GetApiProjectsManagementByProjectIdFilterLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}/filter-locations`,
        params: {
          LocationName: queryArg.locationName,
          Take: queryArg.take,
        },
      }),
    }),
    getApiProjectsManagementByProjectIdAvailableBuildings: build.query<
      GetApiProjectsManagementByProjectIdAvailableBuildingsApiResponse,
      GetApiProjectsManagementByProjectIdAvailableBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}/available-buildings`,
        params: {
          LocationIds: queryArg.locationIds,
          BuildingComplexIds: queryArg.buildingComplexIds,
          Address: queryArg.address,
          IsAssignedToOtherProject: queryArg.isAssignedToOtherProject,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Take: queryArg.take,
        },
      }),
    }),
    getApiProjectsManagementByProjectIdAvailableUsers: build.query<
      GetApiProjectsManagementByProjectIdAvailableUsersApiResponse,
      GetApiProjectsManagementByProjectIdAvailableUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}/available-users`,
        params: {
          Query: queryArg.query,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Take: queryArg.take,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAvailableUsers:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAvailableUsersApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAvailableUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/available-users`,
          params: {
            Query: queryArg.query,
            "Sort.SortOption": queryArg["Sort.SortOption"],
            "Sort.Direction": queryArg["Sort.Direction"],
            Take: queryArg.take,
          },
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerAutocomplete:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerAutocompleteApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerAutocompleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/owner/autocomplete`,
          params: {
            Query: queryArg.query,
            Take: queryArg.take,
          },
        }),
      }),
    putApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdMilestoneSteps:
      build.mutation<
        PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdMilestoneStepsApiResponse,
        PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdMilestoneStepsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/milestone-steps`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    putApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwner:
      build.mutation<
        PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerApiResponse,
        PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/owner`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    putApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdStatus:
      build.mutation<
        PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdStatusApiResponse,
        PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/status`,
          method: "PUT",
          body: queryArg.body,
        }),
      }),
    postApiProjectsManagementByProjectIdUnassignBuildings: build.mutation<
      PostApiProjectsManagementByProjectIdUnassignBuildingsApiResponse,
      PostApiProjectsManagementByProjectIdUnassignBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}/unassign-buildings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignBuildings:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignBuildingsApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignBuildingsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/unassign-buildings`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiProjectsManagementByProjectIdUnassignUsers: build.mutation<
      PostApiProjectsManagementByProjectIdUnassignUsersApiResponse,
      PostApiProjectsManagementByProjectIdUnassignUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/management/${queryArg.projectId}/unassign-users`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignUsers:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignUsersApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/unassign-users`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdInstallationDates:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdInstallationDatesApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdInstallationDatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/management/${queryArg.projectId}/installation-dates`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiProjectsIssuesByProjectIdBuildingUnits: build.query<
      GetApiProjectsIssuesByProjectIdBuildingUnitsApiResponse,
      GetApiProjectsIssuesByProjectIdBuildingUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/issues/${queryArg.projectId}/building-units`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiProjectsIssuesByProjectIdRadiators: build.query<
      GetApiProjectsIssuesByProjectIdRadiatorsApiResponse,
      GetApiProjectsIssuesByProjectIdRadiatorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/issues/${queryArg.projectId}/radiators`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
        },
      }),
    }),
    getApiProjectsIssuesByProjectIdRenters: build.query<
      GetApiProjectsIssuesByProjectIdRentersApiResponse,
      GetApiProjectsIssuesByProjectIdRentersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/issues/${queryArg.projectId}/renters`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
        },
      }),
    }),
    getApiProjectsIssuesByProjectIdRooms: build.query<
      GetApiProjectsIssuesByProjectIdRoomsApiResponse,
      GetApiProjectsIssuesByProjectIdRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/issues/${queryArg.projectId}/rooms`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
        },
      }),
    }),
    getApiProjectsIssuesByProjectIdThermostats: build.query<
      GetApiProjectsIssuesByProjectIdThermostatsApiResponse,
      GetApiProjectsIssuesByProjectIdThermostatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/issues/${queryArg.projectId}/thermostats`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdContactPersons:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdContactPersonsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdContactPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/${queryArg.projectId}/contact-persons`,
        }),
      }),
    getApiProjectsDetailByProjectIdBuildings: build.query<
      GetApiProjectsDetailByProjectIdBuildingsApiResponse,
      GetApiProjectsDetailByProjectIdBuildingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/detail/${queryArg.projectId}/buildings`,
      }),
    }),
    getApiProjectsDetailByProjectId: build.query<
      GetApiProjectsDetailByProjectIdApiResponse,
      GetApiProjectsDetailByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/detail/${queryArg.projectId}`,
      }),
    }),
    getApiProjectsDetailByProjectIdUsers: build.query<
      GetApiProjectsDetailByProjectIdUsersApiResponse,
      GetApiProjectsDetailByProjectIdUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/projects/detail/${queryArg.projectId}/users`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/${queryArg.projectId}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdMilestones: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdMilestonesApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdMilestonesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/${queryArg.projectId}/milestones`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdUsers: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdUsersApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/projects/${queryArg.projectId}/users`,
        params: {
          Query: queryArg.query,
          Roles: queryArg.roles,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
        },
      }),
    }),
    postApiTaxonomyRadiators: build.mutation<
      PostApiTaxonomyRadiatorsApiResponse,
      PostApiTaxonomyRadiatorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiators: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/radiators`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiTaxonomyRadiatorsByRadiatorIdObstruction: build.mutation<
      DeleteApiTaxonomyRadiatorsByRadiatorIdObstructionApiResponse,
      DeleteApiTaxonomyRadiatorsByRadiatorIdObstructionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}/obstruction`,
        method: "DELETE",
      }),
    }),
    patchApiTaxonomyRadiatorsByRadiatorIdObstruction: build.mutation<
      PatchApiTaxonomyRadiatorsByRadiatorIdObstructionApiResponse,
      PatchApiTaxonomyRadiatorsByRadiatorIdObstructionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}/obstruction`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstruction:
      build.mutation<
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionApiResponse,
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/radiators/${queryArg.radiatorId}/obstruction`,
          method: "DELETE",
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstruction:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/radiators/${queryArg.radiatorId}/obstruction`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiTaxonomyRadiatorsByRadiatorId: build.query<
      GetApiTaxonomyRadiatorsByRadiatorIdApiResponse,
      GetApiTaxonomyRadiatorsByRadiatorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}`,
      }),
    }),
    deleteApiTaxonomyRadiatorsByRadiatorId: build.mutation<
      DeleteApiTaxonomyRadiatorsByRadiatorIdApiResponse,
      DeleteApiTaxonomyRadiatorsByRadiatorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}`,
        method: "DELETE",
      }),
    }),
    patchApiTaxonomyRadiatorsByRadiatorId: build.mutation<
      PatchApiTaxonomyRadiatorsByRadiatorIdApiResponse,
      PatchApiTaxonomyRadiatorsByRadiatorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/radiators/${queryArg.radiatorId}`,
      }),
    }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorId:
      build.mutation<
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiResponse,
        DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/radiators/${queryArg.radiatorId}`,
          method: "DELETE",
        }),
      }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/radiators/${queryArg.radiatorId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiTaxonomyRadiatorsByRadiatorIdSpecification: build.query<
      GetApiTaxonomyRadiatorsByRadiatorIdSpecificationApiResponse,
      GetApiTaxonomyRadiatorsByRadiatorIdSpecificationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}/specification`,
      }),
    }),
    putApiTaxonomyRadiatorsByRadiatorIdSpecification: build.mutation<
      PutApiTaxonomyRadiatorsByRadiatorIdSpecificationApiResponse,
      PutApiTaxonomyRadiatorsByRadiatorIdSpecificationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}/specification`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    patchApiTaxonomyRadiatorsByRadiatorIdInstallationFailed: build.mutation<
      PatchApiTaxonomyRadiatorsByRadiatorIdInstallationFailedApiResponse,
      PatchApiTaxonomyRadiatorsByRadiatorIdInstallationFailedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}/installation-failed`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdInstallationFailed:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdInstallationFailedApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdInstallationFailedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/radiators/${queryArg.radiatorId}/installation-failed`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    patchApiTaxonomyRadiatorsByRadiatorIdChecklist: build.mutation<
      PatchApiTaxonomyRadiatorsByRadiatorIdChecklistApiResponse,
      PatchApiTaxonomyRadiatorsByRadiatorIdChecklistApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}/checklist`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchApiTaxonomyRadiatorsByRadiatorIdVenting: build.mutation<
      PatchApiTaxonomyRadiatorsByRadiatorIdVentingApiResponse,
      PatchApiTaxonomyRadiatorsByRadiatorIdVentingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/radiators/${queryArg.radiatorId}/venting`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postApiRenters: build.mutation<
      PostApiRentersApiResponse,
      PostApiRentersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiRentersByRenterId: build.mutation<
      DeleteApiRentersByRenterIdApiResponse,
      DeleteApiRentersByRenterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/${queryArg.renterId}`,
        method: "DELETE",
      }),
    }),
    getApiRentersByRenterId: build.query<
      GetApiRentersByRenterIdApiResponse,
      GetApiRentersByRenterIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/renters/${queryArg.renterId}` }),
    }),
    patchApiRentersByRenterId: build.mutation<
      PatchApiRentersByRenterIdApiResponse,
      PatchApiRentersByRenterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/${queryArg.renterId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postApiRentersBulkUpdate: build.mutation<
      PostApiRentersBulkUpdateApiResponse,
      PostApiRentersBulkUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/bulk-update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiRentersImport: build.mutation<
      PostApiRentersImportApiResponse,
      PostApiRentersImportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/import`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiRentersBulkUpdateValidate: build.mutation<
      PostApiRentersBulkUpdateValidateApiResponse,
      PostApiRentersBulkUpdateValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/bulk-update/validate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiRentersImportValidate: build.mutation<
      PostApiRentersImportValidateApiResponse,
      PostApiRentersImportValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/import/validate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiRentersByRenterIdAgreementInfoReceived: build.mutation<
      PostApiRentersByRenterIdAgreementInfoReceivedApiResponse,
      PostApiRentersByRenterIdAgreementInfoReceivedApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/${queryArg.renterId}/agreement/info-received`,
        method: "POST",
      }),
    }),
    getApiRentersAgreementByRenterId: build.query<
      GetApiRentersAgreementByRenterIdApiResponse,
      GetApiRentersAgreementByRenterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/agreement/${queryArg.renterId}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/agreement/${queryArg.renterId}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdHistory:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdHistoryApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/agreement/${queryArg.renterId}/history`,
        }),
      }),
    getApiGlobalDeviceListRenters: build.query<
      GetApiGlobalDeviceListRentersApiResponse,
      GetApiGlobalDeviceListRentersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/renters`,
        params: {
          Name: queryArg.name,
          PhoneNumber: queryArg.phoneNumber,
          TenantIds: queryArg.tenantIds,
          Take: queryArg.take,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdSubRenters:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdSubRentersApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdSubRentersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/verifications/building-unit/${queryArg.buildingUnitId}/sub-renters`,
        }),
      }),
    getApiRentersVerificationsBuildingUnitByBuildingUnitIdExpired: build.query<
      GetApiRentersVerificationsBuildingUnitByBuildingUnitIdExpiredApiResponse,
      GetApiRentersVerificationsBuildingUnitByBuildingUnitIdExpiredApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/verifications/building-unit/${queryArg.buildingUnitId}/expired`,
        params: {
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsIncomplete:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsIncompleteApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsIncompleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/verifications/incomplete`,
          params: {
            Statuses: queryArg.statuses,
            "Sort.SortOption": queryArg["Sort.SortOption"],
            "Sort.Direction": queryArg["Sort.Direction"],
            Page: queryArg.page,
            PageSize: queryArg.pageSize,
          },
        }),
      }),
    getApiRentersVerificationsUsers: build.query<
      GetApiRentersVerificationsUsersApiResponse,
      GetApiRentersVerificationsUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/verifications/users`,
        params: {
          Query: queryArg.query,
          Take: queryArg.take,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUsers: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUsersApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/verifications/users`,
        params: {
          Query: queryArg.query,
          Take: queryArg.take,
        },
      }),
    }),
    getApiRentersVerificationsBuildingUnitByBuildingUnitId: build.query<
      GetApiRentersVerificationsBuildingUnitByBuildingUnitIdApiResponse,
      GetApiRentersVerificationsBuildingUnitByBuildingUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/verifications/building-unit/${queryArg.buildingUnitId}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/verifications/building-unit/${queryArg.buildingUnitId}`,
        }),
      }),
    getApiRentersVerificationsEmailByEmail: build.query<
      GetApiRentersVerificationsEmailByEmailApiResponse,
      GetApiRentersVerificationsEmailByEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/verifications/email/${queryArg.email}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsEmailEmail:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsEmailEmailApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsEmailEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/verifications/email/${queryArg.email}`,
        }),
      }),
    postApiRentersVerificationsOverrideByUserId: build.mutation<
      PostApiRentersVerificationsOverrideByUserIdApiResponse,
      PostApiRentersVerificationsOverrideByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/renters/verifications/override/${queryArg.userId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsOverrideUserId:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsOverrideUserIdApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsOverrideUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/verifications/override/${queryArg.userId}`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUnlinkUserId:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUnlinkUserIdApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUnlinkUserIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/renters/verifications/unlink/${queryArg.userId}`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiTaxonomyRoomsByRoomIdWindows: build.mutation<
      PostApiTaxonomyRoomsByRoomIdWindowsApiResponse,
      PostApiTaxonomyRoomsByRoomIdWindowsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rooms/${queryArg.roomId}/windows`,
        method: "POST",
      }),
    }),
    getApiTaxonomyRoomsByRoomIdWindows: build.query<
      GetApiTaxonomyRoomsByRoomIdWindowsApiResponse,
      GetApiTaxonomyRoomsByRoomIdWindowsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rooms/${queryArg.roomId}/windows`,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindows:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms/${queryArg.roomId}/windows`,
          method: "POST",
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindows: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms/${queryArg.roomId}/windows`,
      }),
    }),
    postApiTaxonomyRoomsByRoomIdWindowsAndWindowIdDuplicate: build.mutation<
      PostApiTaxonomyRoomsByRoomIdWindowsAndWindowIdDuplicateApiResponse,
      PostApiTaxonomyRoomsByRoomIdWindowsAndWindowIdDuplicateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rooms/${queryArg.roomId}/windows/${queryArg.windowId}/duplicate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyRoomsByRoomIdWindowsAndWindowId: build.query<
      GetApiTaxonomyRoomsByRoomIdWindowsAndWindowIdApiResponse,
      GetApiTaxonomyRoomsByRoomIdWindowsAndWindowIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rooms/${queryArg.roomId}/windows/${queryArg.windowId}`,
      }),
    }),
    deleteApiTaxonomyRoomsByRoomIdWindowsAndWindowId: build.mutation<
      DeleteApiTaxonomyRoomsByRoomIdWindowsAndWindowIdApiResponse,
      DeleteApiTaxonomyRoomsByRoomIdWindowsAndWindowIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rooms/${queryArg.roomId}/windows/${queryArg.windowId}`,
        method: "DELETE",
      }),
    }),
    postApiTaxonomyRooms: build.mutation<
      PostApiTaxonomyRoomsApiResponse,
      PostApiTaxonomyRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRooms: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyRoomsByRoomId: build.query<
      GetApiTaxonomyRoomsByRoomIdApiResponse,
      GetApiTaxonomyRoomsByRoomIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/taxonomy/rooms/${queryArg.roomId}` }),
    }),
    deleteApiTaxonomyRoomsByRoomId: build.mutation<
      DeleteApiTaxonomyRoomsByRoomIdApiResponse,
      DeleteApiTaxonomyRoomsByRoomIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rooms/${queryArg.roomId}`,
        method: "DELETE",
      }),
    }),
    patchApiTaxonomyRoomsByRoomId: build.mutation<
      PatchApiTaxonomyRoomsByRoomIdApiResponse,
      PatchApiTaxonomyRoomsByRoomIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rooms/${queryArg.roomId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms/${queryArg.roomId}`,
      }),
    }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomId: build.mutation<
      DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiResponse,
      DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms/${queryArg.roomId}`,
        method: "DELETE",
      }),
    }),
    patchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomId: build.mutation<
      PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiResponse,
      PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms/${queryArg.roomId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdTree: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdTreeApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdTreeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/rooms/${queryArg.roomId}/tree`,
      }),
    }),
    postApiSensors: build.mutation<
      PostApiSensorsApiResponse,
      PostApiSensorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiSensors: build.query<GetApiSensorsApiResponse, GetApiSensorsApiArg>({
      query: (queryArg) => ({
        url: `/api/sensors`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiSensorsAssignHeatingCircuitBySensorId: build.mutation<
      PostApiSensorsAssignHeatingCircuitBySensorIdApiResponse,
      PostApiSensorsAssignHeatingCircuitBySensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/assign-heating-circuit/${queryArg.sensorId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiSensorsAssignSpaceBySensorId: build.mutation<
      PostApiSensorsAssignSpaceBySensorIdApiResponse,
      PostApiSensorsAssignSpaceBySensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/assign-space/${queryArg.sensorId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiSensorsAssignWindowBySensorId: build.mutation<
      PostApiSensorsAssignWindowBySensorIdApiResponse,
      PostApiSensorsAssignWindowBySensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/assign-window/${queryArg.sensorId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiSensorsBySensorId: build.mutation<
      DeleteApiSensorsBySensorIdApiResponse,
      DeleteApiSensorsBySensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/${queryArg.sensorId}`,
        method: "DELETE",
      }),
    }),
    getApiSensorsBySensorId: build.query<
      GetApiSensorsBySensorIdApiResponse,
      GetApiSensorsBySensorIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/sensors/${queryArg.sensorId}` }),
    }),
    patchApiSensorsBySensorId: build.mutation<
      PatchApiSensorsBySensorIdApiResponse,
      PatchApiSensorsBySensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/${queryArg.sensorId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/sensors/${queryArg.sensorId}`,
      }),
    }),
    patchApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorId: build.mutation<
      PatchApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdApiResponse,
      PatchApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/sensors/${queryArg.sensorId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdLifecycleHistory:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdLifecycleHistoryApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdLifecycleHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/sensors/${queryArg.sensorId}/lifecycle-history`,
          params: {
            From: queryArg["from"],
            To: queryArg.to,
            Statuses: queryArg.statuses,
            "Sort.SortOption": queryArg["Sort.SortOption"],
            "Sort.Direction": queryArg["Sort.Direction"],
            Page: queryArg.page,
            PageSize: queryArg.pageSize,
          },
        }),
      }),
    getApiSensorsAutocomplete: build.query<
      GetApiSensorsAutocompleteApiResponse,
      GetApiSensorsAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/autocomplete`,
        params: {
          Eui: queryArg.eui,
          Assigned: queryArg.assigned,
          Placement: queryArg.placement,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdSensorsAutocomplete: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdSensorsAutocompleteApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdSensorsAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/sensors/autocomplete`,
        params: {
          Eui: queryArg.eui,
          Assigned: queryArg.assigned,
          Placement: queryArg.placement,
        },
      }),
    }),
    getApiSensorsSpaceBySpaceId: build.query<
      GetApiSensorsSpaceBySpaceIdApiResponse,
      GetApiSensorsSpaceBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/space/${queryArg.spaceId}`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdSensorsSpaceSpaceId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSpaceSpaceIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSpaceSpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/sensors/space/${queryArg.spaceId}`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiSensorsPairBySensorId: build.mutation<
      PostApiSensorsPairBySensorIdApiResponse,
      PostApiSensorsPairBySensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/pair/${queryArg.sensorId}`,
        method: "POST",
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdSensorsPairSensorId: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdSensorsPairSensorIdApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdSensorsPairSensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/sensors/pair/${queryArg.sensorId}`,
        method: "POST",
      }),
    }),
    postApiSensorsPairSpaceBySpaceId: build.mutation<
      PostApiSensorsPairSpaceBySpaceIdApiResponse,
      PostApiSensorsPairSpaceBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/pair/space/${queryArg.spaceId}`,
        method: "POST",
      }),
    }),
    postApiSensorsBySensorIdChirpstackConfiguration: build.mutation<
      PostApiSensorsBySensorIdChirpstackConfigurationApiResponse,
      PostApiSensorsBySensorIdChirpstackConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/${queryArg.sensorId}/chirpstack-configuration`,
        method: "POST",
      }),
    }),
    postApiSensorsUnassignBySensorId: build.mutation<
      PostApiSensorsUnassignBySensorIdApiResponse,
      PostApiSensorsUnassignBySensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/unassign/${queryArg.sensorId}`,
        method: "POST",
      }),
    }),
    postApiSensorsUnpairBySensorId: build.mutation<
      PostApiSensorsUnpairBySensorIdApiResponse,
      PostApiSensorsUnpairBySensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/unpair/${queryArg.sensorId}`,
        method: "POST",
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdSensorsUnpairSensorId: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdSensorsUnpairSensorIdApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdSensorsUnpairSensorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/sensors/unpair/${queryArg.sensorId}`,
        method: "POST",
      }),
    }),
    postApiSensorsUnpairSpaceBySpaceId: build.mutation<
      PostApiSensorsUnpairSpaceBySpaceIdApiResponse,
      PostApiSensorsUnpairSpaceBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/sensors/unpair/space/${queryArg.spaceId}`,
        method: "POST",
      }),
    }),
    getApiSignalTesterByEuiLastMeasurement: build.query<
      GetApiSignalTesterByEuiLastMeasurementApiResponse,
      GetApiSignalTesterByEuiLastMeasurementApiArg
    >({
      query: (queryArg) => ({
        url: `/api/signal-tester/${queryArg.eui}/last-measurement`,
      }),
    }),
    getApiSignalTesterAutocomplete: build.query<
      GetApiSignalTesterAutocompleteApiResponse,
      GetApiSignalTesterAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/signal-tester/autocomplete`,
        params: {
          Eui: queryArg.eui,
        },
      }),
    }),
    getApiTaxonomyBySpaceId: build.query<
      GetApiTaxonomyBySpaceIdApiResponse,
      GetApiTaxonomyBySpaceIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/taxonomy/${queryArg.spaceId}` }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyCountsSpaceTypeSpaceId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyCountsSpaceTypeSpaceIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyCountsSpaceTypeSpaceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy-counts/${queryArg.spaceType}/${queryArg.spaceId}`,
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHealthSpaceTypeSpaceId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHealthSpaceTypeSpaceIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHealthSpaceTypeSpaceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy-health/${queryArg.spaceType}/${queryArg.spaceId}`,
        }),
      }),
    patchApiTaxonomyRenameBySpaceId: build.mutation<
      PatchApiTaxonomyRenameBySpaceIdApiResponse,
      PatchApiTaxonomyRenameBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/rename/${queryArg.spaceId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchApiTaxonomyDescriptionBySpaceId: build.mutation<
      PatchApiTaxonomyDescriptionBySpaceIdApiResponse,
      PatchApiTaxonomyDescriptionBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/description/${queryArg.spaceId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postApiTaxonomyAssignedHeatingCircuitBySpaceId: build.mutation<
      PostApiTaxonomyAssignedHeatingCircuitBySpaceIdApiResponse,
      PostApiTaxonomyAssignedHeatingCircuitBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/assigned-heating-circuit/${queryArg.spaceId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedHeatingCircuitSpaceId:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedHeatingCircuitSpaceIdApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedHeatingCircuitSpaceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/assigned-heating-circuit/${queryArg.spaceId}`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiTaxonomyResetHeatingCircuitBySpaceId: build.mutation<
      PostApiTaxonomyResetHeatingCircuitBySpaceIdApiResponse,
      PostApiTaxonomyResetHeatingCircuitBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/reset-heating-circuit/${queryArg.spaceId}`,
        method: "POST",
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetHeatingCircuitSpaceId:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetHeatingCircuitSpaceIdApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetHeatingCircuitSpaceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/reset-heating-circuit/${queryArg.spaceId}`,
          method: "POST",
        }),
      }),
    postApiTaxonomyAssignedFloorsBySpaceId: build.mutation<
      PostApiTaxonomyAssignedFloorsBySpaceIdApiResponse,
      PostApiTaxonomyAssignedFloorsBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/assigned-floors/${queryArg.spaceId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedFloorsSpaceId:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedFloorsSpaceIdApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedFloorsSpaceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/assigned-floors/${queryArg.spaceId}`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiTaxonomyResetFloorsBySpaceId: build.mutation<
      PostApiTaxonomyResetFloorsBySpaceIdApiResponse,
      PostApiTaxonomyResetFloorsBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/reset-floors/${queryArg.spaceId}`,
        method: "POST",
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetFloorsSpaceId:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetFloorsSpaceIdApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetFloorsSpaceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/reset-floors/${queryArg.spaceId}`,
          method: "POST",
        }),
      }),
    postApiTaxonomyImport: build.mutation<
      PostApiTaxonomyImportApiResponse,
      PostApiTaxonomyImportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/import`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiTaxonomyImportByProjectId: build.mutation<
      PostApiTaxonomyImportByProjectIdApiResponse,
      PostApiTaxonomyImportByProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/import/${queryArg.projectId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportProjectId: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportProjectIdApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/import/${queryArg.projectId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiTaxonomyImportValidate: build.mutation<
      PostApiTaxonomyImportValidateApiResponse,
      PostApiTaxonomyImportValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/import/validate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportValidate: build.mutation<
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportValidateApiResponse,
      PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy/import/validate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTaxonomyExportBySpaceId: build.query<
      GetApiTaxonomyExportBySpaceIdApiResponse,
      GetApiTaxonomyExportBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/export/${queryArg.spaceId}`,
      }),
    }),
    getApiTaxonomyTenantExport: build.query<
      GetApiTaxonomyTenantExportApiResponse,
      GetApiTaxonomyTenantExportApiArg
    >({
      query: () => ({ url: `/api/taxonomy/tenant/export` }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdSpaceTelemetrySpaceId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdSpaceTelemetrySpaceIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdSpaceTelemetrySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/space-telemetry/${queryArg.spaceId}`,
      }),
    }),
    getApiTaxonomyGatewaysBySpaceId: build.query<
      GetApiTaxonomyGatewaysBySpaceIdApiResponse,
      GetApiTaxonomyGatewaysBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy/gateways/${queryArg.spaceId}`,
      }),
    }),
    getApiTaxonomyViewBuildingUnitByBuildingUnitId: build.query<
      GetApiTaxonomyViewBuildingUnitByBuildingUnitIdApiResponse,
      GetApiTaxonomyViewBuildingUnitByBuildingUnitIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy-view/building-unit/${queryArg.buildingUnitId}`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTaxonomyViewBuildingUnitBuildingUnitId:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyViewBuildingUnitBuildingUnitIdApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyViewBuildingUnitBuildingUnitIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/taxonomy-view/building-unit/${queryArg.buildingUnitId}`,
        }),
      }),
    getApiTaxonomyViewLocation: build.query<
      GetApiTaxonomyViewLocationApiResponse,
      GetApiTaxonomyViewLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/taxonomy-view/location`,
        params: {
          locationId: queryArg.locationId,
          buildingSearch: queryArg.buildingSearch,
          renterSearch: queryArg.renterSearch,
        },
      }),
    }),
    postApiTenants: build.mutation<
      PostApiTenantsApiResponse,
      PostApiTenantsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/tenants`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTenants: build.query<GetApiTenantsApiResponse, GetApiTenantsApiArg>({
      query: (queryArg) => ({
        url: `/api/tenants`,
        params: {
          OrganizationId: queryArg.organizationId,
          Name: queryArg.name,
          TenantIds: queryArg.tenantIds,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiTenantsByTenantId: build.query<
      GetApiTenantsByTenantIdApiResponse,
      GetApiTenantsByTenantIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/tenants/${queryArg.tenantId}` }),
    }),
    patchApiTenantsByTenantId: build.mutation<
      PatchApiTenantsByTenantIdApiResponse,
      PatchApiTenantsByTenantIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/tenants/${queryArg.tenantId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTenantsTargetTenantId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTenantsTargetTenantIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTenantsTargetTenantIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/tenants/${queryArg.targetTenantId}`,
      }),
    }),
    getApiTenantsByTenantIdOverview: build.query<
      GetApiTenantsByTenantIdOverviewApiResponse,
      GetApiTenantsByTenantIdOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/api/tenants/${queryArg.tenantId}/overview`,
      }),
    }),
    getApiTenantsAutocomplete: build.query<
      GetApiTenantsAutocompleteApiResponse,
      GetApiTenantsAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/tenants/autocomplete`,
        params: {
          OrganizationId: queryArg.organizationId,
          TenantName: queryArg.tenantName,
          Take: queryArg.take,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTenantsAutocomplete: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTenantsAutocompleteApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTenantsAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/tenants/autocomplete`,
        params: {
          OrganizationId: queryArg.organizationId,
          TenantName: queryArg.tenantName,
          Take: queryArg.take,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdTenants: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdTenantsApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdTenantsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/tenants`,
        params: {
          OrganizationId: queryArg.organizationId,
          Name: queryArg.name,
          TenantIds: queryArg.tenantIds,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiTermsOfUse: build.mutation<
      PostApiTermsOfUseApiResponse,
      PostApiTermsOfUseApiArg
    >({
      query: (queryArg) => ({
        url: `/api/terms-of-use`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiTermsOfUse: build.query<
      GetApiTermsOfUseApiResponse,
      GetApiTermsOfUseApiArg
    >({
      query: () => ({ url: `/api/terms-of-use` }),
    }),
    getApiTermsOfUseLatest: build.query<
      GetApiTermsOfUseLatestApiResponse,
      GetApiTermsOfUseLatestApiArg
    >({
      query: () => ({ url: `/api/terms-of-use/latest` }),
    }),
    getApiTermsOfUseById: build.query<
      GetApiTermsOfUseByIdApiResponse,
      GetApiTermsOfUseByIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/terms-of-use/${queryArg.id}` }),
    }),
    getApiGlobalDeviceListOperation: build.query<
      GetApiGlobalDeviceListOperationApiResponse,
      GetApiGlobalDeviceListOperationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/operation`,
        params: {
          LocationIds: queryArg.locationIds,
          ComplexIds: queryArg.complexIds,
          BuildingIds: queryArg.buildingIds,
          Floors: queryArg.floors,
          BuildingUnitIds: queryArg.buildingUnitIds,
          RenterIds: queryArg.renterIds,
          CustomerIds: queryArg.customerIds,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          BuildingUnitTypes: queryArg.buildingUnitTypes,
          RoomTypes: queryArg.roomTypes,
          FirmwareVersions: queryArg.firmwareVersions,
          HardwareVersions: queryArg.hardwareVersions,
          FirmwareUpdateStatuses: queryArg.firmwareUpdateStatuses,
          ThermostatIds: queryArg.thermostatIds,
          Assigned: queryArg.assigned,
          OperationModes: queryArg.operationModes,
          NetworkStatuses: queryArg.networkStatuses,
          "BatteryRange.Min": queryArg["BatteryRange.Min"],
          "BatteryRange.Max": queryArg["BatteryRange.Max"],
          BatteryVoltage: queryArg.batteryVoltage,
          LifecycleStatuses: queryArg.lifecycleStatuses,
          Calibration: queryArg.calibration,
          IsDirectMotorControlActive: queryArg.isDirectMotorControlActive,
          HydraulicBalancing: queryArg.hydraulicBalancing,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListOperation: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListOperationApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListOperationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/global-device-list/operation`,
        params: {
          LocationIds: queryArg.locationIds,
          ComplexIds: queryArg.complexIds,
          BuildingIds: queryArg.buildingIds,
          Floors: queryArg.floors,
          BuildingUnitIds: queryArg.buildingUnitIds,
          RenterIds: queryArg.renterIds,
          CustomerIds: queryArg.customerIds,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          BuildingUnitTypes: queryArg.buildingUnitTypes,
          RoomTypes: queryArg.roomTypes,
          FirmwareVersions: queryArg.firmwareVersions,
          HardwareVersions: queryArg.hardwareVersions,
          FirmwareUpdateStatuses: queryArg.firmwareUpdateStatuses,
          ThermostatIds: queryArg.thermostatIds,
          Assigned: queryArg.assigned,
          OperationModes: queryArg.operationModes,
          NetworkStatuses: queryArg.networkStatuses,
          "BatteryRange.Min": queryArg["BatteryRange.Min"],
          "BatteryRange.Max": queryArg["BatteryRange.Max"],
          BatteryVoltage: queryArg.batteryVoltage,
          LifecycleStatuses: queryArg.lifecycleStatuses,
          Calibration: queryArg.calibration,
          IsDirectMotorControlActive: queryArg.isDirectMotorControlActive,
          HydraulicBalancing: queryArg.hydraulicBalancing,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiGlobalDeviceListOperationExport: build.query<
      GetApiGlobalDeviceListOperationExportApiResponse,
      GetApiGlobalDeviceListOperationExportApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/operation/export`,
        params: {
          LocationIds: queryArg.locationIds,
          ComplexIds: queryArg.complexIds,
          BuildingIds: queryArg.buildingIds,
          Floors: queryArg.floors,
          BuildingUnitIds: queryArg.buildingUnitIds,
          RenterIds: queryArg.renterIds,
          CustomerIds: queryArg.customerIds,
          OrganizationIds: queryArg.organizationIds,
          TenantIds: queryArg.tenantIds,
          BuildingUnitTypes: queryArg.buildingUnitTypes,
          RoomTypes: queryArg.roomTypes,
          FirmwareVersions: queryArg.firmwareVersions,
          HardwareVersions: queryArg.hardwareVersions,
          FirmwareUpdateStatuses: queryArg.firmwareUpdateStatuses,
          ThermostatIds: queryArg.thermostatIds,
          Assigned: queryArg.assigned,
          OperationModes: queryArg.operationModes,
          NetworkStatuses: queryArg.networkStatuses,
          "BatteryRange.Min": queryArg["BatteryRange.Min"],
          "BatteryRange.Max": queryArg["BatteryRange.Max"],
          BatteryVoltage: queryArg.batteryVoltage,
          LifecycleStatuses: queryArg.lifecycleStatuses,
          Calibration: queryArg.calibration,
          IsDirectMotorControlActive: queryArg.isDirectMotorControlActive,
          HydraulicBalancing: queryArg.hydraulicBalancing,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiGlobalDeviceListProduction: build.query<
      GetApiGlobalDeviceListProductionApiResponse,
      GetApiGlobalDeviceListProductionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/global-device-list/production`,
        params: {
          "Sort.SortBy": queryArg["Sort.SortBy"],
          "Sort.SortDirection": queryArg["Sort.SortDirection"],
          DeviceType: queryArg.deviceType,
          HardwareVersions: queryArg.hardwareVersions,
          FirmwareVersions: queryArg.firmwareVersions,
          HealthStatus: queryArg.healthStatus,
          OperationModes: queryArg.operationModes,
          FirmwareStatuses: queryArg.firmwareStatuses,
          ProductionTimestamp: queryArg.productionTimestamp,
          Eui: queryArg.eui,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListProduction: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListProductionApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListProductionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/global-device-list/production`,
        params: {
          "Sort.SortBy": queryArg["Sort.SortBy"],
          "Sort.SortDirection": queryArg["Sort.SortDirection"],
          DeviceType: queryArg.deviceType,
          HardwareVersions: queryArg.hardwareVersions,
          FirmwareVersions: queryArg.firmwareVersions,
          HealthStatus: queryArg.healthStatus,
          OperationModes: queryArg.operationModes,
          FirmwareStatuses: queryArg.firmwareStatuses,
          ProductionTimestamp: queryArg.productionTimestamp,
          Eui: queryArg.eui,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiThermostatsAssignByThermostatId: build.mutation<
      PostApiThermostatsAssignByThermostatIdApiResponse,
      PostApiThermostatsAssignByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/assign/${queryArg.thermostatId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiThermostatsByThermostatId: build.mutation<
      DeleteApiThermostatsByThermostatIdApiResponse,
      DeleteApiThermostatsByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/${queryArg.thermostatId}`,
        method: "DELETE",
      }),
    }),
    getApiThermostatsByThermostatId: build.query<
      GetApiThermostatsByThermostatIdApiResponse,
      GetApiThermostatsByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/${queryArg.thermostatId}`,
      }),
    }),
    patchApiThermostatsByThermostatId: build.mutation<
      PatchApiThermostatsByThermostatIdApiResponse,
      PatchApiThermostatsByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/${queryArg.thermostatId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatId:
      build.mutation<
        DeleteApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiResponse,
        DeleteApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/${queryArg.thermostatId}`,
          method: "DELETE",
        }),
      }),
    getApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/${queryArg.thermostatId}`,
      }),
    }),
    patchApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatId:
      build.mutation<
        PatchApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiResponse,
        PatchApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/${queryArg.thermostatId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
      }),
    getApiThermostatsForDataTransfersByBuildingId: build.query<
      GetApiThermostatsForDataTransfersByBuildingIdApiResponse,
      GetApiThermostatsForDataTransfersByBuildingIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/for-data-transfers/${queryArg.buildingId}`,
        params: {
          FirmwareVersions: queryArg.firmwareVersions,
          "FingerprintHash.Value": queryArg["FingerprintHash.Value"],
          "FingerprintHash.Type": queryArg["FingerprintHash.Type"],
          BatteryLevelThreshold: queryArg.batteryLevelThreshold,
          BatteryVoltageThreshold: queryArg.batteryVoltageThreshold,
          ExcludeActiveTransfers: queryArg.excludeActiveTransfers,
          OperationModes: queryArg.operationModes,
          NetworkStatuses: queryArg.networkStatuses,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiThermostatsDataTransfersToThermostat: build.query<
      GetApiThermostatsDataTransfersToThermostatApiResponse,
      GetApiThermostatsDataTransfersToThermostatApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/data-transfers-to-thermostat`,
        params: {
          TenantId: queryArg.tenantId,
          Eui: queryArg.eui,
          BuildingIds: queryArg.buildingIds,
          "StartedAt.From": queryArg["StartedAt.From"],
          "StartedAt.To": queryArg["StartedAt.To"],
          "FinishedAt.From": queryArg["FinishedAt.From"],
          "FinishedAt.To": queryArg["FinishedAt.To"],
          Type: queryArg["type"],
          Name: queryArg.name,
          IsAutoFuota: queryArg.isAutoFuota,
          IsForced: queryArg.isForced,
          "FingerprintHash.Value": queryArg["FingerprintHash.Value"],
          "FingerprintHash.Type": queryArg["FingerprintHash.Type"],
          UserIds: queryArg.userIds,
          Status: queryArg.status,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiThermostatsAssemblyLineHistoryByEui: build.query<
      GetApiThermostatsAssemblyLineHistoryByEuiApiResponse,
      GetApiThermostatsAssemblyLineHistoryByEuiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/assembly-line-history/${queryArg.eui}`,
      }),
    }),
    getApiThermostatsByThermostatIdConnectivity: build.query<
      GetApiThermostatsByThermostatIdConnectivityApiResponse,
      GetApiThermostatsByThermostatIdConnectivityApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/${queryArg.thermostatId}/connectivity`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdConnectivity:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdConnectivityApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdConnectivityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/${queryArg.thermostatId}/connectivity`,
        }),
      }),
    getApiThermostatsDownlinks: build.query<
      GetApiThermostatsDownlinksApiResponse,
      GetApiThermostatsDownlinksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/downlinks`,
        params: {
          eui: queryArg.eui,
          from: queryArg["from"],
          to: queryArg.to,
          source: queryArg.source,
          code: queryArg.code,
          status: queryArg.status,
        },
      }),
    }),
    getApiThermostatsByThermostatIdLastmeasurements: build.query<
      GetApiThermostatsByThermostatIdLastmeasurementsApiResponse,
      GetApiThermostatsByThermostatIdLastmeasurementsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/${queryArg.thermostatId}/lastmeasurements`,
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdLastmeasurements:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdLastmeasurementsApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdLastmeasurementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/${queryArg.thermostatId}/lastmeasurements`,
        }),
      }),
    getApiThermostatsByThermostatIdOperationalStatus: build.query<
      GetApiThermostatsByThermostatIdOperationalStatusApiResponse,
      GetApiThermostatsByThermostatIdOperationalStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/${queryArg.thermostatId}/operational-status`,
      }),
    }),
    getApiThermostatsByThermostatIdRenter: build.query<
      GetApiThermostatsByThermostatIdRenterApiResponse,
      GetApiThermostatsByThermostatIdRenterApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/${queryArg.thermostatId}/renter`,
      }),
    }),
    getApiThermostatsAutocomplete: build.query<
      GetApiThermostatsAutocompleteApiResponse,
      GetApiThermostatsAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/autocomplete`,
        params: {
          Eui: queryArg.eui,
          Assigned: queryArg.assigned,
          Limit: queryArg.limit,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdThermostatsAutocomplete: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsAutocompleteApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/autocomplete`,
        params: {
          Eui: queryArg.eui,
          Assigned: queryArg.assigned,
          Limit: queryArg.limit,
        },
      }),
    }),
    getApiThermostats: build.query<
      GetApiThermostatsApiResponse,
      GetApiThermostatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiThermostatsSpaceBySpaceId: build.query<
      GetApiThermostatsSpaceBySpaceIdApiResponse,
      GetApiThermostatsSpaceBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/space/${queryArg.spaceId}`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdThermostatsSpaceSpaceId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsSpaceSpaceIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsSpaceSpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/space/${queryArg.spaceId}`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiThermostatsReportMalfunctionByThermostatId: build.mutation<
      PostApiThermostatsReportMalfunctionByThermostatIdApiResponse,
      PostApiThermostatsReportMalfunctionByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/report-malfunction/${queryArg.thermostatId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiThermostatsUnassignByThermostatId: build.mutation<
      PostApiThermostatsUnassignByThermostatIdApiResponse,
      PostApiThermostatsUnassignByThermostatIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/unassign/${queryArg.thermostatId}`,
        method: "POST",
      }),
    }),
    postApiThermostatsOperationsByThermostatIdDirectMotorControlDisable:
      build.mutation<
        PostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableApiResponse,
        PostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableApiArg
      >({
        query: (queryArg) => ({
          url: `/api/thermostats/operations/${queryArg.thermostatId}/direct-motor-control/disable`,
          method: "POST",
        }),
      }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlDisable:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlDisableApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlDisableApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/direct-motor-control/disable`,
          method: "POST",
        }),
      }),
    postApiThermostatsOperationsByThermostatIdDirectMotorControlEnable:
      build.mutation<
        PostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableApiResponse,
        PostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableApiArg
      >({
        query: (queryArg) => ({
          url: `/api/thermostats/operations/${queryArg.thermostatId}/direct-motor-control/enable`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlEnable:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlEnableApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlEnableApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/direct-motor-control/enable`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiThermostatsOperationsByThermostatIdFlushValve: build.mutation<
      PostApiThermostatsOperationsByThermostatIdFlushValveApiResponse,
      PostApiThermostatsOperationsByThermostatIdFlushValveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/operations/${queryArg.thermostatId}/flush-valve`,
        method: "POST",
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdFlushValve:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdFlushValveApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdFlushValveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/flush-valve`,
          method: "POST",
        }),
      }),
    postApiThermostatsOperationsByThermostatIdManualCalibration: build.mutation<
      PostApiThermostatsOperationsByThermostatIdManualCalibrationApiResponse,
      PostApiThermostatsOperationsByThermostatIdManualCalibrationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/operations/${queryArg.thermostatId}/manual-calibration`,
        method: "POST",
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdManualCalibration:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdManualCalibrationApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdManualCalibrationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/manual-calibration`,
          method: "POST",
        }),
      }),
    postApiThermostatsOperationsByThermostatIdMcuReset: build.mutation<
      PostApiThermostatsOperationsByThermostatIdMcuResetApiResponse,
      PostApiThermostatsOperationsByThermostatIdMcuResetApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/operations/${queryArg.thermostatId}/mcu-reset`,
        method: "POST",
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMcuReset:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMcuResetApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMcuResetApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/mcu-reset`,
          method: "POST",
        }),
      }),
    postApiThermostatsOperationsByThermostatIdDisplayRotation: build.mutation<
      PostApiThermostatsOperationsByThermostatIdDisplayRotationApiResponse,
      PostApiThermostatsOperationsByThermostatIdDisplayRotationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/operations/${queryArg.thermostatId}/display-rotation`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDisplayRotation:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDisplayRotationApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDisplayRotationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/display-rotation`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiThermostatsOperationsByThermostatIdMajorMode: build.mutation<
      PostApiThermostatsOperationsByThermostatIdMajorModeApiResponse,
      PostApiThermostatsOperationsByThermostatIdMajorModeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/operations/${queryArg.thermostatId}/major-mode`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMajorMode:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMajorModeApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMajorModeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/major-mode`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiThermostatsOperationsByThermostatIdMotorPositionConstraint:
      build.mutation<
        PostApiThermostatsOperationsByThermostatIdMotorPositionConstraintApiResponse,
        PostApiThermostatsOperationsByThermostatIdMotorPositionConstraintApiArg
      >({
        query: (queryArg) => ({
          url: `/api/thermostats/operations/${queryArg.thermostatId}/motor-position-constraint`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionConstraint:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionConstraintApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionConstraintApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/motor-position-constraint`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiThermostatsOperationsByThermostatIdMotorPosition: build.mutation<
      PostApiThermostatsOperationsByThermostatIdMotorPositionApiResponse,
      PostApiThermostatsOperationsByThermostatIdMotorPositionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/operations/${queryArg.thermostatId}/motor-position`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPosition:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/motor-position`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiThermostatsOperationsByThermostatIdTargetTemperature: build.mutation<
      PostApiThermostatsOperationsByThermostatIdTargetTemperatureApiResponse,
      PostApiThermostatsOperationsByThermostatIdTargetTemperatureApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/operations/${queryArg.thermostatId}/target-temperature`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperature:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/target-temperature`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiThermostatsOperationsByThermostatIdTargetTemperatureLevel:
      build.mutation<
        PostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelApiResponse,
        PostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/thermostats/operations/${queryArg.thermostatId}/target-temperature-level`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureLevel:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureLevelApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureLevelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/target-temperature-level`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivate:
      build.mutation<
        PostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateApiResponse,
        PostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/thermostats/operations/${queryArg.thermostatId}/toggle-active-harvesting/${queryArg.activate}`,
          method: "POST",
        }),
      }),
    postApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdToggleActiveHarvestingActivate:
      build.mutation<
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdToggleActiveHarvestingActivateApiResponse,
        PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdToggleActiveHarvestingActivateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/operations/${queryArg.thermostatId}/toggle-active-harvesting/${queryArg.activate}`,
          method: "POST",
        }),
      }),
    getApiThermostatsLifecycleReservationByReservationId: build.query<
      GetApiThermostatsLifecycleReservationByReservationIdApiResponse,
      GetApiThermostatsLifecycleReservationByReservationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/reservation/${queryArg.reservationId}`,
      }),
    }),
    postApiThermostatsLifecycleImportChirpstackOnboarding: build.mutation<
      PostApiThermostatsLifecycleImportChirpstackOnboardingApiResponse,
      PostApiThermostatsLifecycleImportChirpstackOnboardingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/import-chirpstack-onboarding`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiThermostatsLifecycleImportStatusChange: build.mutation<
      PostApiThermostatsLifecycleImportStatusChangeApiResponse,
      PostApiThermostatsLifecycleImportStatusChangeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/import-status-change`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiThermostatsLifecycleImportTenantReassign: build.mutation<
      PostApiThermostatsLifecycleImportTenantReassignApiResponse,
      PostApiThermostatsLifecycleImportTenantReassignApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/import-tenant-reassign`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiThermostatsLifecycleTenantReassignByThermostatEui: build.mutation<
      PostApiThermostatsLifecycleTenantReassignByThermostatEuiApiResponse,
      PostApiThermostatsLifecycleTenantReassignByThermostatEuiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/tenant-reassign/${queryArg.thermostatEui}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiThermostatsLifecycleReserve: build.mutation<
      PostApiThermostatsLifecycleReserveApiResponse,
      PostApiThermostatsLifecycleReserveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/reserve`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    patchApiThermostatsLifecycleByEuiLifecycleStatus: build.mutation<
      PatchApiThermostatsLifecycleByEuiLifecycleStatusApiResponse,
      PatchApiThermostatsLifecycleByEuiLifecycleStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/${queryArg.eui}/lifecycle-status`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postApiThermostatsLifecycleByEuiChirpstackOnboarding: build.mutation<
      PostApiThermostatsLifecycleByEuiChirpstackOnboardingApiResponse,
      PostApiThermostatsLifecycleByEuiChirpstackOnboardingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/${queryArg.eui}/chirpstack-onboarding`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiThermostatsLifecycleTenantUnassignByThermostatEui: build.mutation<
      PostApiThermostatsLifecycleTenantUnassignByThermostatEuiApiResponse,
      PostApiThermostatsLifecycleTenantUnassignByThermostatEuiApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/lifecycle/tenant-unassign/${queryArg.thermostatEui}`,
        method: "POST",
      }),
    }),
    getApiThermostatsThermostatHistory: build.query<
      GetApiThermostatsThermostatHistoryApiResponse,
      GetApiThermostatsThermostatHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/thermostat-history`,
        params: {
          From: queryArg["from"],
          To: queryArg.to,
          ThermostatId: queryArg.thermostatId,
          Types: queryArg.types,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatHistory:
      build.query<
        GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatHistoryApiResponse,
        GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/thermostats/thermostat-history`,
          params: {
            From: queryArg["from"],
            To: queryArg.to,
            ThermostatId: queryArg.thermostatId,
            Types: queryArg.types,
            "Sort.SortOption": queryArg["Sort.SortOption"],
            "Sort.Direction": queryArg["Sort.Direction"],
            Page: queryArg.page,
            PageSize: queryArg.pageSize,
          },
        }),
      }),
    getApiThermostatsThermostatHistoryRadiators: build.query<
      GetApiThermostatsThermostatHistoryRadiatorsApiResponse,
      GetApiThermostatsThermostatHistoryRadiatorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/thermostats/thermostat-history-radiators`,
        params: {
          RadiatorIds: queryArg.radiatorIds,
        },
      }),
    }),
    getApiGatewaysSpaceBySpaceId: build.query<
      GetApiGatewaysSpaceBySpaceIdApiResponse,
      GetApiGatewaysSpaceBySpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/gateways/space/${queryArg.spaceId}`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getApiV2OrgByOrgIdTenantAndTenantIdGatewaysSpaceSpaceId: build.query<
      GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysSpaceSpaceIdApiResponse,
      GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysSpaceSpaceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/org/${queryArg.orgId}/tenant/${queryArg.tenantId}/gateways/space/${queryArg.spaceId}`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiDevelopmentOnboardingSensors: build.mutation<
      PostApiDevelopmentOnboardingSensorsApiResponse,
      PostApiDevelopmentOnboardingSensorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/onboarding/sensors`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiDevelopmentOnboardingSignalTesters: build.mutation<
      PostApiDevelopmentOnboardingSignalTestersApiResponse,
      PostApiDevelopmentOnboardingSignalTestersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/development/onboarding/signal-testers`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generated };
export type GetApiSettingsApiResponse =
  /** status 200 OK */ AdminAppSettingsReadModel;
export type GetApiSettingsApiArg = void;
export type PutApiSettingsByCodeAndValueApiResponse = unknown;
export type PutApiSettingsByCodeAndValueApiArg = {
  code: AdminAppSettingCode;
  value: string;
};
export type GetApiAlertsThermostatsApiResponse =
  /** status 200 OK */ ThermostatAlertReadModelPagedListResult;
export type GetApiAlertsThermostatsApiArg = {
  from?: string;
  to?: string;
  alertTypes?: ThermostatAlertType[];
  thermostatIds?: string[];
  organizationIds?: string[];
  tenantIds?: string[];
  "Sort.SortOption"?: SortGetThermostatAlertsQueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdAlertsThermostatsApiResponse =
  /** status 200 OK */ ThermostatAlertReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdAlertsThermostatsApiArg = {
  from?: string;
  to?: string;
  alertTypes?: ThermostatAlertType[];
  thermostatIds?: string[];
  organizationIds?: string[];
  tenantIds?: string[];
  "Sort.SortOption"?: SortGetThermostatAlertsQueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type GetApiAlertsStatisticApiResponse =
  /** status 200 OK */ ThermostatAlertStatisticReadModel;
export type GetApiAlertsStatisticApiArg = {
  from?: string;
  to?: string;
  organizationIds?: string[];
  tenantIds?: string[];
};
export type GetApiAlertsEuiAutocompleteApiResponse =
  /** status 200 OK */ ThermostatWithAlertReadModel[];
export type GetApiAlertsEuiAutocompleteApiArg = {
  from?: string;
  to?: string;
  eui?: string;
  take?: number;
  crossTenant?: boolean;
};
export type PostApiAppointmentsApiResponse = /** status 200 OK */ string;
export type PostApiAppointmentsApiArg = {
  body: AddAppointmentRequest;
};
export type DeleteApiAppointmentsByAppointmentIdApiResponse = unknown;
export type DeleteApiAppointmentsByAppointmentIdApiArg = {
  appointmentId: string;
};
export type GetApiAppointmentsByAppointmentIdApiResponse =
  /** status 200 OK */ AppointmentReadModel;
export type GetApiAppointmentsByAppointmentIdApiArg = {
  appointmentId: string;
};
export type PatchApiAppointmentsByAppointmentIdApiResponse =
  /** status 200 OK */ string;
export type PatchApiAppointmentsByAppointmentIdApiArg = {
  appointmentId: string;
  body: UpdateAppointmentRequest;
};
export type GetApiAppointmentsBuildingUnitByBuildingUnitIdApiResponse =
  /** status 200 OK */ AppointmentReadModel[];
export type GetApiAppointmentsBuildingUnitByBuildingUnitIdApiArg = {
  buildingUnitId: string;
};
export type PostApiTaxonomyBuildingComplexesApiResponse =
  /** status 200 OK */ string;
export type PostApiTaxonomyBuildingComplexesApiArg = {
  body: AddBuildingComplexRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesApiArg =
  {
    orgId: string;
    tenantId: string;
    body: AddBuildingComplexRequest;
  };
export type GetApiTaxonomyBuildingComplexesByBuildingComplexIdApiResponse =
  /** status 200 OK */ BuildingComplexReadModel;
export type GetApiTaxonomyBuildingComplexesByBuildingComplexIdApiArg = {
  buildingComplexId: string;
};
export type DeleteApiTaxonomyBuildingComplexesByBuildingComplexIdApiResponse =
  unknown;
export type DeleteApiTaxonomyBuildingComplexesByBuildingComplexIdApiArg = {
  buildingComplexId: string;
};
export type PatchApiTaxonomyBuildingComplexesByBuildingComplexIdApiResponse =
  unknown;
export type PatchApiTaxonomyBuildingComplexesByBuildingComplexIdApiArg = {
  buildingComplexId: string;
  body: UpdateBuildingComplexRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiResponse =
  /** status 200 OK */ BuildingComplexReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiArg =
  {
    buildingComplexId: string;
    orgId: string;
    tenantId: string;
  };
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiArg =
  {
    buildingComplexId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdApiArg =
  {
    buildingComplexId: string;
    orgId: string;
    tenantId: string;
    body: UpdateBuildingComplexRequest;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdTreeApiResponse =
  /** status 200 OK */ BuildingComplexTreeReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdTreeApiArg =
  {
    buildingComplexId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiTaxonomyBuildingComplexesMoveToLocationApiResponse = unknown;
export type PostApiTaxonomyBuildingComplexesMoveToLocationApiArg = {
  body: MoveBuildingComplexesToLocationRequest;
};
export type PostApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsApiResponse =
  /** status 200 OK */ FloorReadModel;
export type PostApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsApiArg = {
  buildingComplexId: string;
  body: AddFloorRequest;
};
export type GetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsApiResponse =
  /** status 200 OK */ FloorReadModelPagedListResult;
export type GetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsApiArg = {
  buildingComplexId: string;
  page: number;
  pageSize: number;
};
export type GetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdApiResponse =
  /** status 200 OK */ FloorReadModel;
export type GetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdApiArg =
  {
    buildingComplexId: string;
    floorId: string;
  };
export type PatchApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdApiResponse =
  /** status 200 OK */ FloorReadModel;
export type PatchApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdApiArg =
  {
    floorId: string;
    buildingComplexId: string;
    body: UpdateFloorRequest;
  };
export type GetApiTaxonomyBuildingsByBuildingIdFloorsApiResponse =
  /** status 200 OK */ FloorReadModel[];
export type GetApiTaxonomyBuildingsByBuildingIdFloorsApiArg = {
  buildingId: string;
};
export type PostApiTaxonomyBuildingUnitsApiResponse =
  /** status 200 OK */ AddBuildingUnitReadModel;
export type PostApiTaxonomyBuildingUnitsApiArg = {
  body: AddBuildingUnitRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsApiResponse =
  /** status 200 OK */ AddBuildingUnitReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsApiArg = {
  orgId: string;
  tenantId: string;
  body: AddBuildingUnitRequest;
};
export type GetApiTaxonomyBuildingUnitsByBuildingUnitIdApiResponse =
  /** status 200 OK */ BuildingUnitReadModel;
export type GetApiTaxonomyBuildingUnitsByBuildingUnitIdApiArg = {
  buildingUnitId: string;
};
export type DeleteApiTaxonomyBuildingUnitsByBuildingUnitIdApiResponse = unknown;
export type DeleteApiTaxonomyBuildingUnitsByBuildingUnitIdApiArg = {
  buildingUnitId: string;
};
export type PatchApiTaxonomyBuildingUnitsByBuildingUnitIdApiResponse = unknown;
export type PatchApiTaxonomyBuildingUnitsByBuildingUnitIdApiArg = {
  buildingUnitId: string;
  body: UpdateBuildingUnitRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiResponse =
  /** status 200 OK */ BuildingUnitReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
  };
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
    body: UpdateBuildingUnitRequest;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdTreeApiResponse =
  /** status 200 OK */ BuildingUnitTreeReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdTreeApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiTaxonomyBuildingUnitsByBuildingUnitIdStatusApiResponse =
  unknown;
export type PatchApiTaxonomyBuildingUnitsByBuildingUnitIdStatusApiArg = {
  buildingUnitId: string;
  body: UpdateBuildingUnitStatusRequest;
};
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdStatusApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdStatusApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
    body: UpdateBuildingUnitStatusRequest;
  };
export type PostApiTaxonomyBuildingsApiResponse = /** status 200 OK */ string;
export type PostApiTaxonomyBuildingsApiArg = {
  body: AddBuildingRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsApiArg = {
  orgId: string;
  tenantId: string;
  body: AddBuildingRequest;
};
export type GetApiTaxonomyBuildingsByBuildingIdApiResponse =
  /** status 200 OK */ BuildingReadModel;
export type GetApiTaxonomyBuildingsByBuildingIdApiArg = {
  buildingId: string;
};
export type DeleteApiTaxonomyBuildingsByBuildingIdApiResponse = unknown;
export type DeleteApiTaxonomyBuildingsByBuildingIdApiArg = {
  buildingId: string;
};
export type PatchApiTaxonomyBuildingsByBuildingIdApiResponse = unknown;
export type PatchApiTaxonomyBuildingsByBuildingIdApiArg = {
  buildingId: string;
  body: UpdateBuildingRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiResponse =
  /** status 200 OK */ BuildingReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
  };
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
    body: UpdateBuildingRequest;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdTreeApiResponse =
  /** status 200 OK */ BuildingTreeReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdTreeApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiTaxonomyBuildingsByBuildingIdGatewaySignalTestApiResponse =
  /** status 200 OK */ string;
export type PostApiTaxonomyBuildingsByBuildingIdGatewaySignalTestApiArg = {
  buildingId: string;
  body: AddOrUpdateGatewaySignalQualityRequest;
};
export type GetApiTaxonomyBuildingsByBuildingIdGatewaySignalTestApiResponse =
  /** status 200 OK */ BuildingGatewaySignalTestResultReadModel;
export type GetApiTaxonomyBuildingsByBuildingIdGatewaySignalTestApiArg = {
  buildingId: string;
};
export type GetApiTaxonomyBuildingsByBuildingIdGatewayIssuesApiResponse =
  /** status 200 OK */ BuildingGatewayInstallationIssueReadModel;
export type GetApiTaxonomyBuildingsByBuildingIdGatewayIssuesApiArg = {
  buildingId: string;
};
export type PatchApiTaxonomyBuildingsByBuildingIdGatewayIssuesApiResponse =
  unknown;
export type PatchApiTaxonomyBuildingsByBuildingIdGatewayIssuesApiArg = {
  buildingId: string;
  body: UpdateGatewayInstallationIssuesRequest;
};
export type PatchApiTaxonomyBuildingsByBuildingIdGatewaySignalTestFloorApiResponse =
  /** status 200 OK */ string;
export type PatchApiTaxonomyBuildingsByBuildingIdGatewaySignalTestFloorApiArg =
  {
    buildingId: string;
    body: UpdateGatewaySignalQualityFloorRequest;
  };
export type PostApiDataPrivacyApiResponse = /** status 200 OK */ string;
export type PostApiDataPrivacyApiArg = {
  body: AddDataPrivacyRequest;
};
export type GetApiDataPrivacyApiResponse =
  /** status 200 OK */ DataPrivacyReadModel[];
export type GetApiDataPrivacyApiArg = void;
export type GetApiDataPrivacyByIdApiResponse =
  /** status 200 OK */ DataPrivacyReadModel;
export type GetApiDataPrivacyByIdApiArg = {
  id: string;
};
export type GetApiDataPrivacyLatestApiResponse =
  /** status 200 OK */ DataPrivacyReadModel;
export type GetApiDataPrivacyLatestApiArg = void;
export type PostApiDataPrivacySiteSignupApiResponse = unknown;
export type PostApiDataPrivacySiteSignupApiArg = {
  body: CreateDataPrivacyAgreementUserRequest;
};
export type PostApiDataPrivacySiteRevokeByTokenApiResponse =
  /** status 200 OK */ string;
export type PostApiDataPrivacySiteRevokeByTokenApiArg = {
  token: string;
};
export type GetApiDataPrivacySiteFilterApiResponse =
  /** status 200 OK */ DataPrivacyAgreementReadModelPagedListResult;
export type GetApiDataPrivacySiteFilterApiArg = {
  page?: number;
  pageSize?: number;
  "Sort.SortOption"?: SortGetDataPrivacyAgreementsQueryOptions;
  "Sort.Direction"?: SortDirection;
  personName?: string;
  city?: string;
  street?: string;
  houseNumber?: string;
  processed?: boolean;
};
export type PatchApiDataPrivacySiteByDataPrivacyAgreementIdApiResponse =
  unknown;
export type PatchApiDataPrivacySiteByDataPrivacyAgreementIdApiArg = {
  dataPrivacyAgreementId: string;
  body: UpdateDataPrivacyAgreementRequest;
};
export type DeleteApiDevelopmentAutoFuotaByAutoFuotaIdApiResponse = unknown;
export type DeleteApiDevelopmentAutoFuotaByAutoFuotaIdApiArg = {
  autoFuotaId: string;
};
export type PutApiDevelopmentAutoFuotaByAutoFuotaIdForceApiResponse = unknown;
export type PutApiDevelopmentAutoFuotaByAutoFuotaIdForceApiArg = {
  autoFuotaId: string;
};
export type GetApiDevelopmentAutoFuotaApiResponse =
  /** status 200 OK */ AutoFuotaThermostatRowPagedListResult;
export type GetApiDevelopmentAutoFuotaApiArg = {
  tenantId?: string;
  eui?: string;
  buildingIds?: string[];
  "ScheduledAt.From"?: string;
  "ScheduledAt.To"?: string;
  "StartedAt.From"?: string;
  "StartedAt.To"?: string;
  "FinishedAt.From"?: string;
  "FinishedAt.To"?: string;
  type?: DataTransferToDeviceType;
  name?: string;
  isForced?: boolean;
  "FingerprintHash.Value"?: string;
  "FingerprintHash.Type"?: StringFilterType;
  userIds?: string[];
  status?: DataTransferProgressStatus[];
  "Sort.SortOption"?: SortGetAutoFuotaThermostatsOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiDevelopmentGatewaysApiResponse =
  /** status 200 OK */ GatewayOpsRowPagedListResult;
export type GetApiDevelopmentGatewaysApiArg = {
  tenantId?: string;
  eui?: string;
  installationDone?: boolean;
  buildingIds?: string[];
  "LastSeen.From"?: string;
  "LastSeen.To"?: string;
  "LastThermostatUplinkAt.From"?: string;
  "LastThermostatUplinkAt.To"?: string;
  status?: DeviceNetworkStatus;
  "WanesyLastSeen.From"?: string;
  "WanesyLastSeen.To"?: string;
  wanesyStatus?: Status;
  "Sort.SortOption"?: SortGetGatewaysOpsOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdDevelopmentGatewaysApiResponse =
  /** status 200 OK */ GatewayOpsRowPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdDevelopmentGatewaysApiArg = {
  TenantId?: string;
  eui?: string;
  installationDone?: boolean;
  buildingIds?: string[];
  "LastSeen.From"?: string;
  "LastSeen.To"?: string;
  "LastThermostatUplinkAt.From"?: string;
  "LastThermostatUplinkAt.To"?: string;
  status?: DeviceNetworkStatus;
  "WanesyLastSeen.From"?: string;
  "WanesyLastSeen.To"?: string;
  wanesyStatus?: Status;
  "Sort.SortOption"?: SortGetGatewaysOpsOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type GetApiDevelopmentGatewaysByGatewayIdThermostatsApiResponse =
  /** status 200 OK */ GatewayThermostatOpsRowPagedListResult;
export type GetApiDevelopmentGatewaysByGatewayIdThermostatsApiArg = {
  gatewayId: string;
  tenantId?: string;
  eui?: string;
  "Hash.Value"?: string;
  "Hash.Type"?: StringFilterType;
  mode?: MajorMode[];
  "Snr.From"?: number;
  "Snr.To"?: number;
  "SpreadingFactor.From"?: number;
  "SpreadingFactor.To"?: number;
  buildingIds?: string[];
  dataTransferToDeviceOngoing?: boolean;
  "Sort.SortOption"?: SortGetGatewayThermostatsOpsOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type PostApiDevelopmentDataTransferFromDeviceByThermostatIdAbortApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferFromDeviceByThermostatIdAbortApiArg =
  {
    notifyDevice?: boolean;
    forced?: boolean;
    thermostatId: string;
  };
export type GetApiDevelopmentDataTransferFromDeviceByTransferIdDownloadApiResponse =
  /** status 200 OK */ Blob;
export type GetApiDevelopmentDataTransferFromDeviceByTransferIdDownloadApiArg =
  {
    transferId: string;
  };
export type PostApiDevelopmentDataTransferFromDeviceByThermostatIdFlashApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferFromDeviceByThermostatIdFlashApiArg =
  {
    thermostatId: string;
    body: FetchThermostatFlashRequest;
  };
export type PostApiDevelopmentDataTransferFromDeviceByThermostatIdLogsApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferFromDeviceByThermostatIdLogsApiArg = {
  thermostatId: string;
  body: FetchThermostatLogsRequest;
};
export type PostApiDevelopmentDataTransferFromDeviceByThermostatIdRamApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferFromDeviceByThermostatIdRamApiArg = {
  thermostatId: string;
  body: FetchThermostatRamRequest;
};
export type GetApiDevelopmentDataTransferFromDeviceTransfersApiResponse =
  /** status 200 OK */ DataTransferFromThermostatRowPagedListResult;
export type GetApiDevelopmentDataTransferFromDeviceTransfersApiArg = {
  eui?: string;
  buildingIds?: string[];
  "StartedAt.From"?: string;
  "StartedAt.To"?: string;
  bankId?: TermiosBankId;
  name?: string;
  "FingerprintHash.Value"?: string;
  "FingerprintHash.Type"?: StringFilterType;
  userIds?: string[];
  status?: DataTransferProgressStatus[];
  "LastReceivedAt.From"?: string;
  "LastReceivedAt.To"?: string;
  page: number;
  pageSize: number;
};
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdAbortApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdAbortApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchDataTransferAbortRequest;
};
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdGetAppsInfoApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdGetAppsInfoApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchDataTransferGetAppsInfoRequest;
  };
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdInstallCoreApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdInstallCoreApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchDataTransferInstallCoreRequest;
  };
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdPauseApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdPauseApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchDataTransferPauseRequest;
};
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdResumeApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdResumeApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchDataTransferResumeRequest;
};
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdSendAppApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdSendAppApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchDataTransferSendAppRequest;
  };
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdSendCoreApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdSendCoreApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchDataTransferSendCoreRequest;
  };
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdSendStaticDataApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdSendStaticDataApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchDataTransferSendStaticDataRequest;
  };
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdSpeedUpApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkDataTransferByThermostatIdSpeedUpApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchDataTransferSpeedUpRequest;
  };
export type PostApiDevelopmentDataTransferToDeviceAbortByThermostatIdApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceAbortByThermostatIdApiArg = {
  notifyDevice?: boolean;
  forced?: boolean;
  thermostatId: string;
};
export type PostApiDevelopmentDataTransferToDeviceBulkUploadAppByBuildingIdAndAppIdVersionKeyApiResponse =
  /** status 200 OK */ ScheduleBulkDataTransferResult;
export type PostApiDevelopmentDataTransferToDeviceBulkUploadAppByBuildingIdAndAppIdVersionKeyApiArg =
  {
    firmwareVersions?: number[];
    "FingerprintHash.Value"?: string;
    "FingerprintHash.Type"?: StringFilterType;
    batteryLevelThreshold?: number;
    batteryVoltageThreshold?: number;
    buildingId: string;
    appId: TermiosAppId;
    versionKey: number;
    autoFuota?: boolean;
    forced?: boolean;
  };
export type PostApiDevelopmentDataTransferToDeviceBulkUploadBinaryByBuildingIdApiResponse =
  /** status 200 OK */ ScheduleBulkDataTransferResult;
export type PostApiDevelopmentDataTransferToDeviceBulkUploadBinaryByBuildingIdApiArg =
  {
    firmwareVersions?: number[];
    "FingerprintHash.Value"?: string;
    "FingerprintHash.Type"?: StringFilterType;
    batteryLevelThreshold?: number;
    batteryVoltageThreshold?: number;
    buildingId: string;
    autoFuota?: boolean;
    forced?: boolean;
    body: {
      TransferType?: DataTransferToDeviceType;
      File?: Blob;
      Name?: string;
    };
  };
export type PostApiDevelopmentDataTransferToDeviceBulkUploadCoreByBuildingIdAndVersionKeyApiResponse =
  /** status 200 OK */ ScheduleBulkDataTransferResult;
export type PostApiDevelopmentDataTransferToDeviceBulkUploadCoreByBuildingIdAndVersionKeyApiArg =
  {
    firmwareVersions?: number[];
    "FingerprintHash.Value"?: string;
    "FingerprintHash.Type"?: StringFilterType;
    batteryLevelThreshold?: number;
    batteryVoltageThreshold?: number;
    buildingId: string;
    versionKey: number;
    autoFuota?: boolean;
    forced?: boolean;
  };
export type GetApiDevelopmentFirmwareUpdateDashboardApiResponse =
  /** status 200 OK */ FirmwareUpdateDashboardRow[];
export type GetApiDevelopmentFirmwareUpdateDashboardApiArg = {
  hardware?: number;
  firmware?: number;
  euiPrefix?: string;
  status?: ThermostatArtifactStatus[];
  updating?: boolean;
  deviceInProgress?: boolean;
};
export type PostApiDevelopmentFirmwareUpdateDashboardApiResponse = unknown;
export type PostApiDevelopmentFirmwareUpdateDashboardApiArg = {
  hardware?: number;
  firmware?: number;
  euiPrefix?: string;
  status?: ThermostatArtifactStatus[];
};
export type PutApiDevelopmentDataTransferToDeviceForceByThermostatIdApiResponse =
  unknown;
export type PutApiDevelopmentDataTransferToDeviceForceByThermostatIdApiArg = {
  thermostatId: string;
};
export type GetApiDevelopmentDataTransferToDeviceApiResponse =
  /** status 200 OK */ DataTransferToDeviceResult[];
export type GetApiDevelopmentDataTransferToDeviceApiArg = {
  eui?: string;
  type?: DataTransferToDeviceType;
  name?: string;
  startedFrom?: string;
  startedTo?: string;
  hash?: string;
};
export type GetApiDevelopmentFirmwareInfoByThermostatIdApiResponse =
  /** status 200 OK */ ThermostatFirmwareInfoReadModel;
export type GetApiDevelopmentFirmwareInfoByThermostatIdApiArg = {
  thermostatId: string;
};
export type PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadAppAndAppIdMajorMinorPatchApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadAppAndAppIdMajorMinorPatchApiArg =
  {
    appId: TermiosAppId;
    major: number;
    minor: number;
    patch: number;
    autoFuota?: boolean;
    forced?: boolean;
    thermostatId: string;
  };
export type PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadBinaryApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadBinaryApiArg =
  {
    autoFuota?: boolean;
    forced?: boolean;
    thermostatId: string;
    body: {
      TransferType?: DataTransferToDeviceType;
      File?: Blob;
      Name?: string;
    };
  };
export type PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreAndMajorMinorPatchApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreAndMajorMinorPatchApiArg =
  {
    major: number;
    minor: number;
    patch: number;
    autoFuota?: boolean;
    forced?: boolean;
    thermostatId: string;
  };
export type PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreByKeyAndKeyApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreByKeyAndKeyApiArg =
  {
    key: number;
    autoFuota?: boolean;
    forced?: boolean;
    thermostatId: string;
  };
export type PostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdApiArg =
  {
    batchId: string;
  };
export type PostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdPhaseAndPhaseIdApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdPhaseAndPhaseIdApiArg =
  {
    batchId: string;
    phaseId: string;
  };
export type PostApiDevelopmentDataTransferToDeviceBatchesCreateCoreBatchByMajorAndMinorPatchApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceBatchesCreateCoreBatchByMajorAndMinorPatchApiArg =
  {
    major: number;
    minor: number;
    patch: number;
    body: {
      File?: Blob;
      AcceptedTenantIds?: string[];
      Notes?: string;
    };
  };
export type PostApiDevelopmentDataTransferToDeviceBatchesCreateAppBatchByAppIdAndMajorMinorPatchApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceBatchesCreateAppBatchByAppIdAndMajorMinorPatchApiArg =
  {
    appId: TermiosAppId;
    major: number;
    minor: number;
    patch: number;
    body: {
      File?: Blob;
      AcceptedTenantIds?: string[];
      Notes?: string;
    };
  };
export type PostApiDevelopmentDataTransferToDeviceBatchesPhaseApiResponse =
  unknown;
export type PostApiDevelopmentDataTransferToDeviceBatchesPhaseApiArg = {
  body: CreateDataTransferToDeviceBatchPhaseRequest;
};
export type GetApiDevelopmentDataTransferToDeviceBatchesExportByBatchIdApiResponse =
  /** status 200 OK */ Blob;
export type GetApiDevelopmentDataTransferToDeviceBatchesExportByBatchIdApiArg =
  {
    batchId: string;
  };
export type GetApiDevelopmentDataTransferToDeviceBatchesApiResponse =
  /** status 200 OK */ DataTransferToDeviceBatchReadModelPagedListResult;
export type GetApiDevelopmentDataTransferToDeviceBatchesApiArg = {
  page: number;
  pageSize: number;
  "Name.Value"?: string;
  "Name.Type"?: StringFilterType;
  "Note.Value"?: string;
  "Note.Type"?: StringFilterType;
  createdBy?: string;
  "CreatedAt.From"?: string;
  "CreatedAt.To"?: string;
  statuses?: DataTransferToDeviceBatchStatus[];
  "Sort.SortOption"?: SortGetDataTransferToDeviceBatchesQueryOptions;
  "Sort.Direction"?: SortDirection;
};
export type GetApiDevelopmentDataTransferToDeviceBatchesPhaseByBatchIdApiResponse =
  /** status 200 OK */ DataTransferToDeviceBatchPhaseReadModelPagedListResult;
export type GetApiDevelopmentDataTransferToDeviceBatchesPhaseByBatchIdApiArg = {
  page: number;
  pageSize: number;
  batchId: string;
};
export type PostApiDevelopmentDataTransferToDeviceBatchesPreviewApiResponse =
  /** status 200 OK */ DataTransferToDeviceBatchPreviewReadModel;
export type PostApiDevelopmentDataTransferToDeviceBatchesPreviewApiArg = {
  body: {
    file?: Blob;
  };
};
export type GetApiDevelopmentThermostatOperationsApiResponse =
  /** status 200 OK */ ThermostatOperationOpsRowPagedListResult;
export type GetApiDevelopmentThermostatOperationsApiArg = {
  tenantId?: string;
  eui?: string;
  buildingIds?: string[];
  code?: ThermostatOperationCode;
  "StartedAt.From"?: string;
  "StartedAt.To"?: string;
  "LastUpdatedAt.From"?: string;
  "LastUpdatedAt.To"?: string;
  completed?: boolean;
  success?: boolean;
  userIds?: string[];
  "Sort.SortOption"?: SortGetThermostatOperationsOpsOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type PostApiDevelopmentDownlinkByThermostatIdGeneralGetInfoApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdGeneralGetInfoApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchGeneralGetInfoRequest;
};
export type PostApiDevelopmentDownlinkByThermostatIdMcuResetApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdMcuResetApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchMcuResetRequest;
};
export type PostApiDevelopmentDownlinkByThermostatIdSetDisplayRotationApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSetDisplayRotationApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchSetDisplayRotationRequest;
};
export type PostApiDevelopmentDownlinkByThermostatIdSetMajorModeApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSetMajorModeApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchSetMajorModeRequest;
};
export type PostApiDevelopmentDownlinkByThermostatIdSetMotorPositionConstraintApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSetMotorPositionConstraintApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchSetMotorPositionConstraintRequest;
  };
export type PostApiDevelopmentDownlinkByThermostatIdSetMotorPositionApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSetMotorPositionApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchSetMotorPositionRequest;
};
export type PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureAndLevelApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureAndLevelApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: TriggerThermostatSetTargetTemperatureAndLevelDownlinkRequest;
  };
export type PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: TriggerThermostatSetTargetTemperatureDownlinkRequest;
  };
export type PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchSetTargetTemperatureLevelRequest;
  };
export type PostApiDevelopmentDownlinkByThermostatIdToggleDirectMotorControlApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdToggleDirectMotorControlApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchToggleDirectMotorControlRequest;
  };
export type PostApiDevelopmentDownlinkByThermostatIdMotorOutwardStallDetectionApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdMotorOutwardStallDetectionApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
  };
export type PostApiDevelopmentDownlinkByThermostatIdMotorInwardStallDetectionApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdMotorInwardStallDetectionApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
  };
export type PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelMappingApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelMappingApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: TriggerThermostatSetTargetTemperatureLevelMappingDownlinkRequest;
  };
export type PostApiDevelopmentDownlinkByThermostatIdConfigureMeasurementsApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdConfigureMeasurementsApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    thermostatId: string;
    body: DispatchConfigureMeasurementsRequest;
  };
export type PostApiDevelopmentDownlinkByThermostatIdSuperBlockGcApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdSuperBlockGcApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchSuperBlockGcRequest;
};
export type PostApiDevelopmentDownlinkByThermostatIdAutoCalibrationClosedValveThresholdApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdAutoCalibrationClosedValveThresholdApiArg =
  {
    ignoreVersion?: boolean;
    expirationMinutes?: number;
    makeDefault?: boolean;
    thermostatId: string;
    body: TriggerConfigureAutoCalibrationClosedValveThresholdRequest;
  };
export type PutApiDevelopmentDownlinkByThermostatIdAmbientTemperatureApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PutApiDevelopmentDownlinkByThermostatIdAmbientTemperatureApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: TriggerSetAmbientTemperatureRequest;
};
export type PostApiDevelopmentDownlinkByThermostatIdAppDataApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdAppDataApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchSendAppDataRequest;
};
export type PostApiDevelopmentDownlinkByThermostatIdHexCommandApiResponse =
  /** status 200 OK */ DownlinkResponse;
export type PostApiDevelopmentDownlinkByThermostatIdHexCommandApiArg = {
  ignoreVersion?: boolean;
  expirationMinutes?: number;
  thermostatId: string;
  body: DispatchHexCommandRequest;
};
export type PostApiDevelopmentInvokeErrorApiResponse = unknown;
export type PostApiDevelopmentInvokeErrorApiArg = void;
export type GetApiDevelopmentChirpstackDeviceConfigurationDataApiResponse =
  /** status 200 OK */ ChirpstackOnboardingConfigurationData;
export type GetApiDevelopmentChirpstackDeviceConfigurationDataApiArg = void;
export type PostApiDevelopmentOnboardingThermostatsApiResponse =
  /** status 200 OK */ OnboardDevicesReport;
export type PostApiDevelopmentOnboardingThermostatsApiArg = {
  body: {
    TenantId?: string;
    ChirpstackApplicationId?: string;
    ChirpstackDeviceProfileId?: string;
    SkipChirpstack?: boolean;
    SkipAdminApp?: boolean;
    File?: Blob;
  };
};
export type PostApiDevelopmentAssemblyLineDetailApiResponse =
  /** status 200 OK */ Blob;
export type PostApiDevelopmentAssemblyLineDetailApiArg = {
  body: AssemblyLineExportDetailRequest;
};
export type PostApiDevelopmentAssemblyLineSummaryApiResponse =
  /** status 200 OK */ Blob;
export type PostApiDevelopmentAssemblyLineSummaryApiArg = {
  body: AssemblyLineExportSummaryRequest;
};
export type GetApiDevelopmentArtifactsFirmwareCoreApiResponse =
  /** status 200 OK */ FirmwareCoreDetailsResult[];
export type GetApiDevelopmentArtifactsFirmwareCoreApiArg = {
  major?: number;
  minor?: number;
  patch?: number;
  hwrev?: number;
};
export type PostApiDevelopmentArtifactsFirmwareCoreApiResponse =
  /** status 200 OK */ FirmwareCoreDetailsResult;
export type PostApiDevelopmentArtifactsFirmwareCoreApiArg = {
  body: {
    "MainFile.File"?: Blob;
    "MainFile.Signature"?: Blob;
    "CompressedFile.File"?: Blob;
    "CompressedFile.Signature"?: Blob;
  };
};
export type DeleteApiDevelopmentArtifactsFirmwareCoreByMajorAndMinorPatchApiResponse =
  unknown;
export type DeleteApiDevelopmentArtifactsFirmwareCoreByMajorAndMinorPatchApiArg =
  {
    major: number;
    minor: number;
    patch: number;
  };
export type GetApiDevelopmentArtifactsTermiosAppApiResponse =
  /** status 200 OK */ TermiosAppDetailsResult[];
export type GetApiDevelopmentArtifactsTermiosAppApiArg = {
  appId?: TermiosAppId;
  major?: number;
  minor?: number;
  patch?: number;
  fw?: number;
  fwmin?: number;
};
export type PostApiDevelopmentArtifactsTermiosAppApiResponse =
  /** status 200 OK */ TermiosAppDetailsResult;
export type PostApiDevelopmentArtifactsTermiosAppApiArg = {
  body: {
    "MainFile.File"?: Blob;
    "MainFile.Signature"?: Blob;
    "CompressedFile.File"?: Blob;
    "CompressedFile.Signature"?: Blob;
  };
};
export type DeleteApiDevelopmentArtifactsTermiosAppByAppIdAndMajorMinorPatchApiResponse =
  unknown;
export type DeleteApiDevelopmentArtifactsTermiosAppByAppIdAndMajorMinorPatchApiArg =
  {
    appId: TermiosAppId;
    major: number;
    minor: number;
    patch: number;
  };
export type GetApiDevicesBuildingDeviceMetadataByBuildingIdApiResponse =
  unknown;
export type GetApiDevicesBuildingDeviceMetadataByBuildingIdApiArg = {
  buildingId: string;
};
export type GetApiDevicesByDeviceTypeImageAndImageIdApiResponse =
  /** status 200 OK */ GetDeviceImageReadModel;
export type GetApiDevicesByDeviceTypeImageAndImageIdApiArg = {
  deviceType: string;
  imageId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageImageIdApiResponse =
  /** status 200 OK */ GetDeviceImageReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageImageIdApiArg =
  {
    deviceType: string;
    imageId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiDevicesImagesByBuildingIdBulkApiResponse = unknown;
export type PostApiDevicesImagesByBuildingIdBulkApiArg = {
  buildingId: string;
  body: DeviceType[];
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdDevicesImagesBuildingIdBulkApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdDevicesImagesBuildingIdBulkApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
    body: DeviceType[];
  };
export type GetApiDevicesByDeviceTypeImageMetadataAndDeviceIdApiResponse =
  /** status 200 OK */ DeviceImageMetadataReadModel[];
export type GetApiDevicesByDeviceTypeImageMetadataAndDeviceIdApiArg = {
  deviceId: string;
  deviceType: DeviceType;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageMetadataDeviceIdApiResponse =
  /** status 200 OK */ DeviceImageMetadataReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageMetadataDeviceIdApiArg =
  {
    deviceId: string;
    deviceType: DeviceType;
    orgId: string;
    tenantId: string;
  };
export type GetApiFilesFileTemplateByTemplateApiResponse =
  /** status 200 OK */ Blob;
export type GetApiFilesFileTemplateByTemplateApiArg = {
  template: TemplateFile;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdFilesFileTemplateTemplateApiResponse =
  /** status 200 OK */ Blob;
export type GetApiV2OrgByOrgIdTenantAndTenantIdFilesFileTemplateTemplateApiArg =
  {
    template: TemplateFile;
    orgId: string;
    tenantId: string;
  };
export type GetApiGlobalDeviceListComplexesApiResponse =
  /** status 200 OK */ BuildingComplexFilterReadModel[];
export type GetApiGlobalDeviceListComplexesApiArg = {
  complexName?: string;
  locationIds?: string[];
  tenantIds?: string[];
  take?: number;
};
export type GetApiGlobalDeviceListBuildingFloorsApiResponse =
  /** status 200 OK */ FloorFilterReadModel[];
export type GetApiGlobalDeviceListBuildingFloorsApiArg = {
  buildingIds?: string[];
};
export type GetApiGlobalDeviceListBuildingsApiResponse =
  /** status 200 OK */ BuildingFilterReadModel[];
export type GetApiGlobalDeviceListBuildingsApiArg = {
  buildingName?: string;
  complexIds?: string[];
  locationIds?: string[];
  tenantIds?: string[];
  take?: number;
};
export type GetApiGlobalDeviceListBuildingUnitsApiResponse =
  /** status 200 OK */ BuildingUnitFilterReadModel[];
export type GetApiGlobalDeviceListBuildingUnitsApiArg = {
  buildingIds?: string[];
};
export type GetApiGlobalDeviceListFirmwareVersionsApiResponse =
  /** status 200 OK */ FirmwareVersionReadModel[];
export type GetApiGlobalDeviceListFirmwareVersionsApiArg = void;
export type GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListSensorsApiResponse =
  /** status 200 OK */ SensorGlobalListReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListSensorsApiArg = {
  eui?: string;
  organizationIds?: string[];
  tenantIds?: string[];
  lifecycleStatuses?: SensorLifecycleStatus[];
  placements?: SensorPlacement[];
  types?: SensorType[];
  pairingStatuses?: SensorPairingStatus[];
  networkStatuses?: DeviceNetworkStatus[];
  assigned?: boolean;
  "Sort.SortOption"?: SortGetGlobalSensorListQueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type GetApiGlobalDeviceListHardwareVersionsApiResponse =
  /** status 200 OK */ HardwareRevisionReadModel[];
export type GetApiGlobalDeviceListHardwareVersionsApiArg = void;
export type GetApiGlobalDeviceListLocationsApiResponse =
  /** status 200 OK */ LocationFilterReadModel[];
export type GetApiGlobalDeviceListLocationsApiArg = {
  locationName?: string;
  tenantIds?: string[];
  take?: number;
};
export type GetApiGlobalDeviceListSpaceCustomersApiResponse =
  /** status 200 OK */ SpaceCustomerReadModel[];
export type GetApiGlobalDeviceListSpaceCustomersApiArg = {
  customerId?: string;
  tenantIds?: string[];
  take?: number;
};
export type PostApiGlobalDeviceListThermostatsApiResponse =
  /** status 200 OK */ ThermostatDeviceListReadModel[];
export type PostApiGlobalDeviceListThermostatsApiArg = {
  body: GetThermostatsAutocompleteRequest;
};
export type PostApiGatewaysApiResponse =
  /** status 200 OK */ GatewayDetailReadModel;
export type PostApiGatewaysApiArg = {
  body: AddGatewayRequest;
};
export type GetApiGatewaysApiResponse =
  /** status 200 OK */ GatewayReadModelPagedListResult;
export type GetApiGatewaysApiArg = {
  page?: number;
  pageSize?: number;
  organizationId?: string;
  onlyUnassigned?: boolean;
};
export type PostApiGatewaysAssignByGatewayIdApiResponse = unknown;
export type PostApiGatewaysAssignByGatewayIdApiArg = {
  gatewayId: string;
  body: AssignGatewayRequest;
};
export type DeleteApiGatewaysByGatewayIdApiResponse = unknown;
export type DeleteApiGatewaysByGatewayIdApiArg = {
  gatewayId: string;
};
export type GetApiGatewaysByGatewayIdApiResponse =
  /** status 200 OK */ GatewayDetailReadModel;
export type GetApiGatewaysByGatewayIdApiArg = {
  gatewayId: string;
};
export type PatchApiGatewaysByGatewayIdApiResponse =
  /** status 200 OK */ GatewayDetailReadModel;
export type PatchApiGatewaysByGatewayIdApiArg = {
  gatewayId: string;
  body: UpdateGatewayRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdApiResponse =
  /** status 200 OK */ GatewayDetailReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdApiArg = {
  gatewayId: string;
  orgId: string;
  tenantId: string;
};
export type PatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdApiResponse =
  /** status 200 OK */ GatewayDetailReadModel;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdApiArg = {
  gatewayId: string;
  orgId: string;
  tenantId: string;
  body: UpdateGatewayRequest;
};
export type GetApiGatewaysAutocompleteApiResponse =
  /** status 200 OK */ GatewayAutocompleteReadModel[];
export type GetApiGatewaysAutocompleteApiArg = {
  eui?: string;
  assigned?: boolean;
  networkStatus?: DeviceNetworkStatus;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysAutocompleteApiResponse =
  /** status 200 OK */ GatewayAutocompleteReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysAutocompleteApiArg = {
  eui?: string;
  assigned?: boolean;
  networkStatus?: DeviceNetworkStatus;
  orgId: string;
  tenantId: string;
};
export type GetApiGatewaysExportApiResponse = unknown;
export type GetApiGatewaysExportApiArg = {
  euis?: string[];
  organizationIds?: string[];
  tenantIds?: string[];
  locationIds?: string[];
  buildingComplexIds?: string[];
  buildingIds?: string[];
  iccids?: number[];
  kerosVersions?: string[];
  placement?: GatewayPlacement[];
  networkStatuses?: DeviceNetworkStatus[];
  signalStrengths?: number[];
  wanesyConnectionStatuses?: Status[];
  assigned?: boolean;
  sortBy?: GetGlobalGatewayListQuerySortProperty;
  sortDirection?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiGatewaysListApiResponse =
  /** status 200 OK */ GatewayGlobalListReadModelPagedListResult;
export type GetApiGatewaysListApiArg = {
  euis?: string[];
  organizationIds?: string[];
  tenantIds?: string[];
  locationIds?: string[];
  buildingComplexIds?: string[];
  buildingIds?: string[];
  iccids?: number[];
  kerosVersions?: string[];
  placement?: GatewayPlacement[];
  networkStatuses?: DeviceNetworkStatus[];
  signalStrengths?: number[];
  wanesyConnectionStatuses?: Status[];
  assigned?: boolean;
  sortBy?: GetGlobalGatewayListQuerySortProperty;
  sortDirection?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysListApiResponse =
  /** status 200 OK */ GatewayGlobalListReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysListApiArg = {
  euis?: string[];
  organizationIds?: string[];
  tenantIds?: string[];
  locationIds?: string[];
  buildingComplexIds?: string[];
  buildingIds?: string[];
  iccids?: number[];
  kerosVersions?: string[];
  placement?: GatewayPlacement[];
  networkStatuses?: DeviceNetworkStatus[];
  signalStrengths?: number[];
  wanesyConnectionStatuses?: Status[];
  assigned?: boolean;
  sortBy?: GetGlobalGatewayListQuerySortProperty;
  sortDirection?: SortDirection;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type GetApiGatewaysSearchApiResponse =
  /** status 200 OK */ GatewayReadModel[];
export type GetApiGatewaysSearchApiArg = {
  euis?: string[];
  tenantIds?: string[];
  page: number;
  pageSize: number;
};
export type PostApiGatewaysImportTenantReassignApiResponse =
  /** status 200 OK */ ImportGatewaysTenantsReport;
export type PostApiGatewaysImportTenantReassignApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiGatewaysReassignTenantByGatewayEuiApiResponse = unknown;
export type PostApiGatewaysReassignTenantByGatewayEuiApiArg = {
  gatewayEui: string;
  body: ReassignTenantGatewayRequest;
};
export type PostApiGatewaysUnassignByGatewayIdApiResponse = unknown;
export type PostApiGatewaysUnassignByGatewayIdApiArg = {
  gatewayId: string;
};
export type PatchApiGatewaysByGatewayIdInstallationProcessApiResponse = unknown;
export type PatchApiGatewaysByGatewayIdInstallationProcessApiArg = {
  gatewayId: string;
  body: UpdateGatewayInstallationProcessRequest;
};
export type PatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdInstallationProcessApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdInstallationProcessApiArg =
  {
    gatewayId: string;
    orgId: string;
    tenantId: string;
    body: UpdateGatewayInstallationProcessRequest;
  };
export type PostApiGatewayOnboarderGatewayApiResponse =
  /** status 200 OK */ CreateGatewayResponse;
export type PostApiGatewayOnboarderGatewayApiArg = {
  body: CreateGatewayRequest;
};
export type GetApiHeatingClampsByBuildingIdStatisticsApiResponse =
  /** status 200 OK */ BuildingTemperatureStatisticsReadModel;
export type GetApiHeatingClampsByBuildingIdStatisticsApiArg = {
  buildingId: string;
};
export type GetApiHeatingClampsByBuildingIdThermostatsApiResponse =
  /** status 200 OK */ HeatingClampsThermostatReadModel[];
export type GetApiHeatingClampsByBuildingIdThermostatsApiArg = {
  buildingId: string;
};
export type PutApiHeatingClampsDefaultApiResponse = unknown;
export type PutApiHeatingClampsDefaultApiArg = {
  body: ResetHeatingClampsRequest;
};
export type PutApiHeatingClampsApiResponse = unknown;
export type PutApiHeatingClampsApiArg = {
  body: SetHeatingClampsRequest;
};
export type GetApiHeatingLoadByBuildingIdCompletionStatisticApiResponse =
  /** status 200 OK */ HeatLoadBuildingCompletionReadModel;
export type GetApiHeatingLoadByBuildingIdCompletionStatisticApiArg = {
  buildingId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdCompletionStatisticApiResponse =
  /** status 200 OK */ HeatLoadBuildingCompletionReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdCompletionStatisticApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiHeatingLoadByBuildingIdNonResidentialUnitsApiResponse =
  /** status 200 OK */ HeatLoadNonResidentialUnitsReadModel;
export type GetApiHeatingLoadByBuildingIdNonResidentialUnitsApiArg = {
  buildingId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdNonResidentialUnitsApiResponse =
  /** status 200 OK */ HeatLoadNonResidentialUnitsReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdNonResidentialUnitsApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiHeatingLoadByBuildingIdEmptyBuildingUnitsApiResponse =
  /** status 200 OK */ HeatLoadEmptyBuildingUnitsReadModelPagedListResult;
export type GetApiHeatingLoadByBuildingIdEmptyBuildingUnitsApiArg = {
  buildingId: string;
  "Sort.SortOption"?: HeatLoadCalcEmptyBuildingUnitsSortOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdEmptyBuildingUnitsApiResponse =
  /** status 200 OK */ HeatLoadEmptyBuildingUnitsReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdEmptyBuildingUnitsApiArg =
  {
    buildingId: string;
    "Sort.SortOption"?: HeatLoadCalcEmptyBuildingUnitsSortOptions;
    "Sort.Direction"?: SortDirection;
    page: number;
    pageSize: number;
    orgId: string;
    tenantId: string;
  };
export type GetApiHeatingLoadByBuildingIdAttemptsApiResponse =
  /** status 200 OK */ HeatLoadCalculationAttemptReadModelPagedListResult;
export type GetApiHeatingLoadByBuildingIdAttemptsApiArg = {
  buildingId: string;
  "Sort.SortOption"?: HeatLoadCalcAttemptsSortOptions;
  "Sort.Direction"?: SortDirection;
  statusFilter?: HeatLoadCalculationAttemptStatus;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdAttemptsApiResponse =
  /** status 200 OK */ HeatLoadCalculationAttemptReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdAttemptsApiArg =
  {
    buildingId: string;
    "Sort.SortOption"?: HeatLoadCalcAttemptsSortOptions;
    "Sort.Direction"?: SortDirection;
    statusFilter?: HeatLoadCalculationAttemptStatus;
    page: number;
    pageSize: number;
    orgId: string;
    tenantId: string;
  };
export type GetApiHeatingLoadByAttemptIdExportApiResponse =
  /** status 200 OK */ GetHeatingLoadExcelExportResponse;
export type GetApiHeatingLoadByAttemptIdExportApiArg = {
  attemptId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadAttemptIdExportApiResponse =
  /** status 200 OK */ GetHeatingLoadExcelExportResponse;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadAttemptIdExportApiArg =
  {
    attemptId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiHeatingLoadByBuildingIdValidationApiResponse =
  /** status 200 OK */ GetHeatingLoadValidationStatusResponse;
export type GetApiHeatingLoadByBuildingIdValidationApiArg = {
  buildingId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdValidationApiResponse =
  /** status 200 OK */ GetHeatingLoadValidationStatusResponse;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdValidationApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiHeatingLoadByBuildingIdInvalidRoomsApiResponse =
  /** status 200 OK */ HeatLoadMissingRoomDataReadModelPagedListResult;
export type GetApiHeatingLoadByBuildingIdInvalidRoomsApiArg = {
  buildingId: string;
  "Sort.SortOption"?: HeatLoadCalcInvalidRoomsSortOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdInvalidRoomsApiResponse =
  /** status 200 OK */ HeatLoadMissingRoomDataReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdInvalidRoomsApiArg =
  {
    buildingId: string;
    "Sort.SortOption"?: HeatLoadCalcInvalidRoomsSortOptions;
    "Sort.Direction"?: SortDirection;
    page: number;
    pageSize: number;
    orgId: string;
    tenantId: string;
  };
export type PostApiHeatingLoadStartCalculationJobApiResponse = unknown;
export type PostApiHeatingLoadStartCalculationJobApiArg = {
  body: StartHeatingLoadCalculationJobRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadStartCalculationJobApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadStartCalculationJobApiArg =
  {
    orgId: string;
    tenantId: string;
    body: StartHeatingLoadCalculationJobRequest;
  };
export type PostApiHydraulicBalancingManageApiResponse = unknown;
export type PostApiHydraulicBalancingManageApiArg = {
  body: ManageHydraulicBalancingRequest;
};
export type PatchApiHydraulicBalancingAttemptsByAttemptIdSettingsApiResponse =
  unknown;
export type PatchApiHydraulicBalancingAttemptsByAttemptIdSettingsApiArg = {
  attemptId: string;
  body: UpdateHydraulicBalancingAttemptSettingsRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationInitialMotorPositionConstraintsFillMissingApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationInitialMotorPositionConstraintsFillMissingApiArg =
  {
    heatingCircuitId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiHydraulicBalancingVdzCalculationAttemptsByAttemptIdExportApiResponse =
  unknown;
export type GetApiHydraulicBalancingVdzCalculationAttemptsByAttemptIdExportApiArg =
  {
    attemptId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingVdzCalculationAttemptsAttemptIdExportApiResponse =
  unknown;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingVdzCalculationAttemptsAttemptIdExportApiArg =
  {
    attemptId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationValidateApiResponse =
  /** status 200 OK */ GetVdzValidationReadModel;
export type GetApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationValidateApiArg =
  {
    heatingCircuitId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationValidateApiResponse =
  /** status 200 OK */ GetVdzValidationReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationValidateApiArg =
  {
    heatingCircuitId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationRunApiResponse =
  /** status 200 OK */ StartVdzCalculationReadModel;
export type PostApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationRunApiArg =
  {
    heatingCircuitId: string;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationRunApiResponse =
  /** status 200 OK */ StartVdzCalculationReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationRunApiArg =
  {
    heatingCircuitId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiHydraulicBalancingImportRadiatorPowerApiResponse =
  /** status 200 OK */ RadiatorPowerImportValidationReadModel;
export type PostApiHydraulicBalancingImportRadiatorPowerApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerApiResponse =
  /** status 200 OK */ RadiatorPowerImportValidationReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerApiArg =
  {
    orgId: string;
    tenantId: string;
    body: {
      File?: Blob;
    };
  };
export type PostApiHydraulicBalancingImportRadiatorPowerValidateApiResponse =
  /** status 200 OK */ RadiatorPowerImportValidationReadModel;
export type PostApiHydraulicBalancingImportRadiatorPowerValidateApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerValidateApiResponse =
  /** status 200 OK */ RadiatorPowerImportValidationReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerValidateApiArg =
  {
    orgId: string;
    tenantId: string;
    body: {
      File?: Blob;
    };
  };
export type GetApiInstallToolProjectsByProjectIdApiResponse =
  /** status 200 OK */ InstallToolProjectReadModel;
export type GetApiInstallToolProjectsByProjectIdApiArg = {
  projectId: string;
};
export type GetApiInstallToolProjectsApiResponse =
  /** status 200 OK */ InstallToolProjectReadModel[];
export type GetApiInstallToolProjectsApiArg = {
  query?: string;
};
export type GetApiInstallToolBuildingByFloorsByBuildingIdApiResponse =
  /** status 200 OK */ InstallationToolBuildingByFloorDetailReadModel;
export type GetApiInstallToolBuildingByFloorsByBuildingIdApiArg = {
  buildingId: string;
};
export type GetApiInstallToolBuildingsApiResponse =
  /** status 200 OK */ InstallationToolBuildingListReadModelPagedListResult;
export type GetApiInstallToolBuildingsApiArg = {
  projectId?: string;
  query?: string;
  page: number;
  pageSize: number;
};
export type GetApiInstallToolBuildingUnitsByBuildingUnitIdApiResponse =
  /** status 200 OK */ InstallationToolBuildingUnitDetailReadModel;
export type GetApiInstallToolBuildingUnitsByBuildingUnitIdApiArg = {
  buildingUnitId: string;
};
export type GetApiInstallToolGatewaysApiResponse =
  /** status 200 OK */ GatewayReadModel[];
export type GetApiInstallToolGatewaysApiArg = {
  spaceId?: string;
};
export type GetApiInstallToolAppointmentsByProjectIdApiResponse =
  /** status 200 OK */ InstallationToolProjectAppointmentsReadModel;
export type GetApiInstallToolAppointmentsByProjectIdApiArg = {
  projectId: string;
  fromUtc?: string;
  toUtc?: string;
};
export type GetApiInstallToolRadiatorsByRadiatorIdApiResponse =
  /** status 200 OK */ InstallationToolRadiatorDetailReadModel;
export type GetApiInstallToolRadiatorsByRadiatorIdApiArg = {
  radiatorId: string;
};
export type GetApiInstallToolRoomsByRoomIdApiResponse =
  /** status 200 OK */ InstallationToolRoomDetailReadModel;
export type GetApiInstallToolRoomsByRoomIdApiArg = {
  roomId: string;
};
export type GetApiInstallToolRadiatorSpecificationCatalogueApiResponse =
  /** status 200 OK */ RadiatorSpecificationCatalogueReadModel;
export type GetApiInstallToolRadiatorSpecificationCatalogueApiArg = void;
export type PatchApiInstallToolGatewaysBuildingsByBuildingIdApiResponse =
  unknown;
export type PatchApiInstallToolGatewaysBuildingsByBuildingIdApiArg = {
  buildingId: string;
  body: UpdateInstallationToolBuildingDetailsRequest;
};
export type GetApiInstallToolGatewaysBuildingsByBuildingIdApiResponse =
  /** status 200 OK */ InstallationToolGatewayBuildingReadModel;
export type GetApiInstallToolGatewaysBuildingsByBuildingIdApiArg = {
  buildingId: string;
};
export type PostApiThermostatsAssignWithChecksAndImageByThermostatIdApiResponse =
  unknown;
export type PostApiThermostatsAssignWithChecksAndImageByThermostatIdApiArg = {
  thermostatId: string;
  body: {
    RadiatorId?: string;
    ValvePinChecked?: boolean;
    ValveIsInPositionZero?: boolean;
    ValveCheckedForLeakage?: boolean;
    ThermostatMounted?: boolean;
    ThermostatTurnedOn?: boolean;
    Image?: Blob;
    FileName?: string;
  };
};
export type GetApiInstallToolGatewaysBuildingsApiResponse =
  /** status 200 OK */ InstallationToolGatewayBuildingReadModel[];
export type GetApiInstallToolGatewaysBuildingsApiArg = {
  projectId?: string;
  searchBy?: string;
  gatewayInstallationNeeded?: boolean;
  "Sort.SortOption"?: GatewayInstallationBuildingsSortOptions;
  "Sort.Direction"?: SortDirection;
};
export type PostApiInstallToolByDeviceIdAndDeviceTypeImagesApiResponse =
  unknown;
export type PostApiInstallToolByDeviceIdAndDeviceTypeImagesApiArg = {
  deviceId: string;
  deviceType: DeviceType;
  body: {
    images?: ImageReadModel[];
  };
};
export type GetApiKerlinkCheckByEuiApiResponse = unknown;
export type GetApiKerlinkCheckByEuiApiArg = {
  eui: string;
};
export type PostApiKerlinkProvisionByEuiApiResponse = unknown;
export type PostApiKerlinkProvisionByEuiApiArg = {
  eui: string;
};
export type PostApiLeasesApiResponse =
  /** status 200 OK */ AddLeaseWithRenterReadModel;
export type PostApiLeasesApiArg = {
  body: AddLeaseRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdLeasesApiResponse =
  /** status 200 OK */ AddLeaseWithRenterReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdLeasesApiArg = {
  orgId: string;
  tenantId: string;
  body: AddLeaseRequest;
};
export type DeleteApiLeasesByLeaseIdApiResponse = unknown;
export type DeleteApiLeasesByLeaseIdApiArg = {
  leaseId: string;
};
export type GetApiLeasesByLeaseIdApiResponse =
  /** status 200 OK */ LeaseReadModel;
export type GetApiLeasesByLeaseIdApiArg = {
  leaseId: string;
};
export type PatchApiLeasesByLeaseIdApiResponse =
  /** status 200 OK */ UpdateLeaseWithRenterReadModel;
export type PatchApiLeasesByLeaseIdApiArg = {
  leaseId: string;
  body: UpdateLeaseWithRenterRequest;
};
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiArg = {
  leaseId: string;
  orgId: string;
  tenantId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiResponse =
  /** status 200 OK */ LeaseReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiArg = {
  leaseId: string;
  orgId: string;
  tenantId: string;
};
export type PatchApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiResponse =
  /** status 200 OK */ UpdateLeaseWithRenterReadModel;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdApiArg = {
  leaseId: string;
  orgId: string;
  tenantId: string;
  body: UpdateLeaseWithRenterRequest;
};
export type GetApiLeasesBuildingUnitByBuildingUnitIdActiveApiResponse =
  /** status 200 OK */ ActiveLeaseReadModel[];
export type GetApiLeasesBuildingUnitByBuildingUnitIdActiveApiArg = {
  buildingUnitId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdActiveApiResponse =
  /** status 200 OK */ ActiveLeaseReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdActiveApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiLeasesBuildingUnitByBuildingUnitIdApiResponse =
  /** status 200 OK */ LeaseItemReadModel[];
export type GetApiLeasesBuildingUnitByBuildingUnitIdApiArg = {
  buildingUnitId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdApiResponse =
  /** status 200 OK */ LeaseItemReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiLegalNoteApiResponse = /** status 200 OK */ string;
export type PostApiLegalNoteApiArg = {
  body: AddLegalNoteRequest;
};
export type GetApiLegalNoteApiResponse =
  /** status 200 OK */ LegalNoteReadModel[];
export type GetApiLegalNoteApiArg = void;
export type GetApiLegalNoteLatestApiResponse =
  /** status 200 OK */ LegalNoteReadModel;
export type GetApiLegalNoteLatestApiArg = void;
export type GetApiLegalNoteByIdApiResponse =
  /** status 200 OK */ LegalNoteReadModel;
export type GetApiLegalNoteByIdApiArg = {
  id: string;
};
export type GetApiLocationAutocompleteLocationsApiResponse =
  /** status 200 OK */ GeocodingReadModel[];
export type GetApiLocationAutocompleteLocationsApiArg = {
  searchBy?: string;
  limit?: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdLocationAutocompleteLocationsApiResponse =
  /** status 200 OK */ GeocodingReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdLocationAutocompleteLocationsApiArg =
  {
    searchBy?: string;
    limit?: number;
    orgId: string;
    tenantId: string;
  };
export type PostApiTaxonomyLocationsApiResponse = /** status 200 OK */ string;
export type PostApiTaxonomyLocationsApiArg = {
  body: AddLocationRequest;
};
export type GetApiTaxonomyLocationsApiResponse =
  /** status 200 OK */ LocationListReadModelPagedListResult;
export type GetApiTaxonomyLocationsApiArg = {
  locationSearch?: string;
  renterSearch?: string;
  page: number;
  pageSize: number;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsApiArg = {
  orgId: string;
  tenantId: string;
  body: AddLocationRequest;
};
export type GetApiTaxonomyLocationsByLocationIdApiResponse =
  /** status 200 OK */ LocationReadModel;
export type GetApiTaxonomyLocationsByLocationIdApiArg = {
  locationId: string;
};
export type DeleteApiTaxonomyLocationsByLocationIdApiResponse = unknown;
export type DeleteApiTaxonomyLocationsByLocationIdApiArg = {
  locationId: string;
};
export type PatchApiTaxonomyLocationsByLocationIdApiResponse = unknown;
export type PatchApiTaxonomyLocationsByLocationIdApiArg = {
  locationId: string;
  body: UpdateLocationRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiResponse =
  /** status 200 OK */ LocationReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiArg =
  {
    locationId: string;
    orgId: string;
    tenantId: string;
  };
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiArg =
  {
    locationId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdApiArg =
  {
    locationId: string;
    orgId: string;
    tenantId: string;
    body: UpdateLocationRequest;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdTreeApiResponse =
  /** status 200 OK */ LocationTreeReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdTreeApiArg =
  {
    locationId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiTaxonomyLocationsByLocationIdResyncApiResponse = unknown;
export type PostApiTaxonomyLocationsByLocationIdResyncApiArg = {
  locationId: string;
};
export type PostApiTaxonomyLocationsByLocationIdHeatingCircuitsApiResponse =
  /** status 200 OK */ string;
export type PostApiTaxonomyLocationsByLocationIdHeatingCircuitsApiArg = {
  locationId: string;
  body: AddHeatingCircuitRequest;
};
export type GetApiTaxonomyLocationsByLocationIdHeatingCircuitsApiResponse =
  /** status 200 OK */ HeatingCircuitReadModel[];
export type GetApiTaxonomyLocationsByLocationIdHeatingCircuitsApiArg = {
  locationId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdChainApiResponse =
  /** status 200 OK */ HeatingCircuitChainReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdChainApiArg =
  {
    heatingCircuitId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdApiResponse =
  /** status 200 OK */ HeatingCircuitDetailReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdApiArg =
  {
    heatingCircuitId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdApiArg =
  {
    heatingCircuitId: string;
    orgId: string;
    tenantId: string;
    body: UpdateHeatingCircuitRequest;
  };
export type GetApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiResponse =
  /** status 200 OK */ HeatingCircuitReadModel;
export type GetApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiArg =
  {
    locationId: string;
    heatingCircuitId: string;
  };
export type DeleteApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiResponse =
  unknown;
export type DeleteApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiArg =
  {
    locationId: string;
    heatingCircuitId: string;
  };
export type PatchApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiResponse =
  unknown;
export type PatchApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdApiArg =
  {
    heatingCircuitId: string;
    locationId: string;
    body: UpdateHeatingCircuitRequest;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdHeatingCircuitsApiResponse =
  /** status 200 OK */ HeatingCircuitReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdHeatingCircuitsApiArg =
  {
    locationId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsSpaceTypeSpaceIdApiResponse =
  /** status 200 OK */ HeatingCircuitDetailReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsSpaceTypeSpaceIdApiArg =
  {
    spaceType: SpaceType;
    spaceId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdThermostatsApiResponse =
  /** status 200 OK */ HeatingCircuitThermostatReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdThermostatsApiArg =
  {
    heatingCircuitId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdActivitiesApiResponse =
  /** status 200 OK */ NonResiActivityListReadModelPagedListResult;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdActivitiesApiArg = {
  from?: string;
  to?: string;
  types?: NonResiActivityType[];
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingModesTemperaturesApiResponse =
  /** status 200 OK */ NonResiHeatingModeTemperatureReadModel[];
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingModesTemperaturesApiArg =
  {
    orgId: string;
    tenantId: string;
  };
export type PostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsApiResponse =
  /** status 200 OK */ NonResiHeatingPlanAssignmentCreatedReadModel;
export type PostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsApiArg =
  {
    buildingId: string;
    floorId: string;
    orgId: string;
    tenantId: string;
    body: CreateNonResiHeatingPlanAssignmentRequest;
  };
export type PostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsApiResponse =
  /** status 200 OK */ NonResiHeatingPlanAssignmentCreatedReadModel;
export type PostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsApiArg =
  {
    nodeType: SpaceType;
    nodeId: string;
    orgId: string;
    tenantId: string;
    body: CreateNonResiHeatingPlanAssignmentRequest;
  };
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsAssignmentIdApiResponse =
  /** status 200 OK */ NonResiHeatingPlanAssignmentDeletedReadModel;
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsAssignmentIdApiArg =
  {
    buildingId: string;
    floorId: string;
    assignmentId: string;
    orgId: string;
    tenantId: string;
  };
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsAssignmentIdApiResponse =
  /** status 200 OK */ NonResiHeatingPlanAssignmentDeletedReadModel;
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsAssignmentIdApiArg =
  {
    nodeType: SpaceType;
    nodeId: string;
    assignmentId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanApiResponse =
  /** status 200 OK */ NonResiHeatingPlanAssignmentNodeReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanApiArg =
  {
    buildingId: string;
    floorId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanApiResponse =
  /** status 200 OK */ NonResiHeatingPlanAssignmentNodeReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanApiArg =
  {
    nodeType: SpaceType;
    nodeId: string;
    orgId: string;
    tenantId: string;
  };
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsOrderApiResponse =
  unknown;
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsOrderApiArg =
  {
    buildingId: string;
    floorId: string;
    orgId: string;
    tenantId: string;
    body: ReorderNonResiHeatingPlanAssignmentsRequest;
  };
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsOrderApiResponse =
  unknown;
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsOrderApiArg =
  {
    nodeType: SpaceType;
    nodeId: string;
    orgId: string;
    tenantId: string;
    body: ReorderNonResiHeatingPlanAssignmentsRequest;
  };
export type PostApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansApiResponse =
  /** status 200 OK */ string;
export type PostApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansApiArg =
  {
    orgId: string;
    tenantId: string;
    body: CreateNonResiHeatingPlanRequest;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansApiResponse =
  /** status 200 OK */ NonResiHeatingPlanListReadModel[];
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansApiArg =
  {
    search?: string;
    orgId: string;
    tenantId: string;
  };
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiResponse =
  unknown;
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiArg =
  {
    planId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiResponse =
  /** status 200 OK */ NonResiHeatingPlanByIdReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiArg =
  {
    planId: string;
    orgId: string;
    tenantId: string;
  };
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiResponse =
  unknown;
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdApiArg =
  {
    planId: string;
    orgId: string;
    tenantId: string;
    body: UpdateNonResiHeatingPlanRequest;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseApiResponse =
  /** status 200 OK */ NonResiBaseHeatingPlanReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseApiArg =
  {
    orgId: string;
    tenantId: string;
  };
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseApiResponse =
  /** status 200 OK */ NonResiBaseHeatingPlanReadModel;
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseApiArg =
  {
    orgId: string;
    tenantId: string;
    body: UpsertNonResiBaseHeatingPlanRequest;
  };
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdStatusApiResponse =
  unknown;
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdStatusApiArg =
  {
    planId: string;
    orgId: string;
    tenantId: string;
    body: SetNonResiHeatingPlanStatusRequest;
  };
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiResponse =
  unknown;
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiArg =
  {
    buildingId: string;
    floorId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiResponse =
  /** status 200 OK */ NonResiHeatingTemperaturesNodeReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiArg =
  {
    buildingId: string;
    floorId: string;
    orgId: string;
    tenantId: string;
  };
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiResponse =
  unknown;
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesApiArg =
  {
    buildingId: string;
    floorId: string;
    orgId: string;
    tenantId: string;
    body: UpsertNonResiHeatingTemperaturesRequest;
  };
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiResponse =
  unknown;
export type DeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiArg =
  {
    nodeType: SpaceType;
    nodeId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiResponse =
  /** status 200 OK */ NonResiHeatingTemperaturesNodeReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiArg =
  {
    nodeType: SpaceType;
    nodeId: string;
    orgId: string;
    tenantId: string;
  };
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiResponse =
  unknown;
export type PutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesApiArg =
  {
    nodeType: SpaceType;
    nodeId: string;
    orgId: string;
    tenantId: string;
    body: UpsertNonResiHeatingTemperaturesRequest;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdSubtreeApiResponse =
  /** status 200 OK */ NonResiNavigationBuildingSubtreeReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdSubtreeApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdFloorsFloorIdApiResponse =
  /** status 200 OK */ NonResiNavigationFloorHeaderReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdFloorsFloorIdApiArg =
  {
    buildingId: string;
    floorId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationLocationsLocationIdSubtreeApiResponse =
  /** status 200 OK */ NonResiNavigationLocationSubtreeReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationLocationsLocationIdSubtreeApiArg =
  {
    locationId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationNodesNodeTypeNodeIdApiResponse =
  /** status 200 OK */ NonResiNavigationNodeHeaderReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationNodesNodeTypeNodeIdApiArg =
  {
    nodeType: SpaceType;
    nodeId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationRootsApiResponse =
  /** status 200 OK */ NonResiNavigationRootReadModel[];
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationRootsApiArg =
  {
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdHeatingStateApiResponse =
  /** status 200 OK */ NonResiRoomHeatingStateReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdHeatingStateApiArg =
  {
    roomId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdThermostatsApiResponse =
  /** status 200 OK */ NonResiTaxonomyBuildingThermostatsReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdThermostatsApiArg =
  {
    buildingId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdSummaryApiResponse =
  /** status 200 OK */ NonResiTaxonomyLocationSummaryReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdSummaryApiArg =
  {
    locationId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdThermostatsApiResponse =
  /** status 200 OK */ NonResiTaxonomyRoomThermostatsReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdThermostatsApiArg =
  {
    roomId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdThermostatsEuiApiResponse =
  /** status 200 OK */ NonResiThermostatByEuiReadModel;
export type GetApiNonResidentialOrgByOrgIdTenantAndTenantIdThermostatsEuiApiArg =
  {
    orgId: string;
    tenantId: string;
    eui: string;
  };
export type PostApiNotificationsTestSendByUserIdApiResponse =
  /** status 200 OK */ string;
export type PostApiNotificationsTestSendByUserIdApiArg = {
  userId: string;
  title?: string;
  body?: string;
};
export type PostApiOptInApiResponse = /** status 200 OK */ string;
export type PostApiOptInApiArg = {
  body: AddOptInRequest;
};
export type DeleteApiOptInApiResponse = unknown;
export type DeleteApiOptInApiArg = {
  id?: string;
};
export type GetApiOptInApiResponse = /** status 200 OK */ OptIntReadModel[];
export type GetApiOptInApiArg = void;
export type GetApiV2OrgByOrgIdTenantAndTenantIdOptInApiResponse =
  /** status 200 OK */ OptIntReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdOptInApiArg = {
  orgId: string;
  tenantId: string;
};
export type GetApiOptInLatestApiResponse = /** status 200 OK */ OptIntReadModel;
export type GetApiOptInLatestApiArg = void;
export type GetApiOptInByIdApiResponse = /** status 200 OK */ OptIntReadModel;
export type GetApiOptInByIdApiArg = {
  id: string;
};
export type PostApiOrganizationsApiResponse =
  /** status 200 OK */ AddOrganizationResponse;
export type PostApiOrganizationsApiArg = {
  body: AddOrganizationRequest;
};
export type GetApiOrganizationsApiResponse =
  /** status 200 OK */ OrganizationListReadModelPagedListResult;
export type GetApiOrganizationsApiArg = {
  searchTerm?: string;
  "Sort.SortOption"?: OrganizationListSort;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type PutApiOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ OrganizationReadModel;
export type PutApiOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
  body: UpdateOrganizationRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioAutocompleteApiResponse =
  /** status 200 OK */ PortfolioAutocompleteReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioAutocompleteApiArg = {
  client?: string;
  address?: string;
  tenant?: string;
  eui?: string;
  heatingCircuit?: string;
  clientIds?: string[];
  take?: number;
  orgId: string;
  tenantId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioCountsApiResponse =
  /** status 200 OK */ PortfolioCountsReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioCountsApiArg = {
  clientIds?: string[];
  buildingIds?: string[];
  tenantIds?: string[];
  euis?: string[];
  heatingCircuitIds?: string[];
  orgId: string;
  tenantId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioApiResponse =
  /** status 200 OK */ PortfolioDataReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdPortfolioApiArg = {
  tab?: PortfolioTab;
  "Sort.SortOption"?: PortfolioSortBy;
  "Sort.Direction"?: SortDirection;
  clientIds?: string[];
  buildingIds?: string[];
  tenantIds?: string[];
  euis?: string[];
  heatingCircuitIds?: string[];
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type GetApiProjectsSyncByProjectIdRenowateApiResponse =
  /** status 200 OK */ RenowateSyncDetailsReadModel;
export type GetApiProjectsSyncByProjectIdRenowateApiArg = {
  projectId: string;
};
export type PostApiProjectsSyncByProjectIdRenowateApiResponse = unknown;
export type PostApiProjectsSyncByProjectIdRenowateApiArg = {
  projectId: string;
};
export type GetApiProjectsSyncRenowateFailureItemsApiResponse =
  /** status 200 OK */ RenowateSyncFailureItemReadModelPagedListResult;
export type GetApiProjectsSyncRenowateFailureItemsApiArg = {
  renowateSyncId?: string;
  "Sort.SortOption"?: RenowateSyncFailureItemSortOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiProjectsByProjectIdExportApiResponse =
  /** status 200 OK */ ProjectExportReadModel;
export type GetApiProjectsByProjectIdExportApiArg = {
  projectId: string;
};
export type GetApiProjectsApiResponse =
  /** status 200 OK */ ProjectListReadModelPagedListResult;
export type GetApiProjectsApiArg = {
  query?: string;
  status?: ProjectStatus;
  "Sort.SortOption"?: SortGetProjectsQueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsApiResponse =
  /** status 200 OK */ ProjectListV2ReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsApiArg = {
  query?: string;
  statuses?: ProjectStatusV2[];
  ownerIds?: string[];
  tenantIds?: string[];
  "Sort.SortOption"?: SortGetProjectsV2QueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: AddProjectContactPersonRequest;
  };
export type PostApiProjectsManagementApiResponse = /** status 200 OK */ string;
export type PostApiProjectsManagementApiArg = {
  body: AddProjectRequest;
};
export type PostApiProjectsManagementByProjectIdAssignBuildingsApiResponse =
  /** status 200 OK */ string;
export type PostApiProjectsManagementByProjectIdAssignBuildingsApiArg = {
  projectId: string;
  body: AssignProjectBuildingsRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignBuildingsApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignBuildingsApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: AssignProjectBuildingsRequest;
  };
export type PostApiProjectsManagementByProjectIdAssignUsersApiResponse =
  /** status 200 OK */ string;
export type PostApiProjectsManagementByProjectIdAssignUsersApiArg = {
  projectId: string;
  body: AssignProjectUsersRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignUsersApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignUsersApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: AssignProjectUsersRequest;
  };
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdApiArg =
  {
    projectId: string;
    contactPersonId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdApiArg =
  {
    projectId: string;
    contactPersonId: string;
    orgId: string;
    tenantId: string;
    body: UpdateProjectContactPersonRequest;
  };
export type DeleteApiProjectsManagementByProjectIdApiResponse = unknown;
export type DeleteApiProjectsManagementByProjectIdApiArg = {
  projectId: string;
};
export type GetApiProjectsManagementByProjectIdApiResponse =
  /** status 200 OK */ ProjectReadModel;
export type GetApiProjectsManagementByProjectIdApiArg = {
  projectId: string;
};
export type PatchApiProjectsManagementByProjectIdApiResponse =
  /** status 200 OK */ string;
export type PatchApiProjectsManagementByProjectIdApiArg = {
  projectId: string;
  body: UpdateProjectRequest;
};
export type GetApiProjectsManagementByProjectIdFilterBuildingComplexesApiResponse =
  /** status 200 OK */ BuildingComplexFilterReadModel[];
export type GetApiProjectsManagementByProjectIdFilterBuildingComplexesApiArg = {
  complexName?: string;
  locationIds?: string[];
  take?: number;
  projectId: string;
};
export type GetApiProjectsManagementByProjectIdFilterLocationsApiResponse =
  /** status 200 OK */ LocationFilterReadModel[];
export type GetApiProjectsManagementByProjectIdFilterLocationsApiArg = {
  locationName?: string;
  take?: number;
  projectId: string;
};
export type GetApiProjectsManagementByProjectIdAvailableBuildingsApiResponse =
  /** status 200 OK */ ProjectBuildingReadModel[];
export type GetApiProjectsManagementByProjectIdAvailableBuildingsApiArg = {
  projectId: string;
  locationIds?: string[];
  buildingComplexIds?: string[];
  address?: string;
  isAssignedToOtherProject?: boolean;
  "Sort.SortOption"?: SortGetProjectAssignableBuildingListQueryOptions;
  "Sort.Direction"?: SortDirection;
  take?: number;
};
export type GetApiProjectsManagementByProjectIdAvailableUsersApiResponse =
  /** status 200 OK */ ProjectUserReadModel[];
export type GetApiProjectsManagementByProjectIdAvailableUsersApiArg = {
  projectId: string;
  query?: string;
  "Sort.SortOption"?: SortGetProjectUsersOptions;
  "Sort.Direction"?: SortDirection;
  take?: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAvailableUsersApiResponse =
  /** status 200 OK */ ProjectUserReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAvailableUsersApiArg =
  {
    projectId: string;
    query?: string;
    "Sort.SortOption"?: SortGetProjectUsersOptions;
    "Sort.Direction"?: SortDirection;
    take?: number;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerAutocompleteApiResponse =
  /** status 200 OK */ ProjectOwnerAutocompleteReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerAutocompleteApiArg =
  {
    projectId: string;
    query?: string;
    take?: number;
    orgId: string;
    tenantId: string;
  };
export type PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdMilestoneStepsApiResponse =
  unknown;
export type PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdMilestoneStepsApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: SetProjectMilestoneStepRequest;
  };
export type PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerApiResponse =
  unknown;
export type PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: SetProjectOwnerRequest;
  };
export type PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdStatusApiResponse =
  unknown;
export type PutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdStatusApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: SetProjectStatusRequest;
  };
export type PostApiProjectsManagementByProjectIdUnassignBuildingsApiResponse =
  /** status 200 OK */ string;
export type PostApiProjectsManagementByProjectIdUnassignBuildingsApiArg = {
  projectId: string;
  body: UnassignProjectBuildingsRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignBuildingsApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignBuildingsApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: UnassignProjectBuildingsRequest;
  };
export type PostApiProjectsManagementByProjectIdUnassignUsersApiResponse =
  /** status 200 OK */ string;
export type PostApiProjectsManagementByProjectIdUnassignUsersApiArg = {
  projectId: string;
  body: UnassignProjectUsersRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignUsersApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignUsersApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: UnassignProjectUsersRequest;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: UpdateProjectInfoRequest;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdInstallationDatesApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdInstallationDatesApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: UpdateProjectInstallationDatesRequest;
  };
export type GetApiProjectsIssuesByProjectIdBuildingUnitsApiResponse =
  /** status 200 OK */ ProjectIssuesBuildingUnitReadModelPagedListResult;
export type GetApiProjectsIssuesByProjectIdBuildingUnitsApiArg = {
  projectId: string;
  "Sort.SortOption"?: SortGetProjectIssuesBuildingUnitsQueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiProjectsIssuesByProjectIdRadiatorsApiResponse =
  /** status 200 OK */ ProjectIssuesRadiatorReadModel[];
export type GetApiProjectsIssuesByProjectIdRadiatorsApiArg = {
  projectId: string;
  "Sort.SortOption"?: SortGetProjectIssuesRadiatorsQueryOptions;
  "Sort.Direction"?: SortDirection;
};
export type GetApiProjectsIssuesByProjectIdRentersApiResponse =
  /** status 200 OK */ ProjectIssuesRenterReadModel[];
export type GetApiProjectsIssuesByProjectIdRentersApiArg = {
  projectId: string;
  "Sort.SortOption"?: SortGetProjectIssuesRentersQueryOptions;
  "Sort.Direction"?: SortDirection;
};
export type GetApiProjectsIssuesByProjectIdRoomsApiResponse =
  /** status 200 OK */ ProjectIssuesRoomReadModel[];
export type GetApiProjectsIssuesByProjectIdRoomsApiArg = {
  projectId: string;
  "Sort.SortOption"?: SortGetProjectIssuesRoomsQueryOptions;
  "Sort.Direction"?: SortDirection;
};
export type GetApiProjectsIssuesByProjectIdThermostatsApiResponse =
  /** status 200 OK */ ProjectIssuesThermostatReadModel[];
export type GetApiProjectsIssuesByProjectIdThermostatsApiArg = {
  projectId: string;
  "Sort.SortOption"?: SortGetProjectIssuesThermostatsQueryOptions;
  "Sort.Direction"?: SortDirection;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdContactPersonsApiResponse =
  /** status 200 OK */ ProjectContactPersonReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdContactPersonsApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiProjectsDetailByProjectIdBuildingsApiResponse =
  /** status 200 OK */ ProjectDetailBuildingReadModel[];
export type GetApiProjectsDetailByProjectIdBuildingsApiArg = {
  projectId: string;
};
export type GetApiProjectsDetailByProjectIdApiResponse =
  /** status 200 OK */ ProjectDetailReadModel;
export type GetApiProjectsDetailByProjectIdApiArg = {
  projectId: string;
};
export type GetApiProjectsDetailByProjectIdUsersApiResponse =
  /** status 200 OK */ ProjectUserReadModel[];
export type GetApiProjectsDetailByProjectIdUsersApiArg = {
  projectId: string;
  "Sort.SortOption"?: SortGetProjectUsersOptions;
  "Sort.Direction"?: SortDirection;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdApiResponse =
  /** status 200 OK */ ProjectDetailV2ReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdApiArg = {
  projectId: string;
  orgId: string;
  tenantId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdMilestonesApiResponse =
  /** status 200 OK */ ProjectMilestoneReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdMilestonesApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdUsersApiResponse =
  /** status 200 OK */ ProjectUserV2ReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdUsersApiArg = {
  projectId: string;
  query?: string;
  roles?: UserRole[];
  "Sort.SortOption"?: SortGetProjectUsersOptions;
  "Sort.Direction"?: SortDirection;
  orgId: string;
  tenantId: string;
};
export type PostApiTaxonomyRadiatorsApiResponse = /** status 200 OK */ string;
export type PostApiTaxonomyRadiatorsApiArg = {
  body: AddRadiatorRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsApiArg = {
  orgId: string;
  tenantId: string;
  body: AddRadiatorRequest;
};
export type DeleteApiTaxonomyRadiatorsByRadiatorIdObstructionApiResponse =
  unknown;
export type DeleteApiTaxonomyRadiatorsByRadiatorIdObstructionApiArg = {
  radiatorId: string;
};
export type PatchApiTaxonomyRadiatorsByRadiatorIdObstructionApiResponse =
  unknown;
export type PatchApiTaxonomyRadiatorsByRadiatorIdObstructionApiArg = {
  radiatorId: string;
  body: RadiatorObstructedRequest;
};
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionApiArg =
  {
    radiatorId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionApiArg =
  {
    radiatorId: string;
    orgId: string;
    tenantId: string;
    body: RadiatorObstructedRequest;
  };
export type GetApiTaxonomyRadiatorsByRadiatorIdApiResponse =
  /** status 200 OK */ RadiatorReadModel;
export type GetApiTaxonomyRadiatorsByRadiatorIdApiArg = {
  radiatorId: string;
};
export type DeleteApiTaxonomyRadiatorsByRadiatorIdApiResponse = unknown;
export type DeleteApiTaxonomyRadiatorsByRadiatorIdApiArg = {
  radiatorId: string;
};
export type PatchApiTaxonomyRadiatorsByRadiatorIdApiResponse = unknown;
export type PatchApiTaxonomyRadiatorsByRadiatorIdApiArg = {
  radiatorId: string;
  body: UpdateRadiatorRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiResponse =
  /** status 200 OK */ RadiatorReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiArg =
  {
    radiatorId: string;
    orgId: string;
    tenantId: string;
  };
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiArg =
  {
    radiatorId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdApiArg =
  {
    radiatorId: string;
    orgId: string;
    tenantId: string;
    body: UpdateRadiatorRequest;
  };
export type GetApiTaxonomyRadiatorsByRadiatorIdSpecificationApiResponse =
  /** status 200 OK */ RadiatorSpecificationReadModel;
export type GetApiTaxonomyRadiatorsByRadiatorIdSpecificationApiArg = {
  radiatorId: string;
};
export type PutApiTaxonomyRadiatorsByRadiatorIdSpecificationApiResponse =
  unknown;
export type PutApiTaxonomyRadiatorsByRadiatorIdSpecificationApiArg = {
  radiatorId: string;
  body: SetRadiatorSpecificationRequest;
};
export type PatchApiTaxonomyRadiatorsByRadiatorIdInstallationFailedApiResponse =
  unknown;
export type PatchApiTaxonomyRadiatorsByRadiatorIdInstallationFailedApiArg = {
  radiatorId: string;
  body: UpdateInstallationFailedRadiatorRequest;
};
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdInstallationFailedApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdInstallationFailedApiArg =
  {
    radiatorId: string;
    orgId: string;
    tenantId: string;
    body: UpdateInstallationFailedRadiatorRequest;
  };
export type PatchApiTaxonomyRadiatorsByRadiatorIdChecklistApiResponse = unknown;
export type PatchApiTaxonomyRadiatorsByRadiatorIdChecklistApiArg = {
  radiatorId: string;
  body: UpdateRadiatorInstallationChecklistRequest;
};
export type PatchApiTaxonomyRadiatorsByRadiatorIdVentingApiResponse = unknown;
export type PatchApiTaxonomyRadiatorsByRadiatorIdVentingApiArg = {
  radiatorId: string;
  body: UpdateRadiatorVentingStatusRequest;
};
export type PostApiRentersApiResponse = /** status 200 OK */ string;
export type PostApiRentersApiArg = {
  body: AddRenterRequest;
};
export type DeleteApiRentersByRenterIdApiResponse = unknown;
export type DeleteApiRentersByRenterIdApiArg = {
  renterId: string;
};
export type GetApiRentersByRenterIdApiResponse =
  /** status 200 OK */ RenterReadModel;
export type GetApiRentersByRenterIdApiArg = {
  renterId: string;
};
export type PatchApiRentersByRenterIdApiResponse = /** status 200 OK */ string;
export type PatchApiRentersByRenterIdApiArg = {
  renterId: string;
  body: UpdateRenterRequest;
};
export type PostApiRentersBulkUpdateApiResponse =
  /** status 200 OK */ RentersBulkUpdateValidationReadModel;
export type PostApiRentersBulkUpdateApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiRentersImportApiResponse =
  /** status 200 OK */ RentersImportValidationReadModel;
export type PostApiRentersImportApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiRentersBulkUpdateValidateApiResponse =
  /** status 200 OK */ RentersBulkUpdateValidationReadModel;
export type PostApiRentersBulkUpdateValidateApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiRentersImportValidateApiResponse =
  /** status 200 OK */ RentersImportValidationReadModel;
export type PostApiRentersImportValidateApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiRentersByRenterIdAgreementInfoReceivedApiResponse =
  /** status 200 OK */ string;
export type PostApiRentersByRenterIdAgreementInfoReceivedApiArg = {
  renterId: string;
};
export type GetApiRentersAgreementByRenterIdApiResponse =
  /** status 200 OK */ RenterAgreementReadModel;
export type GetApiRentersAgreementByRenterIdApiArg = {
  renterId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdApiResponse =
  /** status 200 OK */ RenterAgreementReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdApiArg =
  {
    renterId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdHistoryApiResponse =
  /** status 200 OK */ RenterAgreementHistoryReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdHistoryApiArg =
  {
    renterId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiGlobalDeviceListRentersApiResponse =
  /** status 200 OK */ RenterReadModel[];
export type GetApiGlobalDeviceListRentersApiArg = {
  name?: string;
  phoneNumber?: string;
  tenantIds?: string[];
  take?: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdSubRentersApiResponse =
  /** status 200 OK */ SubRenterReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdSubRentersApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiRentersVerificationsBuildingUnitByBuildingUnitIdExpiredApiResponse =
  /** status 200 OK */ ExpiredRenterReadModelPagedListResult;
export type GetApiRentersVerificationsBuildingUnitByBuildingUnitIdExpiredApiArg =
  {
    buildingUnitId: string;
    "Sort.SortOption"?: SortGetExpiredRentersQueryOptions;
    "Sort.Direction"?: SortDirection;
    page: number;
    pageSize: number;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsIncompleteApiResponse =
  /** status 200 OK */ IncompleteVerificationReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsIncompleteApiArg =
  {
    statuses?: IncompleteVerificationStatusFilter[];
    "Sort.SortOption"?: SortGetIncompleteVerificationsQueryOptions;
    "Sort.Direction"?: SortDirection;
    page: number;
    pageSize: number;
    orgId: string;
    tenantId: string;
  };
export type GetApiRentersVerificationsUsersApiResponse =
  /** status 200 OK */ UserReadModel[];
export type GetApiRentersVerificationsUsersApiArg = {
  query?: string;
  take?: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUsersApiResponse =
  /** status 200 OK */ UserReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUsersApiArg =
  {
    query?: string;
    take?: number;
    orgId: string;
    tenantId: string;
  };
export type GetApiRentersVerificationsBuildingUnitByBuildingUnitIdApiResponse =
  /** status 200 OK */ RenterVerificationDetailReadModel;
export type GetApiRentersVerificationsBuildingUnitByBuildingUnitIdApiArg = {
  buildingUnitId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdApiResponse =
  /** status 200 OK */ RenterVerificationDetailReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiRentersVerificationsEmailByEmailApiResponse =
  /** status 200 OK */ RenterVerificationDetailReadModel;
export type GetApiRentersVerificationsEmailByEmailApiArg = {
  email: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsEmailEmailApiResponse =
  /** status 200 OK */ RenterVerificationDetailReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsEmailEmailApiArg =
  {
    email: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiRentersVerificationsOverrideByUserIdApiResponse =
  /** status 200 OK */ RenterVerificationDetailReadModel;
export type PostApiRentersVerificationsOverrideByUserIdApiArg = {
  userId: string;
  body: OverrideVerificationRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsOverrideUserIdApiResponse =
  /** status 200 OK */ RenterVerificationDetailReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsOverrideUserIdApiArg =
  {
    userId: string;
    orgId: string;
    tenantId: string;
    body: OverrideVerificationRequest;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUnlinkUserIdApiResponse =
  /** status 200 OK */ RenterVerificationDetailReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUnlinkUserIdApiArg =
  {
    userId: string;
    orgId: string;
    tenantId: string;
    body: UnlinkRenterRequest;
  };
export type PostApiTaxonomyRoomsByRoomIdWindowsApiResponse =
  /** status 200 OK */ WindowReadModel;
export type PostApiTaxonomyRoomsByRoomIdWindowsApiArg = {
  roomId: string;
};
export type GetApiTaxonomyRoomsByRoomIdWindowsApiResponse =
  /** status 200 OK */ WindowReadModel[];
export type GetApiTaxonomyRoomsByRoomIdWindowsApiArg = {
  roomId: string;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsApiResponse =
  /** status 200 OK */ WindowReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsApiArg =
  {
    roomId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsApiResponse =
  /** status 200 OK */ WindowReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsApiArg =
  {
    roomId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiTaxonomyRoomsByRoomIdWindowsAndWindowIdDuplicateApiResponse =
  /** status 200 OK */ WindowReadModel;
export type PostApiTaxonomyRoomsByRoomIdWindowsAndWindowIdDuplicateApiArg = {
  roomId: string;
  windowId: string;
  body: DuplicateWindowRequest;
};
export type GetApiTaxonomyRoomsByRoomIdWindowsAndWindowIdApiResponse =
  /** status 200 OK */ WindowReadModel;
export type GetApiTaxonomyRoomsByRoomIdWindowsAndWindowIdApiArg = {
  roomId: string;
  windowId: string;
};
export type DeleteApiTaxonomyRoomsByRoomIdWindowsAndWindowIdApiResponse =
  unknown;
export type DeleteApiTaxonomyRoomsByRoomIdWindowsAndWindowIdApiArg = {
  roomId: string;
  windowId: string;
};
export type PostApiTaxonomyRoomsApiResponse = /** status 200 OK */ string;
export type PostApiTaxonomyRoomsApiArg = {
  body: AddRoomRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsApiArg = {
  orgId: string;
  tenantId: string;
  body: AddRoomRequest;
};
export type GetApiTaxonomyRoomsByRoomIdApiResponse =
  /** status 200 OK */ RoomReadModel;
export type GetApiTaxonomyRoomsByRoomIdApiArg = {
  roomId: string;
};
export type DeleteApiTaxonomyRoomsByRoomIdApiResponse = unknown;
export type DeleteApiTaxonomyRoomsByRoomIdApiArg = {
  roomId: string;
};
export type PatchApiTaxonomyRoomsByRoomIdApiResponse = unknown;
export type PatchApiTaxonomyRoomsByRoomIdApiArg = {
  roomId: string;
  body: UpdateRoomRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiResponse =
  /** status 200 OK */ RoomReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiArg = {
  roomId: string;
  orgId: string;
  tenantId: string;
};
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiArg = {
  roomId: string;
  orgId: string;
  tenantId: string;
};
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiResponse =
  unknown;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdApiArg = {
  roomId: string;
  orgId: string;
  tenantId: string;
  body: UpdateRoomRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdTreeApiResponse =
  /** status 200 OK */ RoomTreeReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdTreeApiArg = {
  roomId: string;
  orgId: string;
  tenantId: string;
};
export type PostApiSensorsApiResponse =
  /** status 200 OK */ SensorDetailReadModel;
export type PostApiSensorsApiArg = {
  body: AddSensorRequest;
};
export type GetApiSensorsApiResponse =
  /** status 200 OK */ SensorReadModelPagedListResult;
export type GetApiSensorsApiArg = {
  page: number;
  pageSize: number;
};
export type PostApiSensorsAssignHeatingCircuitBySensorIdApiResponse = unknown;
export type PostApiSensorsAssignHeatingCircuitBySensorIdApiArg = {
  sensorId: string;
  body: AssignSensorToHeatingCircuitRequest;
};
export type PostApiSensorsAssignSpaceBySensorIdApiResponse = unknown;
export type PostApiSensorsAssignSpaceBySensorIdApiArg = {
  sensorId: string;
  body: AssignSensorToSpaceRequest;
};
export type PostApiSensorsAssignWindowBySensorIdApiResponse = unknown;
export type PostApiSensorsAssignWindowBySensorIdApiArg = {
  sensorId: string;
  body: AssignSensorToWindowRequest;
};
export type DeleteApiSensorsBySensorIdApiResponse = unknown;
export type DeleteApiSensorsBySensorIdApiArg = {
  sensorId: string;
};
export type GetApiSensorsBySensorIdApiResponse =
  /** status 200 OK */ SensorDetailReadModel;
export type GetApiSensorsBySensorIdApiArg = {
  sensorId: string;
};
export type PatchApiSensorsBySensorIdApiResponse =
  /** status 200 OK */ SensorDetailReadModel;
export type PatchApiSensorsBySensorIdApiArg = {
  sensorId: string;
  body: UpdateSensorRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdApiResponse =
  /** status 200 OK */ SensorDetailReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdApiArg = {
  sensorId: string;
  orgId: string;
  tenantId: string;
};
export type PatchApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdApiResponse =
  /** status 200 OK */ SensorDetailReadModel;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdApiArg = {
  sensorId: string;
  orgId: string;
  tenantId: string;
  body: UpdateSensorRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdLifecycleHistoryApiResponse =
  /** status 200 OK */ SensorLifecycleHistoryReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdLifecycleHistoryApiArg =
  {
    sensorId: string;
    from?: string;
    to?: string;
    statuses?: SensorLifecycleStatus[];
    "Sort.SortOption"?: SortGetSensorLifecycleHistoryQueryOptions;
    "Sort.Direction"?: SortDirection;
    page: number;
    pageSize: number;
    orgId: string;
    tenantId: string;
  };
export type GetApiSensorsAutocompleteApiResponse =
  /** status 200 OK */ SensorAutocompleteReadModel[];
export type GetApiSensorsAutocompleteApiArg = {
  eui?: string;
  assigned?: boolean;
  placement?: SensorPlacement;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdSensorsAutocompleteApiResponse =
  /** status 200 OK */ SensorAutocompleteReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdSensorsAutocompleteApiArg = {
  eui?: string;
  assigned?: boolean;
  placement?: SensorPlacement;
  orgId: string;
  tenantId: string;
};
export type GetApiSensorsSpaceBySpaceIdApiResponse =
  /** status 200 OK */ SensorReadModelPagedListResult;
export type GetApiSensorsSpaceBySpaceIdApiArg = {
  spaceId: string;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSpaceSpaceIdApiResponse =
  /** status 200 OK */ SensorReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdSensorsSpaceSpaceIdApiArg = {
  spaceId: string;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type PostApiSensorsPairBySensorIdApiResponse = unknown;
export type PostApiSensorsPairBySensorIdApiArg = {
  sensorId: string;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdSensorsPairSensorIdApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdSensorsPairSensorIdApiArg = {
  sensorId: string;
  orgId: string;
  tenantId: string;
};
export type PostApiSensorsPairSpaceBySpaceIdApiResponse = unknown;
export type PostApiSensorsPairSpaceBySpaceIdApiArg = {
  spaceId: string;
};
export type PostApiSensorsBySensorIdChirpstackConfigurationApiResponse =
  unknown;
export type PostApiSensorsBySensorIdChirpstackConfigurationApiArg = {
  sensorId: string;
};
export type PostApiSensorsUnassignBySensorIdApiResponse = unknown;
export type PostApiSensorsUnassignBySensorIdApiArg = {
  sensorId: string;
};
export type PostApiSensorsUnpairBySensorIdApiResponse = unknown;
export type PostApiSensorsUnpairBySensorIdApiArg = {
  sensorId: string;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdSensorsUnpairSensorIdApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdSensorsUnpairSensorIdApiArg = {
  sensorId: string;
  orgId: string;
  tenantId: string;
};
export type PostApiSensorsUnpairSpaceBySpaceIdApiResponse = unknown;
export type PostApiSensorsUnpairSpaceBySpaceIdApiArg = {
  spaceId: string;
};
export type GetApiSignalTesterByEuiLastMeasurementApiResponse =
  /** status 200 OK */ SignalTesterMeasurementReadModel;
export type GetApiSignalTesterByEuiLastMeasurementApiArg = {
  eui: string;
};
export type GetApiSignalTesterAutocompleteApiResponse =
  /** status 200 OK */ SignalTesterAutocompleteReadModel[];
export type GetApiSignalTesterAutocompleteApiArg = {
  eui?: string;
};
export type GetApiTaxonomyBySpaceIdApiResponse =
  /** status 200 OK */ TaxonomyDetailReadModel;
export type GetApiTaxonomyBySpaceIdApiArg = {
  spaceId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyCountsSpaceTypeSpaceIdApiResponse =
  /** status 200 OK */ TaxonomyCountsReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyCountsSpaceTypeSpaceIdApiArg =
  {
    spaceType: SpaceType;
    spaceId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHealthSpaceTypeSpaceIdApiResponse =
  /** status 200 OK */ TaxonomyHealthReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHealthSpaceTypeSpaceIdApiArg =
  {
    spaceType: SpaceType;
    spaceId: string;
    orgId: string;
    tenantId: string;
  };
export type PatchApiTaxonomyRenameBySpaceIdApiResponse = unknown;
export type PatchApiTaxonomyRenameBySpaceIdApiArg = {
  spaceId: string;
  body: RenameTaxonomyRequest;
};
export type PatchApiTaxonomyDescriptionBySpaceIdApiResponse = unknown;
export type PatchApiTaxonomyDescriptionBySpaceIdApiArg = {
  spaceId: string;
  body: UpdateDescriptionTaxonomyRequest;
};
export type PostApiTaxonomyAssignedHeatingCircuitBySpaceIdApiResponse =
  /** status 200 OK */ string;
export type PostApiTaxonomyAssignedHeatingCircuitBySpaceIdApiArg = {
  spaceId: string;
  body: AssignedHeatingCircuitRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedHeatingCircuitSpaceIdApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedHeatingCircuitSpaceIdApiArg =
  {
    spaceId: string;
    orgId: string;
    tenantId: string;
    body: AssignedHeatingCircuitRequest;
  };
export type PostApiTaxonomyResetHeatingCircuitBySpaceIdApiResponse = unknown;
export type PostApiTaxonomyResetHeatingCircuitBySpaceIdApiArg = {
  spaceId: string;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetHeatingCircuitSpaceIdApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetHeatingCircuitSpaceIdApiArg =
  {
    spaceId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiTaxonomyAssignedFloorsBySpaceIdApiResponse =
  /** status 200 OK */ string;
export type PostApiTaxonomyAssignedFloorsBySpaceIdApiArg = {
  spaceId: string;
  body: AssignedFloorsRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedFloorsSpaceIdApiResponse =
  /** status 200 OK */ string;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedFloorsSpaceIdApiArg =
  {
    spaceId: string;
    orgId: string;
    tenantId: string;
    body: AssignedFloorsRequest;
  };
export type PostApiTaxonomyResetFloorsBySpaceIdApiResponse = unknown;
export type PostApiTaxonomyResetFloorsBySpaceIdApiArg = {
  spaceId: string;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetFloorsSpaceIdApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetFloorsSpaceIdApiArg =
  {
    spaceId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiTaxonomyImportApiResponse =
  /** status 200 OK */ TaxonomyImportValidationReadModel;
export type PostApiTaxonomyImportApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiTaxonomyImportByProjectIdApiResponse =
  /** status 200 OK */ TaxonomyImportValidationReadModel;
export type PostApiTaxonomyImportByProjectIdApiArg = {
  projectId: string;
  body: {
    File?: Blob;
  };
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportProjectIdApiResponse =
  /** status 200 OK */ TaxonomyImportValidationReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportProjectIdApiArg =
  {
    projectId: string;
    orgId: string;
    tenantId: string;
    body: {
      File?: Blob;
    };
  };
export type PostApiTaxonomyImportValidateApiResponse =
  /** status 200 OK */ TaxonomyImportValidationReadModel;
export type PostApiTaxonomyImportValidateApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportValidateApiResponse =
  /** status 200 OK */ TaxonomyImportValidationReadModel;
export type PostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportValidateApiArg = {
  orgId: string;
  tenantId: string;
  body: {
    File?: Blob;
  };
};
export type GetApiTaxonomyExportBySpaceIdApiResponse =
  /** status 200 OK */ LocationExportReadModel;
export type GetApiTaxonomyExportBySpaceIdApiArg = {
  spaceId: string;
};
export type GetApiTaxonomyTenantExportApiResponse =
  /** status 200 OK */ LocationExportReadModel;
export type GetApiTaxonomyTenantExportApiArg = void;
export type GetApiV2OrgByOrgIdTenantAndTenantIdSpaceTelemetrySpaceIdApiResponse =
  /** status 200 OK */ ThermostatTelemetryReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdSpaceTelemetrySpaceIdApiArg = {
  spaceId: string;
  orgId: string;
  tenantId: string;
};
export type GetApiTaxonomyGatewaysBySpaceIdApiResponse =
  /** status 200 OK */ GatewayReadModel[];
export type GetApiTaxonomyGatewaysBySpaceIdApiArg = {
  spaceId: string;
};
export type GetApiTaxonomyViewBuildingUnitByBuildingUnitIdApiResponse =
  /** status 200 OK */ TaxonomyViewRoomReadModel[];
export type GetApiTaxonomyViewBuildingUnitByBuildingUnitIdApiArg = {
  buildingUnitId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyViewBuildingUnitBuildingUnitIdApiResponse =
  /** status 200 OK */ TaxonomyViewRoomReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyViewBuildingUnitBuildingUnitIdApiArg =
  {
    buildingUnitId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiTaxonomyViewLocationApiResponse =
  /** status 200 OK */ TaxonomyViewBuildingComplexReadModel[];
export type GetApiTaxonomyViewLocationApiArg = {
  locationId?: string;
  buildingSearch?: string;
  renterSearch?: string;
};
export type PostApiTenantsApiResponse = /** status 200 OK */ string;
export type PostApiTenantsApiArg = {
  body: AddTenantRequest;
};
export type GetApiTenantsApiResponse =
  /** status 200 OK */ TenantDetailReadModelPagedListResult;
export type GetApiTenantsApiArg = {
  organizationId?: string;
  name?: string;
  tenantIds?: string[];
  "Sort.SortOption"?: SortGetTenantsQueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiTenantsByTenantIdApiResponse =
  /** status 200 OK */ TenantDetailReadModel;
export type GetApiTenantsByTenantIdApiArg = {
  tenantId: string;
};
export type PatchApiTenantsByTenantIdApiResponse = unknown;
export type PatchApiTenantsByTenantIdApiArg = {
  tenantId: string;
  body: UpdateTenantRequest;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTenantsTargetTenantIdApiResponse =
  /** status 200 OK */ TenantDetailReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTenantsTargetTenantIdApiArg = {
  targetTenantId: string;
  orgId: string;
  tenantId: string;
};
export type GetApiTenantsByTenantIdOverviewApiResponse =
  /** status 200 OK */ TenantOverviewReadModel;
export type GetApiTenantsByTenantIdOverviewApiArg = {
  tenantId: string;
};
export type GetApiTenantsAutocompleteApiResponse =
  /** status 200 OK */ TenantAutocompleteReadModel[];
export type GetApiTenantsAutocompleteApiArg = {
  organizationId?: string;
  tenantName?: string;
  take?: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTenantsAutocompleteApiResponse =
  /** status 200 OK */ TenantAutocompleteReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdTenantsAutocompleteApiArg = {
  organizationId?: string;
  tenantName?: string;
  take?: number;
  orgId: string;
  tenantId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdTenantsApiResponse =
  /** status 200 OK */ TenantDetailReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdTenantsApiArg = {
  organizationId?: string;
  name?: string;
  tenantIds?: string[];
  "Sort.SortOption"?: SortGetTenantsQueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type PostApiTermsOfUseApiResponse = /** status 200 OK */ string;
export type PostApiTermsOfUseApiArg = {
  body: AddTermsOfUseRequest;
};
export type GetApiTermsOfUseApiResponse =
  /** status 200 OK */ TermsOfUseReadModel[];
export type GetApiTermsOfUseApiArg = void;
export type GetApiTermsOfUseLatestApiResponse =
  /** status 200 OK */ TermsOfUseReadModel;
export type GetApiTermsOfUseLatestApiArg = void;
export type GetApiTermsOfUseByIdApiResponse =
  /** status 200 OK */ TermsOfUseReadModel;
export type GetApiTermsOfUseByIdApiArg = {
  id: string;
};
export type GetApiGlobalDeviceListOperationApiResponse =
  /** status 200 OK */ ThermostatOperationReadModelPagedListResult;
export type GetApiGlobalDeviceListOperationApiArg = {
  locationIds?: string[];
  complexIds?: string[];
  buildingIds?: string[];
  floors?: number[];
  buildingUnitIds?: string[];
  renterIds?: string[];
  customerIds?: string[];
  organizationIds?: string[];
  tenantIds?: string[];
  buildingUnitTypes?: BuildingUnitType[];
  roomTypes?: RoomType[];
  firmwareVersions?: number[];
  hardwareVersions?: number[];
  firmwareUpdateStatuses?: DataTransferProgressStatus[];
  thermostatIds?: string[];
  assigned?: boolean;
  operationModes?: MajorMode[];
  networkStatuses?: DeviceNetworkStatus[];
  "BatteryRange.Min"?: number;
  "BatteryRange.Max"?: number;
  batteryVoltage?: number;
  lifecycleStatuses?: ThermostatLifecycleStatus[];
  calibration?: boolean;
  isDirectMotorControlActive?: boolean;
  hydraulicBalancing?: boolean;
  "Sort.SortOption"?: ThermostatDeviceListSortOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListOperationApiResponse =
  /** status 200 OK */ ThermostatOperationReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListOperationApiArg =
  {
    locationIds?: string[];
    complexIds?: string[];
    buildingIds?: string[];
    floors?: number[];
    buildingUnitIds?: string[];
    renterIds?: string[];
    customerIds?: string[];
    organizationIds?: string[];
    tenantIds?: string[];
    buildingUnitTypes?: BuildingUnitType[];
    roomTypes?: RoomType[];
    firmwareVersions?: number[];
    hardwareVersions?: number[];
    firmwareUpdateStatuses?: DataTransferProgressStatus[];
    thermostatIds?: string[];
    assigned?: boolean;
    operationModes?: MajorMode[];
    networkStatuses?: DeviceNetworkStatus[];
    "BatteryRange.Min"?: number;
    "BatteryRange.Max"?: number;
    batteryVoltage?: number;
    lifecycleStatuses?: ThermostatLifecycleStatus[];
    calibration?: boolean;
    isDirectMotorControlActive?: boolean;
    hydraulicBalancing?: boolean;
    "Sort.SortOption"?: ThermostatDeviceListSortOptions;
    "Sort.Direction"?: SortDirection;
    page: number;
    pageSize: number;
    orgId: string;
    tenantId: string;
  };
export type GetApiGlobalDeviceListOperationExportApiResponse =
  /** status 200 OK */ Blob;
export type GetApiGlobalDeviceListOperationExportApiArg = {
  locationIds?: string[];
  complexIds?: string[];
  buildingIds?: string[];
  floors?: number[];
  buildingUnitIds?: string[];
  renterIds?: string[];
  customerIds?: string[];
  organizationIds?: string[];
  tenantIds?: string[];
  buildingUnitTypes?: BuildingUnitType[];
  roomTypes?: RoomType[];
  firmwareVersions?: number[];
  hardwareVersions?: number[];
  firmwareUpdateStatuses?: DataTransferProgressStatus[];
  thermostatIds?: string[];
  assigned?: boolean;
  operationModes?: MajorMode[];
  networkStatuses?: DeviceNetworkStatus[];
  "BatteryRange.Min"?: number;
  "BatteryRange.Max"?: number;
  batteryVoltage?: number;
  lifecycleStatuses?: ThermostatLifecycleStatus[];
  calibration?: boolean;
  isDirectMotorControlActive?: boolean;
  hydraulicBalancing?: boolean;
  "Sort.SortOption"?: ThermostatDeviceListSortOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiGlobalDeviceListProductionApiResponse =
  /** status 200 OK */ ThermostatProductionReadModelPagedListResult;
export type GetApiGlobalDeviceListProductionApiArg = {
  "Sort.SortBy"?: string;
  "Sort.SortDirection"?: SortDirection;
  deviceType?: number;
  hardwareVersions?: number[];
  firmwareVersions?: number[];
  healthStatus?: number;
  operationModes?: MajorMode[];
  firmwareStatuses?: DataTransferProgressStatus[];
  productionTimestamp?: string;
  eui?: string;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListProductionApiResponse =
  /** status 200 OK */ ThermostatProductionReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListProductionApiArg =
  {
    "Sort.SortBy"?: string;
    "Sort.SortDirection"?: SortDirection;
    deviceType?: number;
    hardwareVersions?: number[];
    firmwareVersions?: number[];
    healthStatus?: number;
    operationModes?: MajorMode[];
    firmwareStatuses?: DataTransferProgressStatus[];
    productionTimestamp?: string;
    eui?: string;
    page: number;
    pageSize: number;
    orgId: string;
    tenantId: string;
  };
export type PostApiThermostatsAssignByThermostatIdApiResponse = unknown;
export type PostApiThermostatsAssignByThermostatIdApiArg = {
  thermostatId: string;
  body: AssignThermostatRequest;
};
export type DeleteApiThermostatsByThermostatIdApiResponse = unknown;
export type DeleteApiThermostatsByThermostatIdApiArg = {
  thermostatId: string;
};
export type GetApiThermostatsByThermostatIdApiResponse =
  /** status 200 OK */ ThermostatDetailReadModel;
export type GetApiThermostatsByThermostatIdApiArg = {
  thermostatId: string;
};
export type PatchApiThermostatsByThermostatIdApiResponse =
  /** status 200 OK */ ThermostatDetailReadModel;
export type PatchApiThermostatsByThermostatIdApiArg = {
  thermostatId: string;
  body: UpdateThermostatRequest;
};
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiResponse =
  unknown;
export type DeleteApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiResponse =
  /** status 200 OK */ ThermostatDetailReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiArg = {
  thermostatId: string;
  orgId: string;
  tenantId: string;
};
export type PatchApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiResponse =
  /** status 200 OK */ ThermostatDetailReadModel;
export type PatchApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
    body: UpdateThermostatRequest;
  };
export type GetApiThermostatsForDataTransfersByBuildingIdApiResponse =
  /** status 200 OK */ DataTransferSchedulingThermostatResult;
export type GetApiThermostatsForDataTransfersByBuildingIdApiArg = {
  buildingId: string;
  firmwareVersions?: number[];
  "FingerprintHash.Value"?: string;
  "FingerprintHash.Type"?: StringFilterType;
  batteryLevelThreshold?: number;
  batteryVoltageThreshold?: number;
  excludeActiveTransfers?: boolean;
  operationModes?: MajorMode[];
  networkStatuses?: DeviceNetworkStatus[];
  page: number;
  pageSize: number;
};
export type GetApiThermostatsDataTransfersToThermostatApiResponse =
  /** status 200 OK */ DataTransferToThermostatRowPagedListResult;
export type GetApiThermostatsDataTransfersToThermostatApiArg = {
  tenantId?: string;
  eui?: string;
  buildingIds?: string[];
  "StartedAt.From"?: string;
  "StartedAt.To"?: string;
  "FinishedAt.From"?: string;
  "FinishedAt.To"?: string;
  type?: DataTransferToDeviceType;
  name?: string;
  isAutoFuota?: boolean;
  isForced?: boolean;
  "FingerprintHash.Value"?: string;
  "FingerprintHash.Type"?: StringFilterType;
  userIds?: string[];
  status?: DataTransferProgressStatus[];
  "Sort.SortOption"?: SortGetDataTransferToThermostatHistoryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiThermostatsAssemblyLineHistoryByEuiApiResponse =
  /** status 200 OK */ any[];
export type GetApiThermostatsAssemblyLineHistoryByEuiApiArg = {
  eui: string;
};
export type GetApiThermostatsByThermostatIdConnectivityApiResponse =
  /** status 200 OK */ ThermostatConnectivityReadModel;
export type GetApiThermostatsByThermostatIdConnectivityApiArg = {
  thermostatId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdConnectivityApiResponse =
  /** status 200 OK */ ThermostatConnectivityReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdConnectivityApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiThermostatsDownlinksApiResponse =
  /** status 200 OK */ ThermostatDownlinkResponse[];
export type GetApiThermostatsDownlinksApiArg = {
  eui?: string;
  from?: string;
  to?: string;
  source?: DownlinkCommandSource;
  code?: CommandCode;
  status?: ThermostatDownlinkStatus;
};
export type GetApiThermostatsByThermostatIdLastmeasurementsApiResponse =
  /** status 200 OK */ ThermostatMeasurementsReadModel;
export type GetApiThermostatsByThermostatIdLastmeasurementsApiArg = {
  thermostatId: string;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdLastmeasurementsApiResponse =
  /** status 200 OK */ ThermostatMeasurementsReadModel;
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdLastmeasurementsApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
  };
export type GetApiThermostatsByThermostatIdOperationalStatusApiResponse =
  /** status 200 OK */ ThermostatOperationalStatusReadModel;
export type GetApiThermostatsByThermostatIdOperationalStatusApiArg = {
  thermostatId: string;
};
export type GetApiThermostatsByThermostatIdRenterApiResponse =
  /** status 200 OK */ ThermostatRenterReadModel;
export type GetApiThermostatsByThermostatIdRenterApiArg = {
  thermostatId: string;
};
export type GetApiThermostatsAutocompleteApiResponse =
  /** status 200 OK */ ThermostatAutocompleteReadModel[];
export type GetApiThermostatsAutocompleteApiArg = {
  eui?: string;
  assigned?: boolean;
  limit?: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsAutocompleteApiResponse =
  /** status 200 OK */ ThermostatAutocompleteReadModel[];
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsAutocompleteApiArg = {
  eui?: string;
  assigned?: boolean;
  limit?: number;
  orgId: string;
  tenantId: string;
};
export type GetApiThermostatsApiResponse =
  /** status 200 OK */ ThermostatReadModelPagedListResult;
export type GetApiThermostatsApiArg = {
  page: number;
  pageSize: number;
};
export type GetApiThermostatsSpaceBySpaceIdApiResponse =
  /** status 200 OK */ ThermostatReadModelPagedListResult;
export type GetApiThermostatsSpaceBySpaceIdApiArg = {
  spaceId: string;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsSpaceSpaceIdApiResponse =
  /** status 200 OK */ ThermostatReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsSpaceSpaceIdApiArg = {
  spaceId: string;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type PostApiThermostatsReportMalfunctionByThermostatIdApiResponse =
  unknown;
export type PostApiThermostatsReportMalfunctionByThermostatIdApiArg = {
  thermostatId: string;
  body: ReportThermostatMalfunctionRequest;
};
export type PostApiThermostatsUnassignByThermostatIdApiResponse = unknown;
export type PostApiThermostatsUnassignByThermostatIdApiArg = {
  thermostatId: string;
};
export type PostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableApiArg =
  {
    thermostatId: string;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlDisableApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlDisableApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableApiArg =
  {
    thermostatId: string;
    body: EnableDirectMotorControlEndpointRequest;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlEnableApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlEnableApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
    body: EnableDirectMotorControlEndpointRequest;
  };
export type PostApiThermostatsOperationsByThermostatIdFlushValveApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdFlushValveApiArg = {
  thermostatId: string;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdFlushValveApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdFlushValveApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiThermostatsOperationsByThermostatIdManualCalibrationApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdManualCalibrationApiArg =
  {
    thermostatId: string;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdManualCalibrationApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdManualCalibrationApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiThermostatsOperationsByThermostatIdMcuResetApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdMcuResetApiArg = {
  thermostatId: string;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMcuResetApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMcuResetApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
  };
export type PostApiThermostatsOperationsByThermostatIdDisplayRotationApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdDisplayRotationApiArg = {
  thermostatId: string;
  body: SetDisplayRotationRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDisplayRotationApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDisplayRotationApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
    body: SetDisplayRotationRequest;
  };
export type PostApiThermostatsOperationsByThermostatIdMajorModeApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdMajorModeApiArg = {
  thermostatId: string;
  body: SetMajorModeRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMajorModeApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMajorModeApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
    body: SetMajorModeRequest;
  };
export type PostApiThermostatsOperationsByThermostatIdMotorPositionConstraintApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdMotorPositionConstraintApiArg =
  {
    thermostatId: string;
    body: SetMotorPositionConstraintRequest;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionConstraintApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionConstraintApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
    body: SetMotorPositionConstraintRequest;
  };
export type PostApiThermostatsOperationsByThermostatIdMotorPositionApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdMotorPositionApiArg = {
  thermostatId: string;
  body: SetMotorPositionRequest;
};
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
    body: SetMotorPositionRequest;
  };
export type PostApiThermostatsOperationsByThermostatIdTargetTemperatureApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdTargetTemperatureApiArg =
  {
    thermostatId: string;
    body: SetTargetTemperatureRequest;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
    body: SetTargetTemperatureRequest;
  };
export type PostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelApiArg =
  {
    thermostatId: string;
    body: SetTargetTemperatureLevelRequest;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureLevelApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureLevelApiArg =
  {
    thermostatId: string;
    orgId: string;
    tenantId: string;
    body: SetTargetTemperatureLevelRequest;
  };
export type PostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateApiResponse =
  unknown;
export type PostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateApiArg =
  {
    thermostatId: string;
    activate: boolean;
  };
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdToggleActiveHarvestingActivateApiResponse =
  unknown;
export type PostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdToggleActiveHarvestingActivateApiArg =
  {
    thermostatId: string;
    activate: boolean;
    orgId: string;
    tenantId: string;
  };
export type GetApiThermostatsLifecycleReservationByReservationIdApiResponse =
  /** status 200 OK */ EuiReservationReadModel;
export type GetApiThermostatsLifecycleReservationByReservationIdApiArg = {
  reservationId: string;
};
export type PostApiThermostatsLifecycleImportChirpstackOnboardingApiResponse =
  /** status 200 OK */ ImportChirpstackOnboardingReport;
export type PostApiThermostatsLifecycleImportChirpstackOnboardingApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiThermostatsLifecycleImportStatusChangeApiResponse =
  /** status 200 OK */ ImportThermostatStatusChangeReport;
export type PostApiThermostatsLifecycleImportStatusChangeApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiThermostatsLifecycleImportTenantReassignApiResponse =
  /** status 200 OK */ ImportThermostatsTenantsReport;
export type PostApiThermostatsLifecycleImportTenantReassignApiArg = {
  body: {
    File?: Blob;
  };
};
export type PostApiThermostatsLifecycleTenantReassignByThermostatEuiApiResponse =
  unknown;
export type PostApiThermostatsLifecycleTenantReassignByThermostatEuiApiArg = {
  thermostatEui: string;
  body: ReassignThermostatTenantRequest;
};
export type PostApiThermostatsLifecycleReserveApiResponse =
  /** status 200 OK */ string;
export type PostApiThermostatsLifecycleReserveApiArg = {
  body: ReserveThermostatsDevEuiRequest;
};
export type PatchApiThermostatsLifecycleByEuiLifecycleStatusApiResponse =
  /** status 200 OK */ DeviceLifecycleChangeResponse;
export type PatchApiThermostatsLifecycleByEuiLifecycleStatusApiArg = {
  eui: string;
  body: SetLifecycleStatusRequest;
};
export type PostApiThermostatsLifecycleByEuiChirpstackOnboardingApiResponse =
  /** status 200 OK */ ChirpstackOnboardingResponse;
export type PostApiThermostatsLifecycleByEuiChirpstackOnboardingApiArg = {
  eui: string;
  body: ChirpstackOnboardingRequest;
};
export type PostApiThermostatsLifecycleTenantUnassignByThermostatEuiApiResponse =
  unknown;
export type PostApiThermostatsLifecycleTenantUnassignByThermostatEuiApiArg = {
  thermostatEui: string;
};
export type GetApiThermostatsThermostatHistoryApiResponse =
  /** status 200 OK */ ThermostatHistoryReadModelPagedListResult;
export type GetApiThermostatsThermostatHistoryApiArg = {
  from?: string;
  to?: string;
  thermostatId?: string;
  types?: ThermostatHistoryType[];
  "Sort.SortOption"?: SortGetThermostatHistoryQueryOptions;
  "Sort.Direction"?: SortDirection;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatHistoryApiResponse =
  /** status 200 OK */ ThermostatHistoryReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatHistoryApiArg =
  {
    from?: string;
    to?: string;
    thermostatId?: string;
    types?: ThermostatHistoryType[];
    "Sort.SortOption"?: SortGetThermostatHistoryQueryOptions;
    "Sort.Direction"?: SortDirection;
    page: number;
    pageSize: number;
    orgId: string;
    tenantId: string;
  };
export type GetApiThermostatsThermostatHistoryRadiatorsApiResponse =
  /** status 200 OK */ ThermostatTaxonomyHistoryReadModel[];
export type GetApiThermostatsThermostatHistoryRadiatorsApiArg = {
  radiatorIds?: string[];
};
export type GetApiGatewaysSpaceBySpaceIdApiResponse =
  /** status 200 OK */ GatewayReadModelPagedListResult;
export type GetApiGatewaysSpaceBySpaceIdApiArg = {
  spaceId: string;
  page: number;
  pageSize: number;
};
export type GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysSpaceSpaceIdApiResponse =
  /** status 200 OK */ GatewayReadModelPagedListResult;
export type GetApiV2OrgByOrgIdTenantAndTenantIdGatewaysSpaceSpaceIdApiArg = {
  spaceId: string;
  page: number;
  pageSize: number;
  orgId: string;
  tenantId: string;
};
export type PostApiDevelopmentOnboardingSensorsApiResponse =
  /** status 200 OK */ OnboardDevicesReport;
export type PostApiDevelopmentOnboardingSensorsApiArg = {
  body: {
    SensorType?: SensorType;
    ChirpstackApplicationId?: string;
    ChirpstackDeviceProfileId?: string;
    SkipChirpstack?: boolean;
    SkipAdminApp?: boolean;
    File?: Blob;
  };
};
export type PostApiDevelopmentOnboardingSignalTestersApiResponse =
  /** status 200 OK */ OnboardDevicesReport;
export type PostApiDevelopmentOnboardingSignalTestersApiArg = {
  body: {
    ChirpstackDeviceProfileId?: string;
    ChirpstackApplicationId?: string;
    SkipChirpstack?: boolean;
    SkipAdminApp?: boolean;
    File?: Blob;
  };
};
export type AdminAppSettingCode =
  | "ThermostatInitialization_RedundantCommandCount"
  | "ThermostatInitialization_UplinkPeriodThresholdHours"
  | "RenterVerification_Voltage"
  | "RenterVerification_FirmwareVersion"
  | "RenterVerification_ResetAttemptsCount"
  | "RenterVerification_InitAttemptsCount"
  | "RenterVerification_RequestAttemptsCount"
  | "RenterVerification_NameAttemptsCount"
  | "DataTransferToDeviceBatchValidation_RejectionBatteryThreshold"
  | "DataTransferToDeviceBatchValidation_WarningBatteryThreshold"
  | "DataTransferToDeviceBatchValidation_RejectionLastSeenDays"
  | "DataTransferToDeviceBatchValidation_WarningLastSeenDays";
export type Int32AdminAppSettingReadModelValue = {
  code: AdminAppSettingCode;
  value: number;
  description: string;
  isDefault: boolean;
};
export type ThermostatInitializationSettingsReadModel = {
  redundantCommandCount: Int32AdminAppSettingReadModelValue;
  uplinkPeriodThresholdHours: Int32AdminAppSettingReadModelValue;
};
export type Voltage = {
  value: number;
  milliVolts: number;
  volts: number;
};
export type VoltageAdminAppSettingReadModelValue = {
  code: AdminAppSettingCode;
  value?: Voltage | null;
  description: string;
  isDefault: boolean;
};
export type FirmwareVersion = {
  major: number;
  minor: number;
  patch: number;
  rcVersion?: number | null;
  devVersion?: number | null;
};
export type FirmwareVersionAdminAppSettingReadModelValue = {
  code: AdminAppSettingCode;
  value?: FirmwareVersion | null;
  description: string;
  isDefault: boolean;
};
export type RenterVerificationSettingsReadModel = {
  minimumVoltage: VoltageAdminAppSettingReadModelValue;
  minimumFirmwareVersion: FirmwareVersionAdminAppSettingReadModelValue;
  initAttemptsCount: Int32AdminAppSettingReadModelValue;
  requestAttemptsCount: Int32AdminAppSettingReadModelValue;
  nameAttemptsCount: Int32AdminAppSettingReadModelValue;
  resetAttemptsCount: Int32AdminAppSettingReadModelValue;
};
export type DataTransferToDeviceBatchValidationSettingsReadModel = {
  rejectionBatteryThreshold: VoltageAdminAppSettingReadModelValue;
  warningBatteryThreshold: VoltageAdminAppSettingReadModelValue;
  rejectionLastSeenDays: Int32AdminAppSettingReadModelValue;
  warningLastSeenDays: Int32AdminAppSettingReadModelValue;
};
export type AdminAppSettingsReadModel = {
  thermostatInitializationSettings: ThermostatInitializationSettingsReadModel;
  renterVerificationSettings: RenterVerificationSettingsReadModel;
  dataTransferToDeviceBatchValidationSettingsReadModel: DataTransferToDeviceBatchValidationSettingsReadModel;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type ThermostatAlertType =
  | "None"
  | "BatteryLevelLow"
  | "MotorNeedsCalibration"
  | "NonOperationalMode"
  | "ConnectedNotAssigned"
  | "LowDataRate"
  | "CalibrationUnstable";
export type BatteryLowAlertPayloadReadModel = {
  type: ThermostatAlertType;
  currentLevel: number;
};
export type LowDataRateAlertPayloadReadModel = {
  type: ThermostatAlertType;
  dataRate?: number | null;
  spreadingFactor?: number | null;
};
export type MajorMode = "Unknown" | "Installation" | "Normal" | "Summer";
export type NonOperationalModeAlertPayloadReadModel = {
  type: ThermostatAlertType;
  mode: MajorMode;
};
export type VoidPayloadReadModel = {
  type: ThermostatAlertType;
};
export type RoomType =
  | "Bedroom"
  | "Kitchen"
  | "LivingRoom"
  | "DiningRoom"
  | "KidsRoom"
  | "Corridor"
  | "Bathroom"
  | "Toilet"
  | "Other"
  | "WorkRoom"
  | "Parking"
  | "Entrance"
  | "Lobby"
  | "Reception"
  | "UtilityRoom"
  | "ServerRoom"
  | "TechRoom"
  | "Staircase"
  | "StorageRoom"
  | "Warehouse"
  | "MeetingRoom"
  | "Office"
  | "QuietRoom"
  | "CallRoom"
  | "BreakRoom"
  | "PresentationRoom"
  | "OpenOffice";
export type FirmwareVersionReadModel = {
  version: string;
  major: number;
  minor: number;
  patch: number;
  comparisonKey: number;
};
export type ThermostatAlertReadModel = {
  thermostatId: string;
  eui: string;
  reportedAt: string;
  payload:
    | BatteryLowAlertPayloadReadModel
    | LowDataRateAlertPayloadReadModel
    | NonOperationalModeAlertPayloadReadModel
    | VoidPayloadReadModel;
  address?: string | null;
  roomType?: RoomType | null;
  floor?: number | null;
  buildingUnitName?: string | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  tenantName: string;
  tenantId: string;
  alertId: string;
  remoteActionAvailable: boolean;
};
export type ThermostatAlertReadModelPagedListResult = {
  items: ThermostatAlertReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetThermostatAlertsQueryOptions =
  "ReportedAt" | "FirmwareVersion" | "TenantName";
export type SortDirection = "Ascending" | "Descending";
export type ThermostatAlertTypeCountReadModel = {
  alertType: ThermostatAlertType;
  count: number;
};
export type ThermostatAlertStatisticReadModel = {
  alertTypeCounts: ThermostatAlertTypeCountReadModel[];
  totalCount: number;
};
export type ThermostatWithAlertReadModel = {
  id: string;
  eui: string;
};
export type AddAppointmentRequest = {
  buildingUnitId: string;
  occursAt: string;
  note?: string | null;
};
export type AppointmentReadModel = {
  id: string;
  occursAt: string;
  note?: string | null;
};
export type UpdateAppointmentRequest = {
  occursAt: string;
  note?: string | null;
};
export type AddBuildingComplexFloors = {
  name: string;
  level: number;
};
export type AddBuildingComplexRequest = {
  parentId: string;
  name: string;
  description?: string | null;
  floorsUp?: AddBuildingComplexFloors[] | null;
  floorsDown?: AddBuildingComplexFloors[] | null;
};
export type SpaceType =
  | "Unknown"
  | "Location"
  | "BuildingComplex"
  | "Building"
  | "BuildingUnit"
  | "Room"
  | "Radiator";
export type TaxonomyPath = {
  locationId?: string | null;
  buildingComplexId?: string | null;
  buildingId?: string | null;
  buildingUnitId?: string | null;
  roomId?: string | null;
  radiatorId?: string | null;
};
export type FloorDirection = "Upward" | "Downward";
export type FloorReadModel = {
  id: string;
  name: string;
  direction: FloorDirection;
  level: number;
};
export type BuildingComplexReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  description?: string | null;
  taxonomyPath: TaxonomyPath;
  heatingCircuitId?: string | null;
  definedFloorsUp: FloorReadModel[];
  definedFloorsDown: FloorReadModel[];
  lastModifiedAt: string;
  createdAt: string;
};
export type UpdateBuildingComplexFloors = {
  id?: string | null;
  name: string;
  level: number;
};
export type UpdateBuildingComplexRequest = {
  name: string;
  description?: string | null;
  floorsUp?: UpdateBuildingComplexFloors[] | null;
  floorsDown?: UpdateBuildingComplexFloors[] | null;
};
export type LocationTreeNodeReadModel = {
  id: string;
  name: string;
};
export type BuildingTreeNodeReadModel = {
  id: string;
  name: string;
  circuitIds: string[];
  lastFloorInhabited?: boolean | null;
};
export type BuildingComplexTreeReadModel = {
  buildingComplex: LocationTreeNodeReadModel;
  buildings: BuildingTreeNodeReadModel[];
};
export type MoveBuildingComplexesToLocationRequest = {
  sourceLocationId: string;
  targetLocationId: string;
  buildingComplexIds: string[];
};
export type AddFloorRequest = {
  name: string;
  direction: FloorDirection;
  level: number;
};
export type FloorReadModelPagedListResult = {
  items: FloorReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type UpdateFloorRequest = {
  name: string;
  direction: FloorDirection;
  level: number;
};
export type RenowateItemSyncStatus = "None" | "Succeeded" | "Failed";
export type BuildingUnitProjectDetailsReadModel = {
  id: string;
  name: string;
};
export type AddBuildingUnitReadModel = {
  id: string;
  status: RenowateItemSyncStatus;
  renowateProjectDetails?: BuildingUnitProjectDetailsReadModel | null;
};
export type BuildingUnitType = "Residential" | "Public" | "Commercial";
export type InstallationProgressStatus =
  "Open" | "Finalized" | "OnHold" | "AccessNotPossible";
export type AccessNotPossibleReason =
  | "AccessNotPossible"
  | "TenantAbsent"
  | "NoAdultPresent"
  | "TenantDeniesEntry"
  | "DangerousEnvironment"
  | "Other";
export type AddBuildingUnitRequest = {
  parentId: string;
  name: string;
  buildingUnitType: BuildingUnitType;
  installationProgressStatus: InstallationProgressStatus;
  accessNotPossibleReason?: AccessNotPossibleReason | null;
  installationDescription?: string | null;
  enableWindowsSensors: boolean;
  description?: string | null;
  customerId?: string | null;
  appointmentOccursAt?: string | null;
};
export type RenterReadModel = {
  id: string;
  firstName?: string | null;
  surname?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  dataPrivacyAgreement: boolean;
  dataPrivacyAgreementSigned?: boolean | null;
  dataPrivacyAgreedAt?: string | null;
  dataPrivacyRevokedAt?: string | null;
  infoReceivedAgreement?: boolean | null;
};
export type SpaceAncestryNodeReadModel = {
  id: string;
  name: string;
};
export type SpaceAncestryReadModel = {
  location?: SpaceAncestryNodeReadModel | null;
  buildingComplex?: SpaceAncestryNodeReadModel | null;
  building?: SpaceAncestryNodeReadModel | null;
  buildingUnit?: SpaceAncestryNodeReadModel | null;
  room?: SpaceAncestryNodeReadModel | null;
  radiator?: SpaceAncestryNodeReadModel | null;
};
export type LeaseReadModel = {
  id: string;
  startsAt?: string | null;
  endsAt?: string | null;
  buildingUnitId: string;
  renter: RenterReadModel;
  taxonomy?: SpaceAncestryReadModel | null;
};
export type BuildingUnitReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  buildingUnitType?: BuildingUnitType | null;
  installationProgressStatus: InstallationProgressStatus;
  accessNotPossibleReason?: AccessNotPossibleReason | null;
  installationDescription?: string | null;
  customerId?: string | null;
  description?: string | null;
  taxonomyPath: TaxonomyPath;
  roomCount: number;
  heatingCircuitId?: string | null;
  floors: string[];
  appointment?: AppointmentReadModel | null;
  lease?: LeaseReadModel | null;
  lastModifiedAt: string;
  createdAt: string;
  enableWindowsSensors: boolean;
};
export type UpdateBuildingUnitRequest = {
  name: string;
  buildingUnitType: BuildingUnitType;
  installationProgressStatus: InstallationProgressStatus;
  accessNotPossibleReason?: AccessNotPossibleReason | null;
  installationDescription?: string | null;
  description?: string | null;
  enableWindowsSensors: boolean;
  customerId?: string | null;
  appointmentOccursAt?: string | null;
};
export type LocationTreeFloorReadModel = {
  id: string;
  name: string;
  level: number;
};
export type BuildingUnitTreeNodeReadModel = {
  id: string;
  name: string;
  circuitIds: string[];
  floors: LocationTreeFloorReadModel[];
  tenantName?: string | null;
};
export type RoomTreeNodeReadModel = {
  id: string;
  name: string;
  circuitIds: string[];
  roomType?: RoomType | null;
};
export type BuildingUnitTreeReadModel = {
  buildingUnit: BuildingUnitTreeNodeReadModel;
  rooms: RoomTreeNodeReadModel[];
};
export type UpdateBuildingUnitStatusRequest = {
  installationProgressStatus: InstallationProgressStatus;
  accessNotPossibleReason?: AccessNotPossibleReason | null;
};
export type RoofType = "Flat" | "Pitched";
export type AddThermostatInstallationDateRange = {
  from: string;
  to: string;
};
export type AddBuildingRequest = {
  parentId: string;
  name: string;
  constructionYear?: number | null;
  locationGeocodingId: string;
  roofType?: RoofType | null;
  hasBasement?: boolean | null;
  lastFloorInhabited?: boolean | null;
  roofRenovationYear?: number | null;
  wallRenovationYear?: number | null;
  windowRenovationYear?: number | null;
  enableRadiatorVentingService?: boolean | null;
  recommendedNumberOfGateways?: number | null;
  thermostatInstallationDateRange?: AddThermostatInstallationDateRange | null;
  uRoof?: number | null;
  uExternalWall?: number | null;
  uBasement?: number | null;
  uWindow?: number | null;
  description?: string | null;
};
export type CeilingMaterial = "Concrete" | "Wood";
export type DateOnlyRangeReadModel = {
  from: string;
  to: string;
};
export type ProjectStatus = "Active" | "Archived";
export type BuildingProjectReadModel = {
  id: string;
  name: string;
  projectIdentification?: string | null;
  startsAt?: string | null;
  status: ProjectStatus;
};
export type BuildingServiceOverview = {
  radiatorVentingServiceEnabled?: boolean | null;
};
export type BuildingRenovationType = "Window" | "Wall" | "Roof";
export type BuildingRenovationDetailsReadModel = {
  type: BuildingRenovationType;
  year?: number | null;
};
export type BuildingReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  locationGeocodingId?: string | null;
  street?: string | null;
  number?: string | null;
  city?: string | null;
  zipCode?: string | null;
  country?: string | null;
  constructionYear?: number | null;
  description?: string | null;
  taxonomyPath: TaxonomyPath;
  heatingCircuitId?: string | null;
  lastModifiedAt: string;
  createdAt: string;
  roofType?: RoofType | null;
  hasBasement?: boolean | null;
  isLastFloorInhabited?: boolean | null;
  ceilingMaterial?: CeilingMaterial | null;
  gatewayInstallationRequested: boolean;
  thermostatInstallationDateRange?: DateOnlyRangeReadModel | null;
  thermostatInstallationFlyerPosted: boolean;
  numberOfResidentialUnits: number;
  heatQuantity?: number | null;
  numberOfGateways: number;
  recommendedNumberOfGateways?: number | null;
  lastProject?: BuildingProjectReadModel | null;
  servicesOverview: BuildingServiceOverview;
  renovationDetails: BuildingRenovationDetailsReadModel[];
  uRoof?: number | null;
  uBasement?: number | null;
  uExternalWall?: number | null;
  uWindow?: number | null;
};
export type UpdateThermostatInstallationDateRange = {
  from: string;
  to: string;
};
export type UpdateBuildingRequest = {
  name: string;
  locationGeocodingId: string;
  roofType?: RoofType | null;
  hasBasement?: boolean | null;
  lastFloorInhabited?: boolean | null;
  constructionYear?: number | null;
  roofRenovationYear?: number | null;
  wallRenovationYear?: number | null;
  windowRenovationYear?: number | null;
  enableRadiatorVentingService?: boolean | null;
  thermostatInstallationDateRange?: UpdateThermostatInstallationDateRange | null;
  thermostatInstallationFlyerPosted?: boolean | null;
  recommendedNumberOfGateways?: number | null;
  uRoof?: number | null;
  uExternalWall?: number | null;
  uBasement?: number | null;
  uWindow?: number | null;
  description?: string | null;
};
export type BuildingTreeReadModel = {
  building: BuildingTreeNodeReadModel;
  units: BuildingUnitTreeNodeReadModel[];
};
export type AddOrUpdateGatewaySignalQualityRequest = {
  signalTesterId?: string | null;
  description?: string | null;
};
export type GatewaySignalTestStatus = "None" | "Partially" | "Complete";
export type GatewaySignalStrength = "None" | "Weak" | "Strong";
export type BuildingGatewayFloorSignalQualityReadModel = {
  floorId: string;
  level: number;
  name: string;
  signalStrength?: GatewaySignalStrength | null;
};
export type BuildingGatewaySignalTestResultReadModel = {
  status: GatewaySignalTestStatus;
  tests: BuildingGatewayFloorSignalQualityReadModel[];
  signalTesterId?: string | null;
  signalTesterEui?: string | null;
  description?: string | null;
};
export type BuildingGatewayInstallationIssueReadModel = {
  buildingInaccessible: boolean;
  installationNotPossible: boolean;
  noAccessiblePowerSupply: boolean;
  gatewayDoesNotGoOnline: boolean;
  signalNotTestableOnAllFloors: boolean;
  buildingDetailsNotCollectible: boolean;
  cannotPostFlyer: boolean;
  other: boolean;
  details?: string | null;
};
export type UpdateGatewayInstallationIssuesRequest = {
  buildingInaccessible: boolean;
  installationNotPossible: boolean;
  noAccessiblePowerSupply: boolean;
  gatewayDoesNotGoOnline: boolean;
  signalNotTestableOnAllFloors: boolean;
  buildingDetailsNotCollectible: boolean;
  cannotPostFlyer: boolean;
  other: boolean;
  details?: string | null;
};
export type UpdateGatewaySignalQualityFloorRequest = {
  floorId: string;
  strength?: GatewaySignalStrength | null;
  signalTesterId: string;
};
export type AddDataPrivacyRequest = {
  content: string;
};
export type DataPrivacyReadModel = {
  id: string;
  version: number;
  content: string;
  createdBy: string;
  createdAt: string;
};
export type CreateDataPrivacyAgreementUserRequest = {
  email: string;
  firstName: string;
  surname: string;
  street: string;
  number: string;
  city: string;
  zipCode: string;
};
export type DataPrivacyAgreementReadModel = {
  id: string;
  firstName: string;
  surname: string;
  email: string;
  agreed: boolean;
  street: string;
  number: string;
  city: string;
  zipCode: string;
  processed: boolean;
  createdAt: string;
  agreedAt?: string | null;
  revokedAt?: string | null;
};
export type DataPrivacyAgreementReadModelPagedListResult = {
  items: DataPrivacyAgreementReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetDataPrivacyAgreementsQueryOptions =
  | "CreatedAt"
  | "Processed"
  | "CityName"
  | "StreetName"
  | "HouseNumber"
  | "Email";
export type UpdateDataPrivacyAgreementRequest = {
  processed: boolean;
};
export type HardwareRevision = {
  value: number;
};
export type DataTransferToDeviceType =
  "Unknown" | "Core" | "App" | "StaticData";
export type DataTransferProgressStatus =
  "Completed" | "InProgress" | "Aborted" | "Scheduled";
export type AutoFuotaThermostatRow = {
  autoFuotaId: string;
  transferId?: string | null;
  eui: string;
  thermostatId: string;
  hardwareVersion?: HardwareRevision | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  componentsFingerprintHash?: string | null;
  spreadingFactor?: number | null;
  startFirmwareVersion?: FirmwareVersionReadModel | null;
  startComponentsFingerprintHash?: string | null;
  lastSeenAt?: string | null;
  name?: string | null;
  type: DataTransferToDeviceType;
  status: DataTransferProgressStatus;
  size?: number | null;
  payloadHash: string;
  progress: number | null;
  progressPercent?: number | null;
  scheduledAt: string;
  startedAt?: string | null;
  lastProgressAt?: string | null;
  finishedAt?: string | null;
  errorCorrecting?: boolean | null;
  scheduledByUserEmail?: string | null;
  abortedByUserEmail?: string | null;
  abortedReason?: string | null;
  isForced: boolean;
};
export type AutoFuotaThermostatRowPagedListResult = {
  items: AutoFuotaThermostatRow[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type StringFilterType =
  | "Equals"
  | "NotEquals"
  | "Contains"
  | "NotContains"
  | "StartsWith"
  | "NotStartsWith"
  | "EndsWith"
  | "NotEndsWith";
export type SortGetAutoFuotaThermostatsOptions =
  "LastProgressAt" | "ScheduledAt" | "StartedAt" | "FinishedAt" | "Progress";
export type DeviceNetworkStatus = "Unknown" | "Online" | "Offline";
export type GatewayPlacement =
  | "Basement"
  | "BasementHeatingRoom"
  | "Hallway"
  | "Entrance"
  | "MainStaircase"
  | "Attic"
  | "Other";
export type Status = "Operational" | "Warning" | "Unreachable" | "Unknown";
export type GatewayOpsRow = {
  id: string;
  eui: string;
  status: DeviceNetworkStatus;
  lastSeenAt?: string | null;
  lastThermostatUplinkAt?: string | null;
  assignedAt?: string | null;
  placement?: GatewayPlacement | null;
  buildingId?: string | null;
  buildingStreet?: string | null;
  buildingNumber?: string | null;
  buildingZipCode?: string | null;
  buildingCity?: string | null;
  cellularIccid?: number | null;
  cellularStrength?: number | null;
  kerosVersion?: string | null;
  wanesyStatus?: Status | null;
  wanesyLastSeenAt?: string | null;
  totalThermostatCount: number;
  installationThermostatCount: number;
  summerModeThermostatCount: number;
  normalModeThermostatCount: number;
  dataTransferInProgressThermostatCount: number;
  dataTransferScheduledThermostatCount: number;
  crossBuildingThermostatCount: number;
  autoFuotaCollisionChance?: number | null;
};
export type GatewayOpsRowPagedListResult = {
  items: GatewayOpsRow[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetGatewaysOpsOptions =
  | "LastSeenAt"
  | "LastThermostatUplinkAt"
  | "WanesyLastSeenAt"
  | "SignalStrength"
  | "TotalCount"
  | "InstallationCount"
  | "SummerModeCount"
  | "NormalModeCount"
  | "DataTransferInProgressCount"
  | "DataTransferScheduledCount"
  | "CollisionChance";
export type GatewayThermostatOpsRowDataTransfer = {
  type: DataTransferToDeviceType;
  name?: string | null;
  hash: string;
  status: DataTransferProgressStatus;
  size: number;
  scheduledAt?: string | null;
  startedAt?: string | null;
  progress: number;
  progressPercent: number;
};
export type GatewayThermostatOpsRow = {
  id: string;
  tenantId: string;
  tenantName: string;
  buildingName?: string | null;
  buildingStreet?: string | null;
  buildingNumber?: string | null;
  buildingZip?: string | null;
  buildingCity?: string | null;
  buildingMismatch: boolean;
  eui: string;
  lastSeenAt?: string | null;
  operationMode: MajorMode;
  batteryLevel?: number | null;
  batteryVoltage?: Voltage | null;
  hardwareVersion?: HardwareRevision | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  componentsFingerprintHash?: string | null;
  spreadingFactor?: number | null;
  frequency?: number | null;
  rssi?: number | null;
  snr?: number | null;
  usageRatio?: number | null;
  lastDataTransfer?: GatewayThermostatOpsRowDataTransfer | null;
};
export type GatewayThermostatOpsRowPagedListResult = {
  items: GatewayThermostatOpsRow[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetGatewayThermostatsOpsOptions =
  "Battery" | "LastSeenAt" | "UsageRatio" | "BuildingMismatch";
export type FetchThermostatFlashRequest = {
  name: string;
  address: number;
  length: number;
};
export type FetchThermostatLogsRequest = {
  name: string;
};
export type FetchThermostatRamRequest = {
  name: string;
  address: number;
  length: number;
};
export type TermiosBankId = "Ram" | "Flash" | "Log" | "Unknown";
export type DataTransferFromDeviceError =
  | "None"
  | "InvalidBankId"
  | "InvalidTooManyParams"
  | "InvalidBadParam"
  | "InvalidOffset"
  | "TruncatedData"
  | "EarlyDoneRequest";
export type DataTransferFromThermostatRow = {
  transferId: string;
  eui: string;
  thermostatId: string;
  hardwareVersion?: HardwareRevision | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  componentsFingerprintHash?: string | null;
  name: string;
  bankId: TermiosBankId;
  status: DataTransferProgressStatus;
  totalSize?: number | null;
  progress: number;
  startedAt: string;
  lastReceivedAt?: string | null;
  error?: DataTransferFromDeviceError | null;
  email?: string | null;
};
export type DataTransferFromThermostatRowPagedListResult = {
  items: DataTransferFromThermostatRow[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type CommandCode =
  | "Unknown"
  | "McuReset"
  | "SetMotorPositionConstraint"
  | "SetMotorPosition"
  | "ToggleDirectMotorControl"
  | "MotorOutwardStallDetection"
  | "MotorInwardStallDetection"
  | "ConfigureAutoCalibration"
  | "SetTargetTemperatureLevel"
  | "SetTargetTemperature"
  | "SetTargetTemperatureAndLevel"
  | "SetTargetTemperatureLevelMapping"
  | "ConfigureMeasurements"
  | "SetDisplayRotation"
  | "SetMajorMode"
  | "DataTransferGetAppsInfo"
  | "DataTransferAbort"
  | "DataTransferPause"
  | "DataTransferResume"
  | "DataTransferSpeedup"
  | "DataTransferSendApp"
  | "DataTransferSendStaticData"
  | "DataTransferSendCore"
  | "DataTransferInstallCore"
  | "DataTransferFetchDataReq"
  | "DataTransferFetchDataFragment"
  | "DataTransferFetchDataDone"
  | "GeneralGetInfo"
  | "InternalSuperBlockGc"
  | "SetAmbientTemperature"
  | "SendAppData";
export type DownlinkCommandResponse = {
  commandId: string;
  code: CommandCode;
};
export type DownlinkResponse = {
  downlinkId: string;
  command: DownlinkCommandResponse;
  expiresAt?: string | null;
};
export type DispatchDataTransferAbortRequest = {
  fromCloudToDevice: boolean;
  fromDeviceToCloud: boolean;
};
export type TermiosAppId =
  | "Unknown"
  | "DeltaDecoder"
  | "Behavior"
  | "ScreenRasterizer"
  | "MeasurementsCorrector"
  | "UplinkEncoder"
  | "DownlinkDecoder"
  | "DebugAgent"
  | "MotorControl";
export type DispatchDataTransferGetAppsInfoRequest = {
  apps?: TermiosAppId[] | null;
};
export type DispatchDataTransferInstallCoreRequest = {
  force: boolean;
};
export type DispatchDataTransferPauseRequest = {
  fromCloudToDevice: boolean;
  fromDeviceToCloud: boolean;
};
export type DispatchDataTransferResumeRequest = {
  fromCloudToDevice: boolean;
  fromDeviceToCloud: boolean;
};
export type DispatchDataTransferSendAppRequest = {
  overwrite: boolean;
  offset: number;
  data: string;
};
export type DispatchDataTransferSendCoreRequest = {
  offset: number;
  data: string;
};
export type DispatchDataTransferSendStaticDataRequest = {
  overwrite: boolean;
  offset: number;
  data: string;
};
export type DispatchDataTransferSpeedUpRequest = {
  power: number;
};
export type ScheduleDataTransferResultError =
  | "Unknown"
  | "UnknownThermostat"
  | "IncompatibleArtifactVersion"
  | "AnotherTransferInProgress"
  | "EmptyPayload"
  | "DeviceAlreadyScheduled"
  | "SpreadingFactorTooHigh"
  | "NotInNormalMode"
  | "Internal";
export type ScheduleBulkDataTransferResultEntry = {
  eui: string;
  transferId?: string | null;
  autoFuotaId?: string | null;
  error?: ScheduleDataTransferResultError | null;
};
export type ScheduleBulkDataTransferResult = {
  entries: ScheduleBulkDataTransferResultEntry[];
};
export type ThermostatArtifactStatus =
  "Unknown" | "SameVersion" | "LowerVersion" | "HigherVersion";
export type FirmwareUpdateDashboardRow = {
  thermostatId: string;
  lastStatusUplinkAt: string;
  currentHardwareRevision: HardwareRevision;
  currentVersion: string;
  targetVersion?: string | null;
  targetVersionKey?: number | null;
  firmwareStatus: ThermostatArtifactStatus;
  updateInProgress: boolean;
  dataTransferInProgress: boolean;
  lastUplinkAt?: string | null;
};
export type DataTransferToDeviceResult = {
  thermostatId: string;
  type: DataTransferToDeviceType;
  name: string;
  hash: string;
  startedAt: string;
  lastQueuedAt: string;
  length: number;
  dispatched: number;
  paused: boolean;
};
export type ThermostatFirmwareInfoReadModel = {
  id: string;
  eui: string;
  hardwareRevision?: HardwareRevision | null;
  firmwareVersion?: FirmwareVersion | null;
};
export type CreateDataTransferToDeviceBatchPhaseRequest = {
  batchId: string;
  phaseSize: number;
};
export type DataTransferToDeviceBatchStatus =
  "Pending" | "Running" | "Completed" | "Aborted";
export type TermiosAppVersion = {
  appId: TermiosAppId;
  major: number;
  minor: number;
  patch: number;
  rcVersion?: number | null;
  devVersion?: number | null;
};
export type DataTransferToDeviceBatchReadModel = {
  id: string;
  tenantId: string;
  name: string;
  notes?: string | null;
  createdById: string;
  createdByName: string;
  lastModifiedAt: string;
  createdAt: string;
  status: DataTransferToDeviceBatchStatus;
  lastPhaseSize: number;
  totalCount: number;
  pendingCount: number;
  scheduledCount: number;
  failedCount: number;
  abortedCount: number;
  runningCount: number;
  updatedCount: number;
  dataTransferToDeviceType: DataTransferToDeviceType;
  firmwareVersion?: FirmwareVersion | null;
  appVersion?: TermiosAppVersion | null;
};
export type DataTransferToDeviceBatchReadModelPagedListResult = {
  items: DataTransferToDeviceBatchReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetDataTransferToDeviceBatchesQueryOptions =
  "StartDate" | "Name" | "Status" | "CreatedBy";
export type DataTransferToDeviceBatchPhaseStatus = "InProgress" | "Done";
export type DataTransferToDeviceBatchPhaseReadModel = {
  id: string;
  createdAt: string;
  phaseNumber: number;
  size: number;
  status: DataTransferToDeviceBatchPhaseStatus;
  startedAt: string;
  startedByFirstName?: string | null;
  startedByLastName?: string | null;
  finishedAt?: string | null;
  abortedAt?: string | null;
  abortedByFirstName?: string | null;
  abortedByLastName?: string | null;
  totalCount: number;
  scheduledCount: number;
  failedCount: number;
  abortedCount: number;
  completedCount: number;
  runningCount: number;
};
export type DataTransferToDeviceBatchPhaseReadModelPagedListResult = {
  items: DataTransferToDeviceBatchPhaseReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type TenantReadModel = {
  id: string;
  name: string;
};
export type DataTransferToDeviceBatchCounts = {
  total: number;
  healthy: number;
  rejected: number;
  warning: number;
};
export type DataTransferToDeviceBatchReasonsType =
  | "DuplicateEuiInCsv"
  | "EuiInAnotherBatch"
  | "BatteryVoltageIsNull"
  | "BatteryVoltageLowerThanRejectionThreshold"
  | "NotInNormalMode"
  | "LastSeenIsNull"
  | "NotSeenSinceRejectionTimeSpan"
  | "BatteryVoltageLowerThanWarningThreshold"
  | "NotSeenSinceWarningTimeSpan";
export type DataTransferToDeviceBatchThermostatEvaluation = {
  eui: string;
  reasons: DataTransferToDeviceBatchReasonsType[];
};
export type DataTransferToDeviceBatchPreview = {
  tenant: TenantReadModel;
  counts: DataTransferToDeviceBatchCounts;
  rejected: DataTransferToDeviceBatchThermostatEvaluation[];
  withWarnings: DataTransferToDeviceBatchThermostatEvaluation[];
};
export type DataTransferToDeviceBatchPreviewReadModel = {
  batchPreviews: DataTransferToDeviceBatchPreview[];
  processedAt: string;
};
export type ThermostatOperationCode =
  | "SetMajorMode"
  | "SetDisplayRotation"
  | "InstallationSetup"
  | "EnableDirectMotorControl"
  | "SetMotorPosition"
  | "SetMotorPositionConstraint"
  | "DisableDirectMotorControl"
  | "SetTargetTemperature"
  | "SetTargetTemperatureLevel"
  | "SetTemperatureLookup"
  | "SetAmbientTemperature"
  | "ToggleActiveHarvesting"
  | "McuReset"
  | "ManualCalibration"
  | "FlushValve"
  | "StartNightReduction"
  | "EndNightReduction";
export type ThermostatOperationCommandStatus =
  "SchedulingFailed" | "Scheduled" | "Success" | "Failed" | "TimedOut";
export type CommandErrorCode =
  | "None"
  | "McuResetUnknownError"
  | "MotorSetMotorPositionConstraintUnknownError"
  | "MotorSetMotorPositionConstraintInvalidValue"
  | "MotorSetMotorPositionUnknownError"
  | "MotorSetMotorPositionInvalidValue"
  | "MotorSetMotorPositionNeedsDirectMotorControl"
  | "MotorSetMotorPositionNeedsCalibratedMotor"
  | "MotorActivateDirectMotorControlUnknownError"
  | "MotorActivateDirectMotorControlNeedsCalibratedMotor"
  | "MotorOutwardStallDetectionUnknownError"
  | "MotorOutwardStallDetectionNeedsDirectMotorControl"
  | "MotorInwardStallDetectionUnknownError"
  | "MotorInwardStallDetectionNeedsDirectMotorControl"
  | "TargetTemperatureSetLevelUnknownError"
  | "TargetTemperatureSetLevelInvalidValue"
  | "TargetTemperatureSetLevelOverwrittenByUser"
  | "TargetTemperatureSetTemperatureUnknownError"
  | "TargetTemperatureSetTemperatureInvalidValue"
  | "TargetTemperatureSetTemperatureOverwrittenByUser"
  | "TargetTemperatureSetTemperatureAndLevelUnknownError"
  | "TargetTemperatureSetTemperatureAndLevelInvalidValue"
  | "TargetTemperatureSetTemperatureAndLevelOverwrittenByUser"
  | "MeasurementConfigUnknownError"
  | "MeasurementConfigInvalidTimios"
  | "MeasurementConfigInvalidTransmission"
  | "MeasurementConfigInvalidTemperature"
  | "MeasurementConfigInvalidHumidity"
  | "MeasurementConfigInvalidHmt"
  | "MeasurementConfigInvalidTeg"
  | "DisplaySetRotationUnknownError"
  | "DisplaySetRotationInvalidValue"
  | "ModeSetMajorModeUnknownError"
  | "ModeSetMajorModeInvalidValue"
  | "ModeSetMajorModeOngoingDataTransfer"
  | "DataTransferGetAppsInfoUnknownError"
  | "DataTransferAbortUnknownError"
  | "DataTransferAbortNoOngoingDataTransfer"
  | "DataTransferPauseUnknownError"
  | "DataTransferPauseNoOngoingDataTransfer"
  | "DataTransferResumeUnknownError"
  | "DataTransferResumeNoPausedDataTransfer"
  | "DataTransferSpeedupUnknownError"
  | "DataTransferSpeedupInvalidValue"
  | "DataTransferSendAppUnknownError"
  | "DataTransferSendAppBadOffset"
  | "DataTransferSendAppBadData"
  | "DataTransferSendAppBadOperationMode"
  | "DataTransferSendAppOtherOngoingDataTransferExists"
  | "DataTransferSendStaticDataUnknownError"
  | "DataTransferSendStaticDataBadOffset"
  | "DataTransferSendStaticDataBadData"
  | "DataTransferSendStaticDataBadOperationMode"
  | "DataTransferSendStaticDataOtherOngoingDataTransferExists"
  | "DataTransferSendCoreUnknownError"
  | "DataTransferSendCoreBadOffset"
  | "DataTransferSendCoreBadData"
  | "DataTransferSendCoreBadOperationMode"
  | "DataTransferSendCoreOtherOngoingDataTransferExists"
  | "DataTransferInstallCoreUnknownError"
  | "DataTransferInstallCoreInvalidState"
  | "DataTransferInstallCoreNoImageHeader"
  | "DataTransferInstallCoreInvalidImage"
  | "DataTransferInstallCoreNewImageIsOlder"
  | "DataTransferFetchDataReqUnknownError"
  | "GeneralGetInfoUnknownError"
  | "InternalSuperBlockGcUnknownError"
  | "TargetTemperatureSetTemperatureLevelMappingUnknownError"
  | "TargetTemperatureSetTemperatureLevelMappingInvalidValue"
  | "MotorAutoCalibrationStrategyUnknownError"
  | "MotorAutoCalibrationStrategyUnknownStrategy"
  | "MotorAutoCalibrationStrategyInvalidValue"
  | "AppDataSendUnknownError"
  | "AppDataSendAppNotExist"
  | "AppDataSendAppCannotDecode"
  | "DataTransferFetchDataFragmentUnknownError"
  | "DataTransferFetchDataFragmentNoOngoingDataTransfer"
  | "DataTransferFetchDataFragmentDeviceInSendingPhase"
  | "DataTransferFetchDataDoneUnknownError"
  | "DataTransferFetchDataDoneNoOngoingDataTransfer"
  | "DataTransferFetchDataDoneEarlyRequest";
export type ThermostatOperationCommandOpsRow = {
  code: CommandCode;
  downlinkIndex?: number | null;
  status: ThermostatOperationCommandStatus;
  errorCode?: CommandErrorCode | null;
};
export type ThermostatOperationOpsRow = {
  id: string;
  eui: string;
  thermostatId: string;
  operationId: string;
  thermostatLastSeenAt?: string | null;
  code: ThermostatOperationCode;
  payload: any | null;
  commands: ThermostatOperationCommandOpsRow[];
  startedAt: string;
  lastUpdatedAt?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  completed: boolean;
  success?: boolean | null;
};
export type ThermostatOperationOpsRowPagedListResult = {
  items: ThermostatOperationOpsRow[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetThermostatOperationsOpsOptions =
  "StartedAt" | "LastUpdatedAt";
export type DeviceConfigVariant =
  | "DisplayRotationMotorPositionMotorPositionConstraint"
  | "DisplayRotationMotorPositionTargetTemperature"
  | "DisplayRotationMotorPositionMotorPositionConstraintTargetTemperature"
  | "TargetTemperatureLevelMapping"
  | "Unknown";
export type DispatchGeneralGetInfoRequest = {
  flags: boolean;
  configVariant?: DeviceConfigVariant | null;
  deviceHealth: boolean;
  deviceFingerprint: boolean;
  now: boolean;
};
export type DispatchMcuResetRequest = {
  storeStateBeforeReset: boolean;
};
export type DisplayRotation =
  | "ZeroDegrees"
  | "NinetyDegrees"
  | "OneEightyDegrees"
  | "TwoSeventyDegrees"
  | "Unknown";
export type DispatchSetDisplayRotationRequest = {
  displayRotation: DisplayRotation;
};
export type DispatchSetMajorModeRequest = {
  mode: MajorMode;
};
export type SeeroMotorPosition = {
  value: number;
};
export type DispatchSetMotorPositionConstraintRequest = {
  value: SeeroMotorPosition;
};
export type DispatchSetMotorPositionRequest = {
  value: SeeroMotorPosition;
  respectConstraint?: boolean | null;
};
export type TargetTemperatureLevel = {
  value: number;
};
export type TriggerThermostatSetTargetTemperatureAndLevelDownlinkRequest = {
  targetTemperature: number;
  level: TargetTemperatureLevel;
};
export type TriggerThermostatSetTargetTemperatureDownlinkRequest = {
  targetTemperature: number;
};
export type DispatchSetTargetTemperatureLevelRequest = {
  level: TargetTemperatureLevel;
};
export type DispatchToggleDirectMotorControlRequest = {
  activate: boolean;
  motorPosition?: SeeroMotorPosition | null;
  respectConstraint?: boolean | null;
  interruptible?: boolean | null;
};
export type TriggerThermostatSetTargetTemperatureLevelMappingDownlinkRequest = {
  lookupTable: number[];
};
export type TimiosDuration = {
  value: number;
};
export type Timios = {
  value: number;
};
export type TermiosDownlinkMeasurementExtendedConfiguration = {
  period: Timios;
  sendRaw: boolean;
};
export type TermiosDownlinkMeasurementConfiguration = {
  period: Timios;
};
export type DispatchConfigureMeasurementsRequest = {
  timiosDuration: TimiosDuration;
  transmissionPeriod: Timios;
  temperature: TermiosDownlinkMeasurementExtendedConfiguration;
  humidity: TermiosDownlinkMeasurementExtendedConfiguration;
  hmt: TermiosDownlinkMeasurementConfiguration;
  teg: TermiosDownlinkMeasurementConfiguration;
};
export type DispatchSuperBlockGcRequest = {
  exceptList: number;
};
export type TriggerConfigureAutoCalibrationClosedValveThresholdRequest = {
  threshold?: number | null;
};
export type ExternalSensorTag =
  | "Dragino"
  | "Elsys"
  | "Reserved3"
  | "Reserved4"
  | "Reserved5"
  | "Reserved6"
  | "Reserved7"
  | "Reserved8"
  | "Unknown";
export type TriggerSetAmbientTemperatureRequest = {
  tag: ExternalSensorTag;
  temperature: number;
  timeToLive?: number | null;
};
export type DispatchSendAppDataRequest = {
  appId: TermiosAppId;
  payload?: string | null;
};
export type DispatchHexCommandRequest = {
  hexCommand: string;
  port: number;
};
export type ChirpstackApplication = {
  id: string;
  name: string;
  description: string;
};
export type ChirpstackDeviceProfile = {
  id: string;
  name: string;
};
export type ChirpstackOnboardingConfigurationData = {
  applications: ChirpstackApplication[];
  deviceProfiles: ChirpstackDeviceProfile[];
};
export type OnboardDeviceRow = {
  devEui: string;
  importedInChirpstack: boolean;
  deviceCreated: boolean;
  reason?: string | null;
};
export type OnboardDevicesReport = {
  excelInvalidReason?: string | null;
  rows?: OnboardDeviceRow[] | null;
};
export type AssemblyLineExportDetailRequest = {
  from?: string | null;
  to?: string | null;
  euis?: string[] | null;
};
export type AssemblyLineExportSummaryRequest = {
  from?: string | null;
  to?: string | null;
  euis?: string[] | null;
};
export type FirmwareCoreDetailsResult = {
  version: FirmwareVersion;
  key: number;
  name: string;
  comment: string;
  releaseDate: string;
  targetHardwareRevisions: HardwareRevision[];
  hash: string;
  compressedHash?: string | null;
};
export type TermiosAppDetailsResult = {
  version: TermiosAppVersion;
  name: string;
  comment: string;
  releaseDate: string;
  minimumFirmware: FirmwareVersion;
  hash: string;
  compressedHash?: string | null;
};
export type GetDeviceImageReadModel = {
  fileName: string;
  storagePath: string;
  thumbnailPath: string;
};
export type DeviceType = "Unknown" | "Thermostat" | "Gateway" | "Sensor";
export type ImageAngle = "Valve" | "CloseUp" | "WideAngle" | "Unknown";
export type DeviceImageMetadataReadModel = {
  id: string;
  fileName: string;
  contentType: string;
  imageAngle: ImageAngle;
};
export type TemplateFile =
  | "ThermostatOnboarding"
  | "ThermostatChirpstackOnboarding"
  | "SensorOnboarding"
  | "ThermostatStatusChange"
  | "ThermostatTenantChange"
  | "GatewayTenantChange"
  | "SignalTesterOnboarding"
  | "TaxonomyImport"
  | "RentersImport"
  | "RentersUpdateImport";
export type BuildingComplexFilterReadModel = {
  id: string;
  name: string;
};
export type FloorFilterReadModel = {
  level: number;
};
export type BuildingFilterReadModel = {
  id: string;
  name: string;
  street?: string | null;
  number?: string | null;
  city?: string | null;
  zipCode?: string | null;
  country?: string | null;
};
export type BuildingUnitFilterReadModel = {
  id: string;
  name: string;
  buildingId: string;
};
export type SensorLifecycleStatus = "Installed" | "Uninstalled";
export type SensorPlacement = "Room" | "Window" | "Heating";
export type SensorType =
  | "DraginoLHT52"
  | "DraginoLDS02"
  | "DraginoLHT65N"
  | "DraginoD23LB"
  | "ElsysErs"
  | "ElsysErs2"
  | "ElsysErs2Lite"
  | "ElsysErsSound"
  | "ElsysErsEye"
  | "ElsysErs2Co2"
  | "ElsysErsCo2Lite";
export type SensorPairingStatus = "Paired" | "Unpaired" | "Inactive";
export type SensorGlobalListReadModel = {
  id: string;
  eui: string;
  serialNumber?: string | null;
  description?: string | null;
  tenantId: string;
  tenantName?: string | null;
  lifecycleStatus: SensorLifecycleStatus;
  placement: SensorPlacement;
  type: SensorType;
  pairingStatus: SensorPairingStatus;
  pairedAt?: string | null;
  status: DeviceNetworkStatus;
  batteryVoltage?: number | null;
  lastSeenAt?: string | null;
  spaceId?: string | null;
  spaceName?: string | null;
  windowId?: string | null;
  heatingCircuitId?: string | null;
  locationName?: string | null;
  buildingComplexName?: string | null;
  buildingName?: string | null;
};
export type SensorGlobalListReadModelPagedListResult = {
  items: SensorGlobalListReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetGlobalSensorListQueryOptions =
  "Eui" | "LastSeenAt" | "LifecycleStatus";
export type HardwareRevisionReadModel = {
  version: string;
  revision: number;
};
export type LocationFilterReadModel = {
  id: string;
  name: string;
};
export type SpaceCustomerReadModel = {
  customerId: string;
};
export type ThermostatDeviceListReadModel = {
  id: string;
  eui: string;
};
export type GetThermostatsAutocompleteRequest = {
  euis: string[];
  tenantIds?: string[] | null;
  take: number;
};
export type SpaceReadModel = {
  id: string;
  spaceType: SpaceType;
  buildingUnitType?: BuildingUnitType | null;
  name: string;
};
export type GatewayInstallationStatus =
  "Done" | "Partially" | "IssueReported" | "NotDone";
export type GatewayLifecycleStatus = "Uninstalled" | "Installed";
export type GatewaySimReadModel = {
  model?: string | null;
  type?: string | null;
  dailyConsumption?: string | null;
  monthlyConsumption?: string | null;
  provisioningDate?: string | null;
  activationDate?: string | null;
  lifecycleStatus?: string | null;
  orderNumber?: string | null;
  operator?: string | null;
  imeiLock?: string | null;
};
export type GatewayInstallationProcessReadModel = {
  isVandalismProtectionBoxMounted: boolean;
  areCablesConnectedToJunctionBox: boolean;
  isGatewayInstalledAndPowered: boolean;
  isImageUploaded: boolean;
  gatewayPlacement?: GatewayPlacement | null;
  note?: string | null;
};
export type GatewayDetailReadModel = {
  id: string;
  eui: string;
  name?: string | null;
  status: DeviceNetworkStatus;
  productId?: string | null;
  macAddress?: string | null;
  spaceId?: string | null;
  description?: string | null;
  buildingAddress?: string | null;
  building?: SpaceReadModel | null;
  buildingComplex?: SpaceReadModel | null;
  location?: SpaceReadModel | null;
  client?: TenantReadModel | null;
  lastSeenAt?: string | null;
  installationStatus: GatewayInstallationStatus;
  lifecycleStatus: GatewayLifecycleStatus;
  lastThermostatUplinkAt?: string | null;
  assignedAt?: string | null;
  autoFuotaCollisionChance?: number | null;
  connectedThermostatCount: number;
  installationThermostatCount: number;
  summerModeThermostatCount: number;
  normalModeThermostatCount: number;
  crossBuildingThermostatCount: number;
  cellularIccid?: string | null;
  kerosVersion?: string | null;
  wanesyConnection?: Status | null;
  cellularStrength?: number | null;
  networkType?: string | null;
  cellularImei?: number | null;
  lastSeenIpAddress?: string | null;
  sim?: GatewaySimReadModel | null;
  installationProcess: GatewayInstallationProcessReadModel;
};
export type AddGatewayRequest = {
  eui: string;
  name?: string | null;
  productId?: string | null;
  macAddress?: string | null;
  description?: string | null;
};
export type GatewayReadModel = {
  id: string;
  eui: string;
  name?: string | null;
  status: DeviceNetworkStatus;
  productId?: string | null;
  macAddress?: string | null;
  buildingAddress?: string | null;
  spaceId?: string | null;
  description?: string | null;
  lastSeenAt?: string | null;
  assignedSpace?: SpaceReadModel | null;
  installationStatus: GatewayInstallationStatus;
  installationProcess: GatewayInstallationProcessReadModel;
};
export type GatewayReadModelPagedListResult = {
  items: GatewayReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type AssignGatewayRequest = {
  spaceId: string;
};
export type UpdateGatewayRequest = {
  name?: string | null;
  productId?: string | null;
  macAddress?: string | null;
  description?: string | null;
};
export type GatewayAutocompleteReadModel = {
  id: string;
  eui: string;
  status: DeviceNetworkStatus;
  spaceId?: string | null;
  macAddress?: string | null;
  clientId: string;
  clientName?: string | null;
};
export type GetGlobalGatewayListQuerySortProperty =
  "Eui" | "NetworkStatus" | "LastSeen";
export type GatewayGlobalListReadModel = {
  id: string;
  eui: string;
  name?: string | null;
  status: DeviceNetworkStatus;
  productId?: string | null;
  macAddress?: string | null;
  lastSeenAt?: string | null;
  installationStatus: GatewayInstallationStatus;
  gatewayPlacement?: GatewayPlacement | null;
  tenantId: string;
  tenantName: string;
  locationName?: string | null;
  buildingComplexName?: string | null;
  buildingName?: string | null;
  cellularIccid?: string | null;
  kerosVersion?: string | null;
  wanesyConnection?: Status | null;
  wanesyLastSeenAt?: string | null;
  cellularStrength?: number | null;
  cellularImei?: number | null;
  lastSeenIpAddress?: string | null;
};
export type GatewayGlobalListReadModelPagedListResult = {
  items: GatewayGlobalListReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type ImportGatewayTenantReportRow = {
  devEui: string;
  tenantChanged: boolean;
  reason?: string | null;
};
export type ImportGatewaysTenantsReport = {
  excelInvalidReason?: string | null;
  rows?: ImportGatewayTenantReportRow[] | null;
};
export type ReassignTenantGatewayRequest = {
  tenantId: string;
};
export type UpdateGatewayInstallationProcessRequest = {
  isVandalismProtectionBoxMounted: boolean;
  areCablesConnectedToJunctionBox: boolean;
  isGatewayInstalledAndPowered: boolean;
  isImageUploaded: boolean;
  gatewayPlacement?: GatewayPlacement | null;
  note?: string | null;
};
export type CreateGatewayResponse = object;
export type CreateGatewayRequest = {
  eui: string;
};
export type TemperatureOccurrence = {
  temperature: number;
  count: number;
};
export type BuildingTemperatureStatisticsReadModel = {
  antiFreezeTemperatures: TemperatureOccurrence[];
  minHeatingTemperatures: TemperatureOccurrence[];
  maxHeatingTemperatures: TemperatureOccurrence[];
};
export type HeatingClampsThermostatReadModel = {
  thermostatId: string;
  eui: string;
  floor?: string | null;
  buildingUnit: string;
  roomType: RoomType;
  roomName: string;
  minHeatingTemperature: number;
  maxHeatingTemperature: number;
  isDefault: boolean;
  isEditable: boolean;
};
export type ResetHeatingClampsRequest = {
  thermostatIds: string[];
};
export type SetHeatingClampsRequest = {
  thermostatIds: string[];
  minHeatingTemperature: number;
  maxHeatingTemperature: number;
};
export type BuildingUnitCompletionReadModel = {
  totalCount: number;
  unitsWithRoomCount: number;
  unitsWithoutRoomCount: number;
};
export type RoomCompletionReadModel = {
  totalCount: number;
  completeRoomCount: number;
  incompleteRoomCount: number;
  noDataRoomCount: number;
};
export type HeatLoadBuildingCompletionReadModel = {
  buildingUnitStats: BuildingUnitCompletionReadModel;
  roomsStats: RoomCompletionReadModel;
};
export type HeatLoadNonResidentialUnitsReadModel = {
  count: number;
};
export type HeatLoadEmptyBuildingUnitsReadModel = {
  spaceId: string;
  name: string;
};
export type HeatLoadEmptyBuildingUnitsReadModelPagedListResult = {
  items: HeatLoadEmptyBuildingUnitsReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type HeatLoadCalcEmptyBuildingUnitsSortOptions = "UnitName";
export type HeatLoadCalculationAttemptStatus =
  "InProgress" | "Success" | "Failure";
export type HeatLoadCalculationErrorType =
  "Validation" | "InvalidMeasurements" | "Integration" | "Unexpected";
export type HeatLoadCalculationAttemptReadModel = {
  attemptId: string;
  status: HeatLoadCalculationAttemptStatus;
  createdAt: string;
  errorType?: HeatLoadCalculationErrorType | null;
  failureReason?: string | null;
  estimatedValue?: number | null;
  rangeMinValue?: number | null;
  rangeMaxValue?: number | null;
};
export type HeatLoadCalculationAttemptReadModelPagedListResult = {
  items: HeatLoadCalculationAttemptReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type HeatLoadCalcAttemptsSortOptions = "CreatedAt";
export type GetHeatingLoadExcelExportResponse = {
  excelFile: string;
  fileName: string;
  mimeType: string;
};
export type GetHeatingLoadValidationStatusResponse = {
  areFloorsAssignedToAllRooms: boolean;
  areFloorsAssignedToAllApartments: boolean;
  isConstructionYearDefined: boolean;
  isValidZipCodeProvided: boolean;
  isBasementDefined: boolean;
  isRoofTypeDefined: boolean;
  isLastFloorInhabitedDefined: boolean;
  doAllUnitTypesIncludeCompleteRoom: boolean;
  heatLoadJobRunning: boolean;
};
export type HeatLoadMissingRoomDataReadModel = {
  spaceId: string;
  name: string;
  roomType: RoomType;
  buildingUnitName: string;
  isHeightAvailable: boolean;
  isFloorAreaAvailable: boolean;
  isExternalWallInfoAvailable: boolean;
  isInternalWallInfoAvailable: boolean;
};
export type HeatLoadMissingRoomDataReadModelPagedListResult = {
  items: HeatLoadMissingRoomDataReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type HeatLoadCalcInvalidRoomsSortOptions = "Name";
export type StartHeatingLoadCalculationJobRequest = {
  buildingId: string;
};
export type HydraulicBalancingAction = "Start" | "Stop" | "Pause" | "Continue";
export type ManageHydraulicBalancingRequest = {
  heatingCircuitId: string;
  action: HydraulicBalancingAction;
  timeBetweenStepsInMinutes: number;
  nightReductionActive?: boolean | null;
};
export type UpdateHydraulicBalancingAttemptSettingsRequest = {
  temperatureDelta?: number | null;
  missingMeasurementThreshold?: number | null;
  stopHydraulicBalancingProcessCounter?: number | null;
  decreaseMaxTargetTemperatureCounter?: number | null;
  summerModeThreshold?: number | null;
  timeBetweenStepsInMinutes?: number | null;
};
export type VdzMissingHeatLoadBuilding = {
  buildingId: string;
  buildingName: string;
};
export type VdzRoomMissingHeatLoad = {
  roomId: string;
  roomName: string;
  buildingId: string;
  buildingName: string;
};
export type VdzRoomMissingFloor = {
  roomId: string;
  roomName: string;
  buildingId: string;
  buildingName: string;
};
export type VdzRadiatorMissingRatedPower = {
  radiatorId: string;
  radiatorName: string;
  roomName: string;
};
export type VdzCircuitOutOfScope = {
  reason: string;
};
export type GetVdzValidationReadModel = {
  buildingsMissingHeatLoad: VdzMissingHeatLoadBuilding[];
  roomsMissingHeatLoad: VdzRoomMissingHeatLoad[];
  roomsMissingFloor: VdzRoomMissingFloor[];
  radiatorsMissingRatedPower: VdzRadiatorMissingRatedPower[];
  allRadiatorsMissingRatedPower: boolean;
  circuitOutOfScope: VdzCircuitOutOfScope[];
};
export type StartVdzCalculationReadModel = {
  success: boolean;
  attemptId?: string | null;
  buildingsMissingHeatLoad: VdzMissingHeatLoadBuilding[];
  roomsMissingHeatLoad: VdzRoomMissingHeatLoad[];
  roomsMissingFloor: VdzRoomMissingFloor[];
  radiatorsMissingRatedPower: VdzRadiatorMissingRatedPower[];
  allRadiatorsMissingRatedPower: boolean;
  circuitOutOfScope: VdzCircuitOutOfScope[];
};
export type RadiatorPowerImportErrorReason =
  | "RatedPowerNotDefined"
  | "InvalidRoomId"
  | "InvalidApartmentId"
  | "RoomNotFound"
  | "ApartmentMismatch"
  | "RoomHasNoRadiator";
export type RadiatorPowerImportValidationError = {
  rows: number[];
  errorReason: RadiatorPowerImportErrorReason;
  value?: string | null;
};
export type RadiatorPowerImportValidationReadModel = {
  success: boolean;
  excelInvalidReason?: string | null;
  totalRadiatorCount: number;
  updatedRadiatorCount: number;
  totalRoomCount: number;
  validationErrors: RadiatorPowerImportValidationError[];
  validationWarnings: RadiatorPowerImportValidationError[];
};
export type InstallToolProjectReadModel = {
  id: string;
  name: string;
  projectIdentification?: string | null;
  status: ProjectStatus;
  tenantId: string;
};
export type InstallToolBuildingUnitListReadModel = {
  spaceId: string;
  spaceType: SpaceType;
  name: string;
  address?: string | null;
  buildingUnitType?: BuildingUnitType | null;
  status: InstallationProgressStatus;
  thermostatCount: number;
  thermostatInstalledCount: number;
  renterFirstName?: string | null;
  renterSurname?: string | null;
  appointmentAt?: string | null;
  assignedFloors: string[];
};
export type InstallationToolFloorListReadModel = {
  floorId: string;
  name: string;
  direction: FloorDirection;
  level: number;
  items: InstallToolBuildingUnitListReadModel[];
};
export type InstallationToolBuildingByFloorDetailReadModel = {
  id: string;
  name: string;
  street?: string | null;
  number?: string | null;
  city?: string | null;
  floors: InstallationToolFloorListReadModel[];
};
export type BuildingUnitsCount = {
  count: number;
  finishedCount: number;
  residentialCount: number;
  residentialFinishedCount: number;
  publicCount: number;
  publicFinishedCount: number;
  commercialCount: number;
  commercialFinishedCount: number;
};
export type GatewayAggregatedStatus = "None" | "Online" | "Warning" | "Offline";
export type InstallationToolBuildingListReadModel = {
  id: string;
  name: string;
  buildingUnitsCount: BuildingUnitsCount;
  thermostatCount: number;
  thermostatInstalledCount: number;
  gatewayAggregatedStatus: GatewayAggregatedStatus;
  street?: string | null;
  number?: string | null;
  city?: string | null;
  zipCode?: string | null;
  country?: string | null;
  constructionYear?: number | null;
  description?: string | null;
};
export type InstallationToolBuildingListReadModelPagedListResult = {
  items: InstallationToolBuildingListReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type DataGatheringStatus = "Incomplete" | "Complete";
export type InstallationOutcome =
  "Successful" | "Problematic" | "Unsuccessful" | "NotPerformed";
export type ObstructionCoverageType =
  "None" | "RadiatorOnly" | "ThermostatOnly" | "Both";
export type InstallationToolRadiatorListReadModel = {
  radiatorId: string;
  name: string;
  thermostatInstalled: boolean;
  assignedThermostatId?: string | null;
  assignedThermostatEui?: string | null;
  assignedThermostatStatus: DeviceNetworkStatus;
  description?: string | null;
  installationOutcome: InstallationOutcome;
  majorIssue: boolean;
  radiatorObstructionType: ObstructionCoverageType;
};
export type SensorReadModel = {
  id: string;
  spaceId?: string | null;
  windowId?: string | null;
  heatingCircuitId?: string | null;
  eui: string;
  serialNumber?: string | null;
  description?: string | null;
  batteryVoltage?: number | null;
  lifecycleStatus: SensorLifecycleStatus;
  placement: SensorPlacement;
  type: SensorType;
  lastSeenAt?: string | null;
  status: DeviceNetworkStatus;
  pairingStatus: SensorPairingStatus;
  pairedAt?: string | null;
  pairedSensorEui?: string | null;
  assignedSpace?: SpaceReadModel | null;
};
export type WindowReadModel = {
  id: string;
  sensor?: SensorReadModel | null;
};
export type InstallationToolRoomListReadModel = {
  id: string;
  name: string;
  roomType: RoomType;
  roomDataGatheringStatus: DataGatheringStatus;
  description?: string | null;
  radiators: InstallationToolRadiatorListReadModel[];
  gateways: GatewayReadModel[];
  sensors: SensorReadModel[];
  windows: WindowReadModel[];
};
export type InstallationToolBuildingUnitDetailReadModel = {
  id: string;
  name: string;
  buildingId?: string | null;
  buildingUnitType?: BuildingUnitType | null;
  installationProgressStatus: InstallationProgressStatus;
  accessNotPossibleReason?: AccessNotPossibleReason | null;
  installationDescription?: string | null;
  description?: string | null;
  lease?: LeaseReadModel | null;
  appointment?: AppointmentReadModel | null;
  rooms: InstallationToolRoomListReadModel[];
};
export type InstallationToolAppointmentStatusCountsReadModel = {
  toDo: number;
  partlyDone: number;
  finalized: number;
  noAccess: number;
};
export type InstallationToolAppointmentBuildingReadModel = {
  buildingId: string;
  name: string;
  address?: string | null;
  appointmentCount: number;
  finalizedCount: number;
};
export type AppointmentProgressStatus =
  "ToDo" | "PartlyDone" | "Finalized" | "NoAccess";
export type InstallationToolAppointmentReadModel = {
  appointmentId: string;
  buildingUnitId: string;
  occursAtUtc: string;
  name: string;
  assignedFloors: string[];
  buildingUnitType?: BuildingUnitType | null;
  unitStatus: InstallationProgressStatus;
  status: AppointmentProgressStatus;
  buildingId?: string | null;
  buildingName?: string | null;
  address?: string | null;
  radiatorCount: number;
  thermostatInstalledCount: number;
  photographedRadiatorCount: number;
  renterFirstName?: string | null;
  renterSurname?: string | null;
  renterPhoneNumber?: string | null;
};
export type InstallationToolAppointmentDayReadModel = {
  dateUtc: string;
  appointmentCount: number;
  finalizedCount: number;
  statusCounts: InstallationToolAppointmentStatusCountsReadModel;
  buildings: InstallationToolAppointmentBuildingReadModel[];
  appointments: InstallationToolAppointmentReadModel[];
};
export type InstallationToolProjectAppointmentsReadModel = {
  projectId: string;
  projectName: string;
  projectIdentification?: string | null;
  projectStatus: ProjectStatus;
  fromUtc: string;
  toUtc: string;
  appointmentCount: number;
  finalizedCount: number;
  days: InstallationToolAppointmentDayReadModel[];
};
export type ThermostatLifecycleStatus =
  | "ReservedDevEui"
  | "Prototype"
  | "FlashingSuccessful"
  | "FlashingFailed"
  | "EndOfLineSuccessful"
  | "EndOfLineFailed"
  | "FinalCheckoutSuccessful"
  | "FinalCheckoutFailed"
  | "Installed"
  | "Uninstalled"
  | "Returned"
  | "Refurbished";
export type PipeSystem = "OnePipe" | "TwoPipe";
export type HydraulicBalancingStatus =
  "NotRunning" | "Requested" | "Running" | "Paused";
export type HeatingCircuitReadModel = {
  id: string;
  name: string;
  heatingCompany: string | null;
  customerId?: string | null;
  hydraulicBalancingActive: boolean;
  sensor?: SensorReadModel | null;
  pipeSystem?: PipeSystem | null;
  hydraulicBalancingState: HydraulicBalancingStatus;
  radiatorCount?: number | null;
};
export type InstallationToolThermostatDetailReadModel = {
  id: string;
  spaceId?: string | null;
  eui: string;
  serialNumber?: string | null;
  description?: string | null;
  lifecycleStatus: ThermostatLifecycleStatus;
  radiator?: SpaceReadModel | null;
  room?: SpaceReadModel | null;
  buildingUnit?: SpaceReadModel | null;
  building?: SpaceReadModel | null;
  location?: SpaceReadModel | null;
  heatingCircuit?: HeatingCircuitReadModel | null;
  lastSeenAt?: string | null;
  batteryLevel?: number | null;
  batteryVoltage?: number | null;
  status: DeviceNetworkStatus;
  mode: MajorMode;
  isMotorCalibrated?: boolean | null;
  isDirectMotorControlActive?: boolean | null;
  isFirmwareUpdateInProgress: boolean;
  isActiveHarvestingTurnedOn: boolean;
  hardwareRevision?: HardwareRevisionReadModel | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
};
export type ValveType =
  | "Standard_Heimeier_M30"
  | "Danfoss_9702_24"
  | "Danfoss_9700_24"
  | "Danfoss_9800_24"
  | "Ista_M32"
  | "Herz_M28"
  | "Vaillant_Klemm"
  | "Heimeier_M30x1_0"
  | "Kosmia_M28x1_0"
  | "Other";
export type ValveDirection = "Up" | "Right" | "Down" | "Left" | "Front";
export type RadiatorObstructionType =
  | "NoObstruction"
  | "Curtains"
  | "Sofa"
  | "Kitchentte"
  | "OtherFurniture"
  | "Other"
  | "Recess"
  | "HeatingPipe"
  | "Niche";
export type InstallationToolRadiatorObstructionReadModel = {
  type: RadiatorObstructionType;
  details?: string | null;
};
export type InstallationToolChecklistReadModel = {
  valvePinChecked?: boolean | null;
  valveIsInPositionZero?: boolean | null;
  valveCheckedForLeakage?: boolean | null;
  thermostatMounted?: boolean | null;
  thermostatTurnedOn?: boolean | null;
};
export type RadiatorVentingDuration =
  "None" | "Minimal" | "Moderate" | "High" | "Maximum";
export type RadiatorVentingInfoReadModel = {
  radiatorNotAccessible: boolean;
  valvePinBlocked: boolean;
  otherIssue: boolean;
  comment?: string | null;
  ventingDuration?: RadiatorVentingDuration | null;
  ventingDate?: string | null;
};
export type RadiatorShape =
  "Panel" | "Tube" | "CastIron" | "Bathroom" | "Other";
export type PanelRadiatorType =
  "Type10" | "Type11" | "Type20" | "Type21" | "Type22" | "Type30" | "Type33";
export type RadiatorSpecificationReadModel = {
  shape: RadiatorShape;
  panelType?: PanelRadiatorType | null;
  heightMm?: number | null;
  lengthMm?: number | null;
  widthMm?: number | null;
  depthMm?: number | null;
  columns?: number | null;
  sections?: number | null;
  description?: string | null;
  specifiedAt: string;
};
export type InstallationToolRadiatorDetailReadModel = {
  radiatorId: string;
  name: string;
  thermostat?: InstallationToolThermostatDetailReadModel | null;
  valveType?: ValveType | null;
  valveDirection?: ValveDirection | null;
  radiatorNotAccessible?: boolean | null;
  incompatibleValve?: boolean | null;
  valvePinBlocked?: boolean | null;
  valveIsLeaking?: boolean | null;
  valveCantCompletelyOpen?: boolean | null;
  installationNotPossible?: boolean | null;
  issueReportedOn?: string | null;
  installationNotPossibleDescription?: string | null;
  parent?: SpaceReadModel | null;
  description?: string | null;
  obstruction?: InstallationToolRadiatorObstructionReadModel | null;
  obstructionCoverageType: ObstructionCoverageType;
  checklist?: InstallationToolChecklistReadModel | null;
  installationOutcome: InstallationOutcome;
  ventingDetails?: RadiatorVentingInfoReadModel | null;
  hkvId?: string | null;
  specification?: RadiatorSpecificationReadModel | null;
};
export type RoomShape = "Rectangular" | "ShapeL" | "Triangle" | "Trapezoid";
export type RoomDimensionsReadModel = {
  size?: number | null;
  height?: number | null;
  roomShape: RoomShape;
  ceilingSloped: boolean;
  wallsFacingOutside?: number | null;
  wallsFacingUnheated?: number | null;
  heightMin?: number | null;
  heightMax?: number | null;
  wallLengthA?: number | null;
  wallLengthB?: number | null;
  wallLengthC?: number | null;
  wallLengthD?: number | null;
  wallLengthE?: number | null;
  wallLengthF?: number | null;
};
export type InstallationToolRoomDetailReadModel = {
  id: string;
  name: string;
  roomType: RoomType;
  dataGatheringStatus: DataGatheringStatus;
  parent?: SpaceReadModel | null;
  description?: string | null;
  roomDimensions: RoomDimensionsReadModel;
  radiators: InstallationToolRadiatorListReadModel[];
  gateways: GatewayReadModel[];
  windows: WindowReadModel[];
  sensors: SensorReadModel[];
  windowSensorsEnabled: boolean;
  radiatorVentingServiceEnabled?: boolean | null;
};
export type PanelRadiatorTypeReadModel = {
  type: PanelRadiatorType;
  characterised: boolean;
};
export type IntRangeReadModel = {
  min: number;
  max: number;
  step: number;
};
export type PanelCatalogueReadModel = {
  types: PanelRadiatorTypeReadModel[];
  defaultType: PanelRadiatorType;
  heightsMm: number[];
  defaultHeightMm: number;
  lengthsMm: number[];
  lengthRangeMm: IntRangeReadModel;
  defaultLengthMm: number;
};
export type TubeCatalogueReadModel = {
  columns: number[];
  defaultColumns: number;
  heightsMm: number[];
  defaultHeightMm: number;
  sectionsRange: IntRangeReadModel;
  defaultSections: number;
};
export type CastIronCatalogueReadModel = {
  depthsMm: number[];
  defaultDepthMm: number;
  heightsMm: number[];
  defaultHeightMm: number;
  sectionsRange: IntRangeReadModel;
  defaultSections: number;
};
export type BathroomCatalogueReadModel = {
  widthsMm: number[];
  defaultWidthMm: number;
  heightsMm: number[];
  defaultHeightMm: number;
};
export type IntGuideReadModel = {
  min: number;
  max: number;
};
export type OtherCatalogueReadModel = {
  widthRangeMm: IntRangeReadModel;
  widthGuideMm: IntGuideReadModel;
  heightRangeMm: IntRangeReadModel;
  heightGuideMm: IntGuideReadModel;
  descriptionMaxLength: number;
};
export type RadiatorSpecificationCatalogueReadModel = {
  panel: PanelCatalogueReadModel;
  tube: TubeCatalogueReadModel;
  castIron: CastIronCatalogueReadModel;
  bathroom: BathroomCatalogueReadModel;
  other: OtherCatalogueReadModel;
};
export type UpdateInstallationToolBuildingDetailsRequest = {
  thermostatInstallationFlyerPosted: boolean;
  lastFloorInhabited?: boolean | null;
  hasBasement?: boolean | null;
  roofType?: RoofType | null;
};
export type BuildingProcessStatus = "Done" | "Partially" | "NotDone";
export type InstallationToolGatewayBuildingReadModel = {
  buildingId: string;
  name: string;
  nameWithAddress: string;
  gatewaysInstalled: BuildingProcessStatus;
  lorawanSignalTested: BuildingProcessStatus;
  buildingDetailsCollected: BuildingProcessStatus;
  markedForGatewayInstallation: boolean;
  recommendedNumberOfGateways?: number | null;
  installedNumberOfGateways: number;
  numberOfReportedIssues: number;
};
export type GatewayInstallationBuildingsSortOptions = "Name";
export type ImageReadModel = {
  image: Blob;
  fileName: string;
  angle: ImageAngle;
};
export type KerlinkProvisioningErrorResponse = {
  errorCode: string;
  message: string;
};
export type ManageLeaseProjectDetailsReadModel = {
  id: string;
  name: string;
};
export type AddLeaseWithRenterReadModel = {
  id: string;
  status: RenowateItemSyncStatus;
  renowateProjectDetails?: ManageLeaseProjectDetailsReadModel | null;
};
export type DataPrivacyAgreementStatus =
  "Accepted" | "Declined" | "AcceptedOld";
export type AddLeaseRequest = {
  spaceId: string;
  startsAt?: string | null;
  endsAt?: string | null;
  dataPrivacyAgreementStatus: DataPrivacyAgreementStatus;
  firstName?: string | null;
  surname?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  signature?: string | null;
};
export type UpdateLeaseWithRenterReadModel = {
  status: RenowateItemSyncStatus;
  renowateProjectDetails?: ManageLeaseProjectDetailsReadModel | null;
};
export type UpdateLeaseWithRenterRequest = {
  startsAt?: string | null;
  endsAt?: string | null;
  dataPrivacyAgreementStatus: DataPrivacyAgreementStatus;
  firstName?: string | null;
  surname?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  signature?: string | null;
};
export type ActiveLeaseRenterReadModel = {
  id: string;
  firstName?: string | null;
  surname?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
};
export type ActiveLeaseReadModel = {
  id: string;
  startsAt?: string | null;
  endsAt?: string | null;
  buildingUnitId: string;
  renter: ActiveLeaseRenterReadModel;
};
export type LeaseItemRenterReadModel = {
  id: string;
  firstName?: string | null;
  surname?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  dataPrivacyAgreement: boolean;
  dataPrivacyAgreementSigned?: boolean | null;
  dataPrivacyAgreedAt?: string | null;
  dataPrivacyRevokedAt?: string | null;
  isLatestDataPrivacyAgreementAccepted: boolean;
  infoReceivedAgreement?: boolean | null;
};
export type LeaseItemReadModel = {
  id: string;
  startsAt?: string | null;
  endsAt?: string | null;
  buildingUnitId: string;
  createdAt: string;
  renter: LeaseItemRenterReadModel;
};
export type AddLegalNoteRequest = {
  content: string;
};
export type LegalNoteReadModel = {
  id: string;
  version: number;
  content: string;
  createdBy: string;
  createdAt: string;
};
export type GeocodingReadModel = {
  locationExternalId: string;
  fullAddress: string;
  street: string;
  streetNumber: string;
  zipCode: string;
  city: string;
  country: string;
  exactMatch: boolean;
};
export type AddLocationRequest = {
  name: string;
  description?: string | null;
};
export type LocationListReadModel = {
  id: string;
  name: string;
  description?: string | null;
  isEmpty: boolean;
};
export type LocationListReadModelPagedListResult = {
  items: LocationListReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type LocationReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  description?: string | null;
  taxonomyPath: TaxonomyPath;
  heatingCircuitId?: string | null;
  definedHeatingCircuits: string[];
  lastModifiedAt: string;
  createdAt: string;
};
export type UpdateLocationRequest = {
  name: string;
  description?: string | null;
};
export type LocationTreeCircuitReadModel = {
  id: string;
  name: string;
  buildingCount: number;
  radiatorCount: number;
};
export type LocationTreeReadModel = {
  location: LocationTreeNodeReadModel;
  circuits: LocationTreeCircuitReadModel[];
  complexes: LocationTreeNodeReadModel[];
};
export type AddHeatingCircuitRequest = {
  name: string;
  heatingCompany?: string | null;
  hydraulicBalancingActive: boolean;
  customerId?: string | null;
};
export type HeatingCircuitChainCircuitReadModel = {
  id: string;
  name: string;
  buildingCount: number;
  radiatorCount: number;
};
export type HeatingCircuitChainBuildingReadModel = {
  id: string;
  name: string;
  circuitIds: string[];
};
export type HeatingCircuitChainBuildingComplexReadModel = {
  id: string;
  name: string;
  buildings: HeatingCircuitChainBuildingReadModel[];
};
export type HeatingCircuitChainLocationReadModel = {
  id: string;
  name: string;
  complexes: HeatingCircuitChainBuildingComplexReadModel[];
};
export type HeatingCircuitChainReadModel = {
  heatingCircuit: HeatingCircuitChainCircuitReadModel;
  circuits: HeatingCircuitChainCircuitReadModel[];
  locations: HeatingCircuitChainLocationReadModel[];
};
export type HeatingCircuitClientReadModel = {
  id: string;
  name: string;
};
export type HeatingCircuitDetailReadModel = {
  id: string;
  name: string;
  client: HeatingCircuitClientReadModel;
  heatingCompany?: string | null;
  customerId?: string | null;
  hydraulicBalancingActive: boolean;
  pipeSystem?: PipeSystem | null;
  hydraulicBalancingState: HydraulicBalancingStatus;
  radiatorCount: number;
  sensor?: SensorReadModel | null;
};
export type UpdateHeatingCircuitRequest = {
  name: string;
  heatingCompany?: string | null;
  hydraulicBalancingActive: boolean;
  customerId?: string | null;
  pipeSystem?: PipeSystem | null;
};
export type ThermostatFirmwareStatus = "Unknown" | "UpToDate" | "Behind";
export type HeatingCircuitThermostatReadModel = {
  thermostatId: string;
  eui: string;
  status: DeviceNetworkStatus;
  mode: MajorMode;
  batteryVoltage?: Voltage | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  firmwareStatus: ThermostatFirmwareStatus;
  roomId: string;
  roomName: string;
  unitId: string;
  unitName: string;
};
export type NonResiActivityType = "Override" | "PlanEdits" | "LevelChanges";
export type NonResiActivityAction =
  | "PlanCreated"
  | "PlanUpdated"
  | "PlanDeleted"
  | "PlanStatusChanged"
  | "BasePlanUpserted"
  | "PlanAssigned"
  | "PlanUnassigned"
  | "PlansReordered"
  | "TemperaturesSet"
  | "TemperaturesCleared";
export type NonResiActivityActorReadModel = {
  id: string;
  name: string;
};
export type NonResiActivityListReadModel = {
  id: string;
  type: NonResiActivityType;
  action: NonResiActivityAction;
  occurredAt: string;
  actor: NonResiActivityActorReadModel;
  details: any;
};
export type NonResiActivityListReadModelPagedListResult = {
  items: NonResiActivityListReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type HeatingMode = "Comfort" | "Standby" | "Setback" | "FrostProtection";
export type NonResiHeatingModeTemperatureReadModel = {
  mode: HeatingMode;
  celsius: number;
};
export type NonResiHeatingPlanAssignmentCreatedReadModel = {
  assignmentId: string;
  propagationId?: string | null;
};
export type NonResiBelow = "Keep" | "Clear";
export type CreateNonResiHeatingPlanAssignmentRequest = {
  planId: string;
  below?: NonResiBelow | null;
};
export type NonResiHeatingPlanAssignmentDeletedReadModel = {
  propagationId?: string | null;
};
export type NonResiHeatingPlanAssignmentPlanRefReadModel = {
  id?: string | null;
  name: string;
};
export type NonResiHeatingPlanAssignmentLayer =
  "Assigned" | "Inherited" | "Base";
export type NonResiOriginReadModel = {
  type: string;
  id: string;
  name: string;
};
export type NonResiHeatingPlanAssignmentSourceReadModel = {
  layer: NonResiHeatingPlanAssignmentLayer;
  from?: NonResiOriginReadModel | null;
};
export type NonResiHeatingPlanAssignmentValidityReadModel = {
  from: string;
  to: string;
};
export type NonResiHeatingPlanAssignmentOwnPlanReadModel = {
  id: string;
  name: string;
  isActive: boolean;
  validity?: NonResiHeatingPlanAssignmentValidityReadModel | null;
};
export type NonResiHeatingPlanAssignmentOwnReadModel = {
  id: string;
  rank?: number | null;
  plan: NonResiHeatingPlanAssignmentOwnPlanReadModel;
};
export type NonResiHeatingPlanAssignmentAboveReadModel = {
  plan: NonResiHeatingPlanAssignmentPlanRefReadModel;
  source: NonResiHeatingPlanAssignmentSourceReadModel;
  dated: boolean;
};
export type NonResiHeatingPlanAssignmentEffect =
  "Active" | "Inactive" | "NotYetValid";
export type NonResiHeatingPlanAssignmentStackRowReadModel = {
  rank: number;
  assignmentId?: string | null;
  plan: NonResiHeatingPlanAssignmentPlanRefReadModel;
  on?: NonResiOriginReadModel | null;
  dated: boolean;
  effect: NonResiHeatingPlanAssignmentEffect;
  winner: boolean;
};
export type NonResiHeatingPlanAssignmentNodeReadModel = {
  plan: NonResiHeatingPlanAssignmentPlanRefReadModel;
  source: NonResiHeatingPlanAssignmentSourceReadModel;
  own: NonResiHeatingPlanAssignmentOwnReadModel[];
  today: string;
  above: NonResiHeatingPlanAssignmentAboveReadModel;
  stack: NonResiHeatingPlanAssignmentStackRowReadModel[];
};
export type ReorderNonResiHeatingPlanAssignmentsRequest = {
  assignmentIds: string[];
};
export type HeatingPlanKind = "Library" | "Local";
export type NonResiHeatingPlanValidityRequest = {
  from: string;
  to: string;
};
export type NonResiHeatingPlanBandRequest = {
  mode: HeatingMode;
  from: string;
  until: string;
};
export type NonResiHeatingPlanWeekRequest = {
  monday: NonResiHeatingPlanBandRequest[];
  tuesday: NonResiHeatingPlanBandRequest[];
  wednesday: NonResiHeatingPlanBandRequest[];
  thursday: NonResiHeatingPlanBandRequest[];
  friday: NonResiHeatingPlanBandRequest[];
  saturday: NonResiHeatingPlanBandRequest[];
  sunday: NonResiHeatingPlanBandRequest[];
};
export type CreateNonResiHeatingPlanRequest = {
  name: string;
  kind: HeatingPlanKind;
  validity?: NonResiHeatingPlanValidityRequest | null;
  week: NonResiHeatingPlanWeekRequest;
};
export type NonResiHeatingPlanListValidityReadModel = {
  from: string;
  to: string;
};
export type NonResiHeatingPlanListUsageReadModel = {
  locations: number;
  rooms: number;
  nodes: number;
};
export type NonResiHeatingPlanListBoundNodeReadModel = {
  type: string;
  id: string;
  name: string;
};
export type NonResiHeatingPlanListReadModel = {
  id: string;
  name: string;
  kind: HeatingPlanKind;
  isBase: boolean;
  isActive: boolean;
  validity?: NonResiHeatingPlanListValidityReadModel | null;
  usedIn: NonResiHeatingPlanListUsageReadModel;
  boundTo?: NonResiHeatingPlanListBoundNodeReadModel | null;
  updatedAt: string;
  updatedBy: string;
};
export type NonResiHeatingPlanByIdValidityReadModel = {
  from: string;
  to: string;
};
export type NonResiHeatingPlanByIdBandReadModel = {
  mode: HeatingMode;
  from: string;
  until: string;
};
export type NonResiHeatingPlanByIdWeekReadModel = {
  monday: NonResiHeatingPlanByIdBandReadModel[];
  tuesday: NonResiHeatingPlanByIdBandReadModel[];
  wednesday: NonResiHeatingPlanByIdBandReadModel[];
  thursday: NonResiHeatingPlanByIdBandReadModel[];
  friday: NonResiHeatingPlanByIdBandReadModel[];
  saturday: NonResiHeatingPlanByIdBandReadModel[];
  sunday: NonResiHeatingPlanByIdBandReadModel[];
};
export type NonResiHeatingPlanByIdUsageReadModel = {
  locations: number;
  rooms: number;
  nodes: number;
};
export type NonResiHeatingPlanByIdBoundNodeReadModel = {
  type: string;
  id: string;
  name: string;
};
export type NonResiHeatingPlanByIdReadModel = {
  id: string;
  name: string;
  kind: HeatingPlanKind;
  isBase: boolean;
  isActive: boolean;
  validity?: NonResiHeatingPlanByIdValidityReadModel | null;
  week: NonResiHeatingPlanByIdWeekReadModel;
  usedIn: NonResiHeatingPlanByIdUsageReadModel;
  boundTo?: NonResiHeatingPlanByIdBoundNodeReadModel | null;
  updatedAt: string;
  updatedBy: string;
};
export type UpdateNonResiHeatingPlanRequest = {
  name: string;
  validity?: NonResiHeatingPlanValidityRequest | null;
  week: NonResiHeatingPlanWeekRequest;
};
export type NonResiBaseHeatingPlanReadModel = {
  id?: string | null;
  name: string;
  isDefault: boolean;
  week: NonResiHeatingPlanByIdWeekReadModel;
};
export type UpsertNonResiBaseHeatingPlanRequest = {
  name: string;
  week: NonResiHeatingPlanWeekRequest;
};
export type SetNonResiHeatingPlanStatusRequest = {
  isActive: boolean;
};
export type NonResiHeatingTemperaturesValuesReadModel = {
  comfort: number;
  standby: number;
  setback: number;
  frostProtection: number;
};
export type NonResiHeatingTemperaturesLayer =
  "Assigned" | "Inherited" | "Default";
export type NonResiHeatingTemperaturesSourceReadModel = {
  layer: NonResiHeatingTemperaturesLayer;
  from?: NonResiOriginReadModel | null;
};
export type NonResiHeatingTemperaturesOwnReadModel = {
  comfort: number;
  standby: number;
  setback: number;
};
export type NonResiHeatingTemperaturesAboveReadModel = {
  values: NonResiHeatingTemperaturesValuesReadModel;
  source: NonResiHeatingTemperaturesSourceReadModel;
};
export type NonResiHeatingTemperaturesNodeReadModel = {
  values: NonResiHeatingTemperaturesValuesReadModel;
  source: NonResiHeatingTemperaturesSourceReadModel;
  own?: NonResiHeatingTemperaturesOwnReadModel | null;
  above: NonResiHeatingTemperaturesAboveReadModel;
};
export type UpsertNonResiHeatingTemperaturesRequest = {
  comfort?: number | null;
  standby?: number | null;
  setback?: number | null;
  below?: NonResiBelow | null;
};
export type NonResiFloorReadModel = {
  id: string;
  name: string;
  direction: FloorDirection;
  level: number;
};
export type NonResiNavigationBuildingSubtreeRoomReadModel = {
  id: string;
  name: string;
  type: RoomType;
  floors: string[];
};
export type NonResiNavigationBuildingSubtreeUnitReadModel = {
  id: string;
  name: string;
  type: BuildingUnitType;
  floors: string[];
  rooms: NonResiNavigationBuildingSubtreeRoomReadModel[];
};
export type NonResiNavigationBuildingSubtreeFloorReadModel = {
  nodeId: string;
  floor: NonResiFloorReadModel;
  units: NonResiNavigationBuildingSubtreeUnitReadModel[];
};
export type NonResiNavigationBuildingSubtreeReadModel = {
  buildingId: string;
  floors: NonResiNavigationBuildingSubtreeFloorReadModel[];
  unitsWithoutFloor: NonResiNavigationBuildingSubtreeUnitReadModel[];
};
export type NonResiNavigationFloorHeaderPathReadModel = {
  locationId?: string | null;
  buildingComplexId?: string | null;
  buildingId?: string | null;
};
export type NonResiNavigationFloorHeaderCountsReadModel = {
  units: number;
  rooms: number;
  thermostats: number;
};
export type NonResiNavigationFloorHeaderReadModel = {
  id: string;
  nodeId: string;
  name: string;
  direction: FloorDirection;
  level: number;
  path: NonResiNavigationFloorHeaderPathReadModel;
  names: {
    [key: string]: string;
  };
  counts: NonResiNavigationFloorHeaderCountsReadModel;
};
export type NonResiNavigationLocationSubtreeBuildingReadModel = {
  id: string;
  name: string;
};
export type NonResiNavigationLocationSubtreeComplexReadModel = {
  id: string;
  name: string;
  floors: NonResiFloorReadModel[];
  buildings: NonResiNavigationLocationSubtreeBuildingReadModel[];
};
export type NonResiNavigationLocationSubtreeReadModel = {
  complexes: NonResiNavigationLocationSubtreeComplexReadModel[];
};
export type NonResiNavigationNodeHeaderPathReadModel = {
  locationId?: string | null;
  buildingComplexId?: string | null;
  buildingId?: string | null;
  buildingUnitId?: string | null;
  roomId?: string | null;
  radiatorId?: string | null;
};
export type NonResiNavigationNodeHeaderCountsReadModel = {
  complexes?: number | null;
  buildings?: number | null;
  units?: number | null;
  rooms?: number | null;
  thermostats: number;
};
export type NonResiNavigationNodeHeaderReadModel = {
  id: string;
  type: SpaceType;
  name: string;
  path: NonResiNavigationNodeHeaderPathReadModel;
  names: {
    [key: string]: string;
  };
  counts: NonResiNavigationNodeHeaderCountsReadModel;
  address?: string | null;
};
export type NonResiNavigationRootClientReadModel = {
  id: string;
  name: string;
};
export type NonResiNavigationRootReadModel = {
  id: string;
  name: string;
  client: NonResiNavigationRootClientReadModel;
};
export type NonResiRoomHeatingStateActualReadModel = {
  temperature: number;
  measuredAt: string;
};
export type NonResiRoomHeatingStateNextReadModel = {
  mode: HeatingMode;
  at: string;
};
export type NonResiRoomHeatingNoNextReason = "NoScheduledChange";
export type NonResiRoomHeatingStateWinnerReadModel = {
  assignmentId?: string | null;
};
export type NonResiRoomHeatingStateReadModel = {
  roomId: string;
  today: string;
  mode: HeatingMode;
  targetTemperature: number;
  actual?: NonResiRoomHeatingStateActualReadModel | null;
  next?: NonResiRoomHeatingStateNextReadModel | null;
  noNextReason?: NonResiRoomHeatingNoNextReason | null;
  winner: NonResiRoomHeatingStateWinnerReadModel;
};
export type NonResiTaxonomyBuildingThermostatsRoomDeviationReadModel = {
  override: boolean;
  exception: boolean;
};
export type NonResiThermostatLastMeasurementReadModel = {
  ambientTemperature?: number | null;
  ambientTemperatureReceivedAt?: string | null;
  tegVoltage?: number | null;
  tegVoltageReceivedAt?: string | null;
};
export type NonResiThermostatReadModel = {
  eui: string;
  batteryLevel?: number | null;
  batteryVoltage?: number | null;
  rssi?: number | null;
  connectivity: DeviceNetworkStatus;
  majorMode: MajorMode;
  heatingMode: HeatingMode;
  targetTemperature?: number | null;
  lastMeasurement: NonResiThermostatLastMeasurementReadModel;
};
export type NonResiRadiatorReadModel = {
  id: string;
  name: string;
  thermostat?: NonResiThermostatReadModel | null;
};
export type NonResiTaxonomyBuildingThermostatsRoomReadModel = {
  id: string;
  name: string;
  type: RoomType;
  deviation: NonResiTaxonomyBuildingThermostatsRoomDeviationReadModel;
  radiators: NonResiRadiatorReadModel[];
};
export type NonResiTaxonomyBuildingThermostatsUnitReadModel = {
  id: string;
  name: string;
  type: BuildingUnitType;
  rooms: NonResiTaxonomyBuildingThermostatsRoomReadModel[];
};
export type NonResiTaxonomyBuildingThermostatsFloorReadModel = {
  nodeId: string;
  floor: NonResiFloorReadModel;
  units: NonResiTaxonomyBuildingThermostatsUnitReadModel[];
};
export type NonResiTaxonomyBuildingThermostatsReadModel = {
  buildingId: string;
  name: string;
  floors: NonResiTaxonomyBuildingThermostatsFloorReadModel[];
  unitsWithoutFloor: NonResiTaxonomyBuildingThermostatsUnitReadModel[];
};
export type NonResiTaxonomyLocationSummaryHeatingModesReadModel = {
  comfort: number;
  standby: number;
  setback: number;
  frostProtection: number;
  summer: number;
  noData: number;
};
export type NonResiTaxonomyLocationSummaryDeviationCountsReadModel = {
  override: number;
  exception: number;
  inherited: number;
};
export type NonResiTaxonomyLocationSummaryDeviationReadModel = {
  thermostats: NonResiTaxonomyLocationSummaryDeviationCountsReadModel;
  rooms: NonResiTaxonomyLocationSummaryDeviationCountsReadModel;
};
export type NonResiTaxonomyLocationSummaryBatteryReadModel = {
  ok: number;
  warning: number;
  low: number;
  noData: number;
};
export type NonResiTaxonomyLocationSummaryConnectivityReadModel = {
  online: number;
  offline: number;
  noData: number;
};
export type NonResiTaxonomyLocationSummaryCountsReadModel = {
  rooms: number;
  thermostats: number;
  heatingModes: NonResiTaxonomyLocationSummaryHeatingModesReadModel;
  deviation: NonResiTaxonomyLocationSummaryDeviationReadModel;
  battery: NonResiTaxonomyLocationSummaryBatteryReadModel;
  connectivity: NonResiTaxonomyLocationSummaryConnectivityReadModel;
};
export type NonResiTaxonomyLocationSummaryFloorReadModel = {
  nodeId: string;
  floor: NonResiFloorReadModel;
  counts: NonResiTaxonomyLocationSummaryCountsReadModel;
};
export type NonResiTaxonomyLocationSummaryBuildingReadModel = {
  id: string;
  name: string;
  counts: NonResiTaxonomyLocationSummaryCountsReadModel;
  floors: NonResiTaxonomyLocationSummaryFloorReadModel[];
  withoutFloor: NonResiTaxonomyLocationSummaryCountsReadModel;
};
export type NonResiTaxonomyLocationSummaryReadModel = {
  locationId: string;
  buildings: NonResiTaxonomyLocationSummaryBuildingReadModel[];
};
export type NonResiTaxonomyRoomThermostatsReadModel = {
  roomId: string;
  name: string;
  type: RoomType;
  radiators: NonResiRadiatorReadModel[];
};
export type NonResiThermostatByEuiLiveStateReadModel = {
  mode: MajorMode;
  ambientTemperature?: number | null;
  ambientTemperatureReceivedAt?: string | null;
  batteryLevel?: number | null;
  batteryVoltage?: number | null;
  lastSeenAt?: string | null;
};
export type NonResiThermostatByEuiDeviceReadModel = {
  lifecycleStatus: ThermostatLifecycleStatus;
  firmwareVersion?: string | null;
  hardwareRevision?: number | null;
  isMotorCalibrated?: boolean | null;
  isCriticalErrorReportedByDevice?: boolean | null;
};
export type NonResiThermostatByEuiConnectivityReadModel = {
  networkStatus: DeviceNetworkStatus;
  rssi?: number | null;
  spreadingFactor?: number | null;
};
export type NonResiThermostatByEuiReadModel = {
  id: string;
  eui: string;
  liveState: NonResiThermostatByEuiLiveStateReadModel;
  device: NonResiThermostatByEuiDeviceReadModel;
  connectivity: NonResiThermostatByEuiConnectivityReadModel;
};
export type AddOptInRequest = {
  content: string;
};
export type OptIntReadModel = {
  id: string;
  version: number;
  content: string;
  createdAt: string;
};
export type AddOrganizationResponse = {
  organizationId: string;
  tenantId: string;
};
export type AddOrganizationRequest = {
  organizationName: string;
  adminEmail: string;
};
export type OrganizationListReadModel = {
  id: string;
  name: string;
  createdAt: string;
  userCount: number;
  tenantCount: number;
  locationCount: number;
  thermostatCount: number;
  gatewayCount: number;
  sensorCount: number;
};
export type OrganizationListReadModelPagedListResult = {
  items: OrganizationListReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type OrganizationListSort = "Name" | "CreatedAt";
export type OrganizationReadModel = {
  id: string;
  name: string;
};
export type UpdateOrganizationRequest = {
  name: string;
};
export type PortfolioClientOptionReadModel = {
  id: string;
  name: string;
};
export type PortfolioAddressOptionReadModel = {
  id: string;
  address: string;
};
export type PortfolioTenantOptionReadModel = {
  id: string;
  name: string;
};
export type PortfolioThermostatOptionReadModel = {
  id: string;
  eui: string;
  clientId: string;
  clientName?: string | null;
};
export type PortfolioHeatingCircuitOptionReadModel = {
  id: string;
  heatingCircuitName: string;
};
export type PortfolioAutocompleteReadModel = {
  clients: PortfolioClientOptionReadModel[];
  addresses: PortfolioAddressOptionReadModel[];
  tenants: PortfolioTenantOptionReadModel[];
  thermostats: PortfolioThermostatOptionReadModel[];
  heatingCircuits: PortfolioHeatingCircuitOptionReadModel[];
};
export type PortfolioCountsReadModel = {
  heatingCircuits: number;
  buildings: number;
  buildingUnits: number;
  rooms: number;
  thermostats: number;
  unassignedEuis: string[];
};
export type PortfolioTab =
  "HeatingCircuits" | "Buildings" | "BuildingUnits" | "Rooms" | "Thermostats";
export type PortfolioRadiatorCountReadModel = {
  total: number;
  radiatorIssues: {
    NoThermostat?: number;
    ValvePinBlocked?: number;
    ValveIsLeaking?: number;
    ValveCantCompletelyOpen?: number;
    RadiatorNotAccessible?: number;
    InstallationNotPossible?: number;
    IncompatibleValve?: number;
  };
};
export type PortfolioThermostatCountReadModel = {
  total: number;
  offline: number;
  unknown: number;
};
export type PortfolioHeatingCircuitRowReadModel = {
  id: string;
  name: string;
  locationName?: string | null;
  buildingNames?: string | null;
  hydraulicBalancingActive: boolean;
  radiators: PortfolioRadiatorCountReadModel;
  thermostats: PortfolioThermostatCountReadModel;
  clientId: string;
  clientName: string;
  buildingCount: number;
};
export type PortfolioAddressReadModel = {
  street: string | null;
  number: string | null;
  zipCode: string | null;
  city: string | null;
};
export type PortfolioBuildingRowReadModel = {
  id: string;
  address: PortfolioAddressReadModel;
  buildingName: string;
  location: string;
  unitCount: number;
  roomCount: number;
  floorCount: number;
  radiators: PortfolioRadiatorCountReadModel;
  gatewayCount: number;
  thermostats: PortfolioThermostatCountReadModel;
  sensorCount: number;
  clientId: string;
  clientName: string;
};
export type PortfolioSensorCountReadModel = {
  total: number;
  offline: number;
};
export type PortfolioBuildingUnitRowReadModel = {
  id: string;
  name: string;
  address: PortfolioAddressReadModel;
  buildingName: string;
  activeTenant?: string | null;
  unitType?: BuildingUnitType | null;
  roomCount: number;
  radiators: PortfolioRadiatorCountReadModel;
  thermostats: PortfolioThermostatCountReadModel;
  sensors: PortfolioSensorCountReadModel;
  clientId: string;
  clientName: string;
  floor: string;
};
export type PortfolioRoomRowReadModel = {
  id: string;
  name: string;
  address: PortfolioAddressReadModel;
  buildingName: string;
  tenantName?: string | null;
  roomType?: RoomType | null;
  radiators: PortfolioRadiatorCountReadModel;
  sensors: PortfolioSensorCountReadModel;
  thermostats: PortfolioThermostatCountReadModel;
  clientId: string;
  clientName: string;
};
export type PortfolioThermostatRowReadModel = {
  id: string;
  eui: string;
  tenantName?: string | null;
  unitName?: string | null;
  roomName?: string | null;
  networkStatus: DeviceNetworkStatus;
  lastSeenAt?: string | null;
  batteryVoltage?: Voltage | null;
  operationMode: MajorMode;
  clientId: string;
  clientName?: string | null;
};
export type PortfolioDataReadModel = {
  tab: PortfolioTab;
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  heatingCircuits?: PortfolioHeatingCircuitRowReadModel[] | null;
  buildings?: PortfolioBuildingRowReadModel[] | null;
  buildingUnits?: PortfolioBuildingUnitRowReadModel[] | null;
  rooms?: PortfolioRoomRowReadModel[] | null;
  thermostats?: PortfolioThermostatRowReadModel[] | null;
  unassignedEuis: string[];
};
export type PortfolioSortBy =
  | "Default"
  | "Name"
  | "Address"
  | "Location"
  | "BuildingName"
  | "Client"
  | "Tenant"
  | "Type"
  | "Floor"
  | "Eui"
  | "Unit"
  | "Room"
  | "Balancing"
  | "BuildingCount"
  | "UnitCount"
  | "RoomCount"
  | "RadiatorCount"
  | "ThermostatCount"
  | "SensorCount"
  | "GatewayCount"
  | "Network"
  | "Battery"
  | "Mode";
export type RenowateSyncStatus =
  "InProgress" | "Succeeded" | "PartiallySucceeded" | "Failed";
export type RenowateSyncDetailsReadModel = {
  projectId: string;
  renowateSyncId?: string | null;
  status?: RenowateSyncStatus | null;
  lastSync?: string | null;
  projectChangedAfterSync: boolean;
};
export type RenowateSyncItemType =
  "Building" | "BuildingUnit" | "Lease" | "Renter";
export type RenowateSyncFailureDetailsReadModel = {
  buildingId: string;
  buildingDetails: string;
  buildingUnitId?: string | null;
  buildingUnitDetails?: string | null;
  leaseId?: string | null;
  renterId?: string | null;
  renterName?: string | null;
  renterPhoneNumber?: string | null;
};
export type RenowateSyncFailureItemReadModel = {
  id: string;
  itemType: RenowateSyncItemType;
  failureReason?: string | null;
  statusCode?: number | null;
  createdAt: string;
  details: RenowateSyncFailureDetailsReadModel;
};
export type RenowateSyncFailureItemReadModelPagedListResult = {
  items: RenowateSyncFailureItemReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type RenowateSyncFailureItemSortOptions = "CreatedAt";
export type ProjectExportReadModel = {
  name: string;
  contentType: string;
  content: string;
};
export type ProjectListReadModel = {
  id: string;
  name: string;
  projectIdentification?: string | null;
  status: ProjectStatus;
  buildingsCount: number;
  usersCount: number;
  thermostatsInstallationFrom?: string | null;
  thermostatsInstallationTo?: string | null;
  gatewaysInstallationFrom?: string | null;
  gatewaysInstallationTo?: string | null;
  completedAt?: string | null;
  createdAt: string;
  note?: string | null;
  tenantId: string;
  lastRenowateSync?: string | null;
  renowateSyncStatus?: RenowateSyncStatus | null;
  projectChangedAfterSync: boolean;
};
export type ProjectListReadModelPagedListResult = {
  items: ProjectListReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetProjectsQueryOptions = "CreatedAt";
export type ProjectStatusV2 =
  | "Preparation"
  | "GatewayInstallation"
  | "ThermostatInstallation"
  | "Balancing"
  | "Finalised"
  | "Archived";
export type ProjectMilestoneStep =
  | "SetOwner"
  | "SetProjectId"
  | "SetClientContacts"
  | "BuildingsImported"
  | "HeatingCircuitsAssigned"
  | "KontingentenScoped"
  | "TechniciansAdded"
  | "GatewayInstallationDateSet"
  | "ThermostatInstallationDatesSet"
  | "OnboardingMeetingHeld"
  | "TenantDataRequested"
  | "TenantDataReceived"
  | "ReadyToProceedSent"
  | "GatewayInstallationReviewed"
  | "BuildingDataGapsClosed"
  | "GatewayInstallationDone"
  | "TenantDataAdded"
  | "TenantToBuildingAssociationReviewed"
  | "SyncedWithRenowate"
  | "RenowatePortalUpToDate"
  | "SmsSent"
  | "EveryUnitHasOneAppointment"
  | "AppointmentLetterSent"
  | "EveryFinalizedUnitHasThermostat"
  | "EverySaneRadiatorHasThermostat"
  | "NoToDoUnitsWithPastAppointments"
  | "ThermostatInstallationReviewed"
  | "ProjectSnapshotTaken"
  | "BillUploaded"
  | "AllCircuitsAboveSufficiencyThreshold";
export type ProjectListV2ReadModel = {
  id: string;
  name: string;
  projectIdentification?: string | null;
  status?: ProjectStatusV2 | null;
  ownerId?: string | null;
  ownerFirstName?: string | null;
  ownerSurname?: string | null;
  buildingsCount: number;
  usersCount: number;
  gatewaysPlannedCount: number;
  gatewaysInstalledCount: number;
  buildingUnitsCount: number;
  buildingUnitsFinalizedCount: number;
  completedMilestoneSteps: ProjectMilestoneStep[];
  thermostatsInstallationFrom?: string | null;
  thermostatsInstallationTo?: string | null;
  gatewaysInstallationFrom?: string | null;
  gatewaysInstallationTo?: string | null;
  completedAt?: string | null;
  createdAt: string;
  note?: string | null;
  tenantId: string;
  tenantName: string;
  lastRenowateSync?: string | null;
  renowateSyncStatus?: RenowateSyncStatus | null;
  projectChangedAfterSync: boolean;
};
export type ProjectListV2ReadModelPagedListResult = {
  items: ProjectListV2ReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetProjectsV2QueryOptions =
  "CreatedAt" | "Name" | "ClientName" | "Status" | "OwnerName" | "CompletedAt";
export type AddProjectContactPersonRequest = {
  firstName: string;
  lastName: string;
  role?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
};
export type AddProjectRequest = {
  name: string;
  projectIdentification?: string | null;
  thermostatsInstallationFrom?: string | null;
  thermostatsInstallationTo?: string | null;
  gatewaysInstallationFrom?: string | null;
  gatewaysInstallationTo?: string | null;
  note?: string | null;
};
export type AssignProjectBuildingsRequest = {
  buildings: string[];
};
export type AssignProjectUsersRequest = {
  users: string[];
};
export type UpdateProjectContactPersonRequest = {
  firstName: string;
  lastName: string;
  role?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
};
export type ProjectBuildingReadModel = {
  id: string;
  locationName: string;
  buildingComplexName: string;
  buildingName: string;
  address: string;
  otherProjectAssigned: boolean;
  currentProjectAssigned: boolean;
};
export type UserRole =
  | "Technician"
  | "Regular"
  | "Admin"
  | "SuperAdmin"
  | "Customer"
  | "Kerlink"
  | "BuildingManager"
  | "AssetManager";
export type ProjectUserReadModel = {
  id: string;
  email: string;
  firstName?: string | null;
  surname?: string | null;
  role: UserRole;
  assignedProjectsCount: number;
};
export type ProjectReadModel = {
  id: string;
  name: string;
  projectIdentification?: string | null;
  status: ProjectStatus;
  buildings: ProjectBuildingReadModel[];
  users: ProjectUserReadModel[];
  thermostatsInstallationFrom?: string | null;
  thermostatsInstallationTo?: string | null;
  gatewaysInstallationFrom?: string | null;
  gatewaysInstallationTo?: string | null;
  completedAt?: string | null;
  note?: string | null;
  tenantId: string;
};
export type UpdateProjectRequest = {
  name: string;
  projectIdentification?: string | null;
  status: ProjectStatus;
  thermostatsInstallationFrom?: string | null;
  thermostatsInstallationTo?: string | null;
  gatewaysInstallationFrom?: string | null;
  gatewaysInstallationTo?: string | null;
  note?: string | null;
};
export type SortGetProjectAssignableBuildingListQueryOptions =
  "Address" | "BuildingName" | "LocationName" | "BuildingComplexName";
export type SortGetProjectUsersOptions = "Surname" | "Email" | "Role";
export type ProjectOwnerAutocompleteReadModel = {
  id: string;
  email: string;
  firstName?: string | null;
  surname?: string | null;
  role: UserRole;
};
export type SetProjectMilestoneStepRequest = {
  step: ProjectMilestoneStep;
  isCompleted: boolean;
};
export type SetProjectOwnerRequest = {
  ownerId?: string | null;
};
export type SetProjectStatusRequest = {
  status: ProjectStatusV2;
};
export type UnassignProjectBuildingsRequest = {
  buildings: string[];
};
export type UnassignProjectUsersRequest = {
  users: string[];
};
export type UpdateProjectInfoRequest = {
  name: string;
  projectIdentification?: string | null;
  ownerId?: string | null;
  note?: string | null;
};
export type UpdateProjectInstallationDatesRequest = {
  gatewaysInstallationFrom?: string | null;
  gatewaysInstallationTo?: string | null;
  thermostatsInstallationFrom?: string | null;
  thermostatsInstallationTo?: string | null;
};
export type ProjectIssuesBuildingUnitReadModel = {
  locationId: string;
  buildingUnitId: string;
  buildingUnitName: string;
  status: InstallationProgressStatus;
  accessNotPossibleReason?: AccessNotPossibleReason | null;
  address: string;
  comment?: string | null;
  statusSet?: string | null;
  renterName?: string | null;
  renterPhoneNumber?: string | null;
  appointmentAt?: string | null;
};
export type ProjectIssuesBuildingUnitReadModelPagedListResult = {
  items: ProjectIssuesBuildingUnitReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetProjectIssuesBuildingUnitsQueryOptions =
  "BuildingUnitName" | "Address" | "Status" | "RenterName";
export type ProjectRadiatorIssue =
  | "NoThermostat"
  | "ValvePinBlocked"
  | "ValveIsLeaking"
  | "ValveCantCompletelyOpen"
  | "RadiatorNotAccessible"
  | "InstallationNotPossible"
  | "IncompatibleValve";
export type ProjectIssuesRadiatorReadModel = {
  locationId: string;
  radiatorId: string;
  buildingUnitName: string;
  roomType: RoomType;
  radiatorIssue: ProjectRadiatorIssue | null;
  address: string;
  renterName?: string | null;
  renterPhoneNumber?: string | null;
  appointmentAt?: string | null;
};
export type SortGetProjectIssuesRadiatorsQueryOptions =
  "BuildingUnitName" | "Address" | "RadiatorIssue" | "RenterName";
export type ProjectIssuesRenterReadModel = {
  locationId: string;
  buildingUnitId: string;
  buildingUnitName: string;
  address: string;
  dataAgreementStatus: boolean | null;
  renterName?: string | null;
  renterPhoneNumber?: string | null;
  appointmentAt?: string | null;
};
export type SortGetProjectIssuesRentersQueryOptions =
  "BuildingUnitName" | "Address" | "DataAgreementStatus" | "RenterName";
export type ProjectRoomDataGatheringStatus =
  | "Empty"
  | "HeightMissing"
  | "SizeMissing"
  | "WallsFacingOutsideMissing"
  | "WallsFacingUnheatedMissing"
  | "Complete";
export type ProjectIssuesRoomReadModel = {
  locationId: string;
  roomId: string;
  buildingUnitName: string;
  roomType: RoomType;
  dataGatheringStatus: ProjectRoomDataGatheringStatus;
  address: string;
  renterName?: string | null;
  renterPhoneNumber?: string | null;
  appointmentAt?: string | null;
};
export type SortGetProjectIssuesRoomsQueryOptions =
  "BuildingUnitName" | "Address" | "DataGatheringStatus" | "RenterName";
export type ProjectIssuesThermostatReadModel = {
  locationId: string;
  thermostatId: string;
  buildingUnitName: string;
  roomType: RoomType;
  address: string;
  thermostatEui: string;
  thermostatMode: MajorMode;
  renterName?: string | null;
  renterPhoneNumber?: string | null;
  appointmentAt?: string | null;
};
export type SortGetProjectIssuesThermostatsQueryOptions =
  | "BuildingUnitName"
  | "Address"
  | "ThermostatEui"
  | "ThermostatMode"
  | "RenterName";
export type ProjectContactPersonReadModel = {
  id: string;
  firstName: string;
  lastName: string;
  role?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
};
export type ProjectBuildingUnitsStatisticsReadModel = {
  buildingUnitCount: number;
  buildingUnitFinalizedCount: number;
  buildingUnitToDoCount: number;
  buildingUnitOnHoldCount: number;
  buildingUnitAccessNotPossibleCount: number;
};
export type ProjectRoomsStatisticsReadModel = {
  roomsCount: number;
  roomsCompleteCount: number;
  roomsPartialDataCount: number;
  roomsNoDataCount: number;
};
export type ProjectRadiatorsStatisticsReadModel = {
  radiatorCount: number;
  radiatorNormalCount: number;
  radiatorNoThermostatCount: number;
  radiatorBrokenCount: number;
};
export type ProjectThermostatsStatisticsReadModel = {
  thermostatCount: number;
  thermostatNormalCount: number;
  thermostatUnknownCount: number;
  thermostatInstallationModeCount: number;
};
export type ProjectDetailBuildingReadModel = {
  id: string;
  name: string;
  address: string;
  gatewayInstallationStatus: BuildingProcessStatus;
  buildingInfoCollectionStatus: BuildingProcessStatus;
  gatewayInstallationRequested: boolean;
  buildingUnitsStatistics: ProjectBuildingUnitsStatisticsReadModel;
  roomsStatistics: ProjectRoomsStatisticsReadModel;
  radiatorsStatistics: ProjectRadiatorsStatisticsReadModel;
  thermostatsStatistics: ProjectThermostatsStatisticsReadModel;
};
export type ProjectRentersStatisticsReadModel = {
  rentersCount: number;
  agreementsTrueCount: number;
  agreementsFalseCount: number;
  agreementsUnknownCount: number;
};
export type ProjectDetailReadModel = {
  id: string;
  name: string;
  projectIdentification?: string | null;
  status: ProjectStatus;
  thermostatsInstallationFrom?: string | null;
  thermostatsInstallationTo?: string | null;
  gatewaysInstallationFrom?: string | null;
  gatewaysInstallationTo?: string | null;
  canBeSetToActive: boolean;
  completedAt?: string | null;
  note?: string | null;
  createdAt: string;
  tenantId: string;
  buildingUnitsStatistics: ProjectBuildingUnitsStatisticsReadModel;
  roomsStatistics: ProjectRoomsStatisticsReadModel;
  radiatorsStatistics: ProjectRadiatorsStatisticsReadModel;
  thermostatsStatistics: ProjectThermostatsStatisticsReadModel;
  rentersStatistics: ProjectRentersStatisticsReadModel;
};
export type ProjectDetailV2ReadModel = {
  id: string;
  name: string;
  projectIdentification?: string | null;
  status?: ProjectStatusV2 | null;
  canLeaveArchived: boolean;
  ownerId?: string | null;
  ownerFirstName?: string | null;
  ownerSurname?: string | null;
  tenantId: string;
  tenantName: string;
  buildingsCount: number;
  usersCount: number;
  gatewaysPlannedCount: number;
  gatewaysInstalledCount: number;
  completedMilestoneSteps: ProjectMilestoneStep[];
  thermostatsInstallationFrom?: string | null;
  thermostatsInstallationTo?: string | null;
  gatewaysInstallationFrom?: string | null;
  gatewaysInstallationTo?: string | null;
  completedAt?: string | null;
  createdAt: string;
  note?: string | null;
  lastRenowateSync?: string | null;
  renowateSyncStatus?: RenowateSyncStatus | null;
  projectChangedAfterSync: boolean;
  buildingUnitsStatistics: ProjectBuildingUnitsStatisticsReadModel;
  roomsStatistics: ProjectRoomsStatisticsReadModel;
  radiatorsStatistics: ProjectRadiatorsStatisticsReadModel;
  thermostatsStatistics: ProjectThermostatsStatisticsReadModel;
  rentersStatistics: ProjectRentersStatisticsReadModel;
};
export type ProjectMilestone =
  | "ProjectOwned"
  | "BuildingsScoped"
  | "CapacityAndTimelineSet"
  | "ClientOnboarding"
  | "GatewaysInstalled"
  | "TenantDataImported"
  | "AppointmentsSyncedAndBooked"
  | "ThermostatsInstalled"
  | "Billed"
  | "ProjectSufficiencyReached";
export type ProjectMilestoneStepReadModel = {
  step: ProjectMilestoneStep;
  isCompleted: boolean;
  lastModifiedAt?: string | null;
  lastModifiedById?: string | null;
};
export type ProjectMilestoneReadModel = {
  milestone: ProjectMilestone;
  steps: ProjectMilestoneStepReadModel[];
};
export type ProjectUserV2ReadModel = {
  id: string;
  email: string;
  firstName?: string | null;
  surname?: string | null;
  role: UserRole;
  serviceProvider?: string | null;
  assignedProjectsCount: number;
};
export type AddRadiatorRequest = {
  parentId: string;
  name: string;
  valveType?: ValveType | null;
  valveDirection?: ValveDirection | null;
  hkvId?: string | null;
  description?: string | null;
};
export type RadiatorObstructedRequest = {
  type: RadiatorObstructionType;
  coverageType: ObstructionCoverageType;
  details?: string | null;
};
export type RadiatorObstructionReadModel = {
  type: RadiatorObstructionType;
  details?: string | null;
};
export type ThermostatReadModel = {
  id: string;
  spaceId?: string | null;
  eui: string;
  serialNumber?: string | null;
  description?: string | null;
  lifecycleStatus: ThermostatLifecycleStatus;
  lastSeenAt?: string | null;
  batteryLevel?: number | null;
  batteryVoltage?: number | null;
  status: DeviceNetworkStatus;
  hardwareRevision?: HardwareRevisionReadModel | null;
  mode: MajorMode;
  hasRunningFwu: boolean;
  isMotorCalibrated?: boolean | null;
  isDirectMotorControlActive?: boolean | null;
  isLatestRefurbishment: boolean;
  assignedSpace?: SpaceReadModel | null;
};
export type InstallationChecklistReadModel = {
  valvePinChecked?: boolean | null;
  valveIsInPositionZero?: boolean | null;
  valveCheckedForLeakage?: boolean | null;
  thermostatMounted?: boolean | null;
  thermostatTurnedOn?: boolean | null;
};
export type RadiatorReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  description?: string | null;
  taxonomyPath: TaxonomyPath;
  valveType?: ValveType | null;
  valveDirection?: ValveDirection | null;
  radiatorNotAccessible?: boolean | null;
  incompatibleValve?: boolean | null;
  valvePinBlocked?: boolean | null;
  valveIsLeaking?: boolean | null;
  valveCantCompletelyOpen?: boolean | null;
  installationNotPossible?: boolean | null;
  issueReportedOn?: string | null;
  installationNotPossibleDescription?: string | null;
  obstruction?: RadiatorObstructionReadModel | null;
  radiatorObstructionType: ObstructionCoverageType;
  heatingCircuitId?: string | null;
  thermostat?: ThermostatReadModel | null;
  lastModifiedAt: string;
  createdAt: string;
  checklist?: InstallationChecklistReadModel | null;
  installationOutcome: InstallationOutcome;
  ventingDetails?: RadiatorVentingInfoReadModel | null;
  hkvId?: string | null;
  alertCountLast24Hours: number;
};
export type UpdateRadiatorRequest = {
  name: string;
  valveType?: ValveType | null;
  valveDirection?: ValveDirection | null;
  description?: string | null;
  hkvId?: string | null;
};
export type SetRadiatorSpecificationRequest = {
  shape: RadiatorShape;
  panelType?: PanelRadiatorType | null;
  heightMm?: number | null;
  lengthMm?: number | null;
  widthMm?: number | null;
  depthMm?: number | null;
  columns?: number | null;
  sections?: number | null;
  description?: string | null;
};
export type UpdateInstallationFailedRadiatorRequest = {
  valvePinBlocked?: boolean | null;
  valveIsLeaking?: boolean | null;
  valveCantCompletelyOpen?: boolean | null;
  incompatibleValve?: boolean | null;
  radiatorNotAccessible?: boolean | null;
  installationNotPossible?: boolean | null;
  installationNotPossibleDescription?: string | null;
};
export type UpdateRadiatorInstallationChecklistRequest = {
  valvePinChecked: boolean;
  valveIsInPositionZero: boolean;
  valveCheckedForLeakage: boolean;
  thermostatMounted: boolean;
  thermostatTurnedOn: boolean;
};
export type RadiatorVentingSuccessRequest = {
  duration: RadiatorVentingDuration;
};
export type RadiatorVentingFailureRequest = {
  radiatorNotAccessible: boolean;
  valvePinBlocked: boolean;
  otherIssue: boolean;
  comment?: string | null;
};
export type UpdateRadiatorVentingStatusRequest = {
  success?: RadiatorVentingSuccessRequest | null;
  failure?: RadiatorVentingFailureRequest | null;
};
export type AddRenterRequest = {
  firstName?: string | null;
  surname?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
};
export type UpdateRenterRequest = {
  firstName?: string | null;
  surname?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
};
export type RentersBulkUpdateErrorReason =
  | "BuildingUnitCodeEmpty"
  | "BuildingUnitCodeNotUnique"
  | "BuildingUnitNotFound"
  | "NoDatesProvided"
  | "LeaseStartDateRequired"
  | "LeaseStartDateBeforeTerminationDate"
  | "ActiveLeaseNotFound"
  | "ActiveLeaseAlreadyExists"
  | "RenterFirstNameEmpty"
  | "RenterLastNameEmpty"
  | "InvalidPhoneNumber";
export type RentersBulkUpdateValidationError = {
  rows: number[];
  errorReason: RentersBulkUpdateErrorReason;
  buildingUnitCustomerId?: string | null;
};
export type BulkUpdateOperation =
  "TerminateAndCreate" | "CreateOnly" | "TerminateOnly";
export type RentersBulkUpdateExistingLease = {
  leaseId: string;
  renterFirstName: string;
  renterLastName: string;
  currentEndsAt?: string | null;
  newEndsAt: string;
};
export type RentersBulkUpdateNewRenter = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  startsAt: string;
};
export type RentersBulkUpdateBuildingUnit = {
  buildingUnitId: string;
  name: string;
  customerId: string;
  type: BuildingUnitType;
  operation: BulkUpdateOperation;
  existingActiveLeases: RentersBulkUpdateExistingLease[];
  newRenter?: RentersBulkUpdateNewRenter | null;
};
export type RentersBulkUpdateBuilding = {
  buildingId: string;
  name: string;
  address: string;
  buildingUnits: RentersBulkUpdateBuildingUnit[];
};
export type RentersBulkUpdateBuildingComplex = {
  buildingComplexId: string;
  name: string;
  buildings: RentersBulkUpdateBuilding[];
};
export type RentersBulkUpdateLocation = {
  locationId: string;
  name: string;
  buildingComplexes: RentersBulkUpdateBuildingComplex[];
};
export type RentersBulkUpdateValidStructure = {
  locations: RentersBulkUpdateLocation[];
  terminateAndCreateCount: number;
  createOnlyCount: number;
  terminateOnlyCount: number;
};
export type RentersBulkUpdateValidationReadModel = {
  success: boolean;
  excelInvalidReason?: string | null;
  validationErrors: RentersBulkUpdateValidationError[];
  validStructure: RentersBulkUpdateValidStructure;
};
export type RentersImportErrorReason =
  | "BuildingUnitCodeEmpty"
  | "BuildingUnitCodeNotUnique"
  | "BuildingUnitNotFound"
  | "BuildingUnitAlreadyHasLease"
  | "RenterFirstNameEmpty"
  | "RenterLastNameEmpty"
  | "InvalidPhoneNumber";
export type RentersImportValidationError = {
  rows: number[];
  errorReason: RentersImportErrorReason;
  buildingUnitCustomerId?: string | null;
};
export type RentersImportRenter = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
};
export type RentersImportBuildingUnit = {
  buildingUnitId: string;
  name: string;
  customerId: string;
  type: BuildingUnitType;
  renter: RentersImportRenter;
};
export type RentersImportBuilding = {
  buildingId: string;
  name: string;
  address: string;
  buildingUnits: RentersImportBuildingUnit[];
};
export type RentersImportBuildingComplex = {
  buildingComplexId: string;
  name: string;
  buildings: RentersImportBuilding[];
};
export type RentersImportLocation = {
  locationId: string;
  name: string;
  buildingComplexes: RentersImportBuildingComplex[];
};
export type RentersImportValidStructure = {
  locations: RentersImportLocation[];
  rentersCount: number;
};
export type RentersImportValidationReadModel = {
  success: boolean;
  excelInvalidReason?: string | null;
  validationErrors: RentersImportValidationError[];
  validStructure: RentersImportValidStructure;
};
export type RenterAgreementReadModel = {
  renterId: string;
  agreed: boolean;
  signed: boolean;
  dataPrivacyId?: string | null;
  dataPrivacyVersion?: number | null;
  agreedAt?: string | null;
  revokedAt?: string | null;
  signature?: string | null;
};
export type RenterAgreementHistoryReadModel = {
  agreementId: string;
  dataPrivacyId: string;
  version: number;
  agreed: boolean;
  agreedAt?: string | null;
  revokedAt?: string | null;
};
export type SubRenterReadModel = {
  userId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  isPending: boolean;
  invitedAt?: string | null;
  assignedAt: string;
};
export type ExpiredRenterReadModel = {
  renterId: string;
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  confirmedOn?: string | null;
  removedOn?: string | null;
};
export type ExpiredRenterReadModelPagedListResult = {
  items: ExpiredRenterReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetExpiredRentersQueryOptions = "RemovedOn";
export type RenterVerificationStatus =
  "Created" | "Initiated" | "ResidenceVerified" | "Completed" | "Blocked";
export type IncompleteVerificationReadModel = {
  verificationId: string;
  status: RenterVerificationStatus;
  userId: string;
  userEmail: string;
  userFirstName?: string | null;
  userLastName?: string | null;
  buildingUnitId: string;
  buildingUnitName: string;
  address?: string | null;
  resetCount: number;
  failedInitAttemptCount: number;
  failedNameAttemptCount: number;
  openRequestCount: number;
  createdAt: string;
  lastModifiedAt: string;
};
export type IncompleteVerificationReadModelPagedListResult = {
  items: IncompleteVerificationReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type IncompleteVerificationStatusFilter =
  "Incomplete" | "Created" | "Initiated" | "ResidenceVerified" | "Blocked";
export type SortGetIncompleteVerificationsQueryOptions =
  "CreatedAt" | "LastModifiedAt" | "Status";
export type UserReadModel = {
  id: string;
  email: string;
  firstName?: string | null;
  surname?: string | null;
};
export type RenterVerificationRequestStatus =
  "Initial" | "Requested" | "Skipped" | "Verified";
export type RenterVerificationDetailRequestReadModel = {
  requestId: string;
  thermostatId: string;
  thermostatEui: string;
  status: RenterVerificationRequestStatus;
  roomType: RoomType;
  failedAttemptCount: number;
  createdAt: string;
};
export type RenterVerificationDetailReadModel = {
  verificationId: string;
  status: RenterVerificationStatus;
  buildingUnitId?: string | null;
  buildingUnitName?: string | null;
  address?: string | null;
  userId: string;
  userEmail: string;
  userFirstName?: string | null;
  userLastName?: string | null;
  renterId?: string | null;
  resetCount: number;
  failedInitAttemptCount: number;
  failedNameAttemptCount: number;
  hasOverride: boolean;
  requests: RenterVerificationDetailRequestReadModel[];
  lastModifiedAt: string;
  createdAt: string;
};
export type OverrideVerificationRequest = {
  buildingUnitId: string;
  leaseId: string;
};
export type UnlinkRenterRequest = {
  buildingUnitId: string;
  leaseId: string;
};
export type DuplicateWindowRequest = {
  count: number;
};
export type RoomDimensions = {
  size?: number | null;
  height?: number | null;
  roomShape: RoomShape;
  ceilingSloped: boolean;
  wallsFacingOutside?: number | null;
  wallsFacingUnheated?: number | null;
  heightMin?: number | null;
  heightMax?: number | null;
  wallLengthA?: number | null;
  wallLengthB?: number | null;
  wallLengthC?: number | null;
  wallLengthD?: number | null;
  wallLengthE?: number | null;
  wallLengthF?: number | null;
};
export type AddRoomRequest = {
  parentId: string;
  name: string;
  dataGatheringStatus: DataGatheringStatus;
  roomType: RoomType;
  roomDimensions?: RoomDimensions | null;
  description?: string | null;
};
export type RoomReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  dataGatheringStatus: DataGatheringStatus;
  roomType: RoomType;
  description?: string | null;
  taxonomyPath: TaxonomyPath;
  roomDimensions: RoomDimensionsReadModel;
  heatingCircuitId?: string | null;
  parentBuildingUnitType: BuildingUnitType;
  windows: WindowReadModel[];
  lastModifiedAt: string;
  createdAt: string;
};
export type UpdateRoomRequest = {
  name: string;
  dataGatheringStatus: DataGatheringStatus;
  roomType: RoomType;
  roomDimensions: RoomDimensions;
  description?: string | null;
};
export type RadiatorTreeNodeReadModel = {
  id: string;
  name: string;
  circuitIds: string[];
};
export type RoomTreeReadModel = {
  room: RoomTreeNodeReadModel;
  radiators: RadiatorTreeNodeReadModel[];
};
export type SensorDetailHeatingCircuitReadModel = {
  id: string;
  name: string;
};
export type RoomThermostatReadModel = {
  id: string;
  eui: string;
  status: DeviceNetworkStatus;
  isObstructed: boolean;
  ambientTemperature?: number | null;
  targetTemperature?: number | null;
};
export type SensorDetailReadModel = {
  id: string;
  spaceId?: string | null;
  windowId?: string | null;
  heatingCircuitId?: string | null;
  eui: string;
  serialNumber?: string | null;
  description?: string | null;
  batteryVoltage?: number | null;
  lifecycleStatus: SensorLifecycleStatus;
  placement: SensorPlacement;
  type: SensorType;
  room?: SpaceReadModel | null;
  buildingUnit?: SpaceReadModel | null;
  building?: SpaceReadModel | null;
  buildingComplex?: SpaceReadModel | null;
  location?: SpaceReadModel | null;
  client?: TenantReadModel | null;
  heatingCircuit?: SensorDetailHeatingCircuitReadModel | null;
  lastSeenAt?: string | null;
  status: DeviceNetworkStatus;
  skipAutoConfiguration: boolean;
  pairingStatus: SensorPairingStatus;
  pairedAt?: string | null;
  pairedSensorEui?: string | null;
  roomThermostats: RoomThermostatReadModel[];
};
export type AddSensorRequest = {
  eui: string;
  placement: SensorPlacement;
  type: SensorType;
  serialNumber?: string | null;
  description?: string | null;
  skipAutoConfiguration?: boolean | null;
};
export type SensorReadModelPagedListResult = {
  items: SensorReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type AssignSensorToHeatingCircuitRequest = {
  heatingCircuitId: string;
};
export type AssignSensorToSpaceRequest = {
  spaceId: string;
};
export type AssignSensorToWindowRequest = {
  windowId: string;
};
export type UpdateSensorRequest = {
  eui: string;
  placement: SensorPlacement;
  type: SensorType;
  serialNumber?: string | null;
  description?: string | null;
  skipAutoConfiguration?: boolean | null;
};
export type SensorLifecycleHistoryReadModel = {
  historyId: string;
  sensorId: string;
  eui: string;
  previousStatus?: SensorLifecycleStatus | null;
  newStatus: SensorLifecycleStatus;
  createdAt: string;
  userId?: string | null;
  user?: string | null;
};
export type SensorLifecycleHistoryReadModelPagedListResult = {
  items: SensorLifecycleHistoryReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetSensorLifecycleHistoryQueryOptions = "CreatedAt";
export type SensorAutocompleteReadModel = {
  id: string;
  spaceId?: string | null;
  windowId?: string | null;
  heatingCircuitId?: string | null;
  eui: string;
  serialNumber?: string | null;
  placement: SensorPlacement;
  type: SensorType;
  clientId: string;
  clientName?: string | null;
};
export type SignalTesterMeasurementReadModel = {
  eui: string;
  gatewaySignalStrength?: GatewaySignalStrength | null;
  measuredAt?: string | null;
  spreadingFactor?: number | null;
  gateways: string[];
};
export type SignalTesterAutocompleteReadModel = {
  id: string;
  eui: string;
};
export type TaxonomyDetailReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  description?: string | null;
  heatingCircuitId?: string | null;
  heatingCircuitIsInherited?: boolean | null;
  definedHeatingCircuits: string[];
  floorIds: string[];
  floorsIsInherited?: boolean | null;
  definedFloorIds: string[];
  buildingUnitType?: BuildingUnitType | null;
  gatewayCount: number;
  thermostatCount: number;
  sensorCount: number;
  lastModifiedAt: string;
  createdAt: string;
  parent?: SpaceReadModel | null;
  children: TaxonomyDetailReadModel[];
};
export type TaxonomyCountsReadModel = {
  spaceId: string;
  spaceType: SpaceType;
  buildingComplexes?: number | null;
  buildings?: number | null;
  buildingUnits?: number | null;
  rooms?: number | null;
  radiators?: number | null;
  gateways?: number | null;
  thermostats?: number | null;
  sensors?: number | null;
};
export type TaxonomyHealthGatewayReadModel = {
  id: string;
  eui: string;
  status: DeviceNetworkStatus;
};
export type TaxonomyHealthFloorReadModel = {
  id: string;
  name: string;
  level: number;
};
export type TaxonomyHealthDeviceReadModel = {
  thermostatId: string;
  eui: string;
  status: DeviceNetworkStatus;
  updatable: boolean;
  spreadingFactor?: number | null;
  batteryVoltage?: number | null;
  mode: MajorMode;
  alertsLast24Hours: number;
  firmwareVersion?: FirmwareVersionReadModel | null;
  firmwareStatus: ThermostatFirmwareStatus;
  hardwareRevision?: HardwareRevisionReadModel | null;
  isMotorCalibrated?: boolean | null;
  motorPosition?: number | null;
};
export type TaxonomyHealthRadiatorReadModel = {
  id: string;
  name: string;
  heatingCircuitId?: string | null;
  heatingCircuitName?: string | null;
  isObstructed: boolean;
  hasValveIssue: boolean;
  devices: TaxonomyHealthDeviceReadModel[];
};
export type TaxonomyHealthRoomReadModel = {
  id: string;
  name: string;
  roomType?: RoomType | null;
  hasPairedSensor: boolean;
  radiators: TaxonomyHealthRadiatorReadModel[];
};
export type TaxonomyHealthUnitReadModel = {
  id: string;
  name: string;
  floors: TaxonomyHealthFloorReadModel[];
  rooms: TaxonomyHealthRoomReadModel[];
};
export type TaxonomyHealthReadModel = {
  spaceId: string;
  spaceType: SpaceType;
  latestHardwareRevision?: HardwareRevisionReadModel | null;
  gateways: TaxonomyHealthGatewayReadModel[];
  units: TaxonomyHealthUnitReadModel[];
  rooms: TaxonomyHealthRoomReadModel[];
  radiators: TaxonomyHealthRadiatorReadModel[];
};
export type RenameTaxonomyRequest = {
  name: string;
};
export type UpdateDescriptionTaxonomyRequest = {
  description?: string | null;
};
export type AssignedHeatingCircuitRequest = {
  heatingCircuitId?: string | null;
};
export type AssignedFloorsRequest = {
  floorIds: string[];
};
export type TaxonomyImportErrorReason =
  | "CityColumnEmpty"
  | "BuildingComplexNameEmpty"
  | "StreetColumnEmpty"
  | "HouseNumberColumnEmpty"
  | "ZipCodeColumnEmpty"
  | "ConstructionYearColumnEmpty"
  | "ConstructionYearWrongFormat"
  | "ConstructionYearDifferentWithinBuilding"
  | "AddressNotFound"
  | "BuildingAlreadyExists"
  | "SuggestedNumberOfGatewaysDifferentWithinBuildingWrongFormat"
  | "SuggestedNumberOfGatewaysDifferentWithinBuilding"
  | "BuildingUnitCodeEmpty"
  | "BuildingUnitCodeNotUnique"
  | "BuildingUnitAlreadyExists"
  | "BuildingUnitTypeEmpty"
  | "BuildingUnitTypeIncorrect"
  | "FloorNumberEmpty"
  | "FloorNumberFormatIncorrect"
  | "ErrorConstructingDataStructure";
export type TaxonomyImportValidationError = {
  rows: number[];
  errorReason: TaxonomyImportErrorReason;
  value?: string | null;
};
export type TaxonomyImportFloor = {
  level: number;
  direction: FloorDirection;
  name: string;
};
export type TaxonomyImportBuildingUnit = {
  name: string;
  customerId: string;
  type: BuildingUnitType;
  floor: TaxonomyImportFloor;
};
export type TaxonomyImportBuilding = {
  name: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  constructionYear: number;
  suggestedNumberOfGateways: number;
  buildingUnits: TaxonomyImportBuildingUnit[];
};
export type TaxonomyImportBuildingComplex = {
  name: string;
  existing: boolean;
  buildings: TaxonomyImportBuilding[];
};
export type TaxonomyImportLocation = {
  name: string;
  existing: boolean;
  buildingComplexes: TaxonomyImportBuildingComplex[];
};
export type TaxonomyImportValidStructure = {
  locations: TaxonomyImportLocation[];
  locationsCount: number;
  buildingComplexesCount: number;
  buildingsCount: number;
  buildingUnitsCount: number;
};
export type TaxonomyImportValidationReadModel = {
  success: boolean;
  excelInvalidReason?: string | null;
  validationErrors: TaxonomyImportValidationError[];
  validStructure: TaxonomyImportValidStructure;
};
export type LocationExportReadModel = {
  name: string;
  contentType: string;
  content: string;
};
export type ThermostatTelemetryReadModel = {
  thermostatId: string;
  eui: string;
  spaceId?: string | null;
  lastSeenAt?: string | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  latestAvailableFirmwareVersion?: FirmwareVersionReadModel | null;
  firmwareStatus: ThermostatFirmwareStatus;
  hardwareRevision?: HardwareRevisionReadModel | null;
  spreadingFactor?: number | null;
  motorPosition?: number | null;
  motorConstraint?: number | null;
  ambientTemperature?: number | null;
  targetTemperature?: number | null;
  batteryLevel?: number | null;
};
export type TaxonomyViewThermostatsStatus = {
  unassigned: number;
  summerMode: number;
  installationMode: number;
  energySavingMode: number;
  offline: number;
  online: number;
  problem: number;
};
export type TaxonomyViewRadiatorReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  heatingCircuit?: string | null;
  heatingCircuitId?: string | null;
  heatingCircuitIsInherited?: boolean | null;
  floors: string[];
  thermostatsStatus: TaxonomyViewThermostatsStatus;
};
export type TaxonomyViewRoomReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  heatingCircuit?: string | null;
  heatingCircuitId?: string | null;
  heatingCircuitIsInherited?: boolean | null;
  floors: string[];
  thermostatsStatus: TaxonomyViewThermostatsStatus;
  roomType?: RoomType | null;
  radiators: TaxonomyViewRadiatorReadModel[];
};
export type TaxonomyViewBuildingUnitReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  heatingCircuit?: string | null;
  heatingCircuitId?: string | null;
  heatingCircuitIsInherited?: boolean | null;
  floors: string[];
  thermostatsStatus: TaxonomyViewThermostatsStatus;
  buildingUnitType: BuildingUnitType;
};
export type TaxonomyViewBuildingReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  heatingCircuit?: string | null;
  heatingCircuitId?: string | null;
  heatingCircuitIsInherited?: boolean | null;
  floors: string[];
  thermostatsStatus: TaxonomyViewThermostatsStatus;
  buildingUnits: TaxonomyViewBuildingUnitReadModel[];
};
export type TaxonomyViewBuildingComplexReadModel = {
  id: string;
  spaceType: SpaceType;
  name: string;
  heatingCircuit?: string | null;
  heatingCircuitId?: string | null;
  heatingCircuitIsInherited?: boolean | null;
  floors: string[];
  thermostatsStatus: TaxonomyViewThermostatsStatus;
  buildings: TaxonomyViewBuildingReadModel[];
};
export type AddTenantRequest = {
  name: string;
};
export type TenantDetailReadModel = {
  id: string;
  name: string;
  thermostatCount: number;
  gatewayCount: number;
  sensorCount: number;
  userCount: number;
  buildingCount: number;
  createdAt: string;
};
export type TenantDetailReadModelPagedListResult = {
  items: TenantDetailReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetTenantsQueryOptions =
  | "Name"
  | "UserCount"
  | "ThermostatCount"
  | "SensorCount"
  | "GatewayCount"
  | "BuildingCount";
export type UpdateTenantRequest = {
  name: string;
};
export type TenantOverviewReadModel = {
  tenantId: string;
  name: string;
  locationCount: number;
  buildingComplexCount: number;
  buildingCount: number;
  buildingUnitCount: number;
  roomCount: number;
  radiatorCount: number;
  gatewayCount: number;
  thermostatCount: number;
  sensorCount: number;
  userCount: number;
  createdAt: string;
};
export type TenantAutocompleteReadModel = {
  id: string;
  name: string;
};
export type AddTermsOfUseRequest = {
  content: string;
};
export type TermsOfUseReadModel = {
  id: string;
  content: string;
  createdBy: string;
  createdAt: string;
};
export type ThermostatOperationReadModel = {
  id: string;
  lifecycleStatus: ThermostatLifecycleStatus;
  eui: string;
  serialNumber: string;
  operationMode: MajorMode;
  lastSeenAt?: string | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  fingerprint?: string | null;
  firmwareUpdateProgressStatus?: DataTransferProgressStatus | null;
  radiatorId?: string | null;
  roomId?: string | null;
  roomType?: RoomType | null;
  unitId?: string | null;
  unitName?: string | null;
  buildingUnitType?: BuildingUnitType | null;
  buildingId?: string | null;
  buildingName?: string | null;
  addressStreet?: string | null;
  addressNumber?: string | null;
  addressCity?: string | null;
  addressZipCode?: string | null;
  country?: string | null;
  constructionYear?: number | null;
  floorNames?: string[] | null;
  floorNamesAsString: string;
  floorLevels?: number[] | null;
  tenantId: string;
  tenantName?: string | null;
  hardwareVersion?: HardwareRevisionReadModel | null;
  isDirectMotorControlActive?: boolean | null;
  isMotorCalibrated?: boolean | null;
  batteryLevel?: number | null;
  batteryVoltage?: number | null;
  status: DeviceNetworkStatus;
};
export type ThermostatOperationReadModelPagedListResult = {
  items: ThermostatOperationReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type ThermostatDeviceListSortOptions =
  | "Eui"
  | "HardwareVersion"
  | "LifecycleStatus"
  | "IsMotorCalibrated"
  | "IsDirectMotorControlActive"
  | "OperationMode"
  | "BatteryLevel"
  | "BatteryVoltage"
  | "LastSeenAt"
  | "FirmwareUpdateProgressStatus"
  | "FirmwareVersion"
  | "Fingerprint"
  | "AddressCity"
  | "AddressNumber"
  | "AddressStreet"
  | "AddressZipCode"
  | "BuildingName"
  | "TenantName";
export type ThermostatProductionReadModel = {
  id: string;
  spaceId?: string | null;
  tenantId: string;
  tenantName?: string | null;
  eui: string;
  serialNumber?: string | null;
  description?: string | null;
  lifecycleStatus: ThermostatLifecycleStatus;
  lastSeenAt?: string | null;
  status: DeviceNetworkStatus;
  hardwareRevision?: HardwareRevisionReadModel | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  mode: MajorMode;
  hasRunningFwu: boolean;
  batteryLevel?: number | null;
  batteryVoltage?: number | null;
  isMotorCalibrated?: boolean | null;
  isDirectMotorControlActive?: boolean | null;
};
export type ThermostatProductionReadModelPagedListResult = {
  items: ThermostatProductionReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type AssignThermostatRequest = {
  spaceId: string;
};
export type RadiatorIssueSeverity = "NoIssue" | "MinorIssue" | "SeverityIssue";
export type RadiatorSpaceReadModel = {
  id: string;
  spaceType: SpaceType;
  buildingUnitType?: BuildingUnitType | null;
  name: string;
  issueSeverity: RadiatorIssueSeverity;
  isObstructed: boolean;
};
export type RoomSpaceReadModel = {
  id: string;
  spaceType: SpaceType;
  buildingUnitType?: BuildingUnitType | null;
  name: string;
  roomType: RoomType;
  floors: FloorReadModel[];
};
export type BuildingSpaceReadModel = {
  id: string;
  spaceType: SpaceType;
  buildingUnitType?: BuildingUnitType | null;
  name: string;
  isFullAddressAvailable: boolean;
  fullAddress: string;
  city?: string | null;
  street?: string | null;
  zipCode?: string | null;
  number?: string | null;
};
export type ThermostatDetailReadModel = {
  id: string;
  spaceId?: string | null;
  eui: string;
  serialNumber?: string | null;
  description?: string | null;
  lifecycleStatus: ThermostatLifecycleStatus;
  radiator?: RadiatorSpaceReadModel | null;
  room?: RoomSpaceReadModel | null;
  buildingUnit?: SpaceReadModel | null;
  building?: BuildingSpaceReadModel | null;
  buildingComplex?: SpaceReadModel | null;
  location?: SpaceReadModel | null;
  heatingCircuit?: HeatingCircuitReadModel | null;
  lastSeenAt?: string | null;
  batteryLevel?: number | null;
  batteryVoltage?: number | null;
  status: DeviceNetworkStatus;
  mode: MajorMode;
  isMotorCalibrated?: boolean | null;
  isDirectMotorControlActive?: boolean | null;
  isFirmwareUpdateInProgress: boolean;
  isActiveHarvestingTurnedOn: boolean;
  motorPositionLastUpdated?: string | null;
  hardwareRevision?: HardwareRevisionReadModel | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  componentsFingerprintHash?: string | null;
  tenant?: TenantReadModel | null;
  tenantCanBeUnassigned: boolean;
  isLatestRefurbishment: boolean;
  alertsCount: number;
  fingerprintHash?: string | null;
  pairedSensorEui?: string | null;
};
export type UpdateThermostatRequest = {
  serialNumber?: string | null;
  description?: string | null;
};
export type DataTransferSchedulingThermostatRow = {
  thermostatId: string;
  eui: string;
  hardwareVersion?: HardwareRevision | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  componentsFingerprintHash?: string | null;
  operationMode: MajorMode;
  networkStatus: DeviceNetworkStatus;
  lastSeenAt?: string | null;
  batteryLevel?: number | null;
  batteryVoltage?: Voltage | null;
  transferInProgress: boolean;
  canReceiveTransfer: boolean;
};
export type DataTransferSchedulingThermostatRowPagedListResult = {
  items: DataTransferSchedulingThermostatRow[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type DataTransferSchedulingThermostatResult = {
  list: DataTransferSchedulingThermostatRowPagedListResult;
  canStartDataTransferCount: number;
  availableSlotsCount: number;
  runningDataTransfersInBuildingCount: number;
};
export type DataTransferToThermostatRow = {
  transferId: string;
  eui: string;
  thermostatId: string;
  hardwareVersion?: HardwareRevision | null;
  firmwareVersion?: FirmwareVersionReadModel | null;
  componentsFingerprintHash?: string | null;
  spreadingFactor?: number | null;
  startFirmwareVersion?: FirmwareVersionReadModel | null;
  startComponentsFingerprintHash?: string | null;
  lastSeenAt?: string | null;
  name: string;
  type: DataTransferToDeviceType;
  status: DataTransferProgressStatus;
  size: number;
  payloadHash: string;
  progress: number;
  progressPercent: number;
  startedAt: string;
  lastProgressAt?: string | null;
  finishedAt?: string | null;
  errorCorrecting: boolean;
  startedByEmail?: string | null;
  abortedByEmail?: string | null;
  isAutoFuota: boolean;
  isForced: boolean;
};
export type DataTransferToThermostatRowPagedListResult = {
  items: DataTransferToThermostatRow[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetDataTransferToThermostatHistoryOptions =
  "LastProgressAt" | "StartedAt" | "FinishedAt" | "Progress";
export type GatewayConnectivityStatusReadModel = {
  gatewayId: string;
  rssi?: number | null;
  snr?: number | null;
};
export type ThermostatConnectivityReadModel = {
  lastSeenAt?: string | null;
  gateways?: GatewayConnectivityStatusReadModel[] | null;
};
export type DownlinkCommandSource =
  | "Unknown"
  | "AdminApp"
  | "HydraulicBalancing"
  | "AssemblyLine"
  | "ThermostatService"
  | "HeatingAuthority";
export type ThermostatDownlinkStatus =
  "Unknown" | "Running" | "Success" | "Failed" | "Aborted";
export type UplinkCommandResponseError = {
  code: CommandErrorCode;
  msg: string;
};
export type ThermostatDownlinkResponse = {
  commandId: string;
  code: CommandCode;
  source: DownlinkCommandSource;
  queuedAt: string;
  endedAt?: string | null;
  status: ThermostatDownlinkStatus;
  error?: UplinkCommandResponseError | null;
  payload: any;
};
export type ThermostatMeasurementsReadModel = {
  ambientTemperature?: number | null;
  rawAmbientTemperature?: number | null;
  manualTargetTemperature?: number | null;
  tegVoltage?: number | null;
  motorPosition?: number | null;
  motorConstraint?: number | null;
  antiFreezeTemperature?: number | null;
  minimumTemperature?: number | null;
  maximumTemperature?: number | null;
  manualTargetTemperatureLevel?: number | null;
  bodyTemperature?: number | null;
  displayRotation?: DisplayRotation | null;
  dataTransfer?: DataTransferProgressStatus | null;
  humidity?: number | null;
  temperatureFromLookupTable?: boolean | null;
  spreadingFactor?: number | null;
  targetTemperature?: number | null;
  targetTemperatureLevel?: number | null;
  isManualTargetTemperature?: boolean | null;
};
export type ThermostatOperationalStatusReadModel = {
  isHydraulicBalancingActive?: boolean | null;
  isMotorCalibrated?: boolean | null;
  isDirectMotorControlActive?: boolean | null;
  operationalMode?: MajorMode | null;
};
export type ThermostatRenterReadModel = {
  renterName?: string | null;
  phoneNumber?: string | null;
};
export type ThermostatAutocompleteReadModel = {
  id: string;
  spaceId?: string | null;
  eui: string;
  serialNumber?: string | null;
  clientId: string;
  clientName?: string | null;
};
export type ThermostatReadModelPagedListResult = {
  items: ThermostatReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type ThermostatModeIssuesRequest = {
  notSwitchingToInstallationMode: boolean;
  notSwitchingToNormalModeAutomatically: boolean;
  notSwitchingToNormalModeManually: boolean;
};
export type ThermostatStatusIssuesRequest = {
  offline: boolean;
  unknown: boolean;
  neverSeen: boolean;
};
export type ThermostatDisplayIssuesRequest = {
  whiteDisplay: boolean;
  blackDisplay: boolean;
  unresponsiveToKnobMovement: boolean;
};
export type ThermostatFunctionalIssuesRequest = {
  heatingOnSnowflake: boolean;
  notHeatingOnHighLevel: boolean;
  deadBattery: boolean;
};
export type ThermostatRadiatorIssuesRequest = {
  waterLeakingDuringInstallation: boolean;
  waterLeakingDuringRemoval: boolean;
  looseAdapter: boolean;
};
export type ThermostatPhysicalDamageIssuesRequest = {
  brokenKnob: boolean;
  damagedDisplay: boolean;
  scratchedHousing: boolean;
  otherHousingDamage: boolean;
  damagedFlange: boolean;
  dismountedThermostat: boolean;
};
export type ReportThermostatMalfunctionRequest = {
  modeIssues: ThermostatModeIssuesRequest;
  statusIssues: ThermostatStatusIssuesRequest;
  displayIssues: ThermostatDisplayIssuesRequest;
  functionalIssues: ThermostatFunctionalIssuesRequest;
  radiatorIssues: ThermostatRadiatorIssuesRequest;
  physicalDamageIssues: ThermostatPhysicalDamageIssuesRequest;
  other?: string | null;
};
export type EnableDirectMotorControlEndpointRequest = {
  motorPosition?: SeeroMotorPosition | null;
};
export type SetDisplayRotationRequest = {
  displayRotation: DisplayRotation;
};
export type SetMajorModeRequest = {
  mode: MajorMode;
};
export type SetMotorPositionConstraintRequest = {
  value: SeeroMotorPosition;
};
export type SetMotorPositionRequest = {
  value: SeeroMotorPosition;
};
export type SetTargetTemperatureRequest = {
  targetTemperature: number;
};
export type SetTargetTemperatureLevelRequest = {
  level: TargetTemperatureLevel;
};
export type OperationRequestSource = "AdminApp" | "AssemblyLine";
export type EuiReservationReadModel = {
  id: string;
  source: OperationRequestSource;
  userId?: string | null;
  count: number;
};
export type ImportChirpstackOnboardingReportRow = {
  devEui: string;
  onboarded: boolean;
  reason?: string | null;
};
export type ImportChirpstackOnboardingReport = {
  excelInvalidReason?: string | null;
  rows?: ImportChirpstackOnboardingReportRow[] | null;
};
export type ImportThermostatStatusChangeReportRow = {
  devEui: string;
  statusChanged: boolean;
  reason?: string | null;
};
export type ImportThermostatStatusChangeReport = {
  excelInvalidReason?: string | null;
  rows?: ImportThermostatStatusChangeReportRow[] | null;
};
export type ImportThermostatsTenantsReportRow = {
  devEui: string;
  tenantChanged: boolean;
  reason?: string | null;
};
export type ImportThermostatsTenantsReport = {
  excelInvalidReason?: string | null;
  rows?: ImportThermostatsTenantsReportRow[] | null;
};
export type ReassignThermostatTenantRequest = {
  targetTenantId: string;
};
export type ReserveThermostatsDevEuiRequest = {
  count: number;
};
export type DeviceLifecycleChangeResponse = {
  eui: string;
  success: boolean;
  failure?: string | null;
};
export type SetLifecycleStatusRequest = {
  status: ThermostatLifecycleStatus;
};
export type ChirpstackOnboardingResponse = {
  success: boolean;
  message?: string | null;
};
export type ChirpstackOnboardingRequest = {
  description?: string | null;
};
export type ThermostatHistoryType =
  | "LifecycleChanged"
  | "MajorModeChanged"
  | "FirmwareVersionChanged"
  | "AppUpdateCompleted"
  | "DataTransferToDeviceUpdate"
  | "DownlinkQueued"
  | "OperationStarted"
  | "OperationCompleted"
  | "OperationQueued"
  | "FCntReset"
  | "SpaceChanged"
  | "TenantChanged"
  | "FlushThermostatValve";
export type DataTransferToDeviceUpdateReadModel = {
  type: ThermostatHistoryType;
  transferType: DataTransferToDeviceType;
  status: DataTransferProgressStatus;
  name: string;
  hash: string;
};
export type DownlinkType =
  | "DataTransferAbort"
  | "DataTransferFetchData"
  | "DataTransferGetAppsInfo"
  | "DataTransferInstallCore"
  | "DataTransferPause"
  | "DataTransferResume"
  | "DataTransferSendApp"
  | "DataTransferSendCore"
  | "DataTransferSendStaticData"
  | "DataTransferSpeedup"
  | "HexCommand"
  | "OutwardStallDetection"
  | "InwardStallDetection"
  | "SetTargetTemperatureLevelMapping"
  | "ConfigureMeasurements"
  | "SuperBlockGc"
  | "ConfigureAutoCalibrationClosedValveThreshold"
  | "SetAmbientTemperature"
  | "SendAppData"
  | "GeneralGetInfo"
  | "ManualCalibration"
  | "McuReset"
  | "SetDisplayRotation"
  | "SetMajorMode"
  | "SetMotorPositionConstraint"
  | "SetMotorPosition"
  | "SetTargetTemperatureAndLevel"
  | "SetTargetTemperature"
  | "SetTargetTemperatureLevel"
  | "ToggleDirectMotorPosition"
  | "EnableActiveHarvesting"
  | "DisableActiveHarvesting";
export type DownlinkQueuedDataReadModel = {
  type: ThermostatHistoryType;
  downlinkType: DownlinkType;
};
export type FCntResetReadModel = {
  type: ThermostatHistoryType;
  previousFCnt: number;
  currentFCnt: number;
};
export type FirmwareVersionRecord = {
  major: number;
  minor: number;
  patch: number;
  rcVersion?: number | null;
  devVersion?: number | null;
};
export type FirmwareVersionChangedDataReadModel = {
  type: ThermostatHistoryType;
  oldVersion?: FirmwareVersionRecord | null;
  newVersion: FirmwareVersionRecord;
};
export type LifecycleChangedDataReadModel = {
  type: ThermostatHistoryType;
  source: OperationRequestSource;
  assemblyLineCreatedAt?: string | null;
  oldStatus?: ThermostatLifecycleStatus | null;
  newStatus: ThermostatLifecycleStatus;
};
export type MajorModeChangedDataReadModel = {
  type: ThermostatHistoryType;
  oldMode: MajorMode;
  newMode: MajorMode;
};
export type OperationCompletedDataReadModel = {
  type: ThermostatHistoryType;
  code: ThermostatOperationCode;
  payload?: any | null;
  successful: boolean;
};
export type OperationQueuedDataReadModel = {
  type: ThermostatHistoryType;
  code: ThermostatOperationCode;
  payload?: any | null;
};
export type OperationStartedDataReadModel = {
  type: ThermostatHistoryType;
  code: ThermostatOperationCode;
  payload?: any | null;
  successful: boolean;
};
export type SpaceChangedDataReadModel = {
  type: ThermostatHistoryType;
  oldSpace?: string | null;
  newSpace?: string | null;
};
export type TenantChangedDataReadModel = {
  type: ThermostatHistoryType;
  oldTenant: string;
  newTenant: string;
};
export type ThermostatHistoryVoidReadModel = {
  type: ThermostatHistoryType;
};
export type ThermostatHistoryReadModel = {
  thermostatId: string;
  thermostatHistoryId: string;
  eui: string;
  createdAt: string;
  type: ThermostatHistoryType;
  tenantId: string;
  userId?: string | null;
  user?: string | null;
  payload:
    | DataTransferToDeviceUpdateReadModel
    | DownlinkQueuedDataReadModel
    | FCntResetReadModel
    | FirmwareVersionChangedDataReadModel
    | LifecycleChangedDataReadModel
    | MajorModeChangedDataReadModel
    | OperationCompletedDataReadModel
    | OperationQueuedDataReadModel
    | OperationStartedDataReadModel
    | SpaceChangedDataReadModel
    | TenantChangedDataReadModel
    | ThermostatHistoryVoidReadModel;
};
export type ThermostatHistoryReadModelPagedListResult = {
  items: ThermostatHistoryReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGetThermostatHistoryQueryOptions = "CreatedAt";
export type ThermostatTaxonomyHistoryReadModel = {
  radiatorId: string;
  radiatorName: string;
  roomId: string;
  roomName: string;
  unitId: string;
  unitName: string;
  buildingId: string;
  buildingName: string;
  complexId: string;
  complexName: string;
  locationId: string;
  locationName: string;
};
export const {
  useGetApiSettingsQuery,
  usePutApiSettingsByCodeAndValueMutation,
  useGetApiAlertsThermostatsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdAlertsThermostatsQuery,
  useGetApiAlertsStatisticQuery,
  useGetApiAlertsEuiAutocompleteQuery,
  usePostApiAppointmentsMutation,
  useDeleteApiAppointmentsByAppointmentIdMutation,
  useGetApiAppointmentsByAppointmentIdQuery,
  usePatchApiAppointmentsByAppointmentIdMutation,
  useGetApiAppointmentsBuildingUnitByBuildingUnitIdQuery,
  usePostApiTaxonomyBuildingComplexesMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesMutation,
  useGetApiTaxonomyBuildingComplexesByBuildingComplexIdQuery,
  useDeleteApiTaxonomyBuildingComplexesByBuildingComplexIdMutation,
  usePatchApiTaxonomyBuildingComplexesByBuildingComplexIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdQuery,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingComplexesBuildingComplexIdTreeQuery,
  usePostApiTaxonomyBuildingComplexesMoveToLocationMutation,
  usePostApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsMutation,
  useGetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsQuery,
  useGetApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdQuery,
  usePatchApiTaxonomyBuildingComplexesByBuildingComplexIdFloorsAndFloorIdMutation,
  useGetApiTaxonomyBuildingsByBuildingIdFloorsQuery,
  usePostApiTaxonomyBuildingUnitsMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsMutation,
  useGetApiTaxonomyBuildingUnitsByBuildingUnitIdQuery,
  useDeleteApiTaxonomyBuildingUnitsByBuildingUnitIdMutation,
  usePatchApiTaxonomyBuildingUnitsByBuildingUnitIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdQuery,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdTreeQuery,
  usePatchApiTaxonomyBuildingUnitsByBuildingUnitIdStatusMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingUnitsBuildingUnitIdStatusMutation,
  usePostApiTaxonomyBuildingsMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsMutation,
  useGetApiTaxonomyBuildingsByBuildingIdQuery,
  useDeleteApiTaxonomyBuildingsByBuildingIdMutation,
  usePatchApiTaxonomyBuildingsByBuildingIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdQuery,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdTreeQuery,
  usePostApiTaxonomyBuildingsByBuildingIdGatewaySignalTestMutation,
  useGetApiTaxonomyBuildingsByBuildingIdGatewaySignalTestQuery,
  useGetApiTaxonomyBuildingsByBuildingIdGatewayIssuesQuery,
  usePatchApiTaxonomyBuildingsByBuildingIdGatewayIssuesMutation,
  usePatchApiTaxonomyBuildingsByBuildingIdGatewaySignalTestFloorMutation,
  usePostApiDataPrivacyMutation,
  useGetApiDataPrivacyQuery,
  useGetApiDataPrivacyByIdQuery,
  useGetApiDataPrivacyLatestQuery,
  usePostApiDataPrivacySiteSignupMutation,
  usePostApiDataPrivacySiteRevokeByTokenMutation,
  useGetApiDataPrivacySiteFilterQuery,
  usePatchApiDataPrivacySiteByDataPrivacyAgreementIdMutation,
  useDeleteApiDevelopmentAutoFuotaByAutoFuotaIdMutation,
  usePutApiDevelopmentAutoFuotaByAutoFuotaIdForceMutation,
  useGetApiDevelopmentAutoFuotaQuery,
  useGetApiDevelopmentGatewaysQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdDevelopmentGatewaysQuery,
  useGetApiDevelopmentGatewaysByGatewayIdThermostatsQuery,
  usePostApiDevelopmentDataTransferFromDeviceByThermostatIdAbortMutation,
  useGetApiDevelopmentDataTransferFromDeviceByTransferIdDownloadQuery,
  usePostApiDevelopmentDataTransferFromDeviceByThermostatIdFlashMutation,
  usePostApiDevelopmentDataTransferFromDeviceByThermostatIdLogsMutation,
  usePostApiDevelopmentDataTransferFromDeviceByThermostatIdRamMutation,
  useGetApiDevelopmentDataTransferFromDeviceTransfersQuery,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdAbortMutation,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdGetAppsInfoMutation,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdInstallCoreMutation,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdPauseMutation,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdResumeMutation,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdSendAppMutation,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdSendCoreMutation,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdSendStaticDataMutation,
  usePostApiDevelopmentDownlinkDataTransferByThermostatIdSpeedUpMutation,
  usePostApiDevelopmentDataTransferToDeviceAbortByThermostatIdMutation,
  usePostApiDevelopmentDataTransferToDeviceBulkUploadAppByBuildingIdAndAppIdVersionKeyMutation,
  usePostApiDevelopmentDataTransferToDeviceBulkUploadBinaryByBuildingIdMutation,
  usePostApiDevelopmentDataTransferToDeviceBulkUploadCoreByBuildingIdAndVersionKeyMutation,
  useGetApiDevelopmentFirmwareUpdateDashboardQuery,
  usePostApiDevelopmentFirmwareUpdateDashboardMutation,
  usePutApiDevelopmentDataTransferToDeviceForceByThermostatIdMutation,
  useGetApiDevelopmentDataTransferToDeviceQuery,
  useGetApiDevelopmentFirmwareInfoByThermostatIdQuery,
  usePostApiDevelopmentDataTransferToDeviceByThermostatIdUploadAppAndAppIdMajorMinorPatchMutation,
  usePostApiDevelopmentDataTransferToDeviceByThermostatIdUploadBinaryMutation,
  usePostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreAndMajorMinorPatchMutation,
  usePostApiDevelopmentDataTransferToDeviceByThermostatIdUploadCoreByKeyAndKeyMutation,
  usePostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdMutation,
  usePostApiDevelopmentDataTransferToDeviceBatchesAbortByBatchIdPhaseAndPhaseIdMutation,
  usePostApiDevelopmentDataTransferToDeviceBatchesCreateCoreBatchByMajorAndMinorPatchMutation,
  usePostApiDevelopmentDataTransferToDeviceBatchesCreateAppBatchByAppIdAndMajorMinorPatchMutation,
  usePostApiDevelopmentDataTransferToDeviceBatchesPhaseMutation,
  useGetApiDevelopmentDataTransferToDeviceBatchesExportByBatchIdQuery,
  useGetApiDevelopmentDataTransferToDeviceBatchesQuery,
  useGetApiDevelopmentDataTransferToDeviceBatchesPhaseByBatchIdQuery,
  usePostApiDevelopmentDataTransferToDeviceBatchesPreviewMutation,
  useGetApiDevelopmentThermostatOperationsQuery,
  usePostApiDevelopmentDownlinkByThermostatIdGeneralGetInfoMutation,
  usePostApiDevelopmentDownlinkByThermostatIdMcuResetMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSetDisplayRotationMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSetMajorModeMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSetMotorPositionConstraintMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSetMotorPositionMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureAndLevelMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelMutation,
  usePostApiDevelopmentDownlinkByThermostatIdToggleDirectMotorControlMutation,
  usePostApiDevelopmentDownlinkByThermostatIdMotorOutwardStallDetectionMutation,
  usePostApiDevelopmentDownlinkByThermostatIdMotorInwardStallDetectionMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSetTargetTemperatureLevelMappingMutation,
  usePostApiDevelopmentDownlinkByThermostatIdConfigureMeasurementsMutation,
  usePostApiDevelopmentDownlinkByThermostatIdSuperBlockGcMutation,
  usePostApiDevelopmentDownlinkByThermostatIdAutoCalibrationClosedValveThresholdMutation,
  usePutApiDevelopmentDownlinkByThermostatIdAmbientTemperatureMutation,
  usePostApiDevelopmentDownlinkByThermostatIdAppDataMutation,
  usePostApiDevelopmentDownlinkByThermostatIdHexCommandMutation,
  usePostApiDevelopmentInvokeErrorMutation,
  useGetApiDevelopmentChirpstackDeviceConfigurationDataQuery,
  usePostApiDevelopmentOnboardingThermostatsMutation,
  usePostApiDevelopmentAssemblyLineDetailMutation,
  usePostApiDevelopmentAssemblyLineSummaryMutation,
  useGetApiDevelopmentArtifactsFirmwareCoreQuery,
  usePostApiDevelopmentArtifactsFirmwareCoreMutation,
  useDeleteApiDevelopmentArtifactsFirmwareCoreByMajorAndMinorPatchMutation,
  useGetApiDevelopmentArtifactsTermiosAppQuery,
  usePostApiDevelopmentArtifactsTermiosAppMutation,
  useDeleteApiDevelopmentArtifactsTermiosAppByAppIdAndMajorMinorPatchMutation,
  useGetApiDevicesBuildingDeviceMetadataByBuildingIdQuery,
  useGetApiDevicesByDeviceTypeImageAndImageIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageImageIdQuery,
  usePostApiDevicesImagesByBuildingIdBulkMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdDevicesImagesBuildingIdBulkMutation,
  useGetApiDevicesByDeviceTypeImageMetadataAndDeviceIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdDevicesDeviceTypeImageMetadataDeviceIdQuery,
  useGetApiFilesFileTemplateByTemplateQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdFilesFileTemplateTemplateQuery,
  useGetApiGlobalDeviceListComplexesQuery,
  useGetApiGlobalDeviceListBuildingFloorsQuery,
  useGetApiGlobalDeviceListBuildingsQuery,
  useGetApiGlobalDeviceListBuildingUnitsQuery,
  useGetApiGlobalDeviceListFirmwareVersionsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListSensorsQuery,
  useGetApiGlobalDeviceListHardwareVersionsQuery,
  useGetApiGlobalDeviceListLocationsQuery,
  useGetApiGlobalDeviceListSpaceCustomersQuery,
  usePostApiGlobalDeviceListThermostatsMutation,
  usePostApiGatewaysMutation,
  useGetApiGatewaysQuery,
  usePostApiGatewaysAssignByGatewayIdMutation,
  useDeleteApiGatewaysByGatewayIdMutation,
  useGetApiGatewaysByGatewayIdQuery,
  usePatchApiGatewaysByGatewayIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdQuery,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdMutation,
  useGetApiGatewaysAutocompleteQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdGatewaysAutocompleteQuery,
  useGetApiGatewaysExportQuery,
  useGetApiGatewaysListQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdGatewaysListQuery,
  useGetApiGatewaysSearchQuery,
  usePostApiGatewaysImportTenantReassignMutation,
  usePostApiGatewaysReassignTenantByGatewayEuiMutation,
  usePostApiGatewaysUnassignByGatewayIdMutation,
  usePatchApiGatewaysByGatewayIdInstallationProcessMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdGatewaysGatewayIdInstallationProcessMutation,
  usePostApiGatewayOnboarderGatewayMutation,
  useGetApiHeatingClampsByBuildingIdStatisticsQuery,
  useGetApiHeatingClampsByBuildingIdThermostatsQuery,
  usePutApiHeatingClampsDefaultMutation,
  usePutApiHeatingClampsMutation,
  useGetApiHeatingLoadByBuildingIdCompletionStatisticQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdCompletionStatisticQuery,
  useGetApiHeatingLoadByBuildingIdNonResidentialUnitsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdNonResidentialUnitsQuery,
  useGetApiHeatingLoadByBuildingIdEmptyBuildingUnitsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdEmptyBuildingUnitsQuery,
  useGetApiHeatingLoadByBuildingIdAttemptsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdAttemptsQuery,
  useGetApiHeatingLoadByAttemptIdExportQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadAttemptIdExportQuery,
  useGetApiHeatingLoadByBuildingIdValidationQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdValidationQuery,
  useGetApiHeatingLoadByBuildingIdInvalidRoomsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadBuildingIdInvalidRoomsQuery,
  usePostApiHeatingLoadStartCalculationJobMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdHeatingLoadStartCalculationJobMutation,
  usePostApiHydraulicBalancingManageMutation,
  usePatchApiHydraulicBalancingAttemptsByAttemptIdSettingsMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationInitialMotorPositionConstraintsFillMissingMutation,
  useGetApiHydraulicBalancingVdzCalculationAttemptsByAttemptIdExportQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingVdzCalculationAttemptsAttemptIdExportQuery,
  useGetApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationValidateQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationValidateQuery,
  usePostApiHydraulicBalancingHeatingCircuitsByHeatingCircuitIdVdzCalculationRunMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingHeatingCircuitsHeatingCircuitIdVdzCalculationRunMutation,
  usePostApiHydraulicBalancingImportRadiatorPowerMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerMutation,
  usePostApiHydraulicBalancingImportRadiatorPowerValidateMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdHydraulicBalancingImportRadiatorPowerValidateMutation,
  useGetApiInstallToolProjectsByProjectIdQuery,
  useGetApiInstallToolProjectsQuery,
  useGetApiInstallToolBuildingByFloorsByBuildingIdQuery,
  useGetApiInstallToolBuildingsQuery,
  useGetApiInstallToolBuildingUnitsByBuildingUnitIdQuery,
  useGetApiInstallToolGatewaysQuery,
  useGetApiInstallToolAppointmentsByProjectIdQuery,
  useGetApiInstallToolRadiatorsByRadiatorIdQuery,
  useGetApiInstallToolRoomsByRoomIdQuery,
  useGetApiInstallToolRadiatorSpecificationCatalogueQuery,
  usePatchApiInstallToolGatewaysBuildingsByBuildingIdMutation,
  useGetApiInstallToolGatewaysBuildingsByBuildingIdQuery,
  usePostApiThermostatsAssignWithChecksAndImageByThermostatIdMutation,
  useGetApiInstallToolGatewaysBuildingsQuery,
  usePostApiInstallToolByDeviceIdAndDeviceTypeImagesMutation,
  useGetApiKerlinkCheckByEuiQuery,
  usePostApiKerlinkProvisionByEuiMutation,
  usePostApiLeasesMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdLeasesMutation,
  useDeleteApiLeasesByLeaseIdMutation,
  useGetApiLeasesByLeaseIdQuery,
  usePatchApiLeasesByLeaseIdMutation,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdQuery,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdLeasesLeaseIdMutation,
  useGetApiLeasesBuildingUnitByBuildingUnitIdActiveQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdActiveQuery,
  useGetApiLeasesBuildingUnitByBuildingUnitIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdLeasesBuildingUnitBuildingUnitIdQuery,
  usePostApiLegalNoteMutation,
  useGetApiLegalNoteQuery,
  useGetApiLegalNoteLatestQuery,
  useGetApiLegalNoteByIdQuery,
  useGetApiLocationAutocompleteLocationsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdLocationAutocompleteLocationsQuery,
  usePostApiTaxonomyLocationsMutation,
  useGetApiTaxonomyLocationsQuery,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsMutation,
  useGetApiTaxonomyLocationsByLocationIdQuery,
  useDeleteApiTaxonomyLocationsByLocationIdMutation,
  usePatchApiTaxonomyLocationsByLocationIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdQuery,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdTreeQuery,
  usePostApiTaxonomyLocationsByLocationIdResyncMutation,
  usePostApiTaxonomyLocationsByLocationIdHeatingCircuitsMutation,
  useGetApiTaxonomyLocationsByLocationIdHeatingCircuitsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdChainQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdQuery,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdMutation,
  useGetApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdQuery,
  useDeleteApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdMutation,
  usePatchApiTaxonomyLocationsByLocationIdHeatingCircuitsAndHeatingCircuitIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdHeatingCircuitsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsSpaceTypeSpaceIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHeatingCircuitsHeatingCircuitIdThermostatsQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdActivitiesQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingModesTemperaturesQuery,
  usePostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsMutation,
  usePostApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsMutation,
  useDeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsAssignmentIdMutation,
  useDeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsAssignmentIdMutation,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanQuery,
  usePutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingPlanAssignmentsOrderMutation,
  usePutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingPlanAssignmentsOrderMutation,
  usePostApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansMutation,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansQuery,
  useDeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdMutation,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdQuery,
  usePutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdMutation,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseQuery,
  usePutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansBaseMutation,
  usePutApiNonResidentialOrgByOrgIdTenantAndTenantIdHeatingPlansPlanIdStatusMutation,
  useDeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesMutation,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesQuery,
  usePutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdFloorsFloorIdHeatingTemperaturesMutation,
  useDeleteApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesMutation,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesQuery,
  usePutApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyNodesNodeTypeNodeIdHeatingTemperaturesMutation,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdSubtreeQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationBuildingsBuildingIdFloorsFloorIdQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationLocationsLocationIdSubtreeQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationNodesNodeTypeNodeIdQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdNavigationRootsQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdHeatingStateQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyBuildingsBuildingIdThermostatsQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyLocationsLocationIdSummaryQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdThermostatsQuery,
  useGetApiNonResidentialOrgByOrgIdTenantAndTenantIdThermostatsEuiQuery,
  usePostApiNotificationsTestSendByUserIdMutation,
  usePostApiOptInMutation,
  useDeleteApiOptInMutation,
  useGetApiOptInQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdOptInQuery,
  useGetApiOptInLatestQuery,
  useGetApiOptInByIdQuery,
  usePostApiOrganizationsMutation,
  useGetApiOrganizationsQuery,
  usePutApiOrganizationsByOrganizationIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdPortfolioAutocompleteQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdPortfolioCountsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdPortfolioQuery,
  useGetApiProjectsSyncByProjectIdRenowateQuery,
  usePostApiProjectsSyncByProjectIdRenowateMutation,
  useGetApiProjectsSyncRenowateFailureItemsQuery,
  useGetApiProjectsByProjectIdExportQuery,
  useGetApiProjectsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdProjectsQuery,
  usePostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsMutation,
  usePostApiProjectsManagementMutation,
  usePostApiProjectsManagementByProjectIdAssignBuildingsMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignBuildingsMutation,
  usePostApiProjectsManagementByProjectIdAssignUsersMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAssignUsersMutation,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdContactPersonsContactPersonIdMutation,
  useDeleteApiProjectsManagementByProjectIdMutation,
  useGetApiProjectsManagementByProjectIdQuery,
  usePatchApiProjectsManagementByProjectIdMutation,
  useGetApiProjectsManagementByProjectIdFilterBuildingComplexesQuery,
  useGetApiProjectsManagementByProjectIdFilterLocationsQuery,
  useGetApiProjectsManagementByProjectIdAvailableBuildingsQuery,
  useGetApiProjectsManagementByProjectIdAvailableUsersQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdAvailableUsersQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerAutocompleteQuery,
  usePutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdMilestoneStepsMutation,
  usePutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdOwnerMutation,
  usePutApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdStatusMutation,
  usePostApiProjectsManagementByProjectIdUnassignBuildingsMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignBuildingsMutation,
  usePostApiProjectsManagementByProjectIdUnassignUsersMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdUnassignUsersMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdProjectsManagementProjectIdInstallationDatesMutation,
  useGetApiProjectsIssuesByProjectIdBuildingUnitsQuery,
  useGetApiProjectsIssuesByProjectIdRadiatorsQuery,
  useGetApiProjectsIssuesByProjectIdRentersQuery,
  useGetApiProjectsIssuesByProjectIdRoomsQuery,
  useGetApiProjectsIssuesByProjectIdThermostatsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdContactPersonsQuery,
  useGetApiProjectsDetailByProjectIdBuildingsQuery,
  useGetApiProjectsDetailByProjectIdQuery,
  useGetApiProjectsDetailByProjectIdUsersQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdMilestonesQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdProjectsProjectIdUsersQuery,
  usePostApiTaxonomyRadiatorsMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsMutation,
  useDeleteApiTaxonomyRadiatorsByRadiatorIdObstructionMutation,
  usePatchApiTaxonomyRadiatorsByRadiatorIdObstructionMutation,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdObstructionMutation,
  useGetApiTaxonomyRadiatorsByRadiatorIdQuery,
  useDeleteApiTaxonomyRadiatorsByRadiatorIdMutation,
  usePatchApiTaxonomyRadiatorsByRadiatorIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdQuery,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdMutation,
  useGetApiTaxonomyRadiatorsByRadiatorIdSpecificationQuery,
  usePutApiTaxonomyRadiatorsByRadiatorIdSpecificationMutation,
  usePatchApiTaxonomyRadiatorsByRadiatorIdInstallationFailedMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRadiatorsRadiatorIdInstallationFailedMutation,
  usePatchApiTaxonomyRadiatorsByRadiatorIdChecklistMutation,
  usePatchApiTaxonomyRadiatorsByRadiatorIdVentingMutation,
  usePostApiRentersMutation,
  useDeleteApiRentersByRenterIdMutation,
  useGetApiRentersByRenterIdQuery,
  usePatchApiRentersByRenterIdMutation,
  usePostApiRentersBulkUpdateMutation,
  usePostApiRentersImportMutation,
  usePostApiRentersBulkUpdateValidateMutation,
  usePostApiRentersImportValidateMutation,
  usePostApiRentersByRenterIdAgreementInfoReceivedMutation,
  useGetApiRentersAgreementByRenterIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdRentersAgreementRenterIdHistoryQuery,
  useGetApiGlobalDeviceListRentersQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdSubRentersQuery,
  useGetApiRentersVerificationsBuildingUnitByBuildingUnitIdExpiredQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsIncompleteQuery,
  useGetApiRentersVerificationsUsersQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUsersQuery,
  useGetApiRentersVerificationsBuildingUnitByBuildingUnitIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsBuildingUnitBuildingUnitIdQuery,
  useGetApiRentersVerificationsEmailByEmailQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsEmailEmailQuery,
  usePostApiRentersVerificationsOverrideByUserIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsOverrideUserIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdRentersVerificationsUnlinkUserIdMutation,
  usePostApiTaxonomyRoomsByRoomIdWindowsMutation,
  useGetApiTaxonomyRoomsByRoomIdWindowsQuery,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdWindowsQuery,
  usePostApiTaxonomyRoomsByRoomIdWindowsAndWindowIdDuplicateMutation,
  useGetApiTaxonomyRoomsByRoomIdWindowsAndWindowIdQuery,
  useDeleteApiTaxonomyRoomsByRoomIdWindowsAndWindowIdMutation,
  usePostApiTaxonomyRoomsMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsMutation,
  useGetApiTaxonomyRoomsByRoomIdQuery,
  useDeleteApiTaxonomyRoomsByRoomIdMutation,
  usePatchApiTaxonomyRoomsByRoomIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdQuery,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdMutation,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyRoomsRoomIdTreeQuery,
  usePostApiSensorsMutation,
  useGetApiSensorsQuery,
  usePostApiSensorsAssignHeatingCircuitBySensorIdMutation,
  usePostApiSensorsAssignSpaceBySensorIdMutation,
  usePostApiSensorsAssignWindowBySensorIdMutation,
  useDeleteApiSensorsBySensorIdMutation,
  useGetApiSensorsBySensorIdQuery,
  usePatchApiSensorsBySensorIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdQuery,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdSensorsSensorIdLifecycleHistoryQuery,
  useGetApiSensorsAutocompleteQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdSensorsAutocompleteQuery,
  useGetApiSensorsSpaceBySpaceIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdSensorsSpaceSpaceIdQuery,
  usePostApiSensorsPairBySensorIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdSensorsPairSensorIdMutation,
  usePostApiSensorsPairSpaceBySpaceIdMutation,
  usePostApiSensorsBySensorIdChirpstackConfigurationMutation,
  usePostApiSensorsUnassignBySensorIdMutation,
  usePostApiSensorsUnpairBySensorIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdSensorsUnpairSensorIdMutation,
  usePostApiSensorsUnpairSpaceBySpaceIdMutation,
  useGetApiSignalTesterByEuiLastMeasurementQuery,
  useGetApiSignalTesterAutocompleteQuery,
  useGetApiTaxonomyBySpaceIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyCountsSpaceTypeSpaceIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyHealthSpaceTypeSpaceIdQuery,
  usePatchApiTaxonomyRenameBySpaceIdMutation,
  usePatchApiTaxonomyDescriptionBySpaceIdMutation,
  usePostApiTaxonomyAssignedHeatingCircuitBySpaceIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedHeatingCircuitSpaceIdMutation,
  usePostApiTaxonomyResetHeatingCircuitBySpaceIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetHeatingCircuitSpaceIdMutation,
  usePostApiTaxonomyAssignedFloorsBySpaceIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyAssignedFloorsSpaceIdMutation,
  usePostApiTaxonomyResetFloorsBySpaceIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyResetFloorsSpaceIdMutation,
  usePostApiTaxonomyImportMutation,
  usePostApiTaxonomyImportByProjectIdMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportProjectIdMutation,
  usePostApiTaxonomyImportValidateMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdTaxonomyImportValidateMutation,
  useGetApiTaxonomyExportBySpaceIdQuery,
  useGetApiTaxonomyTenantExportQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdSpaceTelemetrySpaceIdQuery,
  useGetApiTaxonomyGatewaysBySpaceIdQuery,
  useGetApiTaxonomyViewBuildingUnitByBuildingUnitIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTaxonomyViewBuildingUnitBuildingUnitIdQuery,
  useGetApiTaxonomyViewLocationQuery,
  usePostApiTenantsMutation,
  useGetApiTenantsQuery,
  useGetApiTenantsByTenantIdQuery,
  usePatchApiTenantsByTenantIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTenantsTargetTenantIdQuery,
  useGetApiTenantsByTenantIdOverviewQuery,
  useGetApiTenantsAutocompleteQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTenantsAutocompleteQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdTenantsQuery,
  usePostApiTermsOfUseMutation,
  useGetApiTermsOfUseQuery,
  useGetApiTermsOfUseLatestQuery,
  useGetApiTermsOfUseByIdQuery,
  useGetApiGlobalDeviceListOperationQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListOperationQuery,
  useGetApiGlobalDeviceListOperationExportQuery,
  useGetApiGlobalDeviceListProductionQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdGlobalDeviceListProductionQuery,
  usePostApiThermostatsAssignByThermostatIdMutation,
  useDeleteApiThermostatsByThermostatIdMutation,
  useGetApiThermostatsByThermostatIdQuery,
  usePatchApiThermostatsByThermostatIdMutation,
  useDeleteApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdMutation,
  useGetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdQuery,
  usePatchApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdMutation,
  useGetApiThermostatsForDataTransfersByBuildingIdQuery,
  useGetApiThermostatsDataTransfersToThermostatQuery,
  useGetApiThermostatsAssemblyLineHistoryByEuiQuery,
  useGetApiThermostatsByThermostatIdConnectivityQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdConnectivityQuery,
  useGetApiThermostatsDownlinksQuery,
  useGetApiThermostatsByThermostatIdLastmeasurementsQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatIdLastmeasurementsQuery,
  useGetApiThermostatsByThermostatIdOperationalStatusQuery,
  useGetApiThermostatsByThermostatIdRenterQuery,
  useGetApiThermostatsAutocompleteQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdThermostatsAutocompleteQuery,
  useGetApiThermostatsQuery,
  useGetApiThermostatsSpaceBySpaceIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdThermostatsSpaceSpaceIdQuery,
  usePostApiThermostatsReportMalfunctionByThermostatIdMutation,
  usePostApiThermostatsUnassignByThermostatIdMutation,
  usePostApiThermostatsOperationsByThermostatIdDirectMotorControlDisableMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlDisableMutation,
  usePostApiThermostatsOperationsByThermostatIdDirectMotorControlEnableMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDirectMotorControlEnableMutation,
  usePostApiThermostatsOperationsByThermostatIdFlushValveMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdFlushValveMutation,
  usePostApiThermostatsOperationsByThermostatIdManualCalibrationMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdManualCalibrationMutation,
  usePostApiThermostatsOperationsByThermostatIdMcuResetMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMcuResetMutation,
  usePostApiThermostatsOperationsByThermostatIdDisplayRotationMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdDisplayRotationMutation,
  usePostApiThermostatsOperationsByThermostatIdMajorModeMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMajorModeMutation,
  usePostApiThermostatsOperationsByThermostatIdMotorPositionConstraintMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionConstraintMutation,
  usePostApiThermostatsOperationsByThermostatIdMotorPositionMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdMotorPositionMutation,
  usePostApiThermostatsOperationsByThermostatIdTargetTemperatureMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureMutation,
  usePostApiThermostatsOperationsByThermostatIdTargetTemperatureLevelMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdTargetTemperatureLevelMutation,
  usePostApiThermostatsOperationsByThermostatIdToggleActiveHarvestingAndActivateMutation,
  usePostApiV2OrgByOrgIdTenantAndTenantIdThermostatsOperationsThermostatIdToggleActiveHarvestingActivateMutation,
  useGetApiThermostatsLifecycleReservationByReservationIdQuery,
  usePostApiThermostatsLifecycleImportChirpstackOnboardingMutation,
  usePostApiThermostatsLifecycleImportStatusChangeMutation,
  usePostApiThermostatsLifecycleImportTenantReassignMutation,
  usePostApiThermostatsLifecycleTenantReassignByThermostatEuiMutation,
  usePostApiThermostatsLifecycleReserveMutation,
  usePatchApiThermostatsLifecycleByEuiLifecycleStatusMutation,
  usePostApiThermostatsLifecycleByEuiChirpstackOnboardingMutation,
  usePostApiThermostatsLifecycleTenantUnassignByThermostatEuiMutation,
  useGetApiThermostatsThermostatHistoryQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdThermostatsThermostatHistoryQuery,
  useGetApiThermostatsThermostatHistoryRadiatorsQuery,
  useGetApiGatewaysSpaceBySpaceIdQuery,
  useGetApiV2OrgByOrgIdTenantAndTenantIdGatewaysSpaceSpaceIdQuery,
  usePostApiDevelopmentOnboardingSensorsMutation,
  usePostApiDevelopmentOnboardingSignalTestersMutation,
} = injectedRtkApi;
